/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * Lotus Health
 * OpenAPI spec version: 0.0.0
 */
import * as zod from "zod";

/**
 * @summary Fetch Server Status
 */
export const fetchServerStatusResponse = zod.object({
  available: zod.boolean(),
  note: zod.string(),
});

/**
 * @summary Add Additional Access
 */
export const addAdditionalAccessParams = zod.object({
  level: zod.enum(["demo", "app"]),
});

export const addAdditionalAccessBody = zod.object({
  token: zod.string(),
});

export const addAdditionalAccessResponse = zod.unknown();

/**
 * @summary Submit Native Application
 */
export const submitNativeApplicationBody = zod.object({
  display_name: zod.string(),
  email: zod.string(),
  phone_number: zod.union([zod.string(), zod.null()]).optional(),
  referral_source: zod.union([zod.string(), zod.null()]).optional(),
  referral_person_name: zod.union([zod.string(), zod.null()]).optional(),
  resume_file_id: zod.union([zod.uuid(), zod.null()]).optional(),
  medical_school: zod.union([zod.string(), zod.null()]).optional(),
  degree: zod.union([zod.string(), zod.null()]).optional(),
  residency: zod.union([zod.string(), zod.null()]).optional(),
  fellowships: zod.union([zod.string(), zod.null()]).optional(),
  specialty: zod.union([zod.string(), zod.null()]).optional(),
  npi_number: zod.union([zod.string(), zod.null()]).optional(),
  licensed_states: zod.union([zod.array(zod.string()), zod.null()]).optional(),
  board_certified: zod.union([zod.boolean(), zod.null()]).optional(),
});

export const submitNativeApplicationResponseTypeDefault = "success";
export const submitNativeApplicationResponseTypeDefaultOne = "failure";

export const submitNativeApplicationResponse = zod.union([
  zod.object({
    type: zod
      .literal("success")
      .default(submitNativeApplicationResponseTypeDefault),
    status: zod.enum([
      "pending",
      "screening_passed",
      "credentialing_pending",
      "hired",
      "rejected",
      "archived",
    ]),
  }),
  zod.object({
    type: zod
      .literal("failure")
      .default(submitNativeApplicationResponseTypeDefaultOne),
    reason: zod.string(),
    details: zod.string(),
  }),
]);

/**
 * @summary Submit Credentialing
 */
export const submitCredentialingBody = zod.object({
  mailing_address_street: zod.string(),
  mailing_address_city: zod.string(),
  mailing_address_state: zod.string(),
  mailing_address_zip: zod.string(),
  date_of_birth: zod.iso.date(),
  headshot_file_id: zod.union([zod.uuid(), zod.null()]).optional(),
  application_data: zod
    .object({
      attestation_professional_liability: zod
        .union([
          zod.object({
            answers: zod.array(zod.boolean()),
            explanation: zod.union([zod.string(), zod.null()]).optional(),
          }),
          zod.null(),
        ])
        .optional(),
      attestation_physical_mental_health: zod
        .union([
          zod.object({
            answers: zod.array(zod.boolean()),
            explanation: zod.union([zod.string(), zod.null()]).optional(),
          }),
          zod.null(),
        ])
        .optional(),
      attestation_disciplinary_license_dea: zod
        .union([
          zod.object({
            answers: zod.array(zod.boolean()),
            explanation: zod.union([zod.string(), zod.null()]).optional(),
          }),
          zod.null(),
        ])
        .optional(),
      attestation_disciplinary_membership: zod
        .union([
          zod.object({
            answers: zod.array(zod.boolean()),
            explanation: zod.union([zod.string(), zod.null()]).optional(),
          }),
          zod.null(),
        ])
        .optional(),
      attestation_compliance_with_laws: zod
        .union([
          zod.object({
            answers: zod.array(zod.boolean()),
            explanation: zod.union([zod.string(), zod.null()]).optional(),
          }),
          zod.null(),
        ])
        .optional(),
    })
    .describe(
      "Screening attestation data stored in JSONB — not promoted to employee_records.",
    ),
});

export const submitCredentialingResponseTypeDefault = "success";
export const submitCredentialingResponseTypeDefaultOne = "failure";

export const submitCredentialingResponse = zod.union([
  zod.object({
    type: zod
      .literal("success")
      .default(submitCredentialingResponseTypeDefault),
    status: zod.enum([
      "pending",
      "screening_passed",
      "credentialing_pending",
      "hired",
      "rejected",
      "archived",
    ]),
  }),
  zod.object({
    type: zod
      .literal("failure")
      .default(submitCredentialingResponseTypeDefaultOne),
    reason: zod.string(),
    details: zod.string(),
  }),
]);

/**
 * @summary Fetch Clinician Applications Admin
 */
export const fetchClinicianApplicationsAdminResponse = zod.object({
  applications: zod.array(
    zod.object({
      id: zod.uuid(),
      user_id: zod.uuid(),
      ashby_application_id: zod.union([zod.string(), zod.null()]),
      ashby_candidate_id: zod.union([zod.string(), zod.null()]),
      job_posting_id: zod.string(),
      status: zod.enum([
        "pending",
        "screening_passed",
        "credentialing_pending",
        "hired",
        "rejected",
        "archived",
      ]),
      display_name: zod.union([zod.string(), zod.null()]).optional(),
      email: zod.union([zod.string(), zod.null()]).optional(),
      phone_number: zod.union([zod.string(), zod.null()]).optional(),
      referral_source: zod.union([zod.string(), zod.null()]).optional(),
      referral_person_name: zod.union([zod.string(), zod.null()]).optional(),
      resume_file_id: zod.union([zod.uuid(), zod.null()]).optional(),
      medical_school: zod.union([zod.string(), zod.null()]).optional(),
      degree: zod.union([zod.string(), zod.null()]).optional(),
      residency: zod.union([zod.string(), zod.null()]).optional(),
      fellowships: zod.union([zod.string(), zod.null()]).optional(),
      specialty: zod.union([zod.string(), zod.null()]).optional(),
      npi_number: zod.union([zod.string(), zod.null()]).optional(),
      licensed_states: zod
        .union([zod.array(zod.string()), zod.null()])
        .optional(),
      board_certified: zod.union([zod.boolean(), zod.null()]).optional(),
      mailing_address_street: zod.union([zod.string(), zod.null()]).optional(),
      mailing_address_city: zod.union([zod.string(), zod.null()]).optional(),
      mailing_address_state: zod.union([zod.string(), zod.null()]).optional(),
      mailing_address_zip: zod.union([zod.string(), zod.null()]).optional(),
      date_of_birth: zod.union([zod.iso.date(), zod.null()]).optional(),
      headshot_file_id: zod.union([zod.uuid(), zod.null()]).optional(),
      application_data: zod
        .union([
          zod
            .object({
              attestation_professional_liability: zod
                .union([
                  zod.object({
                    answers: zod.array(zod.boolean()),
                    explanation: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                  }),
                  zod.null(),
                ])
                .optional(),
              attestation_physical_mental_health: zod
                .union([
                  zod.object({
                    answers: zod.array(zod.boolean()),
                    explanation: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                  }),
                  zod.null(),
                ])
                .optional(),
              attestation_disciplinary_license_dea: zod
                .union([
                  zod.object({
                    answers: zod.array(zod.boolean()),
                    explanation: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                  }),
                  zod.null(),
                ])
                .optional(),
              attestation_disciplinary_membership: zod
                .union([
                  zod.object({
                    answers: zod.array(zod.boolean()),
                    explanation: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                  }),
                  zod.null(),
                ])
                .optional(),
              attestation_compliance_with_laws: zod
                .union([
                  zod.object({
                    answers: zod.array(zod.boolean()),
                    explanation: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                  }),
                  zod.null(),
                ])
                .optional(),
            })
            .describe(
              "Screening attestation data stored in JSONB — not promoted to employee_records.",
            ),
          zod.null(),
        ])
        .optional(),
      created_at: zod.iso.datetime({}),
      updated_at: zod.iso.datetime({}),
    }),
  ),
});

/**
 * @summary Update Clinician Application Admin
 */
export const updateClinicianApplicationAdminParams = zod.object({
  application_id: zod.uuid(),
});

export const updateClinicianApplicationAdminBody = zod.object({
  id: zod.uuid(),
  user_id: zod.uuid(),
  ashby_application_id: zod.union([zod.string(), zod.null()]),
  ashby_candidate_id: zod.union([zod.string(), zod.null()]),
  job_posting_id: zod.string(),
  status: zod.enum([
    "pending",
    "screening_passed",
    "credentialing_pending",
    "hired",
    "rejected",
    "archived",
  ]),
  display_name: zod.union([zod.string(), zod.null()]).optional(),
  email: zod.union([zod.string(), zod.null()]).optional(),
  phone_number: zod.union([zod.string(), zod.null()]).optional(),
  referral_source: zod.union([zod.string(), zod.null()]).optional(),
  referral_person_name: zod.union([zod.string(), zod.null()]).optional(),
  resume_file_id: zod.union([zod.uuid(), zod.null()]).optional(),
  medical_school: zod.union([zod.string(), zod.null()]).optional(),
  degree: zod.union([zod.string(), zod.null()]).optional(),
  residency: zod.union([zod.string(), zod.null()]).optional(),
  fellowships: zod.union([zod.string(), zod.null()]).optional(),
  specialty: zod.union([zod.string(), zod.null()]).optional(),
  npi_number: zod.union([zod.string(), zod.null()]).optional(),
  licensed_states: zod.union([zod.array(zod.string()), zod.null()]).optional(),
  board_certified: zod.union([zod.boolean(), zod.null()]).optional(),
  mailing_address_street: zod.union([zod.string(), zod.null()]).optional(),
  mailing_address_city: zod.union([zod.string(), zod.null()]).optional(),
  mailing_address_state: zod.union([zod.string(), zod.null()]).optional(),
  mailing_address_zip: zod.union([zod.string(), zod.null()]).optional(),
  date_of_birth: zod.union([zod.iso.date(), zod.null()]).optional(),
  headshot_file_id: zod.union([zod.uuid(), zod.null()]).optional(),
  application_data: zod
    .union([
      zod
        .object({
          attestation_professional_liability: zod
            .union([
              zod.object({
                answers: zod.array(zod.boolean()),
                explanation: zod.union([zod.string(), zod.null()]).optional(),
              }),
              zod.null(),
            ])
            .optional(),
          attestation_physical_mental_health: zod
            .union([
              zod.object({
                answers: zod.array(zod.boolean()),
                explanation: zod.union([zod.string(), zod.null()]).optional(),
              }),
              zod.null(),
            ])
            .optional(),
          attestation_disciplinary_license_dea: zod
            .union([
              zod.object({
                answers: zod.array(zod.boolean()),
                explanation: zod.union([zod.string(), zod.null()]).optional(),
              }),
              zod.null(),
            ])
            .optional(),
          attestation_disciplinary_membership: zod
            .union([
              zod.object({
                answers: zod.array(zod.boolean()),
                explanation: zod.union([zod.string(), zod.null()]).optional(),
              }),
              zod.null(),
            ])
            .optional(),
          attestation_compliance_with_laws: zod
            .union([
              zod.object({
                answers: zod.array(zod.boolean()),
                explanation: zod.union([zod.string(), zod.null()]).optional(),
              }),
              zod.null(),
            ])
            .optional(),
        })
        .describe(
          "Screening attestation data stored in JSONB — not promoted to employee_records.",
        ),
      zod.null(),
    ])
    .optional(),
  created_at: zod.iso.datetime({}),
  updated_at: zod.iso.datetime({}),
});

export const updateClinicianApplicationAdminResponse = zod.object({
  id: zod.uuid(),
  user_id: zod.uuid(),
  ashby_application_id: zod.union([zod.string(), zod.null()]),
  ashby_candidate_id: zod.union([zod.string(), zod.null()]),
  job_posting_id: zod.string(),
  status: zod.enum([
    "pending",
    "screening_passed",
    "credentialing_pending",
    "hired",
    "rejected",
    "archived",
  ]),
  display_name: zod.union([zod.string(), zod.null()]).optional(),
  email: zod.union([zod.string(), zod.null()]).optional(),
  phone_number: zod.union([zod.string(), zod.null()]).optional(),
  referral_source: zod.union([zod.string(), zod.null()]).optional(),
  referral_person_name: zod.union([zod.string(), zod.null()]).optional(),
  resume_file_id: zod.union([zod.uuid(), zod.null()]).optional(),
  medical_school: zod.union([zod.string(), zod.null()]).optional(),
  degree: zod.union([zod.string(), zod.null()]).optional(),
  residency: zod.union([zod.string(), zod.null()]).optional(),
  fellowships: zod.union([zod.string(), zod.null()]).optional(),
  specialty: zod.union([zod.string(), zod.null()]).optional(),
  npi_number: zod.union([zod.string(), zod.null()]).optional(),
  licensed_states: zod.union([zod.array(zod.string()), zod.null()]).optional(),
  board_certified: zod.union([zod.boolean(), zod.null()]).optional(),
  mailing_address_street: zod.union([zod.string(), zod.null()]).optional(),
  mailing_address_city: zod.union([zod.string(), zod.null()]).optional(),
  mailing_address_state: zod.union([zod.string(), zod.null()]).optional(),
  mailing_address_zip: zod.union([zod.string(), zod.null()]).optional(),
  date_of_birth: zod.union([zod.iso.date(), zod.null()]).optional(),
  headshot_file_id: zod.union([zod.uuid(), zod.null()]).optional(),
  application_data: zod
    .union([
      zod
        .object({
          attestation_professional_liability: zod
            .union([
              zod.object({
                answers: zod.array(zod.boolean()),
                explanation: zod.union([zod.string(), zod.null()]).optional(),
              }),
              zod.null(),
            ])
            .optional(),
          attestation_physical_mental_health: zod
            .union([
              zod.object({
                answers: zod.array(zod.boolean()),
                explanation: zod.union([zod.string(), zod.null()]).optional(),
              }),
              zod.null(),
            ])
            .optional(),
          attestation_disciplinary_license_dea: zod
            .union([
              zod.object({
                answers: zod.array(zod.boolean()),
                explanation: zod.union([zod.string(), zod.null()]).optional(),
              }),
              zod.null(),
            ])
            .optional(),
          attestation_disciplinary_membership: zod
            .union([
              zod.object({
                answers: zod.array(zod.boolean()),
                explanation: zod.union([zod.string(), zod.null()]).optional(),
              }),
              zod.null(),
            ])
            .optional(),
          attestation_compliance_with_laws: zod
            .union([
              zod.object({
                answers: zod.array(zod.boolean()),
                explanation: zod.union([zod.string(), zod.null()]).optional(),
              }),
              zod.null(),
            ])
            .optional(),
        })
        .describe(
          "Screening attestation data stored in JSONB — not promoted to employee_records.",
        ),
      zod.null(),
    ])
    .optional(),
  created_at: zod.iso.datetime({}),
  updated_at: zod.iso.datetime({}),
});

/**
 * @summary Fetch Current Clinician Onboarding Step
 */
export const fetchCurrentClinicianOnboardingStepResponseDataPrefillNADEANumbersItemNADEANumberRegExp =
  new RegExp("^[a-zA-Z0-9]{9}$");

export const fetchCurrentClinicianOnboardingStepResponse = zod.object({
  step: zod.enum([
    "submit_application",
    "application_pending",
    "application_rejected",
    "fill_credentialing_form",
    "credentialing_pending",
    "fill_employee_record",
    "enter_prescriber_details",
    "awaiting_dosespot",
    "start_idp",
    "sign_disclaimer",
    "sign_legal_agreements",
    "submit_demographics",
    "answer_questions",
    "submit_otp",
    "link_bank_account",
    "complete",
  ]),
  data: zod
    .union([
      zod.object({
        missingFields: zod.array(
          zod.enum([
            "displayName",
            "email",
            "licensedStates",
            "licensedPracticeAreas",
          ]),
        ),
        currentValues: zod.object({
          displayName: zod.union([zod.string(), zod.null()]),
          phoneNumber: zod.union([zod.string(), zod.null()]),
          email: zod.union([zod.string(), zod.null()]),
          licensedStates: zod.union([zod.array(zod.string()), zod.null()]),
          licensedPracticeAreas: zod.union([
            zod.array(zod.string()),
            zod.null(),
          ]),
          originPractices: zod.union([zod.array(zod.string()), zod.null()]),
          mailingAddressStreet: zod
            .union([zod.string(), zod.null()])
            .optional(),
          mailingAddressCity: zod.union([zod.string(), zod.null()]).optional(),
          mailingAddressState: zod.union([zod.string(), zod.null()]).optional(),
          mailingAddressZip: zod.union([zod.string(), zod.null()]).optional(),
          dateOfBirth: zod.union([zod.iso.date(), zod.null()]).optional(),
          npiNumber: zod.union([zod.string(), zod.null()]).optional(),
          headshotFileId: zod.union([zod.uuid(), zod.null()]).optional(),
        }),
      }),
      zod.object({
        prefill: zod.union([
          zod
            .object({
              FirstName: zod.string(),
              LastName: zod.string(),
              DateOfBirth: zod.string(),
              Address1: zod.string(),
              City: zod.string(),
              State: zod.string(),
              ZipCode: zod.string(),
              PrimaryPhone: zod.string(),
              PrimaryFax: zod.string(),
              ClinicianId: zod.union([zod.number(), zod.null()]).optional(),
              Prefix: zod.union([zod.string(), zod.null()]).optional(),
              MiddleName: zod.union([zod.string(), zod.null()]).optional(),
              Suffix: zod.union([zod.string(), zod.null()]).optional(),
              Email: zod.union([zod.string(), zod.null()]).optional(),
              Address2: zod.union([zod.string(), zod.null()]).optional(),
              PrimaryPhoneType: zod
                .union([
                  zod.enum([
                    "Undefined",
                    "Beeper",
                    "Cell",
                    "Fax",
                    "Home",
                    "Work",
                    "Night",
                    "Primary",
                  ]),
                  zod.null(),
                ])
                .optional(),
              PhoneAdditional1: zod
                .union([zod.string(), zod.null()])
                .optional(),
              PhoneAdditionalType1: zod
                .union([
                  zod.enum([
                    "Undefined",
                    "Beeper",
                    "Cell",
                    "Fax",
                    "Home",
                    "Work",
                    "Night",
                    "Primary",
                  ]),
                  zod.null(),
                ])
                .optional(),
              PhoneAdditional2: zod
                .union([zod.string(), zod.null()])
                .optional(),
              PhoneAdditionalType2: zod
                .union([
                  zod.enum([
                    "Undefined",
                    "Beeper",
                    "Cell",
                    "Fax",
                    "Home",
                    "Work",
                    "Night",
                    "Primary",
                  ]),
                  zod.null(),
                ])
                .optional(),
              PhoneAdditional3: zod
                .union([zod.string(), zod.null()])
                .optional(),
              PhoneAdditionalType3: zod
                .union([
                  zod.enum([
                    "Undefined",
                    "Beeper",
                    "Cell",
                    "Fax",
                    "Home",
                    "Work",
                    "Night",
                    "Primary",
                  ]),
                  zod.null(),
                ])
                .optional(),
              DEANumbers: zod
                .union([
                  zod.array(
                    zod.object({
                      DEANumber: zod.string(),
                      State: zod.union([zod.string(), zod.null()]).optional(),
                      ClinicId: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                    }),
                  ),
                  zod.null(),
                ])
                .optional(),
              DEANumber: zod.union([zod.string(), zod.null()]).optional(),
              NADEANumbers: zod
                .union([
                  zod.array(
                    zod.object({
                      NADEANumber: zod
                        .string()
                        .regex(
                          fetchCurrentClinicianOnboardingStepResponseDataPrefillNADEANumbersItemNADEANumberRegExp,
                        ),
                      State: zod.union([zod.string(), zod.null()]).optional(),
                      ClinicId: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                    }),
                  ),
                  zod.null(),
                ])
                .optional(),
              MedicalLicenseNumbers: zod
                .union([
                  zod.array(
                    zod.object({
                      LicenseNumber: zod.string(),
                      State: zod.union([zod.string(), zod.null()]).optional(),
                      ClinicId: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                    }),
                  ),
                  zod.null(),
                ])
                .optional(),
              NPINumber: zod.union([zod.string(), zod.null()]).optional(),
              Roles: zod
                .union([zod.array(zod.string()), zod.null()])
                .optional(),
              PDMPRoleType: zod
                .union([
                  zod.enum([
                    "Physician",
                    "Dentist",
                    "NursePractioner",
                    "PhysiciansAssistant",
                    "Resident",
                    "Intern",
                    "Psychologist",
                    "Optometrist",
                    "NaturopathicPhysician",
                  ]),
                  zod.null(),
                ])
                .optional(),
              SpecialtyTypeId: zod.union([zod.number(), zod.null()]).optional(),
              Confirmed: zod.union([zod.boolean(), zod.null()]).optional(),
              Active: zod.union([zod.boolean(), zod.null()]).optional(),
              AccountLocked: zod.union([zod.boolean(), zod.null()]).optional(),
              EpcsRequested: zod.union([zod.boolean(), zod.null()]).optional(),
              ClinicInfo: zod
                .union([
                  zod.array(
                    zod
                      .object({
                        ClinicId: zod
                          .union([zod.number(), zod.null()])
                          .optional(),
                        HasNewRx: zod
                          .union([zod.boolean(), zod.null()])
                          .optional(),
                        HasRefills: zod
                          .union([zod.boolean(), zod.null()])
                          .optional(),
                        HasRxChange: zod
                          .union([zod.boolean(), zod.null()])
                          .optional(),
                        HasCancel: zod
                          .union([zod.boolean(), zod.null()])
                          .optional(),
                        HasRxFill: zod
                          .union([zod.boolean(), zod.null()])
                          .optional(),
                        HasEpcs: zod
                          .union([zod.boolean(), zod.null()])
                          .optional(),
                        HasEpa: zod
                          .union([zod.boolean(), zod.null()])
                          .optional(),
                      })
                      .describe(
                        "Summary of e-prescribing capabilities for a clinician at a specific clinic.",
                      ),
                  ),
                  zod.null(),
                ])
                .optional(),
            })
            .describe("Complete clinician information from DoseSpot API."),
          zod.null(),
        ]),
        registrationError: zod
          .union([
            zod.enum([
              "Pending",
              "RegistrationSuccess",
              "RegistrationError",
              "IDPSuccess",
              "IDPError",
              "TFAActivateInit",
              "TFAActivatedSuccess",
              "TFAActivatedError",
              "TFADeactivateInit",
              "TFADeactivatedSuccess",
              "TFADeactivatedError",
              "IDPInitializeSuccess",
              "NotApplicable",
            ]),
            zod.null(),
          ])
          .optional(),
      }),
      zod.object({
        message: zod.string(),
      }),
      zod.object({
        pendingAgreementIds: zod.array(zod.number()),
      }),
      zod.object({
        questions: zod.array(zod.string()),
        answerChoices: zod.array(zod.array(zod.string())),
      }),
      zod.null(),
    ])
    .optional(),
});

/**
 * Create a new DoseSpot clinician record for a user.

This endpoint creates a DoseSpot clinician account for the specified user,
validates that they are an employee, and ensures no duplicate records.

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the target user is not an employee or already has a record
 * @summary Create Dosespot Clinician
 */
export const createDosespotClinicianBodyClinicianInfoNADEANumbersItemNADEANumberRegExp =
  new RegExp("^[a-zA-Z0-9]{9}$");

export const createDosespotClinicianBody = zod.object({
  userId: zod.uuid(),
  clinicianInfo: zod.object({
    FirstName: zod.string(),
    LastName: zod.string(),
    DateOfBirth: zod.string(),
    Address1: zod.string(),
    City: zod.string(),
    State: zod.string(),
    ZipCode: zod.string(),
    PrimaryPhone: zod.string(),
    PrimaryFax: zod.string(),
    ClinicianRoleType: zod.array(
      zod
        .enum(["1", "2", "3", "4", "5", "6"])
        .describe("Valid clinician role types for DoseSpot."),
    ),
    NPINumber: zod.string(),
    Prefix: zod.union([zod.string(), zod.null()]).optional(),
    MiddleName: zod.union([zod.string(), zod.null()]).optional(),
    Suffix: zod.union([zod.string(), zod.null()]).optional(),
    Email: zod.union([zod.string(), zod.null()]).optional(),
    Address2: zod.union([zod.string(), zod.null()]).optional(),
    PrimaryPhoneType: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PhoneAdditional1: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType1: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PhoneAdditional2: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType2: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PhoneAdditional3: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType3: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    DEANumber: zod.union([zod.string(), zod.null()]).optional(),
    DEANumbers: zod
      .union([
        zod.array(
          zod.object({
            DEANumber: zod.string(),
            State: zod.union([zod.string(), zod.null()]).optional(),
            ClinicId: zod.union([zod.string(), zod.null()]).optional(),
          }),
        ),
        zod.null(),
      ])
      .optional(),
    NADEANumbers: zod
      .union([
        zod.array(
          zod.object({
            NADEANumber: zod
              .string()
              .regex(
                createDosespotClinicianBodyClinicianInfoNADEANumbersItemNADEANumberRegExp,
              ),
            State: zod.union([zod.string(), zod.null()]).optional(),
            ClinicId: zod.union([zod.string(), zod.null()]).optional(),
          }),
        ),
        zod.null(),
      ])
      .optional(),
    MedicalLicenseNumbers: zod
      .union([
        zod.array(
          zod.object({
            LicenseNumber: zod.string(),
            State: zod.union([zod.string(), zod.null()]).optional(),
            ClinicId: zod.union([zod.string(), zod.null()]).optional(),
          }),
        ),
        zod.null(),
      ])
      .optional(),
    EPCSRequested: zod.union([zod.boolean(), zod.null()]).optional(),
    Active: zod.union([zod.boolean(), zod.null()]).optional(),
    PDMPRoleType: zod
      .union([
        zod.enum([
          "Physician",
          "Dentist",
          "NursePractioner",
          "PhysiciansAssistant",
          "Resident",
          "Intern",
          "Psychologist",
          "Optometrist",
          "NaturopathicPhysician",
        ]),
        zod.null(),
      ])
      .optional(),
    ClinicianSpecialtyType: zod
      .union([
        zod.enum([
          "AllergyAndImmunology",
          "Dermatology",
          "Dentistry",
          "BehavioralHealth",
          "FamilyMedicine",
          "InternalMedicine",
          "ObstetricsAndGynecology",
          "Orthopedics",
          "Pediatrics",
          "PhysicalMedicine",
          "Psychiatry",
          "Urology",
        ]),
        zod.null(),
      ])
      .optional(),
  }),
});

export const createDosespotClinicianResponseCurrentDosespotInfoNADEANumbersItemNADEANumberRegExp =
  new RegExp("^[a-zA-Z0-9]{9}$");

export const createDosespotClinicianResponse = zod
  .object({
    id: zod.uuid(),
    user_id: zod.uuid(),
    dosespot_clinician_id: zod.string(),
    current_dosespot_info: zod
      .object({
        FirstName: zod.string(),
        LastName: zod.string(),
        DateOfBirth: zod.string(),
        Address1: zod.string(),
        City: zod.string(),
        State: zod.string(),
        ZipCode: zod.string(),
        PrimaryPhone: zod.string(),
        PrimaryFax: zod.string(),
        ClinicianId: zod.union([zod.number(), zod.null()]).optional(),
        Prefix: zod.union([zod.string(), zod.null()]).optional(),
        MiddleName: zod.union([zod.string(), zod.null()]).optional(),
        Suffix: zod.union([zod.string(), zod.null()]).optional(),
        Email: zod.union([zod.string(), zod.null()]).optional(),
        Address2: zod.union([zod.string(), zod.null()]).optional(),
        PrimaryPhoneType: zod
          .union([
            zod.enum([
              "Undefined",
              "Beeper",
              "Cell",
              "Fax",
              "Home",
              "Work",
              "Night",
              "Primary",
            ]),
            zod.null(),
          ])
          .optional(),
        PhoneAdditional1: zod.union([zod.string(), zod.null()]).optional(),
        PhoneAdditionalType1: zod
          .union([
            zod.enum([
              "Undefined",
              "Beeper",
              "Cell",
              "Fax",
              "Home",
              "Work",
              "Night",
              "Primary",
            ]),
            zod.null(),
          ])
          .optional(),
        PhoneAdditional2: zod.union([zod.string(), zod.null()]).optional(),
        PhoneAdditionalType2: zod
          .union([
            zod.enum([
              "Undefined",
              "Beeper",
              "Cell",
              "Fax",
              "Home",
              "Work",
              "Night",
              "Primary",
            ]),
            zod.null(),
          ])
          .optional(),
        PhoneAdditional3: zod.union([zod.string(), zod.null()]).optional(),
        PhoneAdditionalType3: zod
          .union([
            zod.enum([
              "Undefined",
              "Beeper",
              "Cell",
              "Fax",
              "Home",
              "Work",
              "Night",
              "Primary",
            ]),
            zod.null(),
          ])
          .optional(),
        DEANumbers: zod
          .union([
            zod.array(
              zod.object({
                DEANumber: zod.string(),
                State: zod.union([zod.string(), zod.null()]).optional(),
                ClinicId: zod.union([zod.string(), zod.null()]).optional(),
              }),
            ),
            zod.null(),
          ])
          .optional(),
        DEANumber: zod.union([zod.string(), zod.null()]).optional(),
        NADEANumbers: zod
          .union([
            zod.array(
              zod.object({
                NADEANumber: zod
                  .string()
                  .regex(
                    createDosespotClinicianResponseCurrentDosespotInfoNADEANumbersItemNADEANumberRegExp,
                  ),
                State: zod.union([zod.string(), zod.null()]).optional(),
                ClinicId: zod.union([zod.string(), zod.null()]).optional(),
              }),
            ),
            zod.null(),
          ])
          .optional(),
        MedicalLicenseNumbers: zod
          .union([
            zod.array(
              zod.object({
                LicenseNumber: zod.string(),
                State: zod.union([zod.string(), zod.null()]).optional(),
                ClinicId: zod.union([zod.string(), zod.null()]).optional(),
              }),
            ),
            zod.null(),
          ])
          .optional(),
        NPINumber: zod.union([zod.string(), zod.null()]).optional(),
        Roles: zod.union([zod.array(zod.string()), zod.null()]).optional(),
        PDMPRoleType: zod
          .union([
            zod.enum([
              "Physician",
              "Dentist",
              "NursePractioner",
              "PhysiciansAssistant",
              "Resident",
              "Intern",
              "Psychologist",
              "Optometrist",
              "NaturopathicPhysician",
            ]),
            zod.null(),
          ])
          .optional(),
        SpecialtyTypeId: zod.union([zod.number(), zod.null()]).optional(),
        Confirmed: zod.union([zod.boolean(), zod.null()]).optional(),
        Active: zod.union([zod.boolean(), zod.null()]).optional(),
        AccountLocked: zod.union([zod.boolean(), zod.null()]).optional(),
        EpcsRequested: zod.union([zod.boolean(), zod.null()]).optional(),
        ClinicInfo: zod
          .union([
            zod.array(
              zod
                .object({
                  ClinicId: zod.union([zod.number(), zod.null()]).optional(),
                  HasNewRx: zod.union([zod.boolean(), zod.null()]).optional(),
                  HasRefills: zod.union([zod.boolean(), zod.null()]).optional(),
                  HasRxChange: zod
                    .union([zod.boolean(), zod.null()])
                    .optional(),
                  HasCancel: zod.union([zod.boolean(), zod.null()]).optional(),
                  HasRxFill: zod.union([zod.boolean(), zod.null()]).optional(),
                  HasEpcs: zod.union([zod.boolean(), zod.null()]).optional(),
                  HasEpa: zod.union([zod.boolean(), zod.null()]).optional(),
                })
                .describe(
                  "Summary of e-prescribing capabilities for a clinician at a specific clinic.",
                ),
            ),
            zod.null(),
          ])
          .optional(),
      })
      .describe("Complete clinician information from DoseSpot API."),
    created_at: zod.iso.datetime({}),
    updated_at: zod.iso.datetime({}),
    mercury_recipient_id: zod.union([zod.string(), zod.null()]).optional(),
  })
  .describe("Record type for DoseSpot clinician information.");

/**
 * List all employee users who don't have DoseSpot clinician records.

This endpoint returns all users who have employee records but no associated
DoseSpot clinician records, useful for identifying who can be onboarded.

Raises:
    AuthException: If the user lacks required privileges
 * @summary List Users Without Dosespot Records
 */
export const listUsersWithoutDosespotRecordsResponseItem = zod
  .object({
    id: zod.uuid(),
    display_name: zod.union([zod.string(), zod.null()]).optional(),
    phone_number: zod.union([zod.string(), zod.null()]).optional(),
    email: zod.union([zod.string(), zod.null()]).optional(),
  })
  .describe("User information for users without DoseSpot records.");
export const listUsersWithoutDosespotRecordsResponse = zod.array(
  listUsersWithoutDosespotRecordsResponseItem,
);

/**
 * List all users who have DoseSpot clinician records.

This endpoint returns all existing DoseSpot clinician records,
useful for administrative oversight.

Raises:
    AuthException: If the user lacks required privileges
 * @summary List Users With Dosespot Records
 */
export const listUsersWithDosespotRecordsResponseCurrentDosespotInfoNADEANumbersItemNADEANumberRegExp =
  new RegExp("^[a-zA-Z0-9]{9}$");

export const listUsersWithDosespotRecordsResponseItem = zod
  .object({
    id: zod.uuid(),
    user_id: zod.uuid(),
    dosespot_clinician_id: zod.string(),
    current_dosespot_info: zod
      .object({
        FirstName: zod.string(),
        LastName: zod.string(),
        DateOfBirth: zod.string(),
        Address1: zod.string(),
        City: zod.string(),
        State: zod.string(),
        ZipCode: zod.string(),
        PrimaryPhone: zod.string(),
        PrimaryFax: zod.string(),
        ClinicianId: zod.union([zod.number(), zod.null()]).optional(),
        Prefix: zod.union([zod.string(), zod.null()]).optional(),
        MiddleName: zod.union([zod.string(), zod.null()]).optional(),
        Suffix: zod.union([zod.string(), zod.null()]).optional(),
        Email: zod.union([zod.string(), zod.null()]).optional(),
        Address2: zod.union([zod.string(), zod.null()]).optional(),
        PrimaryPhoneType: zod
          .union([
            zod.enum([
              "Undefined",
              "Beeper",
              "Cell",
              "Fax",
              "Home",
              "Work",
              "Night",
              "Primary",
            ]),
            zod.null(),
          ])
          .optional(),
        PhoneAdditional1: zod.union([zod.string(), zod.null()]).optional(),
        PhoneAdditionalType1: zod
          .union([
            zod.enum([
              "Undefined",
              "Beeper",
              "Cell",
              "Fax",
              "Home",
              "Work",
              "Night",
              "Primary",
            ]),
            zod.null(),
          ])
          .optional(),
        PhoneAdditional2: zod.union([zod.string(), zod.null()]).optional(),
        PhoneAdditionalType2: zod
          .union([
            zod.enum([
              "Undefined",
              "Beeper",
              "Cell",
              "Fax",
              "Home",
              "Work",
              "Night",
              "Primary",
            ]),
            zod.null(),
          ])
          .optional(),
        PhoneAdditional3: zod.union([zod.string(), zod.null()]).optional(),
        PhoneAdditionalType3: zod
          .union([
            zod.enum([
              "Undefined",
              "Beeper",
              "Cell",
              "Fax",
              "Home",
              "Work",
              "Night",
              "Primary",
            ]),
            zod.null(),
          ])
          .optional(),
        DEANumbers: zod
          .union([
            zod.array(
              zod.object({
                DEANumber: zod.string(),
                State: zod.union([zod.string(), zod.null()]).optional(),
                ClinicId: zod.union([zod.string(), zod.null()]).optional(),
              }),
            ),
            zod.null(),
          ])
          .optional(),
        DEANumber: zod.union([zod.string(), zod.null()]).optional(),
        NADEANumbers: zod
          .union([
            zod.array(
              zod.object({
                NADEANumber: zod
                  .string()
                  .regex(
                    listUsersWithDosespotRecordsResponseCurrentDosespotInfoNADEANumbersItemNADEANumberRegExp,
                  ),
                State: zod.union([zod.string(), zod.null()]).optional(),
                ClinicId: zod.union([zod.string(), zod.null()]).optional(),
              }),
            ),
            zod.null(),
          ])
          .optional(),
        MedicalLicenseNumbers: zod
          .union([
            zod.array(
              zod.object({
                LicenseNumber: zod.string(),
                State: zod.union([zod.string(), zod.null()]).optional(),
                ClinicId: zod.union([zod.string(), zod.null()]).optional(),
              }),
            ),
            zod.null(),
          ])
          .optional(),
        NPINumber: zod.union([zod.string(), zod.null()]).optional(),
        Roles: zod.union([zod.array(zod.string()), zod.null()]).optional(),
        PDMPRoleType: zod
          .union([
            zod.enum([
              "Physician",
              "Dentist",
              "NursePractioner",
              "PhysiciansAssistant",
              "Resident",
              "Intern",
              "Psychologist",
              "Optometrist",
              "NaturopathicPhysician",
            ]),
            zod.null(),
          ])
          .optional(),
        SpecialtyTypeId: zod.union([zod.number(), zod.null()]).optional(),
        Confirmed: zod.union([zod.boolean(), zod.null()]).optional(),
        Active: zod.union([zod.boolean(), zod.null()]).optional(),
        AccountLocked: zod.union([zod.boolean(), zod.null()]).optional(),
        EpcsRequested: zod.union([zod.boolean(), zod.null()]).optional(),
        ClinicInfo: zod
          .union([
            zod.array(
              zod
                .object({
                  ClinicId: zod.union([zod.number(), zod.null()]).optional(),
                  HasNewRx: zod.union([zod.boolean(), zod.null()]).optional(),
                  HasRefills: zod.union([zod.boolean(), zod.null()]).optional(),
                  HasRxChange: zod
                    .union([zod.boolean(), zod.null()])
                    .optional(),
                  HasCancel: zod.union([zod.boolean(), zod.null()]).optional(),
                  HasRxFill: zod.union([zod.boolean(), zod.null()]).optional(),
                  HasEpcs: zod.union([zod.boolean(), zod.null()]).optional(),
                  HasEpa: zod.union([zod.boolean(), zod.null()]).optional(),
                })
                .describe(
                  "Summary of e-prescribing capabilities for a clinician at a specific clinic.",
                ),
            ),
            zod.null(),
          ])
          .optional(),
      })
      .describe("Complete clinician information from DoseSpot API."),
    created_at: zod.iso.datetime({}),
    updated_at: zod.iso.datetime({}),
    mercury_recipient_id: zod.union([zod.string(), zod.null()]).optional(),
  })
  .describe("Record type for DoseSpot clinician information.");
export const listUsersWithDosespotRecordsResponse = zod.array(
  listUsersWithDosespotRecordsResponseItem,
);

/**
 * Get current DoseSpot clinician information for a specific user.

This endpoint retrieves the stored clinician information for the specified user.

Args:
    user_id: The user ID to fetch clinician info for

Returns:
    Current DoseSpot clinician information, or None if no record exists

Raises:
    AuthException: If the user lacks required privileges
 * @summary Get Dosespot Clinician Info By User Id
 */
export const getDosespotClinicianInfoByUserIdParams = zod.object({
  user_id: zod.uuid(),
});

export const getDosespotClinicianInfoByUserIdResponseNADEANumbersItemNADEANumberRegExp =
  new RegExp("^[a-zA-Z0-9]{9}$");

export const getDosespotClinicianInfoByUserIdResponse = zod.union([
  zod
    .object({
      FirstName: zod.string(),
      LastName: zod.string(),
      DateOfBirth: zod.string(),
      Address1: zod.string(),
      City: zod.string(),
      State: zod.string(),
      ZipCode: zod.string(),
      PrimaryPhone: zod.string(),
      PrimaryFax: zod.string(),
      ClinicianId: zod.union([zod.number(), zod.null()]).optional(),
      Prefix: zod.union([zod.string(), zod.null()]).optional(),
      MiddleName: zod.union([zod.string(), zod.null()]).optional(),
      Suffix: zod.union([zod.string(), zod.null()]).optional(),
      Email: zod.union([zod.string(), zod.null()]).optional(),
      Address2: zod.union([zod.string(), zod.null()]).optional(),
      PrimaryPhoneType: zod
        .union([
          zod.enum([
            "Undefined",
            "Beeper",
            "Cell",
            "Fax",
            "Home",
            "Work",
            "Night",
            "Primary",
          ]),
          zod.null(),
        ])
        .optional(),
      PhoneAdditional1: zod.union([zod.string(), zod.null()]).optional(),
      PhoneAdditionalType1: zod
        .union([
          zod.enum([
            "Undefined",
            "Beeper",
            "Cell",
            "Fax",
            "Home",
            "Work",
            "Night",
            "Primary",
          ]),
          zod.null(),
        ])
        .optional(),
      PhoneAdditional2: zod.union([zod.string(), zod.null()]).optional(),
      PhoneAdditionalType2: zod
        .union([
          zod.enum([
            "Undefined",
            "Beeper",
            "Cell",
            "Fax",
            "Home",
            "Work",
            "Night",
            "Primary",
          ]),
          zod.null(),
        ])
        .optional(),
      PhoneAdditional3: zod.union([zod.string(), zod.null()]).optional(),
      PhoneAdditionalType3: zod
        .union([
          zod.enum([
            "Undefined",
            "Beeper",
            "Cell",
            "Fax",
            "Home",
            "Work",
            "Night",
            "Primary",
          ]),
          zod.null(),
        ])
        .optional(),
      DEANumbers: zod
        .union([
          zod.array(
            zod.object({
              DEANumber: zod.string(),
              State: zod.union([zod.string(), zod.null()]).optional(),
              ClinicId: zod.union([zod.string(), zod.null()]).optional(),
            }),
          ),
          zod.null(),
        ])
        .optional(),
      DEANumber: zod.union([zod.string(), zod.null()]).optional(),
      NADEANumbers: zod
        .union([
          zod.array(
            zod.object({
              NADEANumber: zod
                .string()
                .regex(
                  getDosespotClinicianInfoByUserIdResponseNADEANumbersItemNADEANumberRegExp,
                ),
              State: zod.union([zod.string(), zod.null()]).optional(),
              ClinicId: zod.union([zod.string(), zod.null()]).optional(),
            }),
          ),
          zod.null(),
        ])
        .optional(),
      MedicalLicenseNumbers: zod
        .union([
          zod.array(
            zod.object({
              LicenseNumber: zod.string(),
              State: zod.union([zod.string(), zod.null()]).optional(),
              ClinicId: zod.union([zod.string(), zod.null()]).optional(),
            }),
          ),
          zod.null(),
        ])
        .optional(),
      NPINumber: zod.union([zod.string(), zod.null()]).optional(),
      Roles: zod.union([zod.array(zod.string()), zod.null()]).optional(),
      PDMPRoleType: zod
        .union([
          zod.enum([
            "Physician",
            "Dentist",
            "NursePractioner",
            "PhysiciansAssistant",
            "Resident",
            "Intern",
            "Psychologist",
            "Optometrist",
            "NaturopathicPhysician",
          ]),
          zod.null(),
        ])
        .optional(),
      SpecialtyTypeId: zod.union([zod.number(), zod.null()]).optional(),
      Confirmed: zod.union([zod.boolean(), zod.null()]).optional(),
      Active: zod.union([zod.boolean(), zod.null()]).optional(),
      AccountLocked: zod.union([zod.boolean(), zod.null()]).optional(),
      EpcsRequested: zod.union([zod.boolean(), zod.null()]).optional(),
      ClinicInfo: zod
        .union([
          zod.array(
            zod
              .object({
                ClinicId: zod.union([zod.number(), zod.null()]).optional(),
                HasNewRx: zod.union([zod.boolean(), zod.null()]).optional(),
                HasRefills: zod.union([zod.boolean(), zod.null()]).optional(),
                HasRxChange: zod.union([zod.boolean(), zod.null()]).optional(),
                HasCancel: zod.union([zod.boolean(), zod.null()]).optional(),
                HasRxFill: zod.union([zod.boolean(), zod.null()]).optional(),
                HasEpcs: zod.union([zod.boolean(), zod.null()]).optional(),
                HasEpa: zod.union([zod.boolean(), zod.null()]).optional(),
              })
              .describe(
                "Summary of e-prescribing capabilities for a clinician at a specific clinic.",
              ),
          ),
          zod.null(),
        ])
        .optional(),
    })
    .describe("Complete clinician information from DoseSpot API."),
  zod.null(),
]);

/**
 * Get current DoseSpot clinician information for the authenticated user.

This endpoint retrieves the stored clinician information for the authenticated user.

Returns:
    Current DoseSpot clinician information, or None if no record exists

Raises:
    AuthException: If the user lacks required privileges
 * @summary Get My Dosespot Clinician Info
 */
export const getMyDosespotClinicianInfoResponseNADEANumbersItemNADEANumberRegExp =
  new RegExp("^[a-zA-Z0-9]{9}$");

export const getMyDosespotClinicianInfoResponse = zod.union([
  zod
    .object({
      FirstName: zod.string(),
      LastName: zod.string(),
      DateOfBirth: zod.string(),
      Address1: zod.string(),
      City: zod.string(),
      State: zod.string(),
      ZipCode: zod.string(),
      PrimaryPhone: zod.string(),
      PrimaryFax: zod.string(),
      ClinicianId: zod.union([zod.number(), zod.null()]).optional(),
      Prefix: zod.union([zod.string(), zod.null()]).optional(),
      MiddleName: zod.union([zod.string(), zod.null()]).optional(),
      Suffix: zod.union([zod.string(), zod.null()]).optional(),
      Email: zod.union([zod.string(), zod.null()]).optional(),
      Address2: zod.union([zod.string(), zod.null()]).optional(),
      PrimaryPhoneType: zod
        .union([
          zod.enum([
            "Undefined",
            "Beeper",
            "Cell",
            "Fax",
            "Home",
            "Work",
            "Night",
            "Primary",
          ]),
          zod.null(),
        ])
        .optional(),
      PhoneAdditional1: zod.union([zod.string(), zod.null()]).optional(),
      PhoneAdditionalType1: zod
        .union([
          zod.enum([
            "Undefined",
            "Beeper",
            "Cell",
            "Fax",
            "Home",
            "Work",
            "Night",
            "Primary",
          ]),
          zod.null(),
        ])
        .optional(),
      PhoneAdditional2: zod.union([zod.string(), zod.null()]).optional(),
      PhoneAdditionalType2: zod
        .union([
          zod.enum([
            "Undefined",
            "Beeper",
            "Cell",
            "Fax",
            "Home",
            "Work",
            "Night",
            "Primary",
          ]),
          zod.null(),
        ])
        .optional(),
      PhoneAdditional3: zod.union([zod.string(), zod.null()]).optional(),
      PhoneAdditionalType3: zod
        .union([
          zod.enum([
            "Undefined",
            "Beeper",
            "Cell",
            "Fax",
            "Home",
            "Work",
            "Night",
            "Primary",
          ]),
          zod.null(),
        ])
        .optional(),
      DEANumbers: zod
        .union([
          zod.array(
            zod.object({
              DEANumber: zod.string(),
              State: zod.union([zod.string(), zod.null()]).optional(),
              ClinicId: zod.union([zod.string(), zod.null()]).optional(),
            }),
          ),
          zod.null(),
        ])
        .optional(),
      DEANumber: zod.union([zod.string(), zod.null()]).optional(),
      NADEANumbers: zod
        .union([
          zod.array(
            zod.object({
              NADEANumber: zod
                .string()
                .regex(
                  getMyDosespotClinicianInfoResponseNADEANumbersItemNADEANumberRegExp,
                ),
              State: zod.union([zod.string(), zod.null()]).optional(),
              ClinicId: zod.union([zod.string(), zod.null()]).optional(),
            }),
          ),
          zod.null(),
        ])
        .optional(),
      MedicalLicenseNumbers: zod
        .union([
          zod.array(
            zod.object({
              LicenseNumber: zod.string(),
              State: zod.union([zod.string(), zod.null()]).optional(),
              ClinicId: zod.union([zod.string(), zod.null()]).optional(),
            }),
          ),
          zod.null(),
        ])
        .optional(),
      NPINumber: zod.union([zod.string(), zod.null()]).optional(),
      Roles: zod.union([zod.array(zod.string()), zod.null()]).optional(),
      PDMPRoleType: zod
        .union([
          zod.enum([
            "Physician",
            "Dentist",
            "NursePractioner",
            "PhysiciansAssistant",
            "Resident",
            "Intern",
            "Psychologist",
            "Optometrist",
            "NaturopathicPhysician",
          ]),
          zod.null(),
        ])
        .optional(),
      SpecialtyTypeId: zod.union([zod.number(), zod.null()]).optional(),
      Confirmed: zod.union([zod.boolean(), zod.null()]).optional(),
      Active: zod.union([zod.boolean(), zod.null()]).optional(),
      AccountLocked: zod.union([zod.boolean(), zod.null()]).optional(),
      EpcsRequested: zod.union([zod.boolean(), zod.null()]).optional(),
      ClinicInfo: zod
        .union([
          zod.array(
            zod
              .object({
                ClinicId: zod.union([zod.number(), zod.null()]).optional(),
                HasNewRx: zod.union([zod.boolean(), zod.null()]).optional(),
                HasRefills: zod.union([zod.boolean(), zod.null()]).optional(),
                HasRxChange: zod.union([zod.boolean(), zod.null()]).optional(),
                HasCancel: zod.union([zod.boolean(), zod.null()]).optional(),
                HasRxFill: zod.union([zod.boolean(), zod.null()]).optional(),
                HasEpcs: zod.union([zod.boolean(), zod.null()]).optional(),
                HasEpa: zod.union([zod.boolean(), zod.null()]).optional(),
              })
              .describe(
                "Summary of e-prescribing capabilities for a clinician at a specific clinic.",
              ),
          ),
          zod.null(),
        ])
        .optional(),
    })
    .describe("Complete clinician information from DoseSpot API."),
  zod.null(),
]);

/**
 * Update an existing DoseSpot clinician record.

This endpoint updates the DoseSpot clinician information for the specified user.

Args:
    user_id: The user ID of the clinician to update
    request: The updated clinician information

Returns:
    The updated DoseSpot clinician record

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no clinician record exists for the user
 * @summary Update Dosespot Clinician
 */
export const updateDosespotClinicianParams = zod.object({
  user_id: zod.uuid(),
});

export const updateDosespotClinicianBodyClinicianInfoNADEANumbersItemNADEANumberRegExp =
  new RegExp("^[a-zA-Z0-9]{9}$");

export const updateDosespotClinicianBody = zod.object({
  clinicianInfo: zod.object({
    FirstName: zod.string(),
    LastName: zod.string(),
    DateOfBirth: zod.string(),
    Address1: zod.string(),
    City: zod.string(),
    State: zod.string(),
    ZipCode: zod.string(),
    PrimaryPhone: zod.string(),
    PrimaryFax: zod.string(),
    ClinicianRoleType: zod.array(
      zod
        .enum(["1", "2", "3", "4", "5", "6"])
        .describe("Valid clinician role types for DoseSpot."),
    ),
    NPINumber: zod.string(),
    Prefix: zod.union([zod.string(), zod.null()]).optional(),
    MiddleName: zod.union([zod.string(), zod.null()]).optional(),
    Suffix: zod.union([zod.string(), zod.null()]).optional(),
    Email: zod.union([zod.string(), zod.null()]).optional(),
    Address2: zod.union([zod.string(), zod.null()]).optional(),
    PrimaryPhoneType: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PhoneAdditional1: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType1: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PhoneAdditional2: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType2: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PhoneAdditional3: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType3: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    DEANumber: zod.union([zod.string(), zod.null()]).optional(),
    DEANumbers: zod
      .union([
        zod.array(
          zod.object({
            DEANumber: zod.string(),
            State: zod.union([zod.string(), zod.null()]).optional(),
            ClinicId: zod.union([zod.string(), zod.null()]).optional(),
          }),
        ),
        zod.null(),
      ])
      .optional(),
    NADEANumbers: zod
      .union([
        zod.array(
          zod.object({
            NADEANumber: zod
              .string()
              .regex(
                updateDosespotClinicianBodyClinicianInfoNADEANumbersItemNADEANumberRegExp,
              ),
            State: zod.union([zod.string(), zod.null()]).optional(),
            ClinicId: zod.union([zod.string(), zod.null()]).optional(),
          }),
        ),
        zod.null(),
      ])
      .optional(),
    MedicalLicenseNumbers: zod
      .union([
        zod.array(
          zod.object({
            LicenseNumber: zod.string(),
            State: zod.union([zod.string(), zod.null()]).optional(),
            ClinicId: zod.union([zod.string(), zod.null()]).optional(),
          }),
        ),
        zod.null(),
      ])
      .optional(),
    EPCSRequested: zod.union([zod.boolean(), zod.null()]).optional(),
    Active: zod.union([zod.boolean(), zod.null()]).optional(),
    PDMPRoleType: zod
      .union([
        zod.enum([
          "Physician",
          "Dentist",
          "NursePractioner",
          "PhysiciansAssistant",
          "Resident",
          "Intern",
          "Psychologist",
          "Optometrist",
          "NaturopathicPhysician",
        ]),
        zod.null(),
      ])
      .optional(),
    ClinicianSpecialtyType: zod
      .union([
        zod.enum([
          "AllergyAndImmunology",
          "Dermatology",
          "Dentistry",
          "BehavioralHealth",
          "FamilyMedicine",
          "InternalMedicine",
          "ObstetricsAndGynecology",
          "Orthopedics",
          "Pediatrics",
          "PhysicalMedicine",
          "Psychiatry",
          "Urology",
        ]),
        zod.null(),
      ])
      .optional(),
  }),
});

export const updateDosespotClinicianResponseCurrentDosespotInfoNADEANumbersItemNADEANumberRegExp =
  new RegExp("^[a-zA-Z0-9]{9}$");

export const updateDosespotClinicianResponse = zod
  .object({
    id: zod.uuid(),
    user_id: zod.uuid(),
    dosespot_clinician_id: zod.string(),
    current_dosespot_info: zod
      .object({
        FirstName: zod.string(),
        LastName: zod.string(),
        DateOfBirth: zod.string(),
        Address1: zod.string(),
        City: zod.string(),
        State: zod.string(),
        ZipCode: zod.string(),
        PrimaryPhone: zod.string(),
        PrimaryFax: zod.string(),
        ClinicianId: zod.union([zod.number(), zod.null()]).optional(),
        Prefix: zod.union([zod.string(), zod.null()]).optional(),
        MiddleName: zod.union([zod.string(), zod.null()]).optional(),
        Suffix: zod.union([zod.string(), zod.null()]).optional(),
        Email: zod.union([zod.string(), zod.null()]).optional(),
        Address2: zod.union([zod.string(), zod.null()]).optional(),
        PrimaryPhoneType: zod
          .union([
            zod.enum([
              "Undefined",
              "Beeper",
              "Cell",
              "Fax",
              "Home",
              "Work",
              "Night",
              "Primary",
            ]),
            zod.null(),
          ])
          .optional(),
        PhoneAdditional1: zod.union([zod.string(), zod.null()]).optional(),
        PhoneAdditionalType1: zod
          .union([
            zod.enum([
              "Undefined",
              "Beeper",
              "Cell",
              "Fax",
              "Home",
              "Work",
              "Night",
              "Primary",
            ]),
            zod.null(),
          ])
          .optional(),
        PhoneAdditional2: zod.union([zod.string(), zod.null()]).optional(),
        PhoneAdditionalType2: zod
          .union([
            zod.enum([
              "Undefined",
              "Beeper",
              "Cell",
              "Fax",
              "Home",
              "Work",
              "Night",
              "Primary",
            ]),
            zod.null(),
          ])
          .optional(),
        PhoneAdditional3: zod.union([zod.string(), zod.null()]).optional(),
        PhoneAdditionalType3: zod
          .union([
            zod.enum([
              "Undefined",
              "Beeper",
              "Cell",
              "Fax",
              "Home",
              "Work",
              "Night",
              "Primary",
            ]),
            zod.null(),
          ])
          .optional(),
        DEANumbers: zod
          .union([
            zod.array(
              zod.object({
                DEANumber: zod.string(),
                State: zod.union([zod.string(), zod.null()]).optional(),
                ClinicId: zod.union([zod.string(), zod.null()]).optional(),
              }),
            ),
            zod.null(),
          ])
          .optional(),
        DEANumber: zod.union([zod.string(), zod.null()]).optional(),
        NADEANumbers: zod
          .union([
            zod.array(
              zod.object({
                NADEANumber: zod
                  .string()
                  .regex(
                    updateDosespotClinicianResponseCurrentDosespotInfoNADEANumbersItemNADEANumberRegExp,
                  ),
                State: zod.union([zod.string(), zod.null()]).optional(),
                ClinicId: zod.union([zod.string(), zod.null()]).optional(),
              }),
            ),
            zod.null(),
          ])
          .optional(),
        MedicalLicenseNumbers: zod
          .union([
            zod.array(
              zod.object({
                LicenseNumber: zod.string(),
                State: zod.union([zod.string(), zod.null()]).optional(),
                ClinicId: zod.union([zod.string(), zod.null()]).optional(),
              }),
            ),
            zod.null(),
          ])
          .optional(),
        NPINumber: zod.union([zod.string(), zod.null()]).optional(),
        Roles: zod.union([zod.array(zod.string()), zod.null()]).optional(),
        PDMPRoleType: zod
          .union([
            zod.enum([
              "Physician",
              "Dentist",
              "NursePractioner",
              "PhysiciansAssistant",
              "Resident",
              "Intern",
              "Psychologist",
              "Optometrist",
              "NaturopathicPhysician",
            ]),
            zod.null(),
          ])
          .optional(),
        SpecialtyTypeId: zod.union([zod.number(), zod.null()]).optional(),
        Confirmed: zod.union([zod.boolean(), zod.null()]).optional(),
        Active: zod.union([zod.boolean(), zod.null()]).optional(),
        AccountLocked: zod.union([zod.boolean(), zod.null()]).optional(),
        EpcsRequested: zod.union([zod.boolean(), zod.null()]).optional(),
        ClinicInfo: zod
          .union([
            zod.array(
              zod
                .object({
                  ClinicId: zod.union([zod.number(), zod.null()]).optional(),
                  HasNewRx: zod.union([zod.boolean(), zod.null()]).optional(),
                  HasRefills: zod.union([zod.boolean(), zod.null()]).optional(),
                  HasRxChange: zod
                    .union([zod.boolean(), zod.null()])
                    .optional(),
                  HasCancel: zod.union([zod.boolean(), zod.null()]).optional(),
                  HasRxFill: zod.union([zod.boolean(), zod.null()]).optional(),
                  HasEpcs: zod.union([zod.boolean(), zod.null()]).optional(),
                  HasEpa: zod.union([zod.boolean(), zod.null()]).optional(),
                })
                .describe(
                  "Summary of e-prescribing capabilities for a clinician at a specific clinic.",
                ),
            ),
            zod.null(),
          ])
          .optional(),
      })
      .describe("Complete clinician information from DoseSpot API."),
    created_at: zod.iso.datetime({}),
    updated_at: zod.iso.datetime({}),
    mercury_recipient_id: zod.union([zod.string(), zod.null()]).optional(),
  })
  .describe("Record type for DoseSpot clinician information.");

/**
 * Update the authenticated user's DoseSpot clinician record.

This endpoint updates the DoseSpot clinician information for the authenticated user.

Args:
    request: The updated clinician information

Returns:
    The updated DoseSpot clinician record

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no clinician record exists for the authenticated user
 * @summary Update My Dosespot Clinician
 */
export const updateMyDosespotClinicianBodyClinicianInfoNADEANumbersItemNADEANumberRegExp =
  new RegExp("^[a-zA-Z0-9]{9}$");

export const updateMyDosespotClinicianBody = zod.object({
  clinicianInfo: zod.object({
    FirstName: zod.string(),
    LastName: zod.string(),
    DateOfBirth: zod.string(),
    Address1: zod.string(),
    City: zod.string(),
    State: zod.string(),
    ZipCode: zod.string(),
    PrimaryPhone: zod.string(),
    PrimaryFax: zod.string(),
    ClinicianRoleType: zod.array(
      zod
        .enum(["1", "2", "3", "4", "5", "6"])
        .describe("Valid clinician role types for DoseSpot."),
    ),
    NPINumber: zod.string(),
    Prefix: zod.union([zod.string(), zod.null()]).optional(),
    MiddleName: zod.union([zod.string(), zod.null()]).optional(),
    Suffix: zod.union([zod.string(), zod.null()]).optional(),
    Email: zod.union([zod.string(), zod.null()]).optional(),
    Address2: zod.union([zod.string(), zod.null()]).optional(),
    PrimaryPhoneType: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PhoneAdditional1: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType1: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PhoneAdditional2: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType2: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PhoneAdditional3: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType3: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    DEANumber: zod.union([zod.string(), zod.null()]).optional(),
    DEANumbers: zod
      .union([
        zod.array(
          zod.object({
            DEANumber: zod.string(),
            State: zod.union([zod.string(), zod.null()]).optional(),
            ClinicId: zod.union([zod.string(), zod.null()]).optional(),
          }),
        ),
        zod.null(),
      ])
      .optional(),
    NADEANumbers: zod
      .union([
        zod.array(
          zod.object({
            NADEANumber: zod
              .string()
              .regex(
                updateMyDosespotClinicianBodyClinicianInfoNADEANumbersItemNADEANumberRegExp,
              ),
            State: zod.union([zod.string(), zod.null()]).optional(),
            ClinicId: zod.union([zod.string(), zod.null()]).optional(),
          }),
        ),
        zod.null(),
      ])
      .optional(),
    MedicalLicenseNumbers: zod
      .union([
        zod.array(
          zod.object({
            LicenseNumber: zod.string(),
            State: zod.union([zod.string(), zod.null()]).optional(),
            ClinicId: zod.union([zod.string(), zod.null()]).optional(),
          }),
        ),
        zod.null(),
      ])
      .optional(),
    EPCSRequested: zod.union([zod.boolean(), zod.null()]).optional(),
    Active: zod.union([zod.boolean(), zod.null()]).optional(),
    PDMPRoleType: zod
      .union([
        zod.enum([
          "Physician",
          "Dentist",
          "NursePractioner",
          "PhysiciansAssistant",
          "Resident",
          "Intern",
          "Psychologist",
          "Optometrist",
          "NaturopathicPhysician",
        ]),
        zod.null(),
      ])
      .optional(),
    ClinicianSpecialtyType: zod
      .union([
        zod.enum([
          "AllergyAndImmunology",
          "Dermatology",
          "Dentistry",
          "BehavioralHealth",
          "FamilyMedicine",
          "InternalMedicine",
          "ObstetricsAndGynecology",
          "Orthopedics",
          "Pediatrics",
          "PhysicalMedicine",
          "Psychiatry",
          "Urology",
        ]),
        zod.null(),
      ])
      .optional(),
  }),
});

export const updateMyDosespotClinicianResponseCurrentDosespotInfoNADEANumbersItemNADEANumberRegExp =
  new RegExp("^[a-zA-Z0-9]{9}$");

export const updateMyDosespotClinicianResponse = zod
  .object({
    id: zod.uuid(),
    user_id: zod.uuid(),
    dosespot_clinician_id: zod.string(),
    current_dosespot_info: zod
      .object({
        FirstName: zod.string(),
        LastName: zod.string(),
        DateOfBirth: zod.string(),
        Address1: zod.string(),
        City: zod.string(),
        State: zod.string(),
        ZipCode: zod.string(),
        PrimaryPhone: zod.string(),
        PrimaryFax: zod.string(),
        ClinicianId: zod.union([zod.number(), zod.null()]).optional(),
        Prefix: zod.union([zod.string(), zod.null()]).optional(),
        MiddleName: zod.union([zod.string(), zod.null()]).optional(),
        Suffix: zod.union([zod.string(), zod.null()]).optional(),
        Email: zod.union([zod.string(), zod.null()]).optional(),
        Address2: zod.union([zod.string(), zod.null()]).optional(),
        PrimaryPhoneType: zod
          .union([
            zod.enum([
              "Undefined",
              "Beeper",
              "Cell",
              "Fax",
              "Home",
              "Work",
              "Night",
              "Primary",
            ]),
            zod.null(),
          ])
          .optional(),
        PhoneAdditional1: zod.union([zod.string(), zod.null()]).optional(),
        PhoneAdditionalType1: zod
          .union([
            zod.enum([
              "Undefined",
              "Beeper",
              "Cell",
              "Fax",
              "Home",
              "Work",
              "Night",
              "Primary",
            ]),
            zod.null(),
          ])
          .optional(),
        PhoneAdditional2: zod.union([zod.string(), zod.null()]).optional(),
        PhoneAdditionalType2: zod
          .union([
            zod.enum([
              "Undefined",
              "Beeper",
              "Cell",
              "Fax",
              "Home",
              "Work",
              "Night",
              "Primary",
            ]),
            zod.null(),
          ])
          .optional(),
        PhoneAdditional3: zod.union([zod.string(), zod.null()]).optional(),
        PhoneAdditionalType3: zod
          .union([
            zod.enum([
              "Undefined",
              "Beeper",
              "Cell",
              "Fax",
              "Home",
              "Work",
              "Night",
              "Primary",
            ]),
            zod.null(),
          ])
          .optional(),
        DEANumbers: zod
          .union([
            zod.array(
              zod.object({
                DEANumber: zod.string(),
                State: zod.union([zod.string(), zod.null()]).optional(),
                ClinicId: zod.union([zod.string(), zod.null()]).optional(),
              }),
            ),
            zod.null(),
          ])
          .optional(),
        DEANumber: zod.union([zod.string(), zod.null()]).optional(),
        NADEANumbers: zod
          .union([
            zod.array(
              zod.object({
                NADEANumber: zod
                  .string()
                  .regex(
                    updateMyDosespotClinicianResponseCurrentDosespotInfoNADEANumbersItemNADEANumberRegExp,
                  ),
                State: zod.union([zod.string(), zod.null()]).optional(),
                ClinicId: zod.union([zod.string(), zod.null()]).optional(),
              }),
            ),
            zod.null(),
          ])
          .optional(),
        MedicalLicenseNumbers: zod
          .union([
            zod.array(
              zod.object({
                LicenseNumber: zod.string(),
                State: zod.union([zod.string(), zod.null()]).optional(),
                ClinicId: zod.union([zod.string(), zod.null()]).optional(),
              }),
            ),
            zod.null(),
          ])
          .optional(),
        NPINumber: zod.union([zod.string(), zod.null()]).optional(),
        Roles: zod.union([zod.array(zod.string()), zod.null()]).optional(),
        PDMPRoleType: zod
          .union([
            zod.enum([
              "Physician",
              "Dentist",
              "NursePractioner",
              "PhysiciansAssistant",
              "Resident",
              "Intern",
              "Psychologist",
              "Optometrist",
              "NaturopathicPhysician",
            ]),
            zod.null(),
          ])
          .optional(),
        SpecialtyTypeId: zod.union([zod.number(), zod.null()]).optional(),
        Confirmed: zod.union([zod.boolean(), zod.null()]).optional(),
        Active: zod.union([zod.boolean(), zod.null()]).optional(),
        AccountLocked: zod.union([zod.boolean(), zod.null()]).optional(),
        EpcsRequested: zod.union([zod.boolean(), zod.null()]).optional(),
        ClinicInfo: zod
          .union([
            zod.array(
              zod
                .object({
                  ClinicId: zod.union([zod.number(), zod.null()]).optional(),
                  HasNewRx: zod.union([zod.boolean(), zod.null()]).optional(),
                  HasRefills: zod.union([zod.boolean(), zod.null()]).optional(),
                  HasRxChange: zod
                    .union([zod.boolean(), zod.null()])
                    .optional(),
                  HasCancel: zod.union([zod.boolean(), zod.null()]).optional(),
                  HasRxFill: zod.union([zod.boolean(), zod.null()]).optional(),
                  HasEpcs: zod.union([zod.boolean(), zod.null()]).optional(),
                  HasEpa: zod.union([zod.boolean(), zod.null()]).optional(),
                })
                .describe(
                  "Summary of e-prescribing capabilities for a clinician at a specific clinic.",
                ),
            ),
            zod.null(),
          ])
          .optional(),
      })
      .describe("Complete clinician information from DoseSpot API."),
    created_at: zod.iso.datetime({}),
    updated_at: zod.iso.datetime({}),
    mercury_recipient_id: zod.union([zod.string(), zod.null()]).optional(),
  })
  .describe("Record type for DoseSpot clinician information.");

/**
 * Get registration status for the authenticated user.

Returns:
    ErxRegistrationStatusTypeT: The current registration status

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record
 * @summary Get My Registration Status
 */
export const getMyRegistrationStatusResponse = zod.enum([
  "Pending",
  "RegistrationSuccess",
  "RegistrationError",
  "IDPSuccess",
  "IDPError",
  "TFAActivateInit",
  "TFAActivatedSuccess",
  "TFAActivatedError",
  "TFADeactivateInit",
  "TFADeactivatedSuccess",
  "TFADeactivatedError",
  "IDPInitializeSuccess",
  "NotApplicable",
]);

/**
 * Get registration status for a specific user.

Args:
    user_id: The user ID to get registration status for

Returns:
    ErxRegistrationStatusTypeT: The current registration status

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record
 * @summary Get Registration Status By User Id
 */
export const getRegistrationStatusByUserIdParams = zod.object({
  user_id: zod.uuid(),
});

export const getRegistrationStatusByUserIdResponse = zod.enum([
  "Pending",
  "RegistrationSuccess",
  "RegistrationError",
  "IDPSuccess",
  "IDPError",
  "TFAActivateInit",
  "TFAActivatedSuccess",
  "TFAActivatedError",
  "TFADeactivateInit",
  "TFADeactivatedSuccess",
  "TFADeactivatedError",
  "IDPInitializeSuccess",
  "NotApplicable",
]);

/**
 * Refresh the authenticated user's DoseSpot clinician information from the API.

This endpoint fetches the latest clinician information from DoseSpot API
and updates the stored record with the current data for the authenticated user.

Returns:
    The updated DoseSpot clinician information

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no clinician record exists for the authenticated user
 * @summary Refresh My Dosespot Clinician Info
 */
export const refreshMyDosespotClinicianInfoResponseNADEANumbersItemNADEANumberRegExp =
  new RegExp("^[a-zA-Z0-9]{9}$");

export const refreshMyDosespotClinicianInfoResponse = zod
  .object({
    FirstName: zod.string(),
    LastName: zod.string(),
    DateOfBirth: zod.string(),
    Address1: zod.string(),
    City: zod.string(),
    State: zod.string(),
    ZipCode: zod.string(),
    PrimaryPhone: zod.string(),
    PrimaryFax: zod.string(),
    ClinicianId: zod.union([zod.number(), zod.null()]).optional(),
    Prefix: zod.union([zod.string(), zod.null()]).optional(),
    MiddleName: zod.union([zod.string(), zod.null()]).optional(),
    Suffix: zod.union([zod.string(), zod.null()]).optional(),
    Email: zod.union([zod.string(), zod.null()]).optional(),
    Address2: zod.union([zod.string(), zod.null()]).optional(),
    PrimaryPhoneType: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PhoneAdditional1: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType1: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PhoneAdditional2: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType2: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PhoneAdditional3: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType3: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    DEANumbers: zod
      .union([
        zod.array(
          zod.object({
            DEANumber: zod.string(),
            State: zod.union([zod.string(), zod.null()]).optional(),
            ClinicId: zod.union([zod.string(), zod.null()]).optional(),
          }),
        ),
        zod.null(),
      ])
      .optional(),
    DEANumber: zod.union([zod.string(), zod.null()]).optional(),
    NADEANumbers: zod
      .union([
        zod.array(
          zod.object({
            NADEANumber: zod
              .string()
              .regex(
                refreshMyDosespotClinicianInfoResponseNADEANumbersItemNADEANumberRegExp,
              ),
            State: zod.union([zod.string(), zod.null()]).optional(),
            ClinicId: zod.union([zod.string(), zod.null()]).optional(),
          }),
        ),
        zod.null(),
      ])
      .optional(),
    MedicalLicenseNumbers: zod
      .union([
        zod.array(
          zod.object({
            LicenseNumber: zod.string(),
            State: zod.union([zod.string(), zod.null()]).optional(),
            ClinicId: zod.union([zod.string(), zod.null()]).optional(),
          }),
        ),
        zod.null(),
      ])
      .optional(),
    NPINumber: zod.union([zod.string(), zod.null()]).optional(),
    Roles: zod.union([zod.array(zod.string()), zod.null()]).optional(),
    PDMPRoleType: zod
      .union([
        zod.enum([
          "Physician",
          "Dentist",
          "NursePractioner",
          "PhysiciansAssistant",
          "Resident",
          "Intern",
          "Psychologist",
          "Optometrist",
          "NaturopathicPhysician",
        ]),
        zod.null(),
      ])
      .optional(),
    SpecialtyTypeId: zod.union([zod.number(), zod.null()]).optional(),
    Confirmed: zod.union([zod.boolean(), zod.null()]).optional(),
    Active: zod.union([zod.boolean(), zod.null()]).optional(),
    AccountLocked: zod.union([zod.boolean(), zod.null()]).optional(),
    EpcsRequested: zod.union([zod.boolean(), zod.null()]).optional(),
    ClinicInfo: zod
      .union([
        zod.array(
          zod
            .object({
              ClinicId: zod.union([zod.number(), zod.null()]).optional(),
              HasNewRx: zod.union([zod.boolean(), zod.null()]).optional(),
              HasRefills: zod.union([zod.boolean(), zod.null()]).optional(),
              HasRxChange: zod.union([zod.boolean(), zod.null()]).optional(),
              HasCancel: zod.union([zod.boolean(), zod.null()]).optional(),
              HasRxFill: zod.union([zod.boolean(), zod.null()]).optional(),
              HasEpcs: zod.union([zod.boolean(), zod.null()]).optional(),
              HasEpa: zod.union([zod.boolean(), zod.null()]).optional(),
            })
            .describe(
              "Summary of e-prescribing capabilities for a clinician at a specific clinic.",
            ),
        ),
        zod.null(),
      ])
      .optional(),
  })
  .describe("Complete clinician information from DoseSpot API.");

/**
 * Refresh DoseSpot clinician information from the API.

This endpoint fetches the latest clinician information from DoseSpot API
and updates the stored record with the current data.

Args:
    user_id: The user ID of the clinician to refresh

Returns:
    The updated DoseSpot clinician information

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no clinician record exists for the user
 * @summary Refresh Dosespot Clinician Info
 */
export const refreshDosespotClinicianInfoParams = zod.object({
  user_id: zod.uuid(),
});

export const refreshDosespotClinicianInfoResponseNADEANumbersItemNADEANumberRegExp =
  new RegExp("^[a-zA-Z0-9]{9}$");

export const refreshDosespotClinicianInfoResponse = zod
  .object({
    FirstName: zod.string(),
    LastName: zod.string(),
    DateOfBirth: zod.string(),
    Address1: zod.string(),
    City: zod.string(),
    State: zod.string(),
    ZipCode: zod.string(),
    PrimaryPhone: zod.string(),
    PrimaryFax: zod.string(),
    ClinicianId: zod.union([zod.number(), zod.null()]).optional(),
    Prefix: zod.union([zod.string(), zod.null()]).optional(),
    MiddleName: zod.union([zod.string(), zod.null()]).optional(),
    Suffix: zod.union([zod.string(), zod.null()]).optional(),
    Email: zod.union([zod.string(), zod.null()]).optional(),
    Address2: zod.union([zod.string(), zod.null()]).optional(),
    PrimaryPhoneType: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PhoneAdditional1: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType1: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PhoneAdditional2: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType2: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PhoneAdditional3: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType3: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    DEANumbers: zod
      .union([
        zod.array(
          zod.object({
            DEANumber: zod.string(),
            State: zod.union([zod.string(), zod.null()]).optional(),
            ClinicId: zod.union([zod.string(), zod.null()]).optional(),
          }),
        ),
        zod.null(),
      ])
      .optional(),
    DEANumber: zod.union([zod.string(), zod.null()]).optional(),
    NADEANumbers: zod
      .union([
        zod.array(
          zod.object({
            NADEANumber: zod
              .string()
              .regex(
                refreshDosespotClinicianInfoResponseNADEANumbersItemNADEANumberRegExp,
              ),
            State: zod.union([zod.string(), zod.null()]).optional(),
            ClinicId: zod.union([zod.string(), zod.null()]).optional(),
          }),
        ),
        zod.null(),
      ])
      .optional(),
    MedicalLicenseNumbers: zod
      .union([
        zod.array(
          zod.object({
            LicenseNumber: zod.string(),
            State: zod.union([zod.string(), zod.null()]).optional(),
            ClinicId: zod.union([zod.string(), zod.null()]).optional(),
          }),
        ),
        zod.null(),
      ])
      .optional(),
    NPINumber: zod.union([zod.string(), zod.null()]).optional(),
    Roles: zod.union([zod.array(zod.string()), zod.null()]).optional(),
    PDMPRoleType: zod
      .union([
        zod.enum([
          "Physician",
          "Dentist",
          "NursePractioner",
          "PhysiciansAssistant",
          "Resident",
          "Intern",
          "Psychologist",
          "Optometrist",
          "NaturopathicPhysician",
        ]),
        zod.null(),
      ])
      .optional(),
    SpecialtyTypeId: zod.union([zod.number(), zod.null()]).optional(),
    Confirmed: zod.union([zod.boolean(), zod.null()]).optional(),
    Active: zod.union([zod.boolean(), zod.null()]).optional(),
    AccountLocked: zod.union([zod.boolean(), zod.null()]).optional(),
    EpcsRequested: zod.union([zod.boolean(), zod.null()]).optional(),
    ClinicInfo: zod
      .union([
        zod.array(
          zod
            .object({
              ClinicId: zod.union([zod.number(), zod.null()]).optional(),
              HasNewRx: zod.union([zod.boolean(), zod.null()]).optional(),
              HasRefills: zod.union([zod.boolean(), zod.null()]).optional(),
              HasRxChange: zod.union([zod.boolean(), zod.null()]).optional(),
              HasCancel: zod.union([zod.boolean(), zod.null()]).optional(),
              HasRxFill: zod.union([zod.boolean(), zod.null()]).optional(),
              HasEpcs: zod.union([zod.boolean(), zod.null()]).optional(),
              HasEpa: zod.union([zod.boolean(), zod.null()]).optional(),
            })
            .describe(
              "Summary of e-prescribing capabilities for a clinician at a specific clinic.",
            ),
        ),
        zod.null(),
      ])
      .optional(),
  })
  .describe("Complete clinician information from DoseSpot API.");

/**
 * Get IDP status for the authenticated user.

Returns:
    DosespotIDPRecordT: Current IDP record, or None if no IDP process started

Raises:
    AuthException: If the user lacks required privileges
 * @summary Get My Idp Status
 */
export const getMyIdpStatusResponse = zod.union([
  zod
    .object({
      id: zod.uuid(),
      user_id: zod.uuid(),
      current_state: zod
        .enum([
          "NEEDS_TO_SIGN_DISCLAIMER",
          "NEEDS_TO_SIGN_LEGAL_AGREEMENTS",
          "NEEDS_TO_SUBMIT_DEMOGRAPHIC_INFO",
          "NEEDS_TO_SUBMIT_ANSWERS",
          "NEEDS_TO_SUBMIT_OTP",
          "COMPLETED",
          "ERROR",
        ])
        .describe("IDP process states."),
      session_id: zod.union([zod.string(), zod.null()]).optional(),
      is_otp_sent: zod.union([zod.boolean(), zod.null()]).optional(),
      idp_questions_and_choices: zod
        .union([
          zod
            .object({
              questions: zod.array(zod.string()),
              answer_choices: zod.array(zod.array(zod.string())),
            })
            .describe(
              "Structured type for IDP questions and their answer choices.",
            ),
          zod.null(),
        ])
        .optional(),
      error_message: zod.union([zod.string(), zod.null()]).optional(),
      pending_legal_agreements: zod
        .union([
          zod
            .object({
              pending_agreements: zod.array(zod.number()),
            })
            .describe("Structured type for pending legal agreements."),
          zod.null(),
        ])
        .optional(),
      created_at: zod.iso.datetime({}),
      updated_at: zod.iso.datetime({}),
    })
    .describe("Record type for DoseSpot IDP process tracking."),
  zod.null(),
]);

/**
 * Get the IDP disclaimer for the authenticated user.

Returns:
    IdpDisclaimerT: The IDP disclaimer information

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record
 * @summary Get Idp Disclaimer
 */
export const getIdpDisclaimerResponse = zod
  .object({
    IdpDisclaimerDate: zod.union([zod.string(), zod.null()]).optional(),
    IdpDisclaimerId: zod.union([zod.number(), zod.null()]).optional(),
    IdpDisclaimerText: zod.union([zod.string(), zod.null()]).optional(),
  })
  .describe("Identity proofing disclaimer information.");

/**
 * Get the legal agreements for the authenticated user.

Returns:
    List[DoseSpotClinicianAgreementT]: The legal agreements that need to be accepted

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record
 * @summary Get Idp Legal Agreements
 */
export const getIdpLegalAgreementsResponseItem = zod
  .object({
    AgreementId: zod.union([zod.number(), zod.null()]).optional(),
    AgreementDate: zod.union([zod.string(), zod.null()]).optional(),
    AgreementText: zod.union([zod.string(), zod.null()]).optional(),
  })
  .describe("DoseSpot clinician legal agreement information.");
export const getIdpLegalAgreementsResponse = zod.array(
  getIdpLegalAgreementsResponseItem,
);

/**
 * Start the IDP process for the authenticated user.

Returns:
    DosespotIDPRecordT: The created/updated IDP record

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record
 * @summary Start Idp Process
 */
export const startIdpProcessResponse = zod
  .object({
    id: zod.uuid(),
    user_id: zod.uuid(),
    current_state: zod
      .enum([
        "NEEDS_TO_SIGN_DISCLAIMER",
        "NEEDS_TO_SIGN_LEGAL_AGREEMENTS",
        "NEEDS_TO_SUBMIT_DEMOGRAPHIC_INFO",
        "NEEDS_TO_SUBMIT_ANSWERS",
        "NEEDS_TO_SUBMIT_OTP",
        "COMPLETED",
        "ERROR",
      ])
      .describe("IDP process states."),
    session_id: zod.union([zod.string(), zod.null()]).optional(),
    is_otp_sent: zod.union([zod.boolean(), zod.null()]).optional(),
    idp_questions_and_choices: zod
      .union([
        zod
          .object({
            questions: zod.array(zod.string()),
            answer_choices: zod.array(zod.array(zod.string())),
          })
          .describe(
            "Structured type for IDP questions and their answer choices.",
          ),
        zod.null(),
      ])
      .optional(),
    error_message: zod.union([zod.string(), zod.null()]).optional(),
    pending_legal_agreements: zod
      .union([
        zod
          .object({
            pending_agreements: zod.array(zod.number()),
          })
          .describe("Structured type for pending legal agreements."),
        zod.null(),
      ])
      .optional(),
    created_at: zod.iso.datetime({}),
    updated_at: zod.iso.datetime({}),
  })
  .describe("Record type for DoseSpot IDP process tracking.");

/**
 * Accept the IDP disclaimer for the authenticated user.

Returns:
    DosespotIDPRecordT: The updated IDP record

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no active IDP process or disclaimer already accepted
 * @summary Accept Idp Disclaimer
 */
export const acceptIdpDisclaimerResponse = zod
  .object({
    id: zod.uuid(),
    user_id: zod.uuid(),
    current_state: zod
      .enum([
        "NEEDS_TO_SIGN_DISCLAIMER",
        "NEEDS_TO_SIGN_LEGAL_AGREEMENTS",
        "NEEDS_TO_SUBMIT_DEMOGRAPHIC_INFO",
        "NEEDS_TO_SUBMIT_ANSWERS",
        "NEEDS_TO_SUBMIT_OTP",
        "COMPLETED",
        "ERROR",
      ])
      .describe("IDP process states."),
    session_id: zod.union([zod.string(), zod.null()]).optional(),
    is_otp_sent: zod.union([zod.boolean(), zod.null()]).optional(),
    idp_questions_and_choices: zod
      .union([
        zod
          .object({
            questions: zod.array(zod.string()),
            answer_choices: zod.array(zod.array(zod.string())),
          })
          .describe(
            "Structured type for IDP questions and their answer choices.",
          ),
        zod.null(),
      ])
      .optional(),
    error_message: zod.union([zod.string(), zod.null()]).optional(),
    pending_legal_agreements: zod
      .union([
        zod
          .object({
            pending_agreements: zod.array(zod.number()),
          })
          .describe("Structured type for pending legal agreements."),
        zod.null(),
      ])
      .optional(),
    created_at: zod.iso.datetime({}),
    updated_at: zod.iso.datetime({}),
  })
  .describe("Record type for DoseSpot IDP process tracking.");

/**
 * Accept all pending legal agreements for the authenticated user.

Args:
    request: The signature name to use for accepting agreements

Returns:
    DosespotIDPRecordT: The updated IDP record

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no active IDP process or agreements already accepted
 * @summary Accept Legal Agreements
 */
export const acceptLegalAgreementsBody = zod.object({
  nameSigned: zod.string(),
});

export const acceptLegalAgreementsResponse = zod
  .object({
    id: zod.uuid(),
    user_id: zod.uuid(),
    current_state: zod
      .enum([
        "NEEDS_TO_SIGN_DISCLAIMER",
        "NEEDS_TO_SIGN_LEGAL_AGREEMENTS",
        "NEEDS_TO_SUBMIT_DEMOGRAPHIC_INFO",
        "NEEDS_TO_SUBMIT_ANSWERS",
        "NEEDS_TO_SUBMIT_OTP",
        "COMPLETED",
        "ERROR",
      ])
      .describe("IDP process states."),
    session_id: zod.union([zod.string(), zod.null()]).optional(),
    is_otp_sent: zod.union([zod.boolean(), zod.null()]).optional(),
    idp_questions_and_choices: zod
      .union([
        zod
          .object({
            questions: zod.array(zod.string()),
            answer_choices: zod.array(zod.array(zod.string())),
          })
          .describe(
            "Structured type for IDP questions and their answer choices.",
          ),
        zod.null(),
      ])
      .optional(),
    error_message: zod.union([zod.string(), zod.null()]).optional(),
    pending_legal_agreements: zod
      .union([
        zod
          .object({
            pending_agreements: zod.array(zod.number()),
          })
          .describe("Structured type for pending legal agreements."),
        zod.null(),
      ])
      .optional(),
    created_at: zod.iso.datetime({}),
    updated_at: zod.iso.datetime({}),
  })
  .describe("Record type for DoseSpot IDP process tracking.");

/**
 * Submit demographic information for IDP.

Args:
    request: The demographic information to submit

Returns:
    DosespotIDPRecordT: The updated IDP record

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no active IDP process or demographic info already submitted
 * @summary Submit Demographic Info
 */
export const submitDemographicInfoBody = zod.object({
  demographicInfo: zod
    .object({
      FirstName: zod.string(),
      MiddleName: zod.union([zod.string(), zod.null()]).optional(),
      LastName: zod.string(),
      HomeAddress: zod.string(),
      City: zod.string(),
      State: zod.string(),
      ZipCode: zod.string(),
      DateOfBirth: zod.iso.datetime({}),
      SocialSecurityNumber: zod.string(),
      CreditCardNumber: zod.string(),
      DrivingLicenseNumber: zod.union([zod.string(), zod.null()]).optional(),
      DrivingLicenseNumberState: zod
        .union([zod.string(), zod.null()])
        .optional(),
      PhoneNumber: zod.string(),
      IsMobileNumber: zod.boolean(),
    })
    .describe(
      "Request for clinician identity proofing.\n\n`PhoneNumber` is normalized to a bare 10-digit NANP string before it is\nsent to DoseSpot. DoseSpot's IDP endpoint forwards the number to Experian\nfor SMS-based identity capture, and Experian rejects (or, in the wild,\nsilently hangs on) numbers that contain `+`, country-code prefixes, or\nformatting characters. We rely on the shared `validate_phone_number`\nhelper so this contract is enforced regardless of which client sends the\nrequest -- the frontend already calls `stripPhone()` before submit, but\nthe backend should not trust that.",
    ),
});

export const submitDemographicInfoResponse = zod
  .object({
    id: zod.uuid(),
    user_id: zod.uuid(),
    current_state: zod
      .enum([
        "NEEDS_TO_SIGN_DISCLAIMER",
        "NEEDS_TO_SIGN_LEGAL_AGREEMENTS",
        "NEEDS_TO_SUBMIT_DEMOGRAPHIC_INFO",
        "NEEDS_TO_SUBMIT_ANSWERS",
        "NEEDS_TO_SUBMIT_OTP",
        "COMPLETED",
        "ERROR",
      ])
      .describe("IDP process states."),
    session_id: zod.union([zod.string(), zod.null()]).optional(),
    is_otp_sent: zod.union([zod.boolean(), zod.null()]).optional(),
    idp_questions_and_choices: zod
      .union([
        zod
          .object({
            questions: zod.array(zod.string()),
            answer_choices: zod.array(zod.array(zod.string())),
          })
          .describe(
            "Structured type for IDP questions and their answer choices.",
          ),
        zod.null(),
      ])
      .optional(),
    error_message: zod.union([zod.string(), zod.null()]).optional(),
    pending_legal_agreements: zod
      .union([
        zod
          .object({
            pending_agreements: zod.array(zod.number()),
          })
          .describe("Structured type for pending legal agreements."),
        zod.null(),
      ])
      .optional(),
    created_at: zod.iso.datetime({}),
    updated_at: zod.iso.datetime({}),
  })
  .describe("Record type for DoseSpot IDP process tracking.");

/**
 * Submit answers to IDP questions.

Args:
    request: The answers to IDP questions

Returns:
    DosespotIDPRecordT: The updated IDP record

Raises:
    AuthException: If the user lacks required privileges
    fastapi.HTTPException: 422 when the request is client-correctable
        (e.g. no active IDP session, or DoseSpot's own structured
        rejection of the call). 500 for unexpected errors.
 * @summary Submit Idp Answers
 */
export const submitIdpAnswersBody = zod.object({
  answers: zod.array(zod.string()),
});

export const submitIdpAnswersResponse = zod
  .object({
    id: zod.uuid(),
    user_id: zod.uuid(),
    current_state: zod
      .enum([
        "NEEDS_TO_SIGN_DISCLAIMER",
        "NEEDS_TO_SIGN_LEGAL_AGREEMENTS",
        "NEEDS_TO_SUBMIT_DEMOGRAPHIC_INFO",
        "NEEDS_TO_SUBMIT_ANSWERS",
        "NEEDS_TO_SUBMIT_OTP",
        "COMPLETED",
        "ERROR",
      ])
      .describe("IDP process states."),
    session_id: zod.union([zod.string(), zod.null()]).optional(),
    is_otp_sent: zod.union([zod.boolean(), zod.null()]).optional(),
    idp_questions_and_choices: zod
      .union([
        zod
          .object({
            questions: zod.array(zod.string()),
            answer_choices: zod.array(zod.array(zod.string())),
          })
          .describe(
            "Structured type for IDP questions and their answer choices.",
          ),
        zod.null(),
      ])
      .optional(),
    error_message: zod.union([zod.string(), zod.null()]).optional(),
    pending_legal_agreements: zod
      .union([
        zod
          .object({
            pending_agreements: zod.array(zod.number()),
          })
          .describe("Structured type for pending legal agreements."),
        zod.null(),
      ])
      .optional(),
    created_at: zod.iso.datetime({}),
    updated_at: zod.iso.datetime({}),
  })
  .describe("Record type for DoseSpot IDP process tracking.");

/**
 * Deprecated no-op: identity verification no longer uses an OTP code.

DoseSpot has marked the upstream `idpOtp` endpoint obsolete. Identity
capture now completes out-of-band via the SMS link Experian sends
after `POST /idp` (or `POST /idpAnswers`) returns `IDCapture = true`.
The frontend renders an Experian-wait view for the `submit_otp` state
and polls `registrationStatus` until the upstream `IDPSuccess` is
observed -- no manual code entry exists in our UI anymore.

The response is whatever IDP record we already have on file. Clients
should rely on `GET /dosespot/idp/me` polling for state advancement.

Returns:
    DosespotIDPRecordT: The current persisted IDP record for the user.

Raises:
    AuthException: If the user lacks required privileges.
    fastapi.HTTPException: 404 when no IDP record exists for the user
        (i.e. they are calling this before any IDP step has run).
 * @summary Submit Idp Otp
 */
export const submitIdpOtpBody = zod.object({
  otp: zod.string(),
});

export const submitIdpOtpResponse = zod
  .object({
    id: zod.uuid(),
    user_id: zod.uuid(),
    current_state: zod
      .enum([
        "NEEDS_TO_SIGN_DISCLAIMER",
        "NEEDS_TO_SIGN_LEGAL_AGREEMENTS",
        "NEEDS_TO_SUBMIT_DEMOGRAPHIC_INFO",
        "NEEDS_TO_SUBMIT_ANSWERS",
        "NEEDS_TO_SUBMIT_OTP",
        "COMPLETED",
        "ERROR",
      ])
      .describe("IDP process states."),
    session_id: zod.union([zod.string(), zod.null()]).optional(),
    is_otp_sent: zod.union([zod.boolean(), zod.null()]).optional(),
    idp_questions_and_choices: zod
      .union([
        zod
          .object({
            questions: zod.array(zod.string()),
            answer_choices: zod.array(zod.array(zod.string())),
          })
          .describe(
            "Structured type for IDP questions and their answer choices.",
          ),
        zod.null(),
      ])
      .optional(),
    error_message: zod.union([zod.string(), zod.null()]).optional(),
    pending_legal_agreements: zod
      .union([
        zod
          .object({
            pending_agreements: zod.array(zod.number()),
          })
          .describe("Structured type for pending legal agreements."),
        zod.null(),
      ])
      .optional(),
    created_at: zod.iso.datetime({}),
    updated_at: zod.iso.datetime({}),
  })
  .describe("Record type for DoseSpot IDP process tracking.");

/**
 * Sync the authenticated user's patient information to DoseSpot.

This endpoint creates or updates a DoseSpot patient record for the authenticated user
by calling the sync_and_fetch method from the patient model.

Returns:
    DoseSpotPatientSyncResultT: The sync result with patient record and info

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user info is insufficient for sync
 * @summary Sync My Dosespot Patient
 */
export const syncMyDosespotPatientResponse = zod
  .object({
    patient_record: zod
      .object({
        id: zod.uuid(),
        user_id: zod.uuid(),
        dosespot_patient_id: zod.union([zod.string(), zod.null()]).optional(),
        associated_clinician_id: zod
          .union([zod.string(), zod.null()])
          .optional(),
        last_sync_status: zod
          .union([
            zod
              .enum(["success", "failed", "pending", "unknown"])
              .describe("Enum for DoseSpot patient sync status values."),
            zod.null(),
          ])
          .optional(),
        last_sync_error: zod.union([zod.string(), zod.null()]).optional(),
        created_at: zod.iso.datetime({}),
        updated_at: zod.iso.datetime({}),
      })
      .describe("Record type for DoseSpot patient information."),
    patient_info: zod
      .union([
        zod
          .object({
            FirstName: zod.string(),
            LastName: zod.string(),
            DateOfBirth: zod.string(),
            Gender: zod.enum(["Male", "Female", "Unknown"]),
            Address1: zod.string(),
            City: zod.string(),
            State: zod.string(),
            ZipCode: zod.string(),
            PrimaryPhone: zod.union([zod.string(), zod.null()]).optional(),
            Active: zod.boolean(),
            PatientId: zod.union([zod.number(), zod.null()]).optional(),
            Prefix: zod.union([zod.string(), zod.null()]).optional(),
            MiddleName: zod.union([zod.string(), zod.null()]).optional(),
            Suffix: zod.union([zod.string(), zod.null()]).optional(),
            Email: zod.union([zod.string(), zod.null()]).optional(),
            Address2: zod.union([zod.string(), zod.null()]).optional(),
            PhoneAdditional1: zod.union([zod.string(), zod.null()]).optional(),
            PhoneAdditional2: zod.union([zod.string(), zod.null()]).optional(),
            PhoneAdditionalType1: zod
              .union([
                zod.enum([
                  "Undefined",
                  "Beeper",
                  "Cell",
                  "Fax",
                  "Home",
                  "Work",
                  "Night",
                  "Primary",
                ]),
                zod.null(),
              ])
              .optional(),
            PhoneAdditionalType2: zod
              .union([
                zod.enum([
                  "Undefined",
                  "Beeper",
                  "Cell",
                  "Fax",
                  "Home",
                  "Work",
                  "Night",
                  "Primary",
                ]),
                zod.null(),
              ])
              .optional(),
            PrimaryPhoneType: zod
              .union([
                zod.enum([
                  "Undefined",
                  "Beeper",
                  "Cell",
                  "Fax",
                  "Home",
                  "Work",
                  "Night",
                  "Primary",
                ]),
                zod.null(),
              ])
              .optional(),
            Weight: zod.union([zod.number(), zod.null()]).optional(),
            WeightMetric: zod
              .union([
                zod
                  .enum(["lb", "kg"])
                  .describe("Valid weight metrics for DoseSpot patients."),
                zod.null(),
              ])
              .optional(),
            Height: zod.union([zod.number(), zod.null()]).optional(),
            HeightMetric: zod
              .union([
                zod
                  .enum(["inch", "cm"])
                  .describe("Valid height metrics for DoseSpot patients."),
                zod.null(),
              ])
              .optional(),
            NonDoseSpotMedicalRecordNumber: zod
              .union([zod.string(), zod.null()])
              .optional(),
            Encounter: zod.union([zod.string(), zod.null()]).optional(),
            IsHospice: zod.union([zod.boolean(), zod.null()]).optional(),
            Last4SSN: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe("Patient demographic information from DoseSpot API."),
        zod.null(),
      ])
      .optional(),
    sync_successful: zod.boolean(),
    error_message: zod.union([zod.string(), zod.null()]).optional(),
  })
  .describe("Response type for DoseSpot patient sync operations.");

/**
 * Sync a user's patient information to DoseSpot.

This endpoint creates or updates a DoseSpot patient record for the specified user
by calling the sync_and_fetch method from the patient model.

Args:
    user_id: The user ID to sync to DoseSpot

Returns:
    DoseSpotPatientSyncResultT: The sync result with patient record and info

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user info is insufficient for sync
 * @summary Sync Dosespot Patient
 */
export const syncDosespotPatientParams = zod.object({
  user_id: zod.uuid(),
});

export const syncDosespotPatientResponse = zod
  .object({
    patient_record: zod
      .object({
        id: zod.uuid(),
        user_id: zod.uuid(),
        dosespot_patient_id: zod.union([zod.string(), zod.null()]).optional(),
        associated_clinician_id: zod
          .union([zod.string(), zod.null()])
          .optional(),
        last_sync_status: zod
          .union([
            zod
              .enum(["success", "failed", "pending", "unknown"])
              .describe("Enum for DoseSpot patient sync status values."),
            zod.null(),
          ])
          .optional(),
        last_sync_error: zod.union([zod.string(), zod.null()]).optional(),
        created_at: zod.iso.datetime({}),
        updated_at: zod.iso.datetime({}),
      })
      .describe("Record type for DoseSpot patient information."),
    patient_info: zod
      .union([
        zod
          .object({
            FirstName: zod.string(),
            LastName: zod.string(),
            DateOfBirth: zod.string(),
            Gender: zod.enum(["Male", "Female", "Unknown"]),
            Address1: zod.string(),
            City: zod.string(),
            State: zod.string(),
            ZipCode: zod.string(),
            PrimaryPhone: zod.union([zod.string(), zod.null()]).optional(),
            Active: zod.boolean(),
            PatientId: zod.union([zod.number(), zod.null()]).optional(),
            Prefix: zod.union([zod.string(), zod.null()]).optional(),
            MiddleName: zod.union([zod.string(), zod.null()]).optional(),
            Suffix: zod.union([zod.string(), zod.null()]).optional(),
            Email: zod.union([zod.string(), zod.null()]).optional(),
            Address2: zod.union([zod.string(), zod.null()]).optional(),
            PhoneAdditional1: zod.union([zod.string(), zod.null()]).optional(),
            PhoneAdditional2: zod.union([zod.string(), zod.null()]).optional(),
            PhoneAdditionalType1: zod
              .union([
                zod.enum([
                  "Undefined",
                  "Beeper",
                  "Cell",
                  "Fax",
                  "Home",
                  "Work",
                  "Night",
                  "Primary",
                ]),
                zod.null(),
              ])
              .optional(),
            PhoneAdditionalType2: zod
              .union([
                zod.enum([
                  "Undefined",
                  "Beeper",
                  "Cell",
                  "Fax",
                  "Home",
                  "Work",
                  "Night",
                  "Primary",
                ]),
                zod.null(),
              ])
              .optional(),
            PrimaryPhoneType: zod
              .union([
                zod.enum([
                  "Undefined",
                  "Beeper",
                  "Cell",
                  "Fax",
                  "Home",
                  "Work",
                  "Night",
                  "Primary",
                ]),
                zod.null(),
              ])
              .optional(),
            Weight: zod.union([zod.number(), zod.null()]).optional(),
            WeightMetric: zod
              .union([
                zod
                  .enum(["lb", "kg"])
                  .describe("Valid weight metrics for DoseSpot patients."),
                zod.null(),
              ])
              .optional(),
            Height: zod.union([zod.number(), zod.null()]).optional(),
            HeightMetric: zod
              .union([
                zod
                  .enum(["inch", "cm"])
                  .describe("Valid height metrics for DoseSpot patients."),
                zod.null(),
              ])
              .optional(),
            NonDoseSpotMedicalRecordNumber: zod
              .union([zod.string(), zod.null()])
              .optional(),
            Encounter: zod.union([zod.string(), zod.null()]).optional(),
            IsHospice: zod.union([zod.boolean(), zod.null()]).optional(),
            Last4SSN: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe("Patient demographic information from DoseSpot API."),
        zod.null(),
      ])
      .optional(),
    sync_successful: zod.boolean(),
    error_message: zod.union([zod.string(), zod.null()]).optional(),
  })
  .describe("Response type for DoseSpot patient sync operations.");

/**
 * Get the authenticated user's DoseSpot patient information.

This endpoint fetches the current patient information from DoseSpot API
for the authenticated user.

Returns:
    PatientT or None: The patient information if available

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no patient record exists for the user
 * @summary Get My Dosespot Patient Info
 */
export const getMyDosespotPatientInfoResponse = zod.union([
  zod
    .object({
      FirstName: zod.string(),
      LastName: zod.string(),
      DateOfBirth: zod.string(),
      Gender: zod.enum(["Male", "Female", "Unknown"]),
      Address1: zod.string(),
      City: zod.string(),
      State: zod.string(),
      ZipCode: zod.string(),
      PrimaryPhone: zod.union([zod.string(), zod.null()]).optional(),
      Active: zod.boolean(),
      PatientId: zod.union([zod.number(), zod.null()]).optional(),
      Prefix: zod.union([zod.string(), zod.null()]).optional(),
      MiddleName: zod.union([zod.string(), zod.null()]).optional(),
      Suffix: zod.union([zod.string(), zod.null()]).optional(),
      Email: zod.union([zod.string(), zod.null()]).optional(),
      Address2: zod.union([zod.string(), zod.null()]).optional(),
      PhoneAdditional1: zod.union([zod.string(), zod.null()]).optional(),
      PhoneAdditional2: zod.union([zod.string(), zod.null()]).optional(),
      PhoneAdditionalType1: zod
        .union([
          zod.enum([
            "Undefined",
            "Beeper",
            "Cell",
            "Fax",
            "Home",
            "Work",
            "Night",
            "Primary",
          ]),
          zod.null(),
        ])
        .optional(),
      PhoneAdditionalType2: zod
        .union([
          zod.enum([
            "Undefined",
            "Beeper",
            "Cell",
            "Fax",
            "Home",
            "Work",
            "Night",
            "Primary",
          ]),
          zod.null(),
        ])
        .optional(),
      PrimaryPhoneType: zod
        .union([
          zod.enum([
            "Undefined",
            "Beeper",
            "Cell",
            "Fax",
            "Home",
            "Work",
            "Night",
            "Primary",
          ]),
          zod.null(),
        ])
        .optional(),
      Weight: zod.union([zod.number(), zod.null()]).optional(),
      WeightMetric: zod
        .union([
          zod
            .enum(["lb", "kg"])
            .describe("Valid weight metrics for DoseSpot patients."),
          zod.null(),
        ])
        .optional(),
      Height: zod.union([zod.number(), zod.null()]).optional(),
      HeightMetric: zod
        .union([
          zod
            .enum(["inch", "cm"])
            .describe("Valid height metrics for DoseSpot patients."),
          zod.null(),
        ])
        .optional(),
      NonDoseSpotMedicalRecordNumber: zod
        .union([zod.string(), zod.null()])
        .optional(),
      Encounter: zod.union([zod.string(), zod.null()]).optional(),
      IsHospice: zod.union([zod.boolean(), zod.null()]).optional(),
      Last4SSN: zod.union([zod.string(), zod.null()]).optional(),
    })
    .describe("Patient demographic information from DoseSpot API."),
  zod.null(),
]);

/**
 * Get DoseSpot patient information for a specific user.

This endpoint fetches the current patient information from DoseSpot API
for the specified user.

Args:
    user_id: The user ID to fetch patient info for

Returns:
    PatientT or None: The patient information if available

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no patient record exists for the user
 * @summary Get Dosespot Patient Info
 */
export const getDosespotPatientInfoParams = zod.object({
  user_id: zod.uuid(),
});

export const getDosespotPatientInfoResponse = zod.union([
  zod
    .object({
      FirstName: zod.string(),
      LastName: zod.string(),
      DateOfBirth: zod.string(),
      Gender: zod.enum(["Male", "Female", "Unknown"]),
      Address1: zod.string(),
      City: zod.string(),
      State: zod.string(),
      ZipCode: zod.string(),
      PrimaryPhone: zod.union([zod.string(), zod.null()]).optional(),
      Active: zod.boolean(),
      PatientId: zod.union([zod.number(), zod.null()]).optional(),
      Prefix: zod.union([zod.string(), zod.null()]).optional(),
      MiddleName: zod.union([zod.string(), zod.null()]).optional(),
      Suffix: zod.union([zod.string(), zod.null()]).optional(),
      Email: zod.union([zod.string(), zod.null()]).optional(),
      Address2: zod.union([zod.string(), zod.null()]).optional(),
      PhoneAdditional1: zod.union([zod.string(), zod.null()]).optional(),
      PhoneAdditional2: zod.union([zod.string(), zod.null()]).optional(),
      PhoneAdditionalType1: zod
        .union([
          zod.enum([
            "Undefined",
            "Beeper",
            "Cell",
            "Fax",
            "Home",
            "Work",
            "Night",
            "Primary",
          ]),
          zod.null(),
        ])
        .optional(),
      PhoneAdditionalType2: zod
        .union([
          zod.enum([
            "Undefined",
            "Beeper",
            "Cell",
            "Fax",
            "Home",
            "Work",
            "Night",
            "Primary",
          ]),
          zod.null(),
        ])
        .optional(),
      PrimaryPhoneType: zod
        .union([
          zod.enum([
            "Undefined",
            "Beeper",
            "Cell",
            "Fax",
            "Home",
            "Work",
            "Night",
            "Primary",
          ]),
          zod.null(),
        ])
        .optional(),
      Weight: zod.union([zod.number(), zod.null()]).optional(),
      WeightMetric: zod
        .union([
          zod
            .enum(["lb", "kg"])
            .describe("Valid weight metrics for DoseSpot patients."),
          zod.null(),
        ])
        .optional(),
      Height: zod.union([zod.number(), zod.null()]).optional(),
      HeightMetric: zod
        .union([
          zod
            .enum(["inch", "cm"])
            .describe("Valid height metrics for DoseSpot patients."),
          zod.null(),
        ])
        .optional(),
      NonDoseSpotMedicalRecordNumber: zod
        .union([zod.string(), zod.null()])
        .optional(),
      Encounter: zod.union([zod.string(), zod.null()]).optional(),
      IsHospice: zod.union([zod.boolean(), zod.null()]).optional(),
      Last4SSN: zod.union([zod.string(), zod.null()]).optional(),
    })
    .describe("Patient demographic information from DoseSpot API."),
  zod.null(),
]);

/**
 * Get DoseSpot patient information for a specific user.

This endpoint fetches the current patient information from DoseSpot API
for the specified user.

Args:
    dosespot_patient_id: The DoseSpot patient ID to fetch patient info for

Returns:
    PatientT or None: The patient information if available

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no patient record exists for the user
 * @summary Exchange Dosespot Patient Info For Rxchange Rxrenewalrequest
 */
export const exchangeDosespotPatientInfoForRxchangeRxrenewalrequestParams =
  zod.object({
    dosespot_patient_id: zod.string(),
  });

export const exchangeDosespotPatientInfoForRxchangeRxrenewalrequestResponse =
  zod.union([zod.uuid(), zod.null()]);

/**
 * Search for pharmacies using various criteria.

This endpoint searches the DoseSpot pharmacy database using the provided criteria
and returns a paginated list of matching pharmacies.

Args:
    name: Pharmacy name to search for
    city: Pharmacy city
    state: Pharmacy state (2-letter code)
    zip: Pharmacy ZIP code
    address: Pharmacy street address
    phoneOrFax: Pharmacy phone or fax number
    specialty: List of pharmacy specialties to filter by
    ncpdpID: Pharmacy NCPDP ID
    pageNumber: Page number for pagination (default: 1)

Returns:
    PharmacyPagedListResponseT: Paginated list of pharmacies matching criteria

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the search fails
 * @summary Search Pharmacies
 */
export const searchPharmaciesQueryPageNumberDefault = 1;

export const searchPharmaciesQueryParams = zod.object({
  name: zod.union([zod.string(), zod.null()]).optional(),
  city: zod.union([zod.string(), zod.null()]).optional(),
  state: zod.union([zod.string(), zod.null()]).optional(),
  zip: zod.union([zod.string(), zod.null()]).optional(),
  address: zod.union([zod.string(), zod.null()]).optional(),
  phoneOrFax: zod.union([zod.string(), zod.null()]).optional(),
  ncpdpID: zod.union([zod.string(), zod.null()]).optional(),
  pageNumber: zod.number().default(searchPharmaciesQueryPageNumberDefault),
});

export const searchPharmaciesBody = zod.union([
  zod.array(zod.string()),
  zod.null(),
]);

export const searchPharmaciesResponse = zod
  .object({
    Items: zod
      .union([
        zod.array(
          zod
            .object({
              PharmacyId: zod.union([zod.number(), zod.null()]).optional(),
              StoreName: zod.union([zod.string(), zod.null()]).optional(),
              Address1: zod.union([zod.string(), zod.null()]).optional(),
              Address2: zod.union([zod.string(), zod.null()]).optional(),
              City: zod.union([zod.string(), zod.null()]).optional(),
              State: zod.union([zod.string(), zod.null()]).optional(),
              ZipCode: zod.union([zod.string(), zod.null()]).optional(),
              PrimaryPhone: zod.union([zod.string(), zod.null()]).optional(),
              PrimaryPhoneType: zod
                .union([
                  zod.enum([
                    "Undefined",
                    "Beeper",
                    "Cell",
                    "Fax",
                    "Home",
                    "Work",
                    "Night",
                    "Primary",
                  ]),
                  zod.null(),
                ])
                .optional(),
              PrimaryFax: zod.union([zod.string(), zod.null()]).optional(),
              PhoneAdditional1: zod
                .union([zod.string(), zod.null()])
                .optional(),
              PhoneAdditionalType1: zod
                .union([
                  zod.enum([
                    "Undefined",
                    "Beeper",
                    "Cell",
                    "Fax",
                    "Home",
                    "Work",
                    "Night",
                    "Primary",
                  ]),
                  zod.null(),
                ])
                .optional(),
              PhoneAdditional2: zod
                .union([zod.string(), zod.null()])
                .optional(),
              PhoneAdditionalType2: zod
                .union([
                  zod.enum([
                    "Undefined",
                    "Beeper",
                    "Cell",
                    "Fax",
                    "Home",
                    "Work",
                    "Night",
                    "Primary",
                  ]),
                  zod.null(),
                ])
                .optional(),
              PhoneAdditional3: zod
                .union([zod.string(), zod.null()])
                .optional(),
              PhoneAdditionalType3: zod
                .union([
                  zod.enum([
                    "Undefined",
                    "Beeper",
                    "Cell",
                    "Fax",
                    "Home",
                    "Work",
                    "Night",
                    "Primary",
                  ]),
                  zod.null(),
                ])
                .optional(),
              PharmacySpecialties: zod
                .union([zod.array(zod.string()), zod.null()])
                .optional(),
              ServiceLevel: zod.union([zod.number(), zod.null()]).optional(),
              Latitude: zod.union([zod.number(), zod.null()]).optional(),
              Longitude: zod.union([zod.number(), zod.null()]).optional(),
              NCPDPID: zod.union([zod.string(), zod.null()]).optional(),
            })
            .describe("DoseSpot Pharmacy model."),
        ),
        zod.null(),
      ])
      .optional(),
    PageResult: zod
      .union([
        zod
          .object({
            CurrentPage: zod.union([zod.number(), zod.null()]).optional(),
            TotalPages: zod.union([zod.number(), zod.null()]).optional(),
            PageSize: zod.union([zod.number(), zod.null()]).optional(),
            TotalCount: zod.union([zod.number(), zod.null()]).optional(),
            HasPrevious: zod.union([zod.boolean(), zod.null()]).optional(),
            HasNext: zod.union([zod.boolean(), zod.null()]).optional(),
          })
          .describe("DoseSpot page result information."),
        zod.null(),
      ])
      .optional(),
    Result: zod
      .union([
        zod
          .object({
            ResultCode: zod.string(),
            ResultDescription: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe("Standard DoseSpot API result object."),
        zod.null(),
      ])
      .optional(),
  })
  .describe("PagedListResponse wrapper for paged pharmacy lists.");

/**
 * Get pharmacy details by ID.

This endpoint retrieves detailed information about a specific pharmacy
from the DoseSpot database.

Args:
    pharmacy_id: The pharmacy ID to retrieve

Returns:
    PharmacyT: Detailed pharmacy information

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the pharmacy is not found or request fails
 * @summary Get Pharmacy By Id
 */
export const getPharmacyByIdParams = zod.object({
  pharmacy_id: zod.string(),
});

export const getPharmacyByIdResponse = zod
  .object({
    PharmacyId: zod.union([zod.number(), zod.null()]).optional(),
    StoreName: zod.union([zod.string(), zod.null()]).optional(),
    Address1: zod.union([zod.string(), zod.null()]).optional(),
    Address2: zod.union([zod.string(), zod.null()]).optional(),
    City: zod.union([zod.string(), zod.null()]).optional(),
    State: zod.union([zod.string(), zod.null()]).optional(),
    ZipCode: zod.union([zod.string(), zod.null()]).optional(),
    PrimaryPhone: zod.union([zod.string(), zod.null()]).optional(),
    PrimaryPhoneType: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PrimaryFax: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditional1: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType1: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PhoneAdditional2: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType2: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PhoneAdditional3: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType3: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PharmacySpecialties: zod
      .union([zod.array(zod.string()), zod.null()])
      .optional(),
    ServiceLevel: zod.union([zod.number(), zod.null()]).optional(),
    Latitude: zod.union([zod.number(), zod.null()]).optional(),
    Longitude: zod.union([zod.number(), zod.null()]).optional(),
    NCPDPID: zod.union([zod.string(), zod.null()]).optional(),
  })
  .describe("DoseSpot Pharmacy model.");

/**
 * Get the authenticated user's preferred pharmacies.

This endpoint retrieves all pharmacies assigned to the authenticated user's
DoseSpot patient record.

Returns:
    List[PatientPharmacyT]: List of patient's preferred pharmacies

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no patient record exists or request fails
 * @summary Get My Patient Pharmacies
 */
export const getMyPatientPharmaciesResponseItem = zod
  .object({
    PharmacyId: zod.union([zod.number(), zod.null()]).optional(),
    StoreName: zod.union([zod.string(), zod.null()]).optional(),
    Address1: zod.union([zod.string(), zod.null()]).optional(),
    Address2: zod.union([zod.string(), zod.null()]).optional(),
    City: zod.union([zod.string(), zod.null()]).optional(),
    State: zod.union([zod.string(), zod.null()]).optional(),
    ZipCode: zod.union([zod.string(), zod.null()]).optional(),
    PrimaryPhone: zod.union([zod.string(), zod.null()]).optional(),
    PrimaryPhoneType: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PrimaryFax: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditional1: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType1: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PhoneAdditional2: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType2: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PhoneAdditional3: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType3: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PharmacySpecialties: zod
      .union([zod.array(zod.string()), zod.null()])
      .optional(),
    ServiceLevel: zod.union([zod.number(), zod.null()]).optional(),
    Latitude: zod.union([zod.number(), zod.null()]).optional(),
    Longitude: zod.union([zod.number(), zod.null()]).optional(),
    NCPDPID: zod.union([zod.string(), zod.null()]).optional(),
    IsDefault: zod.union([zod.boolean(), zod.null()]).optional(),
  })
  .describe(
    "DoseSpot Patient Pharmacy model - extends PharmacyT with patient-specific fields.",
  );
export const getMyPatientPharmaciesResponse = zod.array(
  getMyPatientPharmaciesResponseItem,
);

/**
 * Add a pharmacy to the authenticated user's preferred pharmacies.

This endpoint adds a pharmacy to the authenticated user's DoseSpot patient record
and optionally sets it as the primary pharmacy.

Args:
    request: The pharmacy ID and primary setting

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the pharmacy cannot be added or request fails
 * @summary Add Pharmacy To My Patient
 */
export const addPharmacyToMyPatientBodySetAsPrimaryDefault = false;

export const addPharmacyToMyPatientBody = zod.object({
  pharmacyId: zod.number(),
  setAsPrimary: zod.boolean().optional(),
});

export const addPharmacyToMyPatientResponse = zod.unknown();

/**
 * Get a specific user's preferred pharmacies.

This endpoint retrieves all pharmacies assigned to the specified user's
DoseSpot patient record.

Args:
    user_id: The user ID to get pharmacies for

Returns:
    List[PatientPharmacyT]: List of patient's preferred pharmacies

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no patient record exists or request fails
 * @summary Get Patient Pharmacies By User Id
 */
export const getPatientPharmaciesByUserIdParams = zod.object({
  user_id: zod.uuid(),
});

export const getPatientPharmaciesByUserIdResponseItem = zod
  .object({
    PharmacyId: zod.union([zod.number(), zod.null()]).optional(),
    StoreName: zod.union([zod.string(), zod.null()]).optional(),
    Address1: zod.union([zod.string(), zod.null()]).optional(),
    Address2: zod.union([zod.string(), zod.null()]).optional(),
    City: zod.union([zod.string(), zod.null()]).optional(),
    State: zod.union([zod.string(), zod.null()]).optional(),
    ZipCode: zod.union([zod.string(), zod.null()]).optional(),
    PrimaryPhone: zod.union([zod.string(), zod.null()]).optional(),
    PrimaryPhoneType: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PrimaryFax: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditional1: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType1: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PhoneAdditional2: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType2: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PhoneAdditional3: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType3: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PharmacySpecialties: zod
      .union([zod.array(zod.string()), zod.null()])
      .optional(),
    ServiceLevel: zod.union([zod.number(), zod.null()]).optional(),
    Latitude: zod.union([zod.number(), zod.null()]).optional(),
    Longitude: zod.union([zod.number(), zod.null()]).optional(),
    NCPDPID: zod.union([zod.string(), zod.null()]).optional(),
    IsDefault: zod.union([zod.boolean(), zod.null()]).optional(),
  })
  .describe(
    "DoseSpot Patient Pharmacy model - extends PharmacyT with patient-specific fields.",
  );
export const getPatientPharmaciesByUserIdResponse = zod.array(
  getPatientPharmaciesByUserIdResponseItem,
);

/**
 * Add a pharmacy to a specific user's preferred pharmacies.

This endpoint adds a pharmacy to the specified user's DoseSpot patient record
and optionally sets it as the primary pharmacy.

Args:
    user_id: The user ID to add the pharmacy to
    request: The pharmacy ID and primary setting

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the pharmacy cannot be added or request fails
 * @summary Add Pharmacy To Patient By User Id
 */
export const addPharmacyToPatientByUserIdParams = zod.object({
  user_id: zod.uuid(),
});

export const addPharmacyToPatientByUserIdBodySetAsPrimaryDefault = false;

export const addPharmacyToPatientByUserIdBody = zod.object({
  pharmacyId: zod.number(),
  setAsPrimary: zod.boolean().optional(),
});

export const addPharmacyToPatientByUserIdResponse = zod.unknown();

/**
 * Remove a pharmacy from the authenticated user's preferred pharmacies.

This endpoint removes a pharmacy from the authenticated user's DoseSpot patient record.

Args:
    pharmacy_id: The pharmacy ID to remove

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the pharmacy cannot be removed or request fails
 * @summary Remove Pharmacy From My Patient
 */
export const removePharmacyFromMyPatientParams = zod.object({
  pharmacy_id: zod.string(),
});

export const removePharmacyFromMyPatientResponse = zod.unknown();

/**
 * Remove a pharmacy from a specific user's preferred pharmacies.

This endpoint removes a pharmacy from the specified user's DoseSpot patient record.

Args:
    user_id: The user ID to remove the pharmacy from
    pharmacy_id: The pharmacy ID to remove

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the pharmacy cannot be removed or request fails
 * @summary Remove Pharmacy From Patient By User Id
 */
export const removePharmacyFromPatientByUserIdParams = zod.object({
  user_id: zod.uuid(),
  pharmacy_id: zod.string(),
});

export const removePharmacyFromPatientByUserIdResponse = zod.unknown();

/**
 * Get a specific user's allergies.

This endpoint retrieves all allergies recorded for the specified user's
DoseSpot patient record.

Args:
    user_id: The user ID to get allergies for

Returns:
    List[PatientAllergyT]: List of patient's allergies

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no patient record exists or request fails
 * @summary Get Patient Allergies By User Id
 */
export const getPatientAllergiesByUserIdParams = zod.object({
  user_id: zod.uuid(),
});

export const getPatientAllergiesByUserIdResponseItem = zod
  .object({
    PatientAllergyId: zod.union([zod.number(), zod.null()]).optional(),
    DisplayName: zod.union([zod.string(), zod.null()]).optional(),
    AllergenId: zod.union([zod.number(), zod.null()]).optional(),
    AllergenType: zod
      .union([
        zod
          .enum([
            "AllergenClass",
            "ScreenableIngredient",
            "FoodAndEnvironmentalAllergens",
            "RoutedDoseFormDrugs",
          ])
          .describe("Valid allergen types for DoseSpot."),
        zod.null(),
      ])
      .optional(),
    Reaction: zod.union([zod.string(), zod.null()]).optional(),
    ReactionType: zod
      .union([
        zod
          .enum(["Allergy", "AdverseReaction"])
          .describe("Valid reaction types for allergies."),
        zod.null(),
      ])
      .optional(),
    StatusType: zod
      .union([
        zod
          .enum(["Active", "Inactive", "Deleted"])
          .describe("Valid status types for allergies."),
        zod.null(),
      ])
      .optional(),
    OnsetDate: zod.union([zod.string(), zod.null()]).optional(),
    LastUpdatedUserId: zod.union([zod.number(), zod.null()]).optional(),
  })
  .describe("Patient allergy information from DoseSpot API.");
export const getPatientAllergiesByUserIdResponse = zod.array(
  getPatientAllergiesByUserIdResponseItem,
);

/**
 * Add an allergy to a specific user's patient record.

This endpoint adds an allergy to the specified user's DoseSpot patient record.
The allergy can be either coded (with AllergenId) or freetext.

Args:
    user_id: The user ID to add the allergy to
    request: The allergy information (coded or freetext)

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the allergy cannot be added or request fails
 * @summary Add Allergy To Patient By User Id
 */
export const addAllergyToPatientByUserIdParams = zod.object({
  user_id: zod.uuid(),
});

export const addAllergyToPatientByUserIdBody = zod.union([
  zod
    .object({
      AllergenId: zod.number(),
      Reaction: zod.union([zod.string(), zod.null()]).optional(),
      ReactionType: zod
        .enum(["Allergy", "AdverseReaction"])
        .describe("Valid reaction types for allergies."),
      StatusType: zod
        .enum(["Active", "Inactive", "Deleted"])
        .describe("Valid status types for allergies."),
      OnsetDate: zod.union([zod.string(), zod.null()]).optional(),
    })
    .describe("Request for adding a coded patient allergy."),
  zod
    .object({
      FreeTextDisplayName: zod.string(),
      Reaction: zod.union([zod.string(), zod.null()]).optional(),
      ReactionType: zod
        .enum(["Allergy", "AdverseReaction"])
        .describe("Valid reaction types for allergies."),
      StatusType: zod
        .enum(["Active", "Inactive", "Deleted"])
        .describe("Valid status types for allergies."),
      OnsetDate: zod.union([zod.string(), zod.null()]).optional(),
    })
    .describe("Request for adding a freetext patient allergy."),
]);

export const addAllergyToPatientByUserIdResponse = zod.unknown();

/**
 * Edit an allergy in a specific user's patient record.

This endpoint updates an existing allergy in the specified user's DoseSpot patient record.

Args:
    user_id: The user ID to edit the allergy for
    allergy_id: The allergy ID to edit
    request: The updated allergy information

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the allergy cannot be edited or request fails
 * @summary Edit Patient Allergy By User Id
 */
export const editPatientAllergyByUserIdParams = zod.object({
  user_id: zod.uuid(),
  allergy_id: zod.string(),
});

export const editPatientAllergyByUserIdBody = zod
  .object({
    Reaction: zod.union([zod.string(), zod.null()]).optional(),
    ReactionType: zod
      .enum(["Allergy", "AdverseReaction"])
      .describe("Valid reaction types for allergies."),
    StatusType: zod
      .enum(["Active", "Inactive", "Deleted"])
      .describe("Valid status types for allergies."),
    OnsetDate: zod.union([zod.string(), zod.null()]).optional(),
  })
  .describe("Request for editing a patient allergy.");

export const editPatientAllergyByUserIdResponse = zod.unknown();

/**
 * Search for allergens by name.

This endpoint searches the DoseSpot allergen database for matching allergens.
Requires at least 3 characters in the search term.

Args:
    name: Allergen name to search for (minimum 3 characters)
    page_number: Page number for pagination (optional)

Returns:
    AllergyPagedListResponseT: Paginated list of allergens matching the search criteria

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the search fails or name is too short
 * @summary Search Allergens
 */
export const searchAllergensQueryParams = zod.object({
  name: zod.string(),
  page_number: zod.union([zod.number(), zod.null()]).optional(),
});

export const searchAllergensResponse = zod
  .object({
    Items: zod
      .union([
        zod.array(
          zod
            .object({
              Name: zod.union([zod.string(), zod.null()]).optional(),
              BrandName: zod.union([zod.string(), zod.null()]).optional(),
              AllergenId: zod.union([zod.number(), zod.null()]).optional(),
              AllergenType: zod
                .union([
                  zod
                    .enum([
                      "AllergenClass",
                      "ScreenableIngredient",
                      "FoodAndEnvironmentalAllergens",
                      "RoutedDoseFormDrugs",
                    ])
                    .describe("Valid allergen types for DoseSpot."),
                  zod.null(),
                ])
                .optional(),
              IsActive: zod.union([zod.boolean(), zod.null()]).optional(),
              AllergenCategory: zod
                .union([
                  zod
                    .enum([
                      "CommonAllergens",
                      "UncommonAllergens",
                      "OtherBrandDrugs",
                    ])
                    .describe("Valid allergen category types for DoseSpot."),
                  zod.null(),
                ])
                .optional(),
            })
            .describe("Allergen search result from DoseSpot API."),
        ),
        zod.null(),
      ])
      .optional(),
    PageResult: zod
      .union([
        zod
          .object({
            CurrentPage: zod.union([zod.number(), zod.null()]).optional(),
            TotalPages: zod.union([zod.number(), zod.null()]).optional(),
            PageSize: zod.union([zod.number(), zod.null()]).optional(),
            TotalCount: zod.union([zod.number(), zod.null()]).optional(),
            HasPrevious: zod.union([zod.boolean(), zod.null()]).optional(),
            HasNext: zod.union([zod.boolean(), zod.null()]).optional(),
          })
          .describe("DoseSpot page result information."),
        zod.null(),
      ])
      .optional(),
    Result: zod
      .union([
        zod
          .object({
            ResultCode: zod.string(),
            ResultDescription: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe("Standard DoseSpot API result object."),
        zod.null(),
      ])
      .optional(),
  })
  .describe("PagedListResponse wrapper for allergen search results.");

/**
 * Get allergen details by ID.

This endpoint retrieves detailed information about a specific allergen
from the DoseSpot database.

Args:
    allergen_id: The allergen ID to retrieve

Returns:
    AllergySearchResultT: Detailed allergen information

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the allergen is not found or request fails
 * @summary Get Allergen By Id
 */
export const getAllergenByIdParams = zod.object({
  allergen_id: zod.string(),
});

export const getAllergenByIdResponse = zod
  .object({
    Name: zod.union([zod.string(), zod.null()]).optional(),
    BrandName: zod.union([zod.string(), zod.null()]).optional(),
    AllergenId: zod.union([zod.number(), zod.null()]).optional(),
    AllergenType: zod
      .union([
        zod
          .enum([
            "AllergenClass",
            "ScreenableIngredient",
            "FoodAndEnvironmentalAllergens",
            "RoutedDoseFormDrugs",
          ])
          .describe("Valid allergen types for DoseSpot."),
        zod.null(),
      ])
      .optional(),
    IsActive: zod.union([zod.boolean(), zod.null()]).optional(),
    AllergenCategory: zod
      .union([
        zod
          .enum(["CommonAllergens", "UncommonAllergens", "OtherBrandDrugs"])
          .describe("Valid allergen category types for DoseSpot."),
        zod.null(),
      ])
      .optional(),
  })
  .describe("Allergen search result from DoseSpot API.");

/**
 * Search for medications by name.

This endpoint searches the DoseSpot medication database for drugs matching the provided name.
Requires at least 3 characters in the search term.

Args:
    name: Medication name to search for (minimum 3 characters)
    page_number: Page number for pagination (optional)
    drug_status: Filter by drug status (optional)

Returns:
    List[MedicationSearchResultT]: List of medications matching the search criteria

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the search fails or name is too short
 * @summary Search Medications
 */
export const searchMedicationsQueryParams = zod.object({
  name: zod.string(),
  page_number: zod.union([zod.number(), zod.null()]).optional(),
  drug_status: zod.union([zod.string(), zod.null()]).optional(),
});

export const searchMedicationsResponseItem = zod
  .object({
    DispensableDrugId: zod.union([zod.number(), zod.null()]).optional(),
    RoutedDoseFormDrugId: zod.union([zod.number(), zod.null()]).optional(),
    NDC: zod.union([zod.string(), zod.null()]).optional(),
    RXCUI: zod.union([zod.number(), zod.null()]).optional(),
    NameWithRouteDoseForm: zod.union([zod.string(), zod.null()]).optional(),
    Strength: zod.union([zod.string(), zod.null()]).optional(),
    IsObsolete: zod.union([zod.boolean(), zod.null()]).optional(),
  })
  .describe("Result model for medication search operations.");
export const searchMedicationsResponse = zod.array(
  searchMedicationsResponseItem,
);

/**
 * Search for medications by rxCUI.

This endpoint searches for dispensable drugs by rxCUI identifier.

Args:
    rxcui: The rxCUI identifier to search by

Returns:
    List[MedicationSelectResultT]: List of medications matching the rxCUI

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the search fails
 * @summary Search Medications By Rxcui
 */
export const searchMedicationsByRxcuiParams = zod.object({
  rxcui: zod.string(),
});

export const searchMedicationsByRxcuiResponseItem = zod
  .object({
    DispensableDrugId: zod.union([zod.number(), zod.null()]).optional(),
    NDC: zod.union([zod.string(), zod.null()]).optional(),
    RXCUI: zod.union([zod.number(), zod.null()]).optional(),
    DisplayName: zod.union([zod.string(), zod.null()]).optional(),
    DrugName: zod.union([zod.string(), zod.null()]).optional(),
    Route: zod.union([zod.string(), zod.null()]).optional(),
    DoseForm: zod.union([zod.string(), zod.null()]).optional(),
    Strength: zod.union([zod.string(), zod.null()]).optional(),
    DispenseUnitId: zod.union([zod.number(), zod.null()]).optional(),
    Brand: zod.union([zod.boolean(), zod.null()]).optional(),
    GenericDrugName: zod.union([zod.string(), zod.null()]).optional(),
    OTC: zod.union([zod.boolean(), zod.null()]).optional(),
    IsObsolete: zod.union([zod.boolean(), zod.null()]).optional(),
    DrugClassification: zod.union([zod.string(), zod.null()]).optional(),
    Schedule: zod.union([zod.number(), zod.null()]).optional(),
    StateSchedule: zod
      .union([
        zod.array(
          zod
            .object({
              StateName: zod.union([zod.string(), zod.null()]).optional(),
              Schedule: zod.union([zod.number(), zod.null()]).optional(),
            })
            .describe("State-specific drug scheduling information."),
        ),
        zod.null(),
      ])
      .optional(),
  })
  .describe("Result model for medication selection and detail operations.");
export const searchMedicationsByRxcuiResponse = zod.array(
  searchMedicationsByRxcuiResponseItem,
);

/**
 * Get detailed medication information by ID, NDC, or rxCUI.

This endpoint retrieves detailed information about a specific medication.
At least one identifier parameter must be provided.

Args:
    dispensable_drug_id: The dispensable drug ID (optional)
    ndc: The NDC number (optional)
    rxcui: The rxCUI identifier (optional)

Returns:
    MedicationSelectResultT: Detailed medication information

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no identifier is provided or medication not found
 * @summary Select Medication
 */
export const selectMedicationQueryParams = zod.object({
  dispensable_drug_id: zod.union([zod.number(), zod.null()]).optional(),
  ndc: zod.union([zod.string(), zod.null()]).optional(),
  rxcui: zod.union([zod.number(), zod.null()]).optional(),
});

export const selectMedicationResponse = zod
  .object({
    DispensableDrugId: zod.union([zod.number(), zod.null()]).optional(),
    NDC: zod.union([zod.string(), zod.null()]).optional(),
    RXCUI: zod.union([zod.number(), zod.null()]).optional(),
    DisplayName: zod.union([zod.string(), zod.null()]).optional(),
    DrugName: zod.union([zod.string(), zod.null()]).optional(),
    Route: zod.union([zod.string(), zod.null()]).optional(),
    DoseForm: zod.union([zod.string(), zod.null()]).optional(),
    Strength: zod.union([zod.string(), zod.null()]).optional(),
    DispenseUnitId: zod.union([zod.number(), zod.null()]).optional(),
    Brand: zod.union([zod.boolean(), zod.null()]).optional(),
    GenericDrugName: zod.union([zod.string(), zod.null()]).optional(),
    OTC: zod.union([zod.boolean(), zod.null()]).optional(),
    IsObsolete: zod.union([zod.boolean(), zod.null()]).optional(),
    DrugClassification: zod.union([zod.string(), zod.null()]).optional(),
    Schedule: zod.union([zod.number(), zod.null()]).optional(),
    StateSchedule: zod
      .union([
        zod.array(
          zod
            .object({
              StateName: zod.union([zod.string(), zod.null()]).optional(),
              Schedule: zod.union([zod.number(), zod.null()]).optional(),
            })
            .describe("State-specific drug scheduling information."),
        ),
        zod.null(),
      ])
      .optional(),
  })
  .describe("Result model for medication selection and detail operations.");

/**
 * Get medication monograph by ID or NDC.

This endpoint retrieves the drug monograph information for patient education.

Args:
    dispensable_drug_id: The dispensable drug ID (optional)
    ndc: The NDC number (optional)
    monograph_format: Format for monograph ("HTML" or "XML"), defaults to "HTML"

Returns:
    str: HTML or XML content of the drug monograph

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no identifier is provided or monograph not found
 * @summary Get Medication Monograph
 */
export const getMedicationMonographQueryMonographFormatDefault = "HTML";

export const getMedicationMonographQueryParams = zod.object({
  dispensable_drug_id: zod.union([zod.number(), zod.null()]).optional(),
  ndc: zod.union([zod.string(), zod.null()]).optional(),
  monograph_format: zod
    .string()
    .default(getMedicationMonographQueryMonographFormatDefault),
});

export const getMedicationMonographResponse = zod.string();

/**
 * Get all available dispense units.

This endpoint returns all available dispense unit types for use in prescriptions.

Returns:
    List[StandardDispenseUnitTypeT]: List of all dispense unit types

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the request fails
 * @summary Get Dispense Units
 */
export const getDispenseUnitsResponseItem = zod
  .object({
    StandardDispenseUnitTypeID: zod
      .union([zod.number(), zod.null()])
      .optional(),
    Name: zod.union([zod.string(), zod.null()]).optional(),
    Abbreviation: zod.union([zod.string(), zod.null()]).optional(),
    Singular: zod.union([zod.string(), zod.null()]).optional(),
    Plural: zod.union([zod.string(), zod.null()]).optional(),
    SingularOrPlural: zod.union([zod.string(), zod.null()]).optional(),
    PotencyUnitCode: zod.union([zod.string(), zod.null()]).optional(),
    IsActive: zod.union([zod.boolean(), zod.null()]).optional(),
  })
  .describe("Model for dispense unit type information.");
export const getDispenseUnitsResponse = zod.array(getDispenseUnitsResponseItem);

/**
 * Get dispense unit details by ID.

This endpoint retrieves detailed information about a specific dispense unit.

Args:
    unit_id: The dispense unit ID

Returns:
    StandardDispenseUnitTypeT: Dispense unit details

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the dispense unit is not found
 * @summary Get Dispense Unit By Id
 */
export const getDispenseUnitByIdParams = zod.object({
  unit_id: zod.number(),
});

export const getDispenseUnitByIdResponse = zod
  .object({
    StandardDispenseUnitTypeID: zod
      .union([zod.number(), zod.null()])
      .optional(),
    Name: zod.union([zod.string(), zod.null()]).optional(),
    Abbreviation: zod.union([zod.string(), zod.null()]).optional(),
    Singular: zod.union([zod.string(), zod.null()]).optional(),
    Plural: zod.union([zod.string(), zod.null()]).optional(),
    SingularOrPlural: zod.union([zod.string(), zod.null()]).optional(),
    PotencyUnitCode: zod.union([zod.string(), zod.null()]).optional(),
    IsActive: zod.union([zod.boolean(), zod.null()]).optional(),
  })
  .describe("Model for dispense unit type information.");

/**
 * Search for supplies by name, NDC, or UPC.

This endpoint searches the DoseSpot supply database. You can search by:
- Supply name (minimum 3 characters)
- Exact NDC (National Drug Code)
- Exact UPC (Universal Packaging Code)

At least one search parameter must be provided.

Args:
    name: Supply name to search for (minimum 3 characters, optional)
    ndc: National Drug Code (exact match, optional)
    upc: Universal Packaging Code (exact match, optional)
    page_number: Page number for pagination (optional)
    supply_status: Filter by supply status (optional)

Returns:
    List[SupplySearchResultT]: List of supplies matching the search criteria

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the search fails or no search parameters provided
 * @summary Search Supplies
 */
export const searchSuppliesQueryParams = zod.object({
  name: zod.union([zod.string(), zod.null()]).optional(),
  ndc: zod.union([zod.string(), zod.null()]).optional(),
  upc: zod.union([zod.string(), zod.null()]).optional(),
  page_number: zod.union([zod.number(), zod.null()]).optional(),
  supply_status: zod.union([zod.string(), zod.null()]).optional(),
});

export const searchSuppliesResponseItem = zod
  .object({
    SupplyId: zod.union([zod.number(), zod.null()]).optional(),
    NDC: zod.union([zod.string(), zod.null()]).optional(),
    UPC: zod.union([zod.string(), zod.null()]).optional(),
    Name: zod.union([zod.string(), zod.null()]).optional(),
    OTC: zod.union([zod.boolean(), zod.null()]).optional(),
    IsObsolete: zod.union([zod.boolean(), zod.null()]).optional(),
  })
  .describe("Result model for supply search operations.");
export const searchSuppliesResponse = zod.array(searchSuppliesResponseItem);

/**
 * Get supply details by ID.

This endpoint retrieves detailed information about a specific supply
from the DoseSpot database.

Args:
    supply_id: The supply ID to retrieve

Returns:
    SupplySearchResultT: Detailed supply information

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the supply is not found or request fails
 * @summary Get Supply By Id
 */
export const getSupplyByIdParams = zod.object({
  supply_id: zod.number(),
});

export const getSupplyByIdResponse = zod
  .object({
    SupplyId: zod.union([zod.number(), zod.null()]).optional(),
    NDC: zod.union([zod.string(), zod.null()]).optional(),
    UPC: zod.union([zod.string(), zod.null()]).optional(),
    Name: zod.union([zod.string(), zod.null()]).optional(),
    OTC: zod.union([zod.boolean(), zod.null()]).optional(),
    IsObsolete: zod.union([zod.boolean(), zod.null()]).optional(),
  })
  .describe("Result model for supply search operations.");

/**
 * Create a new prescription for a patient.

This endpoint creates a new prescription in DoseSpot for the specified patient.
The prescription type is automatically determined from the request data structure.

Args:
    user_id: The patient's user ID
    request: The prescription data (coded, freetext, supply, or compound) and optional clinician request ticket

Returns:
    PrescriptionT: The newly created prescription information

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the patient has no DoseSpot record or prescription creation fails
 * @summary Create Prescription
 */
export const createPrescriptionParams = zod.object({
  user_id: zod.uuid(),
});

export const createPrescriptionBody = zod.object({
  prescriptionData: zod.union([
    zod
      .object({
        DispensableDrugId: zod.number(),
        PatientFormularyId: zod.union([zod.number(), zod.null()]).optional(),
        Refills: zod.number(),
        DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
        DispenseUnitId: zod.number(),
        Quantity: zod.number(),
        Directions: zod.string(),
        PharmacyId: zod.number(),
        PharmacyNotes: zod.union([zod.string(), zod.null()]).optional(),
        NoSubstitutions: zod.union([zod.boolean(), zod.null()]).optional(),
        EffectiveDate: zod.string(),
        RxReferenceNumber: zod.union([zod.string(), zod.null()]).optional(),
        EligibilityId: zod.union([zod.number(), zod.null()]).optional(),
        NonDoseSpotPrescriptionId: zod
          .union([zod.string(), zod.null()])
          .optional(),
        FirstPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                SecondaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis IDs for requests."),
            zod.null(),
          ])
          .optional(),
        SecondPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                SecondaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis IDs for requests."),
            zod.null(),
          ])
          .optional(),
        IsRefillReplace: zod.union([zod.boolean(), zod.null()]).optional(),
        IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
        SupervisorId: zod.union([zod.number(), zod.null()]).optional(),
        RetailPharmacyToMailToPatient: zod
          .union([zod.boolean(), zod.null()])
          .optional(),
        Status: zod
          .enum([
            "Unknown",
            "Active",
            "Inactive",
            "Discontinued",
            "Deleted",
            "Completed",
            "CancelRequested",
            "CancelPending",
            "Cancelled",
            "CancelDenied",
            "Changed",
            "FullFill",
            "PartialFill",
            "NoFill",
          ])
          .describe("Valid medication status types for DoseSpot."),
        InactiveDate: zod.union([zod.string(), zod.null()]).optional(),
        Comment: zod.union([zod.string(), zod.null()]).optional(),
        Encounter: zod.union([zod.string(), zod.null()]).optional(),
      })
      .describe("Request for coded prescription creation/editing."),
    zod
      .object({
        DisplayName: zod.string(),
        NotControlled: zod.boolean(),
        Refills: zod.number(),
        DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
        DispenseUnitId: zod.number(),
        Quantity: zod.number(),
        Directions: zod.string(),
        PharmacyId: zod.number(),
        PharmacyNotes: zod.union([zod.string(), zod.null()]).optional(),
        NoSubstitutions: zod.union([zod.boolean(), zod.null()]).optional(),
        EffectiveDate: zod.string(),
        RxReferenceNumber: zod.union([zod.string(), zod.null()]).optional(),
        EligibilityId: zod.union([zod.number(), zod.null()]).optional(),
        NonDoseSpotPrescriptionId: zod
          .union([zod.string(), zod.null()])
          .optional(),
        FirstPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                SecondaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis IDs for requests."),
            zod.null(),
          ])
          .optional(),
        SecondPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                SecondaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis IDs for requests."),
            zod.null(),
          ])
          .optional(),
        IsRefillReplace: zod.union([zod.boolean(), zod.null()]).optional(),
        IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
        SupervisorId: zod.union([zod.number(), zod.null()]).optional(),
        RetailPharmacyToMailToPatient: zod
          .union([zod.boolean(), zod.null()])
          .optional(),
        Status: zod
          .enum([
            "Unknown",
            "Active",
            "Inactive",
            "Discontinued",
            "Deleted",
            "Completed",
            "CancelRequested",
            "CancelPending",
            "Cancelled",
            "CancelDenied",
            "Changed",
            "FullFill",
            "PartialFill",
            "NoFill",
          ])
          .describe("Valid medication status types for DoseSpot."),
        InactiveDate: zod.union([zod.string(), zod.null()]).optional(),
        Comment: zod.union([zod.string(), zod.null()]).optional(),
        Encounter: zod.union([zod.string(), zod.null()]).optional(),
      })
      .describe("Request for free text supply prescription creation/editing."),
    zod
      .object({
        SupplyId: zod.number(),
        Refills: zod.number(),
        DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
        DispenseUnitId: zod.number(),
        Quantity: zod.number(),
        Directions: zod.string(),
        PharmacyId: zod.number(),
        PharmacyNotes: zod.union([zod.string(), zod.null()]).optional(),
        NoSubstitutions: zod.union([zod.boolean(), zod.null()]).optional(),
        EffectiveDate: zod.string(),
        RxReferenceNumber: zod.union([zod.string(), zod.null()]).optional(),
        EligibilityId: zod.union([zod.number(), zod.null()]).optional(),
        NonDoseSpotPrescriptionId: zod
          .union([zod.string(), zod.null()])
          .optional(),
        FirstPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                SecondaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis IDs for requests."),
            zod.null(),
          ])
          .optional(),
        SecondPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                SecondaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis IDs for requests."),
            zod.null(),
          ])
          .optional(),
        IsRefillReplace: zod.union([zod.boolean(), zod.null()]).optional(),
        IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
        SupervisorId: zod.union([zod.number(), zod.null()]).optional(),
        RetailPharmacyToMailToPatient: zod
          .union([zod.boolean(), zod.null()])
          .optional(),
        Status: zod
          .enum([
            "Unknown",
            "Active",
            "Inactive",
            "Discontinued",
            "Deleted",
            "Completed",
            "CancelRequested",
            "CancelPending",
            "Cancelled",
            "CancelDenied",
            "Changed",
            "FullFill",
            "PartialFill",
            "NoFill",
          ])
          .describe("Valid medication status types for DoseSpot."),
        InactiveDate: zod.union([zod.string(), zod.null()]).optional(),
        Comment: zod.union([zod.string(), zod.null()]).optional(),
        Encounter: zod.union([zod.string(), zod.null()]).optional(),
      })
      .describe("Request for coded supply prescription creation/editing."),
    zod
      .object({
        CompoundDescription: zod.string(),
        CompoundIngredients: zod.array(
          zod
            .object({
              DispensableDrugId: zod
                .union([zod.number(), zod.null()])
                .optional(),
              FreeText: zod.union([zod.string(), zod.null()]).optional(),
              DispenseUnitId: zod.union([zod.number(), zod.null()]).optional(),
              Quantity: zod.string(),
              IsFreeTextEPCS: zod.union([zod.boolean(), zod.null()]).optional(),
            })
            .describe("DoseSpot compound ingredient information."),
        ),
        Refills: zod.number(),
        DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
        DispenseUnitId: zod.number(),
        Quantity: zod.number(),
        Directions: zod.string(),
        PharmacyId: zod.number(),
        PharmacyNotes: zod.union([zod.string(), zod.null()]).optional(),
        NoSubstitutions: zod.union([zod.boolean(), zod.null()]).optional(),
        EffectiveDate: zod.string(),
        RxReferenceNumber: zod.union([zod.string(), zod.null()]).optional(),
        EligibilityId: zod.union([zod.number(), zod.null()]).optional(),
        NonDoseSpotPrescriptionId: zod
          .union([zod.string(), zod.null()])
          .optional(),
        FirstPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                SecondaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis IDs for requests."),
            zod.null(),
          ])
          .optional(),
        SecondPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                SecondaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis IDs for requests."),
            zod.null(),
          ])
          .optional(),
        IsRefillReplace: zod.union([zod.boolean(), zod.null()]).optional(),
        IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
        SupervisorId: zod.union([zod.number(), zod.null()]).optional(),
        RetailPharmacyToMailToPatient: zod
          .union([zod.boolean(), zod.null()])
          .optional(),
        Status: zod
          .enum([
            "Unknown",
            "Active",
            "Inactive",
            "Discontinued",
            "Deleted",
            "Completed",
            "CancelRequested",
            "CancelPending",
            "Cancelled",
            "CancelDenied",
            "Changed",
            "FullFill",
            "PartialFill",
            "NoFill",
          ])
          .describe("Valid medication status types for DoseSpot."),
        InactiveDate: zod.union([zod.string(), zod.null()]).optional(),
        Comment: zod.union([zod.string(), zod.null()]).optional(),
        Encounter: zod.union([zod.string(), zod.null()]).optional(),
      })
      .describe("Request for compound prescription creation/editing."),
  ]),
  clinicianRequestTicket: zod.union([zod.uuid(), zod.null()]).optional(),
});

export const createPrescriptionResponse = zod
  .object({
    PrescriptionId: zod.union([zod.number(), zod.null()]).optional(),
    WrittenDate: zod.union([zod.string(), zod.null()]).optional(),
    Directions: zod.union([zod.string(), zod.null()]).optional(),
    Quantity: zod.union([zod.string(), zod.null()]).optional(),
    DispenseUnitId: zod.union([zod.number(), zod.null()]).optional(),
    Refills: zod.union([zod.string(), zod.null()]).optional(),
    DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
    PharmacyId: zod.union([zod.number(), zod.null()]).optional(),
    PharmacyNotes: zod.union([zod.string(), zod.null()]).optional(),
    NoSubstitutions: zod.union([zod.boolean(), zod.null()]).optional(),
    EffectiveDate: zod.union([zod.string(), zod.null()]).optional(),
    LastFillDate: zod.union([zod.string(), zod.null()]).optional(),
    PrescriberId: zod.union([zod.number(), zod.null()]).optional(),
    PrescriberAgentId: zod.union([zod.number(), zod.null()]).optional(),
    RxReferenceNumber: zod.union([zod.string(), zod.null()]).optional(),
    Status: zod
      .union([
        zod
          .enum([
            "Unknown",
            "Entered",
            "Printed",
            "Sending",
            "eRxSent",
            "FaxSent",
            "Error",
            "Deleted",
            "Requested",
            "Edited",
            "EpcsError",
            "EpcsSigned",
            "ReadyToSign",
            "PharmacyVerified",
            "PharmacySelect",
          ])
          .describe("Valid prescription status types for DoseSpot."),
        zod.null(),
      ])
      .optional(),
    Formulary: zod.union([zod.boolean(), zod.null()]).optional(),
    EligibilityId: zod.union([zod.number(), zod.null()]).optional(),
    Type: zod
      .union([
        zod
          .enum(["Coded", "FreeText", "NDC", "Supply", "Compound"])
          .describe("Valid prescription types for DoseSpot."),
        zod.null(),
      ])
      .optional(),
    NonDoseSpotPrescriptionId: zod.union([zod.string(), zod.null()]).optional(),
    ErrorIgnored: zod.union([zod.boolean(), zod.null()]).optional(),
    SupplyId: zod.union([zod.number(), zod.null()]).optional(),
    FreeTextType: zod
      .union([
        zod
          .enum(["Medication", "Supply", "Compound"])
          .describe("Valid free text types for DoseSpot prescriptions."),
        zod.null(),
      ])
      .optional(),
    ClinicId: zod.union([zod.number(), zod.null()]).optional(),
    SupervisorId: zod.union([zod.number(), zod.null()]).optional(),
    IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
    IsRxRenewal: zod.union([zod.boolean(), zod.null()]).optional(),
    RxRenewalNote: zod.union([zod.string(), zod.null()]).optional(),
    FirstPrescriptionDiagnosis: zod
      .union([
        zod
          .object({
            PrimaryDiagnosis: zod
              .union([
                zod
                  .object({
                    DiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    DiagnosisCode: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    DiagnosisDescription: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                  })
                  .describe("DoseSpot diagnosis information."),
                zod.null(),
              ])
              .optional(),
            SecondaryDiagnosis: zod
              .union([
                zod
                  .object({
                    DiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    DiagnosisCode: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    DiagnosisDescription: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                  })
                  .describe("DoseSpot diagnosis information."),
                zod.null(),
              ])
              .optional(),
          })
          .describe("DoseSpot prescription diagnosis information."),
        zod.null(),
      ])
      .optional(),
    SecondPrescriptionDiagnosis: zod
      .union([
        zod
          .object({
            PrimaryDiagnosis: zod
              .union([
                zod
                  .object({
                    DiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    DiagnosisCode: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    DiagnosisDescription: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                  })
                  .describe("DoseSpot diagnosis information."),
                zod.null(),
              ])
              .optional(),
            SecondaryDiagnosis: zod
              .union([
                zod
                  .object({
                    DiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    DiagnosisCode: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    DiagnosisDescription: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                  })
                  .describe("DoseSpot diagnosis information."),
                zod.null(),
              ])
              .optional(),
          })
          .describe("DoseSpot prescription diagnosis information."),
        zod.null(),
      ])
      .optional(),
    Strength: zod.union([zod.string(), zod.null()]).optional(),
    PatientMedicationId: zod.union([zod.number(), zod.null()]).optional(),
    MedicationStatus: zod
      .union([
        zod
          .enum([
            "Unknown",
            "Active",
            "Inactive",
            "Discontinued",
            "Deleted",
            "Completed",
            "CancelRequested",
            "CancelPending",
            "Cancelled",
            "CancelDenied",
            "Changed",
            "FullFill",
            "PartialFill",
            "NoFill",
          ])
          .describe("Valid medication status types for DoseSpot."),
        zod.null(),
      ])
      .optional(),
    Comment: zod.union([zod.string(), zod.null()]).optional(),
    DateInactive: zod.union([zod.string(), zod.null()]).optional(),
    Encounter: zod.union([zod.string(), zod.null()]).optional(),
    DisplayName: zod.union([zod.string(), zod.null()]).optional(),
    DispensableDrugId: zod.union([zod.number(), zod.null()]).optional(),
    Schedule: zod.union([zod.number(), zod.null()]).optional(),
    CompoundIngredients: zod
      .union([
        zod.array(
          zod
            .object({
              DispensableDrugId: zod
                .union([zod.number(), zod.null()])
                .optional(),
              FreeText: zod.union([zod.string(), zod.null()]).optional(),
              DispenseUnitId: zod.union([zod.number(), zod.null()]).optional(),
              Quantity: zod.string(),
              IsFreeTextEPCS: zod.union([zod.boolean(), zod.null()]).optional(),
            })
            .describe("DoseSpot compound ingredient information."),
        ),
        zod.null(),
      ])
      .optional(),
  })
  .describe("Complete prescription information from DoseSpot API.");

/**
 * Edit an existing prescription.

This endpoint updates an existing prescription in DoseSpot.

Args:
    dosespot_prescription_id: The DoseSpot prescription ID to edit
    request: The updated prescription data

Returns:
    PrescriptionT: The updated prescription information

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the prescription record is not found or update fails
 * @summary Edit Prescription
 */
export const editPrescriptionParams = zod.object({
  dosespot_prescription_id: zod.string(),
});

export const editPrescriptionBody = zod.object({
  prescriptionData: zod.union([
    zod
      .object({
        DispensableDrugId: zod.number(),
        PatientFormularyId: zod.union([zod.number(), zod.null()]).optional(),
        Refills: zod.number(),
        DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
        DispenseUnitId: zod.number(),
        Quantity: zod.number(),
        Directions: zod.string(),
        PharmacyId: zod.number(),
        PharmacyNotes: zod.union([zod.string(), zod.null()]).optional(),
        NoSubstitutions: zod.union([zod.boolean(), zod.null()]).optional(),
        EffectiveDate: zod.string(),
        RxReferenceNumber: zod.union([zod.string(), zod.null()]).optional(),
        EligibilityId: zod.union([zod.number(), zod.null()]).optional(),
        NonDoseSpotPrescriptionId: zod
          .union([zod.string(), zod.null()])
          .optional(),
        FirstPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                SecondaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis IDs for requests."),
            zod.null(),
          ])
          .optional(),
        SecondPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                SecondaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis IDs for requests."),
            zod.null(),
          ])
          .optional(),
        IsRefillReplace: zod.union([zod.boolean(), zod.null()]).optional(),
        IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
        SupervisorId: zod.union([zod.number(), zod.null()]).optional(),
        RetailPharmacyToMailToPatient: zod
          .union([zod.boolean(), zod.null()])
          .optional(),
        Status: zod
          .enum([
            "Unknown",
            "Active",
            "Inactive",
            "Discontinued",
            "Deleted",
            "Completed",
            "CancelRequested",
            "CancelPending",
            "Cancelled",
            "CancelDenied",
            "Changed",
            "FullFill",
            "PartialFill",
            "NoFill",
          ])
          .describe("Valid medication status types for DoseSpot."),
        InactiveDate: zod.union([zod.string(), zod.null()]).optional(),
        Comment: zod.union([zod.string(), zod.null()]).optional(),
        Encounter: zod.union([zod.string(), zod.null()]).optional(),
      })
      .describe("Request for coded prescription creation/editing."),
    zod
      .object({
        DisplayName: zod.string(),
        NotControlled: zod.boolean(),
        Refills: zod.number(),
        DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
        DispenseUnitId: zod.number(),
        Quantity: zod.number(),
        Directions: zod.string(),
        PharmacyId: zod.number(),
        PharmacyNotes: zod.union([zod.string(), zod.null()]).optional(),
        NoSubstitutions: zod.union([zod.boolean(), zod.null()]).optional(),
        EffectiveDate: zod.string(),
        RxReferenceNumber: zod.union([zod.string(), zod.null()]).optional(),
        EligibilityId: zod.union([zod.number(), zod.null()]).optional(),
        NonDoseSpotPrescriptionId: zod
          .union([zod.string(), zod.null()])
          .optional(),
        FirstPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                SecondaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis IDs for requests."),
            zod.null(),
          ])
          .optional(),
        SecondPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                SecondaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis IDs for requests."),
            zod.null(),
          ])
          .optional(),
        IsRefillReplace: zod.union([zod.boolean(), zod.null()]).optional(),
        IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
        SupervisorId: zod.union([zod.number(), zod.null()]).optional(),
        RetailPharmacyToMailToPatient: zod
          .union([zod.boolean(), zod.null()])
          .optional(),
        Status: zod
          .enum([
            "Unknown",
            "Active",
            "Inactive",
            "Discontinued",
            "Deleted",
            "Completed",
            "CancelRequested",
            "CancelPending",
            "Cancelled",
            "CancelDenied",
            "Changed",
            "FullFill",
            "PartialFill",
            "NoFill",
          ])
          .describe("Valid medication status types for DoseSpot."),
        InactiveDate: zod.union([zod.string(), zod.null()]).optional(),
        Comment: zod.union([zod.string(), zod.null()]).optional(),
        Encounter: zod.union([zod.string(), zod.null()]).optional(),
      })
      .describe("Request for free text supply prescription creation/editing."),
    zod
      .object({
        SupplyId: zod.number(),
        Refills: zod.number(),
        DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
        DispenseUnitId: zod.number(),
        Quantity: zod.number(),
        Directions: zod.string(),
        PharmacyId: zod.number(),
        PharmacyNotes: zod.union([zod.string(), zod.null()]).optional(),
        NoSubstitutions: zod.union([zod.boolean(), zod.null()]).optional(),
        EffectiveDate: zod.string(),
        RxReferenceNumber: zod.union([zod.string(), zod.null()]).optional(),
        EligibilityId: zod.union([zod.number(), zod.null()]).optional(),
        NonDoseSpotPrescriptionId: zod
          .union([zod.string(), zod.null()])
          .optional(),
        FirstPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                SecondaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis IDs for requests."),
            zod.null(),
          ])
          .optional(),
        SecondPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                SecondaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis IDs for requests."),
            zod.null(),
          ])
          .optional(),
        IsRefillReplace: zod.union([zod.boolean(), zod.null()]).optional(),
        IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
        SupervisorId: zod.union([zod.number(), zod.null()]).optional(),
        RetailPharmacyToMailToPatient: zod
          .union([zod.boolean(), zod.null()])
          .optional(),
        Status: zod
          .enum([
            "Unknown",
            "Active",
            "Inactive",
            "Discontinued",
            "Deleted",
            "Completed",
            "CancelRequested",
            "CancelPending",
            "Cancelled",
            "CancelDenied",
            "Changed",
            "FullFill",
            "PartialFill",
            "NoFill",
          ])
          .describe("Valid medication status types for DoseSpot."),
        InactiveDate: zod.union([zod.string(), zod.null()]).optional(),
        Comment: zod.union([zod.string(), zod.null()]).optional(),
        Encounter: zod.union([zod.string(), zod.null()]).optional(),
      })
      .describe("Request for coded supply prescription creation/editing."),
    zod
      .object({
        CompoundDescription: zod.string(),
        CompoundIngredients: zod.array(
          zod
            .object({
              DispensableDrugId: zod
                .union([zod.number(), zod.null()])
                .optional(),
              FreeText: zod.union([zod.string(), zod.null()]).optional(),
              DispenseUnitId: zod.union([zod.number(), zod.null()]).optional(),
              Quantity: zod.string(),
              IsFreeTextEPCS: zod.union([zod.boolean(), zod.null()]).optional(),
            })
            .describe("DoseSpot compound ingredient information."),
        ),
        Refills: zod.number(),
        DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
        DispenseUnitId: zod.number(),
        Quantity: zod.number(),
        Directions: zod.string(),
        PharmacyId: zod.number(),
        PharmacyNotes: zod.union([zod.string(), zod.null()]).optional(),
        NoSubstitutions: zod.union([zod.boolean(), zod.null()]).optional(),
        EffectiveDate: zod.string(),
        RxReferenceNumber: zod.union([zod.string(), zod.null()]).optional(),
        EligibilityId: zod.union([zod.number(), zod.null()]).optional(),
        NonDoseSpotPrescriptionId: zod
          .union([zod.string(), zod.null()])
          .optional(),
        FirstPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                SecondaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis IDs for requests."),
            zod.null(),
          ])
          .optional(),
        SecondPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                SecondaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis IDs for requests."),
            zod.null(),
          ])
          .optional(),
        IsRefillReplace: zod.union([zod.boolean(), zod.null()]).optional(),
        IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
        SupervisorId: zod.union([zod.number(), zod.null()]).optional(),
        RetailPharmacyToMailToPatient: zod
          .union([zod.boolean(), zod.null()])
          .optional(),
        Status: zod
          .enum([
            "Unknown",
            "Active",
            "Inactive",
            "Discontinued",
            "Deleted",
            "Completed",
            "CancelRequested",
            "CancelPending",
            "Cancelled",
            "CancelDenied",
            "Changed",
            "FullFill",
            "PartialFill",
            "NoFill",
          ])
          .describe("Valid medication status types for DoseSpot."),
        InactiveDate: zod.union([zod.string(), zod.null()]).optional(),
        Comment: zod.union([zod.string(), zod.null()]).optional(),
        Encounter: zod.union([zod.string(), zod.null()]).optional(),
      })
      .describe("Request for compound prescription creation/editing."),
  ]),
});

export const editPrescriptionResponse = zod
  .object({
    PrescriptionId: zod.union([zod.number(), zod.null()]).optional(),
    WrittenDate: zod.union([zod.string(), zod.null()]).optional(),
    Directions: zod.union([zod.string(), zod.null()]).optional(),
    Quantity: zod.union([zod.string(), zod.null()]).optional(),
    DispenseUnitId: zod.union([zod.number(), zod.null()]).optional(),
    Refills: zod.union([zod.string(), zod.null()]).optional(),
    DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
    PharmacyId: zod.union([zod.number(), zod.null()]).optional(),
    PharmacyNotes: zod.union([zod.string(), zod.null()]).optional(),
    NoSubstitutions: zod.union([zod.boolean(), zod.null()]).optional(),
    EffectiveDate: zod.union([zod.string(), zod.null()]).optional(),
    LastFillDate: zod.union([zod.string(), zod.null()]).optional(),
    PrescriberId: zod.union([zod.number(), zod.null()]).optional(),
    PrescriberAgentId: zod.union([zod.number(), zod.null()]).optional(),
    RxReferenceNumber: zod.union([zod.string(), zod.null()]).optional(),
    Status: zod
      .union([
        zod
          .enum([
            "Unknown",
            "Entered",
            "Printed",
            "Sending",
            "eRxSent",
            "FaxSent",
            "Error",
            "Deleted",
            "Requested",
            "Edited",
            "EpcsError",
            "EpcsSigned",
            "ReadyToSign",
            "PharmacyVerified",
            "PharmacySelect",
          ])
          .describe("Valid prescription status types for DoseSpot."),
        zod.null(),
      ])
      .optional(),
    Formulary: zod.union([zod.boolean(), zod.null()]).optional(),
    EligibilityId: zod.union([zod.number(), zod.null()]).optional(),
    Type: zod
      .union([
        zod
          .enum(["Coded", "FreeText", "NDC", "Supply", "Compound"])
          .describe("Valid prescription types for DoseSpot."),
        zod.null(),
      ])
      .optional(),
    NonDoseSpotPrescriptionId: zod.union([zod.string(), zod.null()]).optional(),
    ErrorIgnored: zod.union([zod.boolean(), zod.null()]).optional(),
    SupplyId: zod.union([zod.number(), zod.null()]).optional(),
    FreeTextType: zod
      .union([
        zod
          .enum(["Medication", "Supply", "Compound"])
          .describe("Valid free text types for DoseSpot prescriptions."),
        zod.null(),
      ])
      .optional(),
    ClinicId: zod.union([zod.number(), zod.null()]).optional(),
    SupervisorId: zod.union([zod.number(), zod.null()]).optional(),
    IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
    IsRxRenewal: zod.union([zod.boolean(), zod.null()]).optional(),
    RxRenewalNote: zod.union([zod.string(), zod.null()]).optional(),
    FirstPrescriptionDiagnosis: zod
      .union([
        zod
          .object({
            PrimaryDiagnosis: zod
              .union([
                zod
                  .object({
                    DiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    DiagnosisCode: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    DiagnosisDescription: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                  })
                  .describe("DoseSpot diagnosis information."),
                zod.null(),
              ])
              .optional(),
            SecondaryDiagnosis: zod
              .union([
                zod
                  .object({
                    DiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    DiagnosisCode: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    DiagnosisDescription: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                  })
                  .describe("DoseSpot diagnosis information."),
                zod.null(),
              ])
              .optional(),
          })
          .describe("DoseSpot prescription diagnosis information."),
        zod.null(),
      ])
      .optional(),
    SecondPrescriptionDiagnosis: zod
      .union([
        zod
          .object({
            PrimaryDiagnosis: zod
              .union([
                zod
                  .object({
                    DiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    DiagnosisCode: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    DiagnosisDescription: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                  })
                  .describe("DoseSpot diagnosis information."),
                zod.null(),
              ])
              .optional(),
            SecondaryDiagnosis: zod
              .union([
                zod
                  .object({
                    DiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    DiagnosisCode: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    DiagnosisDescription: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                  })
                  .describe("DoseSpot diagnosis information."),
                zod.null(),
              ])
              .optional(),
          })
          .describe("DoseSpot prescription diagnosis information."),
        zod.null(),
      ])
      .optional(),
    Strength: zod.union([zod.string(), zod.null()]).optional(),
    PatientMedicationId: zod.union([zod.number(), zod.null()]).optional(),
    MedicationStatus: zod
      .union([
        zod
          .enum([
            "Unknown",
            "Active",
            "Inactive",
            "Discontinued",
            "Deleted",
            "Completed",
            "CancelRequested",
            "CancelPending",
            "Cancelled",
            "CancelDenied",
            "Changed",
            "FullFill",
            "PartialFill",
            "NoFill",
          ])
          .describe("Valid medication status types for DoseSpot."),
        zod.null(),
      ])
      .optional(),
    Comment: zod.union([zod.string(), zod.null()]).optional(),
    DateInactive: zod.union([zod.string(), zod.null()]).optional(),
    Encounter: zod.union([zod.string(), zod.null()]).optional(),
    DisplayName: zod.union([zod.string(), zod.null()]).optional(),
    DispensableDrugId: zod.union([zod.number(), zod.null()]).optional(),
    Schedule: zod.union([zod.number(), zod.null()]).optional(),
    CompoundIngredients: zod
      .union([
        zod.array(
          zod
            .object({
              DispensableDrugId: zod
                .union([zod.number(), zod.null()])
                .optional(),
              FreeText: zod.union([zod.string(), zod.null()]).optional(),
              DispenseUnitId: zod.union([zod.number(), zod.null()]).optional(),
              Quantity: zod.string(),
              IsFreeTextEPCS: zod.union([zod.boolean(), zod.null()]).optional(),
            })
            .describe("DoseSpot compound ingredient information."),
        ),
        zod.null(),
      ])
      .optional(),
  })
  .describe("Complete prescription information from DoseSpot API.");

/**
 * Delete a prescription.

This endpoint cancels a prescription in DoseSpot and deletes the local record.

Args:
    dosespot_prescription_id: The DoseSpot prescription ID to delete

Returns:
    PrescriptionMessageT: Message indicating success or failure with error details

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the prescription record is not found
 * @summary Delete Prescription
 */
export const deletePrescriptionParams = zod.object({
  dosespot_prescription_id: zod.string(),
});

export const deletePrescriptionResponse = zod
  .object({
    success: zod.boolean(),
    message: zod.union([zod.string(), zod.null()]).optional(),
  })
  .describe(
    "Message response for prescription operations that may have errors.",
  );

/**
 * Get prescriptions for a patient with optional pagination.

This endpoint retrieves prescriptions for the specified patient with optional pagination support.

Args:
    user_id: The patient's user ID
    limit: Maximum number of prescriptions to return (None for no limit)
    offset: Number of prescriptions to skip
    synchronize: Whether to synchronize with DoseSpot before answering
Returns:
    PaginatedPrescriptionsResponseT: Paginated list of prescriptions for the patient

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the patient has no DoseSpot record
 * @summary Get Prescriptions For Patient
 */
export const getPrescriptionsForPatientParams = zod.object({
  user_id: zod.uuid(),
});

export const getPrescriptionsForPatientQueryOffsetDefault = 0;
export const getPrescriptionsForPatientQuerySynchronizeDefault = false;

export const getPrescriptionsForPatientQueryParams = zod.object({
  limit: zod.union([zod.number(), zod.null()]).optional(),
  offset: zod.number().optional(),
  synchronize: zod.boolean().optional(),
});

export const getPrescriptionsForPatientResponseOffsetDefault = 0;
export const getPrescriptionsForPatientResponseHasNextDefault = false;
export const getPrescriptionsForPatientResponseHasPreviousDefault = false;

export const getPrescriptionsForPatientResponse = zod.object({
  prescriptions: zod.array(
    zod
      .object({
        PrescriptionId: zod.union([zod.number(), zod.null()]).optional(),
        WrittenDate: zod.union([zod.string(), zod.null()]).optional(),
        Directions: zod.union([zod.string(), zod.null()]).optional(),
        Quantity: zod.union([zod.string(), zod.null()]).optional(),
        DispenseUnitId: zod.union([zod.number(), zod.null()]).optional(),
        Refills: zod.union([zod.string(), zod.null()]).optional(),
        DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
        PharmacyId: zod.union([zod.number(), zod.null()]).optional(),
        PharmacyNotes: zod.union([zod.string(), zod.null()]).optional(),
        NoSubstitutions: zod.union([zod.boolean(), zod.null()]).optional(),
        EffectiveDate: zod.union([zod.string(), zod.null()]).optional(),
        LastFillDate: zod.union([zod.string(), zod.null()]).optional(),
        PrescriberId: zod.union([zod.number(), zod.null()]).optional(),
        PrescriberAgentId: zod.union([zod.number(), zod.null()]).optional(),
        RxReferenceNumber: zod.union([zod.string(), zod.null()]).optional(),
        Status: zod
          .union([
            zod
              .enum([
                "Unknown",
                "Entered",
                "Printed",
                "Sending",
                "eRxSent",
                "FaxSent",
                "Error",
                "Deleted",
                "Requested",
                "Edited",
                "EpcsError",
                "EpcsSigned",
                "ReadyToSign",
                "PharmacyVerified",
                "PharmacySelect",
              ])
              .describe("Valid prescription status types for DoseSpot."),
            zod.null(),
          ])
          .optional(),
        Formulary: zod.union([zod.boolean(), zod.null()]).optional(),
        EligibilityId: zod.union([zod.number(), zod.null()]).optional(),
        Type: zod
          .union([
            zod
              .enum(["Coded", "FreeText", "NDC", "Supply", "Compound"])
              .describe("Valid prescription types for DoseSpot."),
            zod.null(),
          ])
          .optional(),
        NonDoseSpotPrescriptionId: zod
          .union([zod.string(), zod.null()])
          .optional(),
        ErrorIgnored: zod.union([zod.boolean(), zod.null()]).optional(),
        SupplyId: zod.union([zod.number(), zod.null()]).optional(),
        FreeTextType: zod
          .union([
            zod
              .enum(["Medication", "Supply", "Compound"])
              .describe("Valid free text types for DoseSpot prescriptions."),
            zod.null(),
          ])
          .optional(),
        ClinicId: zod.union([zod.number(), zod.null()]).optional(),
        SupervisorId: zod.union([zod.number(), zod.null()]).optional(),
        IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
        IsRxRenewal: zod.union([zod.boolean(), zod.null()]).optional(),
        RxRenewalNote: zod.union([zod.string(), zod.null()]).optional(),
        FirstPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosis: zod
                  .union([
                    zod
                      .object({
                        DiagnosisId: zod
                          .union([zod.number(), zod.null()])
                          .optional(),
                        DiagnosisCode: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        DiagnosisDescription: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                      })
                      .describe("DoseSpot diagnosis information."),
                    zod.null(),
                  ])
                  .optional(),
                SecondaryDiagnosis: zod
                  .union([
                    zod
                      .object({
                        DiagnosisId: zod
                          .union([zod.number(), zod.null()])
                          .optional(),
                        DiagnosisCode: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        DiagnosisDescription: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                      })
                      .describe("DoseSpot diagnosis information."),
                    zod.null(),
                  ])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis information."),
            zod.null(),
          ])
          .optional(),
        SecondPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosis: zod
                  .union([
                    zod
                      .object({
                        DiagnosisId: zod
                          .union([zod.number(), zod.null()])
                          .optional(),
                        DiagnosisCode: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        DiagnosisDescription: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                      })
                      .describe("DoseSpot diagnosis information."),
                    zod.null(),
                  ])
                  .optional(),
                SecondaryDiagnosis: zod
                  .union([
                    zod
                      .object({
                        DiagnosisId: zod
                          .union([zod.number(), zod.null()])
                          .optional(),
                        DiagnosisCode: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        DiagnosisDescription: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                      })
                      .describe("DoseSpot diagnosis information."),
                    zod.null(),
                  ])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis information."),
            zod.null(),
          ])
          .optional(),
        Strength: zod.union([zod.string(), zod.null()]).optional(),
        PatientMedicationId: zod.union([zod.number(), zod.null()]).optional(),
        MedicationStatus: zod
          .union([
            zod
              .enum([
                "Unknown",
                "Active",
                "Inactive",
                "Discontinued",
                "Deleted",
                "Completed",
                "CancelRequested",
                "CancelPending",
                "Cancelled",
                "CancelDenied",
                "Changed",
                "FullFill",
                "PartialFill",
                "NoFill",
              ])
              .describe("Valid medication status types for DoseSpot."),
            zod.null(),
          ])
          .optional(),
        Comment: zod.union([zod.string(), zod.null()]).optional(),
        DateInactive: zod.union([zod.string(), zod.null()]).optional(),
        Encounter: zod.union([zod.string(), zod.null()]).optional(),
        DisplayName: zod.union([zod.string(), zod.null()]).optional(),
        DispensableDrugId: zod.union([zod.number(), zod.null()]).optional(),
        Schedule: zod.union([zod.number(), zod.null()]).optional(),
        CompoundIngredients: zod
          .union([
            zod.array(
              zod
                .object({
                  DispensableDrugId: zod
                    .union([zod.number(), zod.null()])
                    .optional(),
                  FreeText: zod.union([zod.string(), zod.null()]).optional(),
                  DispenseUnitId: zod
                    .union([zod.number(), zod.null()])
                    .optional(),
                  Quantity: zod.string(),
                  IsFreeTextEPCS: zod
                    .union([zod.boolean(), zod.null()])
                    .optional(),
                })
                .describe("DoseSpot compound ingredient information."),
            ),
            zod.null(),
          ])
          .optional(),
      })
      .describe("Complete prescription information from DoseSpot API."),
  ),
  totalCount: zod.number(),
  limit: zod.union([zod.number(), zod.null()]).optional(),
  offset: zod.number().optional(),
  hasNext: zod.boolean().optional(),
  hasPrevious: zod.boolean().optional(),
});

/**
 * Get a specific prescription for a patient.

This endpoint retrieves a specific prescription for the specified patient.

Args:
    user_id: The patient's user ID
    dosespot_prescription_id: The DoseSpot prescription ID

Returns:
    PrescriptionT or None: The prescription information if found

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the patient has no DoseSpot record
 * @summary Get Prescription
 */
export const getPrescriptionParams = zod.object({
  user_id: zod.uuid(),
  dosespot_prescription_id: zod.string(),
});

export const getPrescriptionResponse = zod.union([
  zod
    .object({
      PrescriptionId: zod.union([zod.number(), zod.null()]).optional(),
      WrittenDate: zod.union([zod.string(), zod.null()]).optional(),
      Directions: zod.union([zod.string(), zod.null()]).optional(),
      Quantity: zod.union([zod.string(), zod.null()]).optional(),
      DispenseUnitId: zod.union([zod.number(), zod.null()]).optional(),
      Refills: zod.union([zod.string(), zod.null()]).optional(),
      DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
      PharmacyId: zod.union([zod.number(), zod.null()]).optional(),
      PharmacyNotes: zod.union([zod.string(), zod.null()]).optional(),
      NoSubstitutions: zod.union([zod.boolean(), zod.null()]).optional(),
      EffectiveDate: zod.union([zod.string(), zod.null()]).optional(),
      LastFillDate: zod.union([zod.string(), zod.null()]).optional(),
      PrescriberId: zod.union([zod.number(), zod.null()]).optional(),
      PrescriberAgentId: zod.union([zod.number(), zod.null()]).optional(),
      RxReferenceNumber: zod.union([zod.string(), zod.null()]).optional(),
      Status: zod
        .union([
          zod
            .enum([
              "Unknown",
              "Entered",
              "Printed",
              "Sending",
              "eRxSent",
              "FaxSent",
              "Error",
              "Deleted",
              "Requested",
              "Edited",
              "EpcsError",
              "EpcsSigned",
              "ReadyToSign",
              "PharmacyVerified",
              "PharmacySelect",
            ])
            .describe("Valid prescription status types for DoseSpot."),
          zod.null(),
        ])
        .optional(),
      Formulary: zod.union([zod.boolean(), zod.null()]).optional(),
      EligibilityId: zod.union([zod.number(), zod.null()]).optional(),
      Type: zod
        .union([
          zod
            .enum(["Coded", "FreeText", "NDC", "Supply", "Compound"])
            .describe("Valid prescription types for DoseSpot."),
          zod.null(),
        ])
        .optional(),
      NonDoseSpotPrescriptionId: zod
        .union([zod.string(), zod.null()])
        .optional(),
      ErrorIgnored: zod.union([zod.boolean(), zod.null()]).optional(),
      SupplyId: zod.union([zod.number(), zod.null()]).optional(),
      FreeTextType: zod
        .union([
          zod
            .enum(["Medication", "Supply", "Compound"])
            .describe("Valid free text types for DoseSpot prescriptions."),
          zod.null(),
        ])
        .optional(),
      ClinicId: zod.union([zod.number(), zod.null()]).optional(),
      SupervisorId: zod.union([zod.number(), zod.null()]).optional(),
      IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
      IsRxRenewal: zod.union([zod.boolean(), zod.null()]).optional(),
      RxRenewalNote: zod.union([zod.string(), zod.null()]).optional(),
      FirstPrescriptionDiagnosis: zod
        .union([
          zod
            .object({
              PrimaryDiagnosis: zod
                .union([
                  zod
                    .object({
                      DiagnosisId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      DiagnosisCode: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DiagnosisDescription: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                    })
                    .describe("DoseSpot diagnosis information."),
                  zod.null(),
                ])
                .optional(),
              SecondaryDiagnosis: zod
                .union([
                  zod
                    .object({
                      DiagnosisId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      DiagnosisCode: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DiagnosisDescription: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                    })
                    .describe("DoseSpot diagnosis information."),
                  zod.null(),
                ])
                .optional(),
            })
            .describe("DoseSpot prescription diagnosis information."),
          zod.null(),
        ])
        .optional(),
      SecondPrescriptionDiagnosis: zod
        .union([
          zod
            .object({
              PrimaryDiagnosis: zod
                .union([
                  zod
                    .object({
                      DiagnosisId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      DiagnosisCode: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DiagnosisDescription: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                    })
                    .describe("DoseSpot diagnosis information."),
                  zod.null(),
                ])
                .optional(),
              SecondaryDiagnosis: zod
                .union([
                  zod
                    .object({
                      DiagnosisId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      DiagnosisCode: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DiagnosisDescription: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                    })
                    .describe("DoseSpot diagnosis information."),
                  zod.null(),
                ])
                .optional(),
            })
            .describe("DoseSpot prescription diagnosis information."),
          zod.null(),
        ])
        .optional(),
      Strength: zod.union([zod.string(), zod.null()]).optional(),
      PatientMedicationId: zod.union([zod.number(), zod.null()]).optional(),
      MedicationStatus: zod
        .union([
          zod
            .enum([
              "Unknown",
              "Active",
              "Inactive",
              "Discontinued",
              "Deleted",
              "Completed",
              "CancelRequested",
              "CancelPending",
              "Cancelled",
              "CancelDenied",
              "Changed",
              "FullFill",
              "PartialFill",
              "NoFill",
            ])
            .describe("Valid medication status types for DoseSpot."),
          zod.null(),
        ])
        .optional(),
      Comment: zod.union([zod.string(), zod.null()]).optional(),
      DateInactive: zod.union([zod.string(), zod.null()]).optional(),
      Encounter: zod.union([zod.string(), zod.null()]).optional(),
      DisplayName: zod.union([zod.string(), zod.null()]).optional(),
      DispensableDrugId: zod.union([zod.number(), zod.null()]).optional(),
      Schedule: zod.union([zod.number(), zod.null()]).optional(),
      CompoundIngredients: zod
        .union([
          zod.array(
            zod
              .object({
                DispensableDrugId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                FreeText: zod.union([zod.string(), zod.null()]).optional(),
                DispenseUnitId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                Quantity: zod.string(),
                IsFreeTextEPCS: zod
                  .union([zod.boolean(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot compound ingredient information."),
          ),
          zod.null(),
        ])
        .optional(),
    })
    .describe("Complete prescription information from DoseSpot API."),
  zod.null(),
]);

/**
 * Change the pharmacy for an existing prescription.

This endpoint updates the pharmacy for a specific prescription in DoseSpot.

Args:
    dosespot_prescription_id: The DoseSpot prescription ID to update
    request: The new pharmacy information

Returns:
    PrescriptionT: The updated prescription information

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the prescription record is not found or pharmacy change fails
 * @summary Change Prescription Pharmacy
 */
export const changePrescriptionPharmacyParams = zod.object({
  dosespot_prescription_id: zod.string(),
});

export const changePrescriptionPharmacyBody = zod.object({
  pharmacyId: zod.number(),
});

export const changePrescriptionPharmacyResponse = zod
  .object({
    PrescriptionId: zod.union([zod.number(), zod.null()]).optional(),
    WrittenDate: zod.union([zod.string(), zod.null()]).optional(),
    Directions: zod.union([zod.string(), zod.null()]).optional(),
    Quantity: zod.union([zod.string(), zod.null()]).optional(),
    DispenseUnitId: zod.union([zod.number(), zod.null()]).optional(),
    Refills: zod.union([zod.string(), zod.null()]).optional(),
    DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
    PharmacyId: zod.union([zod.number(), zod.null()]).optional(),
    PharmacyNotes: zod.union([zod.string(), zod.null()]).optional(),
    NoSubstitutions: zod.union([zod.boolean(), zod.null()]).optional(),
    EffectiveDate: zod.union([zod.string(), zod.null()]).optional(),
    LastFillDate: zod.union([zod.string(), zod.null()]).optional(),
    PrescriberId: zod.union([zod.number(), zod.null()]).optional(),
    PrescriberAgentId: zod.union([zod.number(), zod.null()]).optional(),
    RxReferenceNumber: zod.union([zod.string(), zod.null()]).optional(),
    Status: zod
      .union([
        zod
          .enum([
            "Unknown",
            "Entered",
            "Printed",
            "Sending",
            "eRxSent",
            "FaxSent",
            "Error",
            "Deleted",
            "Requested",
            "Edited",
            "EpcsError",
            "EpcsSigned",
            "ReadyToSign",
            "PharmacyVerified",
            "PharmacySelect",
          ])
          .describe("Valid prescription status types for DoseSpot."),
        zod.null(),
      ])
      .optional(),
    Formulary: zod.union([zod.boolean(), zod.null()]).optional(),
    EligibilityId: zod.union([zod.number(), zod.null()]).optional(),
    Type: zod
      .union([
        zod
          .enum(["Coded", "FreeText", "NDC", "Supply", "Compound"])
          .describe("Valid prescription types for DoseSpot."),
        zod.null(),
      ])
      .optional(),
    NonDoseSpotPrescriptionId: zod.union([zod.string(), zod.null()]).optional(),
    ErrorIgnored: zod.union([zod.boolean(), zod.null()]).optional(),
    SupplyId: zod.union([zod.number(), zod.null()]).optional(),
    FreeTextType: zod
      .union([
        zod
          .enum(["Medication", "Supply", "Compound"])
          .describe("Valid free text types for DoseSpot prescriptions."),
        zod.null(),
      ])
      .optional(),
    ClinicId: zod.union([zod.number(), zod.null()]).optional(),
    SupervisorId: zod.union([zod.number(), zod.null()]).optional(),
    IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
    IsRxRenewal: zod.union([zod.boolean(), zod.null()]).optional(),
    RxRenewalNote: zod.union([zod.string(), zod.null()]).optional(),
    FirstPrescriptionDiagnosis: zod
      .union([
        zod
          .object({
            PrimaryDiagnosis: zod
              .union([
                zod
                  .object({
                    DiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    DiagnosisCode: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    DiagnosisDescription: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                  })
                  .describe("DoseSpot diagnosis information."),
                zod.null(),
              ])
              .optional(),
            SecondaryDiagnosis: zod
              .union([
                zod
                  .object({
                    DiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    DiagnosisCode: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    DiagnosisDescription: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                  })
                  .describe("DoseSpot diagnosis information."),
                zod.null(),
              ])
              .optional(),
          })
          .describe("DoseSpot prescription diagnosis information."),
        zod.null(),
      ])
      .optional(),
    SecondPrescriptionDiagnosis: zod
      .union([
        zod
          .object({
            PrimaryDiagnosis: zod
              .union([
                zod
                  .object({
                    DiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    DiagnosisCode: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    DiagnosisDescription: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                  })
                  .describe("DoseSpot diagnosis information."),
                zod.null(),
              ])
              .optional(),
            SecondaryDiagnosis: zod
              .union([
                zod
                  .object({
                    DiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    DiagnosisCode: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    DiagnosisDescription: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                  })
                  .describe("DoseSpot diagnosis information."),
                zod.null(),
              ])
              .optional(),
          })
          .describe("DoseSpot prescription diagnosis information."),
        zod.null(),
      ])
      .optional(),
    Strength: zod.union([zod.string(), zod.null()]).optional(),
    PatientMedicationId: zod.union([zod.number(), zod.null()]).optional(),
    MedicationStatus: zod
      .union([
        zod
          .enum([
            "Unknown",
            "Active",
            "Inactive",
            "Discontinued",
            "Deleted",
            "Completed",
            "CancelRequested",
            "CancelPending",
            "Cancelled",
            "CancelDenied",
            "Changed",
            "FullFill",
            "PartialFill",
            "NoFill",
          ])
          .describe("Valid medication status types for DoseSpot."),
        zod.null(),
      ])
      .optional(),
    Comment: zod.union([zod.string(), zod.null()]).optional(),
    DateInactive: zod.union([zod.string(), zod.null()]).optional(),
    Encounter: zod.union([zod.string(), zod.null()]).optional(),
    DisplayName: zod.union([zod.string(), zod.null()]).optional(),
    DispensableDrugId: zod.union([zod.number(), zod.null()]).optional(),
    Schedule: zod.union([zod.number(), zod.null()]).optional(),
    CompoundIngredients: zod
      .union([
        zod.array(
          zod
            .object({
              DispensableDrugId: zod
                .union([zod.number(), zod.null()])
                .optional(),
              FreeText: zod.union([zod.string(), zod.null()]).optional(),
              DispenseUnitId: zod.union([zod.number(), zod.null()]).optional(),
              Quantity: zod.string(),
              IsFreeTextEPCS: zod.union([zod.boolean(), zod.null()]).optional(),
            })
            .describe("DoseSpot compound ingredient information."),
        ),
        zod.null(),
      ])
      .optional(),
  })
  .describe("Complete prescription information from DoseSpot API.");

/**
 * Set one or more prescriptions as ready to sign.

This endpoint marks prescriptions as ready to sign in DoseSpot for the specified patient.

Args:
    user_id: The patient's user ID
    request: The prescriptions to set ready to sign with optional DEA overrides

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If any prescription record is not found or operation fails
 * @summary Set Prescriptions Ready To Sign
 */
export const setPrescriptionsReadyToSignParams = zod.object({
  user_id: zod.uuid(),
});

export const setPrescriptionsReadyToSignBody = zod.object({
  dosespotPrescriptionIds: zod.array(zod.string()),
  deaOverrides: zod
    .union([zod.record(zod.string(), zod.unknown()), zod.null()])
    .optional(),
});

export const setPrescriptionsReadyToSignResponse = zod.unknown();

/**
 * Send one or more prescriptions to designated pharmacies.

This endpoint sends prescriptions to their designated pharmacies via
DoseSpot, after running each one through the Rx-time prior-auth
gate. Returns a :class:`SendPrescriptionsResponseT` describing what
happened per-prescription — some ids may have been sent to the
pharmacy while others were diverted into PA cases.

Args:
    user_id: The patient's user ID
    request: The prescriptions to send with optional PIN and pharmacy override

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If any prescription record is not found or sending fails
 * @summary Send Prescriptions To Pharmacy
 */
export const sendPrescriptionsToPharmacyParams = zod.object({
  user_id: zod.uuid(),
});

export const sendPrescriptionsToPharmacyBody = zod.object({
  dosespotPrescriptionIds: zod.array(zod.string()),
  pin: zod.union([zod.string(), zod.null()]).optional(),
  expedited: zod.union([zod.boolean(), zod.null()]).optional(),
});

export const sendPrescriptionsToPharmacyResponse = zod
  .object({
    sentToPharmacy: zod.array(zod.string()),
    priorAuthsInitiated: zod.array(
      zod
        .object({
          dosespotPrescriptionId: zod.string(),
          caseNumber: zod.union([zod.string(), zod.null()]).optional(),
        })
        .describe(
          "One ``PA_REQUIRED`` prescription that was diverted into a PA case.\n\n``case_number`` mirrors DoseSpot's ``PriorAuthorizationCaseId`` from\nthe ``POST /priorAuths/initiate`` response. It may be ``None`` when\nDoseSpot accepted the initiate but didn't echo an id yet; the UI\nshould still show \"Prior auth sent\" in that case — the poller will\nhydrate the case number on the next tick.",
        ),
    ),
    excluded: zod.array(zod.string()),
    divertFailed: zod.array(zod.string()),
  })
  .describe(
    "Per-prescription outcome of ``send_prescriptions_to_pharmacy``.\n\nThe three id lists / list-of-results partition the request's\n``dosespot_prescription_ids``: each id lands in exactly one of\n``sent_to_pharmacy``, ``prior_auths_initiated``, ``excluded``, or\n``divert_failed``. This lets the Rx wizard tell the clinician the\ntruth about what happened instead of guessing from the pre-submit\npreview (which can disagree with the Rx-time gate when live\nformulary data moves between preview and send).",
  );

/**
 * Live ``GET /api/patients/{id}/formulary`` against DoseSpot.

Lookup is scoped to one NDC under one coverage. Drives the formulary
section of the Rx wizard so the clinician can see formulary status,
copay tiers, payer-preferred alternatives, and therapeutic alternatives
*before* settling on a final draft.

Inputs are deliberately permissive so the wizard can fire as soon as a
medication is selected:

- ``dispensable_drug_id`` xor ``ndc`` — at least one must be provided.
  When only ``dispensable_drug_id`` is given, the NDC is resolved via
  ``select_medication``.
- ``pharmacy_id`` is optional. When provided, the eligibility channel
  (Retail / MailOrder / Specialty / LTC) is derived from the pharmacy's
  specialties; otherwise we default to Retail (the most common channel
  and the one the patient's primary coverage typically backs).
- ``patient_eligibility_id`` is optional. When omitted, we resolve the
  first active coverage that covers the channel — same selection logic
  the gate uses.

Returns ``formulary=None`` (rather than 4xx-ing) when DoseSpot returns
no data or the patient has no coverage for the channel; the UI shows a
"no formulary data available" message in that case.
 * @summary Get Patient Formulary For Drug
 */
export const getPatientFormularyForDrugParams = zod.object({
  user_id: zod.uuid(),
});

export const getPatientFormularyForDrugQueryParams = zod.object({
  dispensable_drug_id: zod.union([zod.number(), zod.null()]).optional(),
  ndc: zod.union([zod.string(), zod.null()]).optional(),
  pharmacy_id: zod.union([zod.number(), zod.null()]).optional(),
  patient_eligibility_id: zod.union([zod.number(), zod.null()]).optional(),
});

export const getPatientFormularyForDrugResponse = zod
  .object({
    formulary: zod
      .union([
        zod
          .object({
            FormularyStatus: zod.union([zod.string(), zod.null()]).optional(),
            Brand: zod.union([zod.boolean(), zod.null()]).optional(),
            Otc: zod.union([zod.boolean(), zod.null()]).optional(),
            Copays: zod
              .union([
                zod.array(
                  zod
                    .object({
                      IsDrugSpecific: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      PharmacyType: zod
                        .union([
                          zod
                            .enum([
                              "Any",
                              "FaxPharmacy",
                              "EPCS",
                              "TwentyFourHourPharmacy",
                              "LongTermCarePharmacy",
                              "MailOrder",
                              "Retail",
                              "SpecialtyPharmacy",
                            ])
                            .describe(
                              "Valid pharmacy specialty types for DoseSpot.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      FlatCopayAmount: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      PercentCopayAmount: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      FlatCopayAmountFirst: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      MinimumCopayAmount: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      MaximumCopayAmount: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      DaysSupply: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      CopayTier: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      MaximumCopayTier: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      OutOfPocketMinimum: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      OutOfPocketMaximum: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                    })
                    .describe(
                      "Single copay tier (`PayerCopay`).\n\nPer-channel pricing rule returned on formulary responses and on the\n``RepresentitiveFormularyCoverage`` slice of each alternative. The\ngate doesn't consult any of these fields directly — they're carried\nthrough for UI display next to an ``EXCLUDED`` / ``PA_REQUIRED``\nbanner.",
                    ),
                ),
                zod.null(),
              ])
              .optional(),
            Alternatives: zod
              .union([
                zod.array(
                  zod
                    .object({
                      Ndc: zod.union([zod.string(), zod.null()]).optional(),
                      DisplayName: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      RxCUI: zod.union([zod.number(), zod.null()]).optional(),
                      DispensableDrugId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Brand: zod.union([zod.boolean(), zod.null()]).optional(),
                      Otc: zod.union([zod.boolean(), zod.null()]).optional(),
                      Details: zod
                        .union([
                          zod.array(
                            zod
                              .object({
                                PatientSpecificPricingCoverages: zod
                                  .union([
                                    zod.array(
                                      zod
                                        .object({
                                          Pharmacy: zod
                                            .union([
                                              zod
                                                .object({
                                                  PharmacyType: zod
                                                    .union([
                                                      zod
                                                        .enum([
                                                          "Retail",
                                                          "Mail",
                                                          "Item90DayAtRetail",
                                                          "Specialty",
                                                          "LongTermCare",
                                                        ])
                                                        .describe(
                                                          "`PrescriptionBenefitsPharmacy.PharmacyType` values.\n\nDistinct from :class:`PharmacySpecialtyTypeT` — DoseSpot uses a\ndifferent (smaller) vocabulary for the pharmacy slice returned on\nrealtime-benefits responses than for channel-level eligibility.",
                                                        ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  Identifications: zod
                                                    .union([
                                                      zod.record(
                                                        zod.string(),
                                                        zod.unknown(),
                                                      ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PharmacistLastName: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PharmacistFirstName: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PharmacistMiddleName: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PharmacistSuffix: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PharmacistPrefix: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  Email: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  DistanceFromRequestedPharmacy:
                                                    zod
                                                      .union([
                                                        zod.number(),
                                                        zod.null(),
                                                      ])
                                                      .optional(),
                                                  PharmacyId: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  StoreName: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  Address1: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  Address2: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  City: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  State: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  ZipCode: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PrimaryPhone: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PrimaryPhoneType: zod
                                                    .union([
                                                      zod
                                                        .enum([
                                                          "Undefined",
                                                          "Beeper",
                                                          "Cell",
                                                          "Fax",
                                                          "Home",
                                                          "Work",
                                                          "Night",
                                                          "Primary",
                                                        ])
                                                        .describe(
                                                          "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` / `PhoneAdditionalType*` values.",
                                                        ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PrimaryFax: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PhoneAdditional1: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PhoneAdditionalType1: zod
                                                    .union([
                                                      zod
                                                        .enum([
                                                          "Undefined",
                                                          "Beeper",
                                                          "Cell",
                                                          "Fax",
                                                          "Home",
                                                          "Work",
                                                          "Night",
                                                          "Primary",
                                                        ])
                                                        .describe(
                                                          "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` / `PhoneAdditionalType*` values.",
                                                        ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PhoneAdditional2: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PhoneAdditionalType2: zod
                                                    .union([
                                                      zod
                                                        .enum([
                                                          "Undefined",
                                                          "Beeper",
                                                          "Cell",
                                                          "Fax",
                                                          "Home",
                                                          "Work",
                                                          "Night",
                                                          "Primary",
                                                        ])
                                                        .describe(
                                                          "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` / `PhoneAdditionalType*` values.",
                                                        ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PhoneAdditional3: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PhoneAdditionalType3: zod
                                                    .union([
                                                      zod
                                                        .enum([
                                                          "Undefined",
                                                          "Beeper",
                                                          "Cell",
                                                          "Fax",
                                                          "Home",
                                                          "Work",
                                                          "Night",
                                                          "Primary",
                                                        ])
                                                        .describe(
                                                          "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` / `PhoneAdditionalType*` values.",
                                                        ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PharmacySpecialties: zod
                                                    .union([
                                                      zod.array(zod.string()),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  ServiceLevel: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  Latitude: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  Longitude: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  NCPDPID: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                })
                                                .describe(
                                                  "`PrescriptionBenefitsPharmacy` — pharmacy slice on RTPB responses.\n\nNarrower-use than :class:`PharmacyT`; mirrors the full swagger shape\nso callers can surface dispensing-pharmacy details (name, address,\nNCPDPID) alongside pricing / PA signals from a\n``PatientSpecificPricingCoverage`` entry.",
                                                ),
                                              zod.null(),
                                            ])
                                            .optional(),
                                          PricingCoverage: zod
                                            .union([
                                              zod
                                                .object({
                                                  DrugStatusCode: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  DrugStatus: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  QuantityPricedValue: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  QuantityPricedCodeListQualifier:
                                                    zod
                                                      .union([
                                                        zod
                                                          .enum([
                                                            "Item38",
                                                            "Item40",
                                                            "Item87",
                                                            "QS",
                                                            "CF",
                                                            "UQ",
                                                          ])
                                                          .describe(
                                                            "`PricingCoverageFactors.QuantityPricedCodeListQualifier` values.",
                                                          ),
                                                        zod.null(),
                                                      ])
                                                      .optional(),
                                                  QuantityPricedUnitOfMeasureType:
                                                    zod
                                                      .union([
                                                        zod.string(),
                                                        zod.null(),
                                                      ])
                                                      .optional(),
                                                  QuantityPricedUnitOfMeasureTypeId:
                                                    zod
                                                      .union([
                                                        zod.number(),
                                                        zod.null(),
                                                      ])
                                                      .optional(),
                                                  DaysSupplyPriced: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PlanPayAmount: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  EstimatedPatientPayAmount: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  OOPAppliedAmount: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  OOPRemainingAmount: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  DeductibleAppliedAmount: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  DeductibleRemainingAmount: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  CoverageAlerts: zod
                                                    .union([
                                                      zod.array(
                                                        zod
                                                          .object({
                                                            ReferenceCode: zod
                                                              .union([
                                                                zod
                                                                  .enum([
                                                                    "AgeLimits",
                                                                    "DaysSupplyExceeded",
                                                                    "DrugExclusion",
                                                                    "ExcessiveUtilization",
                                                                    "FullCostNotCovered",
                                                                    "GenderLimits",
                                                                    "MandatoryGeneric",
                                                                    "MedicalNecessity",
                                                                    "NotOnFormulary",
                                                                    "PharmacyOutOfNetwork",
                                                                    "PlanLimitExclusion",
                                                                    "QuantityLimits",
                                                                    "QuantityLimitExceeded",
                                                                    "QuantityNotValid",
                                                                    "ResourceLink",
                                                                    "StepTherapy",
                                                                    "TextMessage",
                                                                  ])
                                                                  .describe(
                                                                    "`PricingCoverageFactorsCoverageAlerts.ReferenceCode` values.",
                                                                  ),
                                                                zod.null(),
                                                              ])
                                                              .optional(),
                                                            ReferenceText: zod
                                                              .union([
                                                                zod.string(),
                                                                zod.null(),
                                                              ])
                                                              .optional(),
                                                          })
                                                          .describe(
                                                            "`PricingCoverageFactorsCoverageAlerts` entry on :class:`PricingCoverageFactorsT`.\n\nDoseSpot returns coverage-alert *objects* here (not plain strings):\na ``ReferenceCode`` enum plus a human-readable ``ReferenceText``.",
                                                          ),
                                                      ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  FormularyStatus: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PriorAuthRequired: zod
                                                    .union([
                                                      zod.boolean(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                })
                                                .describe(
                                                  "`PricingCoverageFactors` — `PricingCoverage` sub-object on RTPB.\n\nThe realtime gate's authoritative PA source: ``PriorAuthRequired=true``\non any pharmacy-specific pricing coverage flips the gate to\n:attr:`PA_REQUIRED`. Pricing fields are kept for downstream UI — they\nare not consulted by the gate but are cheap to carry.",
                                                ),
                                              zod.null(),
                                            ])
                                            .optional(),
                                        })
                                        .describe(
                                          "`PatientSpecificPricingCoverage` — one (pharmacy × coverage) pricing row.\n\nA coverage can yield multiple entries — one per pharmacy the payer\npriced against — so the gate has to OR the ``PriorAuthRequired`` bits\nacross the list to get a conservative answer.",
                                        ),
                                    ),
                                    zod.null(),
                                  ])
                                  .optional(),
                                Ndc: zod
                                  .union([zod.string(), zod.null()])
                                  .optional(),
                                DisplayName: zod
                                  .union([zod.string(), zod.null()])
                                  .optional(),
                                RxCUI: zod
                                  .union([zod.number(), zod.null()])
                                  .optional(),
                                DispensableDrugId: zod
                                  .union([zod.number(), zod.null()])
                                  .optional(),
                                Coverage: zod
                                  .union([
                                    zod
                                      .object({
                                        FormularyStatus: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        Copays: zod
                                          .union([
                                            zod.array(
                                              zod
                                                .object({
                                                  IsDrugSpecific: zod
                                                    .union([
                                                      zod.boolean(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PharmacyType: zod
                                                    .union([
                                                      zod
                                                        .enum([
                                                          "Any",
                                                          "FaxPharmacy",
                                                          "EPCS",
                                                          "TwentyFourHourPharmacy",
                                                          "LongTermCarePharmacy",
                                                          "MailOrder",
                                                          "Retail",
                                                          "SpecialtyPharmacy",
                                                        ])
                                                        .describe(
                                                          "Valid pharmacy specialty types for DoseSpot.",
                                                        ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  FlatCopayAmount: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PercentCopayAmount: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  FlatCopayAmountFirst: zod
                                                    .union([
                                                      zod.boolean(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  MinimumCopayAmount: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  MaximumCopayAmount: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  DaysSupply: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  CopayTier: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  MaximumCopayTier: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  OutOfPocketMinimum: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  OutOfPocketMaximum: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                })
                                                .describe(
                                                  "Single copay tier (`PayerCopay`).\n\nPer-channel pricing rule returned on formulary responses and on the\n``RepresentitiveFormularyCoverage`` slice of each alternative. The\ngate doesn't consult any of these fields directly — they're carried\nthrough for UI display next to an ``EXCLUDED`` / ``PA_REQUIRED``\nbanner.",
                                                ),
                                            ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        Alternatives: zod
                                          .union([
                                            zod.array(
                                              zod
                                                .object({
                                                  Ndc: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  Details: zod
                                                    .union([
                                                      zod.array(
                                                        zod
                                                          .object({
                                                            Ndc: zod
                                                              .union([
                                                                zod.string(),
                                                                zod.null(),
                                                              ])
                                                              .optional(),
                                                            Coverage: zod
                                                              .union([
                                                                zod.unknown(),
                                                                zod.null(),
                                                              ])
                                                              .optional(),
                                                          })
                                                          .describe(
                                                            "`PayerAlternativeDetail` — one detail under :class:`PayerAlternativeSimpleT`.",
                                                          ),
                                                      ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                })
                                                .describe(
                                                  "`PayerAlternative` — the narrower alternative shape nested in :class:`MedicationCoverageT`.\n\nPer v2 swagger, nested alternatives (alternatives of alternatives) only\ncarry ``Ndc`` and a ``Details`` list, not the full\n:class:`PayerAlternativeT` payload.",
                                                ),
                                            ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        Restrictions: zod
                                          .union([
                                            zod
                                              .object({
                                                IsExcluded: zod
                                                  .union([
                                                    zod.boolean(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                HasMedicalNecessity: zod
                                                  .union([
                                                    zod.boolean(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                HasPriorAuthorization: zod
                                                  .union([
                                                    zod.boolean(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                HasStepTherapy: zod
                                                  .union([
                                                    zod.boolean(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                HasQuantityLimit: zod
                                                  .union([
                                                    zod.boolean(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                HasAgeLimit: zod
                                                  .union([
                                                    zod.boolean(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                AgeLimitRestrictions: zod
                                                  .union([
                                                    zod.array(
                                                      zod
                                                        .object({
                                                          MinimumAge: zod
                                                            .union([
                                                              zod.number(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          MinimumAgeUnit: zod
                                                            .union([
                                                              zod
                                                                .enum([
                                                                  "Days",
                                                                  "Years",
                                                                ])
                                                                .describe(
                                                                  "Unit on :class:`AgeLimitRestrictionT` bounds.",
                                                                ),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          MaximumAge: zod
                                                            .union([
                                                              zod.number(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          MaximumAgeUnit: zod
                                                            .union([
                                                              zod
                                                                .enum([
                                                                  "Days",
                                                                  "Years",
                                                                ])
                                                                .describe(
                                                                  "Unit on :class:`AgeLimitRestrictionT` bounds.",
                                                                ),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                        })
                                                        .describe(
                                                          "`AgeLimitRestriction` entry on a `CoverageRestrictions`.",
                                                        ),
                                                    ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                GenderRestriction: zod
                                                  .union([
                                                    zod
                                                      .enum([
                                                        "Male",
                                                        "Female",
                                                        "Unknown",
                                                      ])
                                                      .describe(
                                                        "`PayerDemographics.Gender` and `CoverageRestrictions.GenderRestriction` values.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                QuantityLimitRestrictions: zod
                                                  .union([
                                                    zod.array(
                                                      zod
                                                        .object({
                                                          MaximumAmount: zod
                                                            .union([
                                                              zod.number(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          AmountUnit: zod
                                                            .union([
                                                              zod
                                                                .enum([
                                                                  "DollarAmount",
                                                                  "DaysSupply",
                                                                  "Fills",
                                                                  "Quantity",
                                                                ])
                                                                .describe(
                                                                  "`QuantityLimitRestriction.AmountUnit` values.",
                                                                ),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          TimePeriodUnit: zod
                                                            .union([
                                                              zod
                                                                .enum([
                                                                  "Days",
                                                                  "Lifetime",
                                                                  "PerDispensing",
                                                                  "SpecificDateRange",
                                                                  "CalendarYear",
                                                                  "CalendarQuarter",
                                                                  "CalendarMonth",
                                                                ])
                                                                .describe(
                                                                  "`QuantityLimitRestriction.TimePeriodUnit` values.",
                                                                ),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          StartDate: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          EndDate: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          MaximumTimePeriodUnits:
                                                            zod
                                                              .union([
                                                                zod.number(),
                                                                zod.null(),
                                                              ])
                                                              .optional(),
                                                        })
                                                        .describe(
                                                          "`QuantityLimitRestriction` entry on a `CoverageRestrictions`.",
                                                        ),
                                                    ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                StepMedicationRestrictions: zod
                                                  .union([
                                                    zod.array(
                                                      zod
                                                        .object({
                                                          Ndc: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          StepDrugType: zod
                                                            .union([
                                                              zod
                                                                .enum([
                                                                  "Unknown",
                                                                  "SpecificMedication",
                                                                  "PharmacologicalClass",
                                                                ])
                                                                .describe(
                                                                  "`StepMedicationRestriction.StepDrugType` values.",
                                                                ),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          StepOrder: zod
                                                            .union([
                                                              zod.number(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          DisplayName: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          RxCUI: zod
                                                            .union([
                                                              zod.number(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          DispensableDrugId: zod
                                                            .union([
                                                              zod.number(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                        })
                                                        .describe(
                                                          "`StepMedicationRestriction` entry on a `CoverageRestrictions`.",
                                                        ),
                                                    ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                Messages: zod
                                                  .union([
                                                    zod.array(
                                                      zod
                                                        .object({
                                                          Message: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          LongMessage: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                        })
                                                        .describe(
                                                          "`CoverageMessage` entry on a `CoverageRestrictions`.",
                                                        ),
                                                    ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                DrugResources: zod
                                                  .union([
                                                    zod.array(
                                                      zod
                                                        .object({
                                                          Url: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          ResourceType: zod
                                                            .union([
                                                              zod
                                                                .enum([
                                                                  "AgeLimits",
                                                                  "ProductCoverageExclusion",
                                                                  "GenderLimits",
                                                                  "MedicalNecessity",
                                                                  "PriorAuthorization",
                                                                  "QuantityLimits",
                                                                  "StepTherapy",
                                                                  "General",
                                                                  "Copay",
                                                                  "Formulary",
                                                                ])
                                                                .describe(
                                                                  "`CoverageResource.ResourceType` values.",
                                                                ),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                        })
                                                        .describe(
                                                          "`CoverageResource` entry on a `CoverageRestrictions`.",
                                                        ),
                                                    ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                SummaryResources: zod
                                                  .union([
                                                    zod.array(
                                                      zod
                                                        .object({
                                                          Url: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          ResourceType: zod
                                                            .union([
                                                              zod
                                                                .enum([
                                                                  "AgeLimits",
                                                                  "ProductCoverageExclusion",
                                                                  "GenderLimits",
                                                                  "MedicalNecessity",
                                                                  "PriorAuthorization",
                                                                  "QuantityLimits",
                                                                  "StepTherapy",
                                                                  "General",
                                                                  "Copay",
                                                                  "Formulary",
                                                                ])
                                                                .describe(
                                                                  "`CoverageResource.ResourceType` values.",
                                                                ),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                        })
                                                        .describe(
                                                          "`CoverageResource` entry on a `CoverageRestrictions`.",
                                                        ),
                                                    ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "Coverage restrictions on the primary drug (`CoverageRestrictions`).\n\n``HasPriorAuthorization`` is the primary bit the gate consults when\n`/prescriptionbenefits` is unavailable. ``IsExcluded`` shortcuts to\nthe `EXCLUDED` gate outcome: no point initiating a PA for a drug the\npayer will never cover.\n\nField-name alignment with the v2 swagger: ``HasAgeLimit`` /\n``HasQuantityLimit`` are singular here (not plural as on\n:class:`RealTimeFormularyCoverageRestrictionsT`); there is no\n``HasGenderLimit`` — use ``GenderRestriction`` for that.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                      })
                                      .describe(
                                        "`MedicationCoverage` — coverage slice nested under `PayerAlternativeDetail`.\n\nDistinct from :class:`MedicationCoverageResponseT` (the\n``/formulary`` response body): no ``Otc`` / ``Brand`` /\n``TherapeuticAlternatives`` / ``RealTimeFormularyRequestStatus``\nfields here.",
                                      ),
                                    zod.null(),
                                  ])
                                  .optional(),
                              })
                              .describe(
                                "`PrescriptionBenefitPayerAlternativeDetail` — one detail under :class:`PayerAlternativeT`.\n\nEach detail describes an NDC-level variant of the alternative drug\nalong with its patient-specific pricing.",
                              ),
                          ),
                          zod.null(),
                        ])
                        .optional(),
                      RepresentativeFormularyCoverage: zod
                        .union([
                          zod
                            .object({
                              CopayFactors: zod
                                .union([
                                  zod.array(
                                    zod
                                      .object({
                                        IsDrugSpecific: zod
                                          .union([zod.boolean(), zod.null()])
                                          .optional(),
                                        PharmacyType: zod
                                          .union([
                                            zod
                                              .enum([
                                                "Any",
                                                "FaxPharmacy",
                                                "EPCS",
                                                "TwentyFourHourPharmacy",
                                                "LongTermCarePharmacy",
                                                "MailOrder",
                                                "Retail",
                                                "SpecialtyPharmacy",
                                              ])
                                              .describe(
                                                "Valid pharmacy specialty types for DoseSpot.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        FlatCopayAmount: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        PercentCopayAmount: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        FlatCopayAmountFirst: zod
                                          .union([zod.boolean(), zod.null()])
                                          .optional(),
                                        MinimumCopayAmount: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        MaximumCopayAmount: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        DaysSupply: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        CopayTier: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        MaximumCopayTier: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        OutOfPocketMinimum: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        OutOfPocketMaximum: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                      })
                                      .describe(
                                        "Single copay tier (`PayerCopay`).\n\nPer-channel pricing rule returned on formulary responses and on the\n``RepresentitiveFormularyCoverage`` slice of each alternative. The\ngate doesn't consult any of these fields directly — they're carried\nthrough for UI display next to an ``EXCLUDED`` / ``PA_REQUIRED``\nbanner.",
                                      ),
                                  ),
                                  zod.null(),
                                ])
                                .optional(),
                              FormularyStatus: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              FormularyStatusText: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              RealTimeFormularyCoverageRestrictions: zod
                                .union([
                                  zod
                                    .object({
                                      HasCoverageRestrictions: zod
                                        .union([zod.boolean(), zod.null()])
                                        .optional(),
                                      IsExcluded: zod
                                        .union([zod.boolean(), zod.null()])
                                        .optional(),
                                      HasMedicalNecessity: zod
                                        .union([zod.boolean(), zod.null()])
                                        .optional(),
                                      HasPriorAuthorization: zod
                                        .union([zod.boolean(), zod.null()])
                                        .optional(),
                                      HasStepTherapy: zod
                                        .union([zod.boolean(), zod.null()])
                                        .optional(),
                                      AgeLimitRestrictions: zod
                                        .union([
                                          zod.array(
                                            zod
                                              .object({
                                                MinimumAge: zod
                                                  .union([
                                                    zod.number(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                MinimumAgeUnit: zod
                                                  .union([
                                                    zod
                                                      .enum(["Days", "Years"])
                                                      .describe(
                                                        "Unit on :class:`AgeLimitRestrictionT` bounds.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                MaximumAge: zod
                                                  .union([
                                                    zod.number(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                MaximumAgeUnit: zod
                                                  .union([
                                                    zod
                                                      .enum(["Days", "Years"])
                                                      .describe(
                                                        "Unit on :class:`AgeLimitRestrictionT` bounds.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "`AgeLimitRestriction` entry on a `CoverageRestrictions`.",
                                              ),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                      GenderLimitRestrictions: zod
                                        .union([
                                          zod.array(
                                            zod
                                              .object({
                                                GenderAbbreviation: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                GenderDescription: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "`GenderLimitRestriction` entry on a `RealTimeFormularyCoverageRestrictions`.",
                                              ),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                      QuantityLimitRestrictions: zod
                                        .union([
                                          zod.array(
                                            zod
                                              .object({
                                                MaximumAmount: zod
                                                  .union([
                                                    zod.number(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                AmountUnit: zod
                                                  .union([
                                                    zod
                                                      .enum([
                                                        "DollarAmount",
                                                        "DaysSupply",
                                                        "Fills",
                                                        "Quantity",
                                                      ])
                                                      .describe(
                                                        "`QuantityLimitRestriction.AmountUnit` values.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                TimePeriodUnit: zod
                                                  .union([
                                                    zod
                                                      .enum([
                                                        "Days",
                                                        "Lifetime",
                                                        "PerDispensing",
                                                        "SpecificDateRange",
                                                        "CalendarYear",
                                                        "CalendarQuarter",
                                                        "CalendarMonth",
                                                      ])
                                                      .describe(
                                                        "`QuantityLimitRestriction.TimePeriodUnit` values.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                StartDate: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                EndDate: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                MaximumTimePeriodUnits: zod
                                                  .union([
                                                    zod.number(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "`QuantityLimitRestriction` entry on a `CoverageRestrictions`.",
                                              ),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                      StepMedicationRestrictions: zod
                                        .union([
                                          zod.array(
                                            zod
                                              .object({
                                                Ndc: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                StepDrugType: zod
                                                  .union([
                                                    zod
                                                      .enum([
                                                        "Unknown",
                                                        "SpecificMedication",
                                                        "PharmacologicalClass",
                                                      ])
                                                      .describe(
                                                        "`StepMedicationRestriction.StepDrugType` values.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                StepOrder: zod
                                                  .union([
                                                    zod.number(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                DisplayName: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                RxCUI: zod
                                                  .union([
                                                    zod.number(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                DispensableDrugId: zod
                                                  .union([
                                                    zod.number(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "`StepMedicationRestriction` entry on a `CoverageRestrictions`.",
                                              ),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                      Messages: zod
                                        .union([
                                          zod.array(
                                            zod
                                              .object({
                                                Message: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                LongMessage: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "`CoverageMessage` entry on a `CoverageRestrictions`.",
                                              ),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                      DrugResources: zod
                                        .union([
                                          zod.array(
                                            zod
                                              .object({
                                                Url: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                ResourceType: zod
                                                  .union([
                                                    zod
                                                      .enum([
                                                        "AgeLimits",
                                                        "ProductCoverageExclusion",
                                                        "GenderLimits",
                                                        "MedicalNecessity",
                                                        "PriorAuthorization",
                                                        "QuantityLimits",
                                                        "StepTherapy",
                                                        "General",
                                                        "Copay",
                                                        "Formulary",
                                                      ])
                                                      .describe(
                                                        "`CoverageResource.ResourceType` values.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "`CoverageResource` entry on a `CoverageRestrictions`.",
                                              ),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                      SummaryResources: zod
                                        .union([
                                          zod.array(
                                            zod
                                              .object({
                                                Url: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                ResourceType: zod
                                                  .union([
                                                    zod
                                                      .enum([
                                                        "AgeLimits",
                                                        "ProductCoverageExclusion",
                                                        "GenderLimits",
                                                        "MedicalNecessity",
                                                        "PriorAuthorization",
                                                        "QuantityLimits",
                                                        "StepTherapy",
                                                        "General",
                                                        "Copay",
                                                        "Formulary",
                                                      ])
                                                      .describe(
                                                        "`CoverageResource.ResourceType` values.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "`CoverageResource` entry on a `CoverageRestrictions`.",
                                              ),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                    })
                                    .describe(
                                      "Realtime-only restriction slice (`RealTimeFormularyCoverageRestrictions`).\n\nAppears only on :class:`RepresentitiveFormularyCoverageT` (i.e. on each\nalternative drug), **not** on the primary drug's ``CoverageRestrictions``.\nThat asymmetry is per the v2 swagger: the primary drug's realtime PA\nbit is conveyed by ``/prescriptionbenefits`` (``PriorAuthRequired``)\nand its cached bit by ``CoverageRestrictions.HasPriorAuthorization``.\n\nField names match the swagger exactly — note ``HasMedicalNecessity``\n(not the legacy ``RequiresMedicalNecessity``) and ``HasAge`` /\n``HasQuantity`` rather than the plural ``…Limits`` spellings used on\n:class:`CoverageRestrictionsT`.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                            })
                            .describe(
                              "`RepresentitiveFormularyCoverage` on a :class:`PayerAlternativeT`.\n\nThe typo (``Representitive`` rather than ``Representative``) is\nDoseSpot's, not ours — the field name is verbatim from the v2 swagger\ndefinition so pydantic's ``model_validate`` of a raw DoseSpot\nresponse lines up.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      PatientSpecificPricingCoverages: zod
                        .union([
                          zod.array(
                            zod
                              .object({
                                Pharmacy: zod
                                  .union([
                                    zod
                                      .object({
                                        PharmacyType: zod
                                          .union([
                                            zod
                                              .enum([
                                                "Retail",
                                                "Mail",
                                                "Item90DayAtRetail",
                                                "Specialty",
                                                "LongTermCare",
                                              ])
                                              .describe(
                                                "`PrescriptionBenefitsPharmacy.PharmacyType` values.\n\nDistinct from :class:`PharmacySpecialtyTypeT` — DoseSpot uses a\ndifferent (smaller) vocabulary for the pharmacy slice returned on\nrealtime-benefits responses than for channel-level eligibility.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        Identifications: zod
                                          .union([
                                            zod.record(
                                              zod.string(),
                                              zod.unknown(),
                                            ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        PharmacistLastName: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PharmacistFirstName: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PharmacistMiddleName: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PharmacistSuffix: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PharmacistPrefix: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        Email: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        DistanceFromRequestedPharmacy: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        PharmacyId: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        StoreName: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        Address1: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        Address2: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        City: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        State: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        ZipCode: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PrimaryPhone: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PrimaryPhoneType: zod
                                          .union([
                                            zod
                                              .enum([
                                                "Undefined",
                                                "Beeper",
                                                "Cell",
                                                "Fax",
                                                "Home",
                                                "Work",
                                                "Night",
                                                "Primary",
                                              ])
                                              .describe(
                                                "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` / `PhoneAdditionalType*` values.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        PrimaryFax: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PhoneAdditional1: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PhoneAdditionalType1: zod
                                          .union([
                                            zod
                                              .enum([
                                                "Undefined",
                                                "Beeper",
                                                "Cell",
                                                "Fax",
                                                "Home",
                                                "Work",
                                                "Night",
                                                "Primary",
                                              ])
                                              .describe(
                                                "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` / `PhoneAdditionalType*` values.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        PhoneAdditional2: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PhoneAdditionalType2: zod
                                          .union([
                                            zod
                                              .enum([
                                                "Undefined",
                                                "Beeper",
                                                "Cell",
                                                "Fax",
                                                "Home",
                                                "Work",
                                                "Night",
                                                "Primary",
                                              ])
                                              .describe(
                                                "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` / `PhoneAdditionalType*` values.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        PhoneAdditional3: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PhoneAdditionalType3: zod
                                          .union([
                                            zod
                                              .enum([
                                                "Undefined",
                                                "Beeper",
                                                "Cell",
                                                "Fax",
                                                "Home",
                                                "Work",
                                                "Night",
                                                "Primary",
                                              ])
                                              .describe(
                                                "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` / `PhoneAdditionalType*` values.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        PharmacySpecialties: zod
                                          .union([
                                            zod.array(zod.string()),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        ServiceLevel: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        Latitude: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        Longitude: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        NCPDPID: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                      })
                                      .describe(
                                        "`PrescriptionBenefitsPharmacy` — pharmacy slice on RTPB responses.\n\nNarrower-use than :class:`PharmacyT`; mirrors the full swagger shape\nso callers can surface dispensing-pharmacy details (name, address,\nNCPDPID) alongside pricing / PA signals from a\n``PatientSpecificPricingCoverage`` entry.",
                                      ),
                                    zod.null(),
                                  ])
                                  .optional(),
                                PricingCoverage: zod
                                  .union([
                                    zod
                                      .object({
                                        DrugStatusCode: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        DrugStatus: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        QuantityPricedValue: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        QuantityPricedCodeListQualifier: zod
                                          .union([
                                            zod
                                              .enum([
                                                "Item38",
                                                "Item40",
                                                "Item87",
                                                "QS",
                                                "CF",
                                                "UQ",
                                              ])
                                              .describe(
                                                "`PricingCoverageFactors.QuantityPricedCodeListQualifier` values.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        QuantityPricedUnitOfMeasureType: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        QuantityPricedUnitOfMeasureTypeId: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        DaysSupplyPriced: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PlanPayAmount: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        EstimatedPatientPayAmount: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        OOPAppliedAmount: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        OOPRemainingAmount: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        DeductibleAppliedAmount: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        DeductibleRemainingAmount: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        CoverageAlerts: zod
                                          .union([
                                            zod.array(
                                              zod
                                                .object({
                                                  ReferenceCode: zod
                                                    .union([
                                                      zod
                                                        .enum([
                                                          "AgeLimits",
                                                          "DaysSupplyExceeded",
                                                          "DrugExclusion",
                                                          "ExcessiveUtilization",
                                                          "FullCostNotCovered",
                                                          "GenderLimits",
                                                          "MandatoryGeneric",
                                                          "MedicalNecessity",
                                                          "NotOnFormulary",
                                                          "PharmacyOutOfNetwork",
                                                          "PlanLimitExclusion",
                                                          "QuantityLimits",
                                                          "QuantityLimitExceeded",
                                                          "QuantityNotValid",
                                                          "ResourceLink",
                                                          "StepTherapy",
                                                          "TextMessage",
                                                        ])
                                                        .describe(
                                                          "`PricingCoverageFactorsCoverageAlerts.ReferenceCode` values.",
                                                        ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  ReferenceText: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                })
                                                .describe(
                                                  "`PricingCoverageFactorsCoverageAlerts` entry on :class:`PricingCoverageFactorsT`.\n\nDoseSpot returns coverage-alert *objects* here (not plain strings):\na ``ReferenceCode`` enum plus a human-readable ``ReferenceText``.",
                                                ),
                                            ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        FormularyStatus: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PriorAuthRequired: zod
                                          .union([zod.boolean(), zod.null()])
                                          .optional(),
                                      })
                                      .describe(
                                        "`PricingCoverageFactors` — `PricingCoverage` sub-object on RTPB.\n\nThe realtime gate's authoritative PA source: ``PriorAuthRequired=true``\non any pharmacy-specific pricing coverage flips the gate to\n:attr:`PA_REQUIRED`. Pricing fields are kept for downstream UI — they\nare not consulted by the gate but are cheap to carry.",
                                      ),
                                    zod.null(),
                                  ])
                                  .optional(),
                              })
                              .describe(
                                "`PatientSpecificPricingCoverage` — one (pharmacy × coverage) pricing row.\n\nA coverage can yield multiple entries — one per pharmacy the payer\npriced against — so the gate has to OR the ``PriorAuthRequired`` bits\nacross the list to get a conservative answer.",
                              ),
                          ),
                          zod.null(),
                        ])
                        .optional(),
                    })
                    .describe(
                      "`PayerAlternativeAPI` — payer-preferred alternative for an NDC.\n\nSurfaced alongside a gate decision of :attr:`EXCLUDED` or\n:attr:`PA_REQUIRED` so the clinician can rewrite to a preferred drug\ninstead of fighting a PA. Returned both on the formulary response\n(``MedicationCoverageResponse.Alternatives``) and on the RTPB\nresponse (``GetPrescriptionBenefitResponse.Alternatives``).",
                    ),
                ),
                zod.null(),
              ])
              .optional(),
            TherapeuticAlternatives: zod
              .union([
                zod.array(
                  zod
                    .object({
                      Ndc: zod.union([zod.string(), zod.null()]).optional(),
                      FormularyStatus: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Copay: zod
                        .union([
                          zod
                            .object({
                              IsDrugSpecific: zod
                                .union([zod.boolean(), zod.null()])
                                .optional(),
                              PharmacyType: zod
                                .union([
                                  zod
                                    .enum([
                                      "Any",
                                      "FaxPharmacy",
                                      "EPCS",
                                      "TwentyFourHourPharmacy",
                                      "LongTermCarePharmacy",
                                      "MailOrder",
                                      "Retail",
                                      "SpecialtyPharmacy",
                                    ])
                                    .describe(
                                      "Valid pharmacy specialty types for DoseSpot.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              FlatCopayAmount: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              PercentCopayAmount: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              FlatCopayAmountFirst: zod
                                .union([zod.boolean(), zod.null()])
                                .optional(),
                              MinimumCopayAmount: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              MaximumCopayAmount: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              DaysSupply: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              CopayTier: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              MaximumCopayTier: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              OutOfPocketMinimum: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              OutOfPocketMaximum: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                            })
                            .describe(
                              "Single copay tier (`PayerCopay`).\n\nPer-channel pricing rule returned on formulary responses and on the\n``RepresentitiveFormularyCoverage`` slice of each alternative. The\ngate doesn't consult any of these fields directly — they're carried\nthrough for UI display next to an ``EXCLUDED`` / ``PA_REQUIRED``\nbanner.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      DisplayName: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      FormularyInfo: zod
                        .union([
                          zod
                            .object({
                              ProductId: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              Ndc: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              FormularyStatusId: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              FormularyAbbreviation: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              FormularyStatusMessage: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              OrderRank: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              IsGeneric: zod
                                .union([zod.boolean(), zod.null()])
                                .optional(),
                              IsRx: zod
                                .union([zod.boolean(), zod.null()])
                                .optional(),
                            })
                            .describe(
                              "`FormularyInfo` nested on :class:`TherapeuticAlternativesT`.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      FullDisplayString: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DisplayStrength: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DefaultDispenseUnitID: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      DispensableDrugId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Schedule: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      IsDetox: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      HasGHB: zod.union([zod.boolean(), zod.null()]).optional(),
                      RxCUI: zod.union([zod.number(), zod.null()]).optional(),
                    })
                    .describe(
                      "`TherapeuticAlternatives` entry on a formulary response.\n\nV2 replaces the v1 ``/therapeuticAlternatives`` endpoint with a\n``TherapeuticAlternatives`` list returned inline on the formulary\nresponse. Surfaced alongside :attr:`EXCLUDED` / :attr:`PA_REQUIRED`\noutcomes so the clinician can rewrite to a preferred drug without a\nsecond round trip.",
                    ),
                ),
                zod.null(),
              ])
              .optional(),
            Restrictions: zod
              .union([
                zod
                  .object({
                    IsExcluded: zod
                      .union([zod.boolean(), zod.null()])
                      .optional(),
                    HasMedicalNecessity: zod
                      .union([zod.boolean(), zod.null()])
                      .optional(),
                    HasPriorAuthorization: zod
                      .union([zod.boolean(), zod.null()])
                      .optional(),
                    HasStepTherapy: zod
                      .union([zod.boolean(), zod.null()])
                      .optional(),
                    HasQuantityLimit: zod
                      .union([zod.boolean(), zod.null()])
                      .optional(),
                    HasAgeLimit: zod
                      .union([zod.boolean(), zod.null()])
                      .optional(),
                    AgeLimitRestrictions: zod
                      .union([
                        zod.array(
                          zod
                            .object({
                              MinimumAge: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              MinimumAgeUnit: zod
                                .union([
                                  zod
                                    .enum(["Days", "Years"])
                                    .describe(
                                      "Unit on :class:`AgeLimitRestrictionT` bounds.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              MaximumAge: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              MaximumAgeUnit: zod
                                .union([
                                  zod
                                    .enum(["Days", "Years"])
                                    .describe(
                                      "Unit on :class:`AgeLimitRestrictionT` bounds.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                            })
                            .describe(
                              "`AgeLimitRestriction` entry on a `CoverageRestrictions`.",
                            ),
                        ),
                        zod.null(),
                      ])
                      .optional(),
                    GenderRestriction: zod
                      .union([
                        zod
                          .enum(["Male", "Female", "Unknown"])
                          .describe(
                            "`PayerDemographics.Gender` and `CoverageRestrictions.GenderRestriction` values.",
                          ),
                        zod.null(),
                      ])
                      .optional(),
                    QuantityLimitRestrictions: zod
                      .union([
                        zod.array(
                          zod
                            .object({
                              MaximumAmount: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              AmountUnit: zod
                                .union([
                                  zod
                                    .enum([
                                      "DollarAmount",
                                      "DaysSupply",
                                      "Fills",
                                      "Quantity",
                                    ])
                                    .describe(
                                      "`QuantityLimitRestriction.AmountUnit` values.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              TimePeriodUnit: zod
                                .union([
                                  zod
                                    .enum([
                                      "Days",
                                      "Lifetime",
                                      "PerDispensing",
                                      "SpecificDateRange",
                                      "CalendarYear",
                                      "CalendarQuarter",
                                      "CalendarMonth",
                                    ])
                                    .describe(
                                      "`QuantityLimitRestriction.TimePeriodUnit` values.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              StartDate: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              EndDate: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              MaximumTimePeriodUnits: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                            })
                            .describe(
                              "`QuantityLimitRestriction` entry on a `CoverageRestrictions`.",
                            ),
                        ),
                        zod.null(),
                      ])
                      .optional(),
                    StepMedicationRestrictions: zod
                      .union([
                        zod.array(
                          zod
                            .object({
                              Ndc: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              StepDrugType: zod
                                .union([
                                  zod
                                    .enum([
                                      "Unknown",
                                      "SpecificMedication",
                                      "PharmacologicalClass",
                                    ])
                                    .describe(
                                      "`StepMedicationRestriction.StepDrugType` values.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              StepOrder: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              DisplayName: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              RxCUI: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              DispensableDrugId: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                            })
                            .describe(
                              "`StepMedicationRestriction` entry on a `CoverageRestrictions`.",
                            ),
                        ),
                        zod.null(),
                      ])
                      .optional(),
                    Messages: zod
                      .union([
                        zod.array(
                          zod
                            .object({
                              Message: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              LongMessage: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                            })
                            .describe(
                              "`CoverageMessage` entry on a `CoverageRestrictions`.",
                            ),
                        ),
                        zod.null(),
                      ])
                      .optional(),
                    DrugResources: zod
                      .union([
                        zod.array(
                          zod
                            .object({
                              Url: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              ResourceType: zod
                                .union([
                                  zod
                                    .enum([
                                      "AgeLimits",
                                      "ProductCoverageExclusion",
                                      "GenderLimits",
                                      "MedicalNecessity",
                                      "PriorAuthorization",
                                      "QuantityLimits",
                                      "StepTherapy",
                                      "General",
                                      "Copay",
                                      "Formulary",
                                    ])
                                    .describe(
                                      "`CoverageResource.ResourceType` values.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                            })
                            .describe(
                              "`CoverageResource` entry on a `CoverageRestrictions`.",
                            ),
                        ),
                        zod.null(),
                      ])
                      .optional(),
                    SummaryResources: zod
                      .union([
                        zod.array(
                          zod
                            .object({
                              Url: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              ResourceType: zod
                                .union([
                                  zod
                                    .enum([
                                      "AgeLimits",
                                      "ProductCoverageExclusion",
                                      "GenderLimits",
                                      "MedicalNecessity",
                                      "PriorAuthorization",
                                      "QuantityLimits",
                                      "StepTherapy",
                                      "General",
                                      "Copay",
                                      "Formulary",
                                    ])
                                    .describe(
                                      "`CoverageResource.ResourceType` values.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                            })
                            .describe(
                              "`CoverageResource` entry on a `CoverageRestrictions`.",
                            ),
                        ),
                        zod.null(),
                      ])
                      .optional(),
                  })
                  .describe(
                    "Coverage restrictions on the primary drug (`CoverageRestrictions`).\n\n``HasPriorAuthorization`` is the primary bit the gate consults when\n`/prescriptionbenefits` is unavailable. ``IsExcluded`` shortcuts to\nthe `EXCLUDED` gate outcome: no point initiating a PA for a drug the\npayer will never cover.\n\nField-name alignment with the v2 swagger: ``HasAgeLimit`` /\n``HasQuantityLimit`` are singular here (not plural as on\n:class:`RealTimeFormularyCoverageRestrictionsT`); there is no\n``HasGenderLimit`` — use ``GenderRestriction`` for that.",
                  ),
                zod.null(),
              ])
              .optional(),
            RealTimeFormularyRequestStatus: zod
              .union([zod.number(), zod.null()])
              .optional(),
          })
          .describe(
            "`MedicationCoverageResponse` — inner item of ``ItemResponse[…]`` on\n``GET /api/patients/{patient_id}/formulary``.\n\nRetained under the historical ``FormularyResponseT`` name so in-repo\ncallers don't need to rename types; the shape is now the v2 swagger's\nunwrapped `Item` (see :class:`FormularyItemResponseT` for the wire-\nlevel wrapper).\n\nKey fields for the gate:\n\n- ``Restrictions.HasPriorAuthorization`` — cached-formulary PA bit.\n- ``Restrictions.IsExcluded`` — drug is flatly not covered; maps to\n  the :attr:`EXCLUDED` gate outcome.\n- ``RealTimeFormularyRequestStatus`` — non-OK here means \"realtime\n  call didn't land\"; the gate falls back to the cached slice before\n  declaring :attr:`UNKNOWN`.\n\nNotably absent: ``PatientEligibilityId`` / ``NDC`` / ``DrugName``.\nV2's `MedicationCoverageResponse` does not echo the request context\nback; the gate tracks that out-of-band.",
          ),
        zod.null(),
      ])
      .optional(),
    payerInformation: zod
      .union([
        zod
          .object({
            PatientEligibilityId: zod
              .union([zod.number(), zod.null()])
              .optional(),
            PayerName: zod.union([zod.string(), zod.null()]).optional(),
            PharmacyEligibilities: zod
              .union([
                zod.array(
                  zod
                    .object({
                      PharmacyType: zod
                        .union([
                          zod
                            .enum([
                              "Any",
                              "FaxPharmacy",
                              "EPCS",
                              "TwentyFourHourPharmacy",
                              "LongTermCarePharmacy",
                              "MailOrder",
                              "Retail",
                              "SpecialtyPharmacy",
                            ])
                            .describe(
                              "Valid pharmacy specialty types for DoseSpot.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      EligibilityStatus: zod
                        .union([
                          zod
                            .enum([
                              "Covered",
                              "NotCovered",
                              "OutOfPocket",
                              "Unknown",
                              "UnableToProcess",
                            ])
                            .describe(
                              "`EligibilityStatus` on a `PharmacyEligibility` entry.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      Name: zod.union([zod.string(), zod.null()]).optional(),
                    })
                    .describe(
                      "Per-channel eligibility entry on a `PayerInformationResponse`.\n\nEach coverage reports one of these per pharmacy type so the Rx-time\ngate can pick the coverage that actually covers the channel the\nprescription is routed to (e.g. Retail vs MailOrder).",
                    ),
                ),
                zod.null(),
              ])
              .optional(),
            PlanName: zod.union([zod.string(), zod.null()]).optional(),
            CoverageId: zod.union([zod.string(), zod.null()]).optional(),
            PayerId: zod.union([zod.string(), zod.null()]).optional(),
            BIN: zod.union([zod.string(), zod.null()]).optional(),
            PCN: zod.union([zod.string(), zod.null()]).optional(),
            FormularyId: zod.union([zod.string(), zod.null()]).optional(),
            AlternativesId: zod.union([zod.string(), zod.null()]).optional(),
            CopayId: zod.union([zod.string(), zod.null()]).optional(),
            DemographicChanges: zod
              .union([zod.boolean(), zod.null()])
              .optional(),
            Demographics: zod
              .union([
                zod
                  .object({
                    LastName: zod.union([zod.string(), zod.null()]).optional(),
                    FirstName: zod.union([zod.string(), zod.null()]).optional(),
                    MiddleName: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    Suffix: zod.union([zod.string(), zod.null()]).optional(),
                    DateOfBirth: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    Gender: zod
                      .union([
                        zod
                          .enum(["Male", "Female", "Unknown"])
                          .describe(
                            "`PayerDemographics.Gender` and `CoverageRestrictions.GenderRestriction` values.",
                          ),
                        zod.null(),
                      ])
                      .optional(),
                    Address: zod
                      .union([
                        zod
                          .object({
                            AddressLine1: zod
                              .union([zod.string(), zod.null()])
                              .optional(),
                            AddressLine2: zod
                              .union([zod.string(), zod.null()])
                              .optional(),
                            City: zod
                              .union([zod.string(), zod.null()])
                              .optional(),
                            State: zod
                              .union([zod.string(), zod.null()])
                              .optional(),
                            ZipCode: zod
                              .union([zod.string(), zod.null()])
                              .optional(),
                          })
                          .describe(
                            "`PayerAddress` sub-object on :class:`PayerDemographicsT`.",
                          ),
                        zod.null(),
                      ])
                      .optional(),
                  })
                  .describe(
                    "`PayerDemographics` block on :class:`PayerInformationT`.\n\nSurfaced when the payer returns updated member demographics on an\neligibility response (combined with ``DemographicChanges=true``).",
                  ),
                zod.null(),
              ])
              .optional(),
            ErrorMessage: zod.union([zod.string(), zod.null()]).optional(),
            InfoMessage: zod.union([zod.string(), zod.null()]).optional(),
            MemberId: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe(
            "One active coverage for a patient (`PayerInformationResponse`).\n\nReturned by `GET /api/patients/{patient_id}/eligibilities`. The gate\nkeys subsequent `/formulary` and `/prescriptionbenefits` calls on\n``PatientEligibilityId``; the other ids (`CoverageId`, `FormularyId`,\n...) are carried through for audit but not otherwise consulted.\n\nFields match the DoseSpot v2 swagger `PayerInformationResponse`\ndefinition exactly. No `GroupId` here — that's a legacy field from\nthe v1 shape and was dropped when v2 consolidated onto `MemberId` +\n``Demographics``.",
          ),
        zod.null(),
      ])
      .optional(),
    patientEligibilityId: zod.union([zod.number(), zod.null()]).optional(),
    ndc: zod.union([zod.string(), zod.null()]).optional(),
  })
  .describe(
    "Wrapper around DoseSpot's ``/formulary`` payload for the Rx form.\n\nSurfaces the medication-coverage slice (formulary status, drug-specific\ncopay tiers, payer alternatives, therapeutic alternatives, restrictions)\nthat the clinician needs *before* finalising quantity / pharmacy in the\nRx wizard. Distinct from :class:`PreviewPriorAuthResponseT`: that one\ndrives the post-sign PA gate preview (and therefore needs every\nper-fill input); this one is the lightweight \"what does the patient's\nplan say about this drug?\" lookup that fires the moment a medication\nis selected.\n\n``payer_information`` carries the resolved coverage's BenefitsCoordination\ndetails (PayerName, PayerId, BIN, PCN, MemberId, FormularyId, ...) so\nthe caller can show which plan answered.",
  );

/**
 * Predict the post-sign prior-auth gate outcome for an in-flight Rx draft.

Shares its full decision path with
:mod:`lotushealth.dosespot.prescription_pa_gate` — the same NDC
resolution, pharmacy-channel mapping, coverage lookup, and
realtime-benefits / formulary classifier that run after
``set_prescriptions_ready_to_sign`` runs here too. That shared path
is why a pre-sign preview matches the post-sign decision
deterministically: there is no second "likely PA?" classifier to
keep in sync.

Missing or unresolved inputs collapse to ``UNKNOWN`` /
``NO_COVERAGE`` rather than 4xx'ing, so the client can safely poll
this endpoint as the wizard fills and only render an indicator once
the outcome firms up.
 * @summary Preview Prior Auth For Rx Draft
 */
export const previewPriorAuthForRxDraftParams = zod.object({
  user_id: zod.uuid(),
});

export const previewPriorAuthForRxDraftBody = zod
  .object({
    dispensableDrugId: zod.union([zod.number(), zod.null()]).optional(),
    pharmacyId: zod.union([zod.number(), zod.null()]).optional(),
    quantity: zod.union([zod.number(), zod.null()]).optional(),
    daysSupply: zod.union([zod.number(), zod.null()]).optional(),
    dispenseUnitTypeId: zod.union([zod.number(), zod.null()]).optional(),
  })
  .describe(
    "Rx-form inputs needed to preview the post-sign PA gate outcome.\n\nThese are the same inputs the gate reads off a\n``DosespotPrescriptionRecord.cached_info`` after sign — see\n:func:`lotushealth.dosespot.prescription_pa_gate.evaluate_inputs`.\nAll fields are optional so the client can call this endpoint as the\nclinician fills the wizard and watch the outcome sharpen from\n``UNKNOWN`` to ``NO_PA`` / ``PA_REQUIRED`` / ``EXCLUDED``.",
  );

export const previewPriorAuthForRxDraftResponse = zod
  .object({
    outcome: zod
      .enum(["NO_COVERAGE", "NO_PA", "PA_REQUIRED", "EXCLUDED", "UNKNOWN"])
      .describe(
        'Five-way classification of a prescription\'s PA posture at write time.\n\nConsumed by :class:`PrescriptionModel` to split a batch into sendable\nvs. PA-gated prescriptions. See ``PRIOR_AUTH.md`` § \"Decision logic\"\nfor the source-of-truth description.',
      ),
    reason: zod.string(),
    patientEligibilityId: zod.union([zod.number(), zod.null()]).optional(),
    realtimeStatus: zod.union([zod.number(), zod.null()]).optional(),
    formulary: zod
      .union([
        zod
          .object({
            FormularyStatus: zod.union([zod.string(), zod.null()]).optional(),
            Brand: zod.union([zod.boolean(), zod.null()]).optional(),
            Otc: zod.union([zod.boolean(), zod.null()]).optional(),
            Copays: zod
              .union([
                zod.array(
                  zod
                    .object({
                      IsDrugSpecific: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      PharmacyType: zod
                        .union([
                          zod
                            .enum([
                              "Any",
                              "FaxPharmacy",
                              "EPCS",
                              "TwentyFourHourPharmacy",
                              "LongTermCarePharmacy",
                              "MailOrder",
                              "Retail",
                              "SpecialtyPharmacy",
                            ])
                            .describe(
                              "Valid pharmacy specialty types for DoseSpot.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      FlatCopayAmount: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      PercentCopayAmount: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      FlatCopayAmountFirst: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      MinimumCopayAmount: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      MaximumCopayAmount: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      DaysSupply: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      CopayTier: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      MaximumCopayTier: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      OutOfPocketMinimum: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      OutOfPocketMaximum: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                    })
                    .describe(
                      "Single copay tier (`PayerCopay`).\n\nPer-channel pricing rule returned on formulary responses and on the\n``RepresentitiveFormularyCoverage`` slice of each alternative. The\ngate doesn't consult any of these fields directly — they're carried\nthrough for UI display next to an ``EXCLUDED`` / ``PA_REQUIRED``\nbanner.",
                    ),
                ),
                zod.null(),
              ])
              .optional(),
            Alternatives: zod
              .union([
                zod.array(
                  zod
                    .object({
                      Ndc: zod.union([zod.string(), zod.null()]).optional(),
                      DisplayName: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      RxCUI: zod.union([zod.number(), zod.null()]).optional(),
                      DispensableDrugId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Brand: zod.union([zod.boolean(), zod.null()]).optional(),
                      Otc: zod.union([zod.boolean(), zod.null()]).optional(),
                      Details: zod
                        .union([
                          zod.array(
                            zod
                              .object({
                                PatientSpecificPricingCoverages: zod
                                  .union([
                                    zod.array(
                                      zod
                                        .object({
                                          Pharmacy: zod
                                            .union([
                                              zod
                                                .object({
                                                  PharmacyType: zod
                                                    .union([
                                                      zod
                                                        .enum([
                                                          "Retail",
                                                          "Mail",
                                                          "Item90DayAtRetail",
                                                          "Specialty",
                                                          "LongTermCare",
                                                        ])
                                                        .describe(
                                                          "`PrescriptionBenefitsPharmacy.PharmacyType` values.\n\nDistinct from :class:`PharmacySpecialtyTypeT` — DoseSpot uses a\ndifferent (smaller) vocabulary for the pharmacy slice returned on\nrealtime-benefits responses than for channel-level eligibility.",
                                                        ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  Identifications: zod
                                                    .union([
                                                      zod.record(
                                                        zod.string(),
                                                        zod.unknown(),
                                                      ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PharmacistLastName: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PharmacistFirstName: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PharmacistMiddleName: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PharmacistSuffix: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PharmacistPrefix: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  Email: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  DistanceFromRequestedPharmacy:
                                                    zod
                                                      .union([
                                                        zod.number(),
                                                        zod.null(),
                                                      ])
                                                      .optional(),
                                                  PharmacyId: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  StoreName: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  Address1: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  Address2: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  City: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  State: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  ZipCode: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PrimaryPhone: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PrimaryPhoneType: zod
                                                    .union([
                                                      zod
                                                        .enum([
                                                          "Undefined",
                                                          "Beeper",
                                                          "Cell",
                                                          "Fax",
                                                          "Home",
                                                          "Work",
                                                          "Night",
                                                          "Primary",
                                                        ])
                                                        .describe(
                                                          "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` / `PhoneAdditionalType*` values.",
                                                        ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PrimaryFax: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PhoneAdditional1: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PhoneAdditionalType1: zod
                                                    .union([
                                                      zod
                                                        .enum([
                                                          "Undefined",
                                                          "Beeper",
                                                          "Cell",
                                                          "Fax",
                                                          "Home",
                                                          "Work",
                                                          "Night",
                                                          "Primary",
                                                        ])
                                                        .describe(
                                                          "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` / `PhoneAdditionalType*` values.",
                                                        ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PhoneAdditional2: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PhoneAdditionalType2: zod
                                                    .union([
                                                      zod
                                                        .enum([
                                                          "Undefined",
                                                          "Beeper",
                                                          "Cell",
                                                          "Fax",
                                                          "Home",
                                                          "Work",
                                                          "Night",
                                                          "Primary",
                                                        ])
                                                        .describe(
                                                          "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` / `PhoneAdditionalType*` values.",
                                                        ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PhoneAdditional3: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PhoneAdditionalType3: zod
                                                    .union([
                                                      zod
                                                        .enum([
                                                          "Undefined",
                                                          "Beeper",
                                                          "Cell",
                                                          "Fax",
                                                          "Home",
                                                          "Work",
                                                          "Night",
                                                          "Primary",
                                                        ])
                                                        .describe(
                                                          "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` / `PhoneAdditionalType*` values.",
                                                        ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PharmacySpecialties: zod
                                                    .union([
                                                      zod.array(zod.string()),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  ServiceLevel: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  Latitude: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  Longitude: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  NCPDPID: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                })
                                                .describe(
                                                  "`PrescriptionBenefitsPharmacy` — pharmacy slice on RTPB responses.\n\nNarrower-use than :class:`PharmacyT`; mirrors the full swagger shape\nso callers can surface dispensing-pharmacy details (name, address,\nNCPDPID) alongside pricing / PA signals from a\n``PatientSpecificPricingCoverage`` entry.",
                                                ),
                                              zod.null(),
                                            ])
                                            .optional(),
                                          PricingCoverage: zod
                                            .union([
                                              zod
                                                .object({
                                                  DrugStatusCode: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  DrugStatus: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  QuantityPricedValue: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  QuantityPricedCodeListQualifier:
                                                    zod
                                                      .union([
                                                        zod
                                                          .enum([
                                                            "Item38",
                                                            "Item40",
                                                            "Item87",
                                                            "QS",
                                                            "CF",
                                                            "UQ",
                                                          ])
                                                          .describe(
                                                            "`PricingCoverageFactors.QuantityPricedCodeListQualifier` values.",
                                                          ),
                                                        zod.null(),
                                                      ])
                                                      .optional(),
                                                  QuantityPricedUnitOfMeasureType:
                                                    zod
                                                      .union([
                                                        zod.string(),
                                                        zod.null(),
                                                      ])
                                                      .optional(),
                                                  QuantityPricedUnitOfMeasureTypeId:
                                                    zod
                                                      .union([
                                                        zod.number(),
                                                        zod.null(),
                                                      ])
                                                      .optional(),
                                                  DaysSupplyPriced: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PlanPayAmount: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  EstimatedPatientPayAmount: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  OOPAppliedAmount: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  OOPRemainingAmount: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  DeductibleAppliedAmount: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  DeductibleRemainingAmount: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  CoverageAlerts: zod
                                                    .union([
                                                      zod.array(
                                                        zod
                                                          .object({
                                                            ReferenceCode: zod
                                                              .union([
                                                                zod
                                                                  .enum([
                                                                    "AgeLimits",
                                                                    "DaysSupplyExceeded",
                                                                    "DrugExclusion",
                                                                    "ExcessiveUtilization",
                                                                    "FullCostNotCovered",
                                                                    "GenderLimits",
                                                                    "MandatoryGeneric",
                                                                    "MedicalNecessity",
                                                                    "NotOnFormulary",
                                                                    "PharmacyOutOfNetwork",
                                                                    "PlanLimitExclusion",
                                                                    "QuantityLimits",
                                                                    "QuantityLimitExceeded",
                                                                    "QuantityNotValid",
                                                                    "ResourceLink",
                                                                    "StepTherapy",
                                                                    "TextMessage",
                                                                  ])
                                                                  .describe(
                                                                    "`PricingCoverageFactorsCoverageAlerts.ReferenceCode` values.",
                                                                  ),
                                                                zod.null(),
                                                              ])
                                                              .optional(),
                                                            ReferenceText: zod
                                                              .union([
                                                                zod.string(),
                                                                zod.null(),
                                                              ])
                                                              .optional(),
                                                          })
                                                          .describe(
                                                            "`PricingCoverageFactorsCoverageAlerts` entry on :class:`PricingCoverageFactorsT`.\n\nDoseSpot returns coverage-alert *objects* here (not plain strings):\na ``ReferenceCode`` enum plus a human-readable ``ReferenceText``.",
                                                          ),
                                                      ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  FormularyStatus: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PriorAuthRequired: zod
                                                    .union([
                                                      zod.boolean(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                })
                                                .describe(
                                                  "`PricingCoverageFactors` — `PricingCoverage` sub-object on RTPB.\n\nThe realtime gate's authoritative PA source: ``PriorAuthRequired=true``\non any pharmacy-specific pricing coverage flips the gate to\n:attr:`PA_REQUIRED`. Pricing fields are kept for downstream UI — they\nare not consulted by the gate but are cheap to carry.",
                                                ),
                                              zod.null(),
                                            ])
                                            .optional(),
                                        })
                                        .describe(
                                          "`PatientSpecificPricingCoverage` — one (pharmacy × coverage) pricing row.\n\nA coverage can yield multiple entries — one per pharmacy the payer\npriced against — so the gate has to OR the ``PriorAuthRequired`` bits\nacross the list to get a conservative answer.",
                                        ),
                                    ),
                                    zod.null(),
                                  ])
                                  .optional(),
                                Ndc: zod
                                  .union([zod.string(), zod.null()])
                                  .optional(),
                                DisplayName: zod
                                  .union([zod.string(), zod.null()])
                                  .optional(),
                                RxCUI: zod
                                  .union([zod.number(), zod.null()])
                                  .optional(),
                                DispensableDrugId: zod
                                  .union([zod.number(), zod.null()])
                                  .optional(),
                                Coverage: zod
                                  .union([
                                    zod
                                      .object({
                                        FormularyStatus: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        Copays: zod
                                          .union([
                                            zod.array(
                                              zod
                                                .object({
                                                  IsDrugSpecific: zod
                                                    .union([
                                                      zod.boolean(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PharmacyType: zod
                                                    .union([
                                                      zod
                                                        .enum([
                                                          "Any",
                                                          "FaxPharmacy",
                                                          "EPCS",
                                                          "TwentyFourHourPharmacy",
                                                          "LongTermCarePharmacy",
                                                          "MailOrder",
                                                          "Retail",
                                                          "SpecialtyPharmacy",
                                                        ])
                                                        .describe(
                                                          "Valid pharmacy specialty types for DoseSpot.",
                                                        ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  FlatCopayAmount: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PercentCopayAmount: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  FlatCopayAmountFirst: zod
                                                    .union([
                                                      zod.boolean(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  MinimumCopayAmount: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  MaximumCopayAmount: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  DaysSupply: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  CopayTier: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  MaximumCopayTier: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  OutOfPocketMinimum: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  OutOfPocketMaximum: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                })
                                                .describe(
                                                  "Single copay tier (`PayerCopay`).\n\nPer-channel pricing rule returned on formulary responses and on the\n``RepresentitiveFormularyCoverage`` slice of each alternative. The\ngate doesn't consult any of these fields directly — they're carried\nthrough for UI display next to an ``EXCLUDED`` / ``PA_REQUIRED``\nbanner.",
                                                ),
                                            ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        Alternatives: zod
                                          .union([
                                            zod.array(
                                              zod
                                                .object({
                                                  Ndc: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  Details: zod
                                                    .union([
                                                      zod.array(
                                                        zod
                                                          .object({
                                                            Ndc: zod
                                                              .union([
                                                                zod.string(),
                                                                zod.null(),
                                                              ])
                                                              .optional(),
                                                            Coverage: zod
                                                              .union([
                                                                zod.unknown(),
                                                                zod.null(),
                                                              ])
                                                              .optional(),
                                                          })
                                                          .describe(
                                                            "`PayerAlternativeDetail` — one detail under :class:`PayerAlternativeSimpleT`.",
                                                          ),
                                                      ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                })
                                                .describe(
                                                  "`PayerAlternative` — the narrower alternative shape nested in :class:`MedicationCoverageT`.\n\nPer v2 swagger, nested alternatives (alternatives of alternatives) only\ncarry ``Ndc`` and a ``Details`` list, not the full\n:class:`PayerAlternativeT` payload.",
                                                ),
                                            ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        Restrictions: zod
                                          .union([
                                            zod
                                              .object({
                                                IsExcluded: zod
                                                  .union([
                                                    zod.boolean(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                HasMedicalNecessity: zod
                                                  .union([
                                                    zod.boolean(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                HasPriorAuthorization: zod
                                                  .union([
                                                    zod.boolean(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                HasStepTherapy: zod
                                                  .union([
                                                    zod.boolean(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                HasQuantityLimit: zod
                                                  .union([
                                                    zod.boolean(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                HasAgeLimit: zod
                                                  .union([
                                                    zod.boolean(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                AgeLimitRestrictions: zod
                                                  .union([
                                                    zod.array(
                                                      zod
                                                        .object({
                                                          MinimumAge: zod
                                                            .union([
                                                              zod.number(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          MinimumAgeUnit: zod
                                                            .union([
                                                              zod
                                                                .enum([
                                                                  "Days",
                                                                  "Years",
                                                                ])
                                                                .describe(
                                                                  "Unit on :class:`AgeLimitRestrictionT` bounds.",
                                                                ),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          MaximumAge: zod
                                                            .union([
                                                              zod.number(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          MaximumAgeUnit: zod
                                                            .union([
                                                              zod
                                                                .enum([
                                                                  "Days",
                                                                  "Years",
                                                                ])
                                                                .describe(
                                                                  "Unit on :class:`AgeLimitRestrictionT` bounds.",
                                                                ),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                        })
                                                        .describe(
                                                          "`AgeLimitRestriction` entry on a `CoverageRestrictions`.",
                                                        ),
                                                    ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                GenderRestriction: zod
                                                  .union([
                                                    zod
                                                      .enum([
                                                        "Male",
                                                        "Female",
                                                        "Unknown",
                                                      ])
                                                      .describe(
                                                        "`PayerDemographics.Gender` and `CoverageRestrictions.GenderRestriction` values.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                QuantityLimitRestrictions: zod
                                                  .union([
                                                    zod.array(
                                                      zod
                                                        .object({
                                                          MaximumAmount: zod
                                                            .union([
                                                              zod.number(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          AmountUnit: zod
                                                            .union([
                                                              zod
                                                                .enum([
                                                                  "DollarAmount",
                                                                  "DaysSupply",
                                                                  "Fills",
                                                                  "Quantity",
                                                                ])
                                                                .describe(
                                                                  "`QuantityLimitRestriction.AmountUnit` values.",
                                                                ),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          TimePeriodUnit: zod
                                                            .union([
                                                              zod
                                                                .enum([
                                                                  "Days",
                                                                  "Lifetime",
                                                                  "PerDispensing",
                                                                  "SpecificDateRange",
                                                                  "CalendarYear",
                                                                  "CalendarQuarter",
                                                                  "CalendarMonth",
                                                                ])
                                                                .describe(
                                                                  "`QuantityLimitRestriction.TimePeriodUnit` values.",
                                                                ),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          StartDate: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          EndDate: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          MaximumTimePeriodUnits:
                                                            zod
                                                              .union([
                                                                zod.number(),
                                                                zod.null(),
                                                              ])
                                                              .optional(),
                                                        })
                                                        .describe(
                                                          "`QuantityLimitRestriction` entry on a `CoverageRestrictions`.",
                                                        ),
                                                    ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                StepMedicationRestrictions: zod
                                                  .union([
                                                    zod.array(
                                                      zod
                                                        .object({
                                                          Ndc: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          StepDrugType: zod
                                                            .union([
                                                              zod
                                                                .enum([
                                                                  "Unknown",
                                                                  "SpecificMedication",
                                                                  "PharmacologicalClass",
                                                                ])
                                                                .describe(
                                                                  "`StepMedicationRestriction.StepDrugType` values.",
                                                                ),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          StepOrder: zod
                                                            .union([
                                                              zod.number(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          DisplayName: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          RxCUI: zod
                                                            .union([
                                                              zod.number(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          DispensableDrugId: zod
                                                            .union([
                                                              zod.number(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                        })
                                                        .describe(
                                                          "`StepMedicationRestriction` entry on a `CoverageRestrictions`.",
                                                        ),
                                                    ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                Messages: zod
                                                  .union([
                                                    zod.array(
                                                      zod
                                                        .object({
                                                          Message: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          LongMessage: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                        })
                                                        .describe(
                                                          "`CoverageMessage` entry on a `CoverageRestrictions`.",
                                                        ),
                                                    ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                DrugResources: zod
                                                  .union([
                                                    zod.array(
                                                      zod
                                                        .object({
                                                          Url: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          ResourceType: zod
                                                            .union([
                                                              zod
                                                                .enum([
                                                                  "AgeLimits",
                                                                  "ProductCoverageExclusion",
                                                                  "GenderLimits",
                                                                  "MedicalNecessity",
                                                                  "PriorAuthorization",
                                                                  "QuantityLimits",
                                                                  "StepTherapy",
                                                                  "General",
                                                                  "Copay",
                                                                  "Formulary",
                                                                ])
                                                                .describe(
                                                                  "`CoverageResource.ResourceType` values.",
                                                                ),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                        })
                                                        .describe(
                                                          "`CoverageResource` entry on a `CoverageRestrictions`.",
                                                        ),
                                                    ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                SummaryResources: zod
                                                  .union([
                                                    zod.array(
                                                      zod
                                                        .object({
                                                          Url: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          ResourceType: zod
                                                            .union([
                                                              zod
                                                                .enum([
                                                                  "AgeLimits",
                                                                  "ProductCoverageExclusion",
                                                                  "GenderLimits",
                                                                  "MedicalNecessity",
                                                                  "PriorAuthorization",
                                                                  "QuantityLimits",
                                                                  "StepTherapy",
                                                                  "General",
                                                                  "Copay",
                                                                  "Formulary",
                                                                ])
                                                                .describe(
                                                                  "`CoverageResource.ResourceType` values.",
                                                                ),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                        })
                                                        .describe(
                                                          "`CoverageResource` entry on a `CoverageRestrictions`.",
                                                        ),
                                                    ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "Coverage restrictions on the primary drug (`CoverageRestrictions`).\n\n``HasPriorAuthorization`` is the primary bit the gate consults when\n`/prescriptionbenefits` is unavailable. ``IsExcluded`` shortcuts to\nthe `EXCLUDED` gate outcome: no point initiating a PA for a drug the\npayer will never cover.\n\nField-name alignment with the v2 swagger: ``HasAgeLimit`` /\n``HasQuantityLimit`` are singular here (not plural as on\n:class:`RealTimeFormularyCoverageRestrictionsT`); there is no\n``HasGenderLimit`` — use ``GenderRestriction`` for that.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                      })
                                      .describe(
                                        "`MedicationCoverage` — coverage slice nested under `PayerAlternativeDetail`.\n\nDistinct from :class:`MedicationCoverageResponseT` (the\n``/formulary`` response body): no ``Otc`` / ``Brand`` /\n``TherapeuticAlternatives`` / ``RealTimeFormularyRequestStatus``\nfields here.",
                                      ),
                                    zod.null(),
                                  ])
                                  .optional(),
                              })
                              .describe(
                                "`PrescriptionBenefitPayerAlternativeDetail` — one detail under :class:`PayerAlternativeT`.\n\nEach detail describes an NDC-level variant of the alternative drug\nalong with its patient-specific pricing.",
                              ),
                          ),
                          zod.null(),
                        ])
                        .optional(),
                      RepresentativeFormularyCoverage: zod
                        .union([
                          zod
                            .object({
                              CopayFactors: zod
                                .union([
                                  zod.array(
                                    zod
                                      .object({
                                        IsDrugSpecific: zod
                                          .union([zod.boolean(), zod.null()])
                                          .optional(),
                                        PharmacyType: zod
                                          .union([
                                            zod
                                              .enum([
                                                "Any",
                                                "FaxPharmacy",
                                                "EPCS",
                                                "TwentyFourHourPharmacy",
                                                "LongTermCarePharmacy",
                                                "MailOrder",
                                                "Retail",
                                                "SpecialtyPharmacy",
                                              ])
                                              .describe(
                                                "Valid pharmacy specialty types for DoseSpot.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        FlatCopayAmount: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        PercentCopayAmount: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        FlatCopayAmountFirst: zod
                                          .union([zod.boolean(), zod.null()])
                                          .optional(),
                                        MinimumCopayAmount: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        MaximumCopayAmount: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        DaysSupply: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        CopayTier: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        MaximumCopayTier: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        OutOfPocketMinimum: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        OutOfPocketMaximum: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                      })
                                      .describe(
                                        "Single copay tier (`PayerCopay`).\n\nPer-channel pricing rule returned on formulary responses and on the\n``RepresentitiveFormularyCoverage`` slice of each alternative. The\ngate doesn't consult any of these fields directly — they're carried\nthrough for UI display next to an ``EXCLUDED`` / ``PA_REQUIRED``\nbanner.",
                                      ),
                                  ),
                                  zod.null(),
                                ])
                                .optional(),
                              FormularyStatus: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              FormularyStatusText: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              RealTimeFormularyCoverageRestrictions: zod
                                .union([
                                  zod
                                    .object({
                                      HasCoverageRestrictions: zod
                                        .union([zod.boolean(), zod.null()])
                                        .optional(),
                                      IsExcluded: zod
                                        .union([zod.boolean(), zod.null()])
                                        .optional(),
                                      HasMedicalNecessity: zod
                                        .union([zod.boolean(), zod.null()])
                                        .optional(),
                                      HasPriorAuthorization: zod
                                        .union([zod.boolean(), zod.null()])
                                        .optional(),
                                      HasStepTherapy: zod
                                        .union([zod.boolean(), zod.null()])
                                        .optional(),
                                      AgeLimitRestrictions: zod
                                        .union([
                                          zod.array(
                                            zod
                                              .object({
                                                MinimumAge: zod
                                                  .union([
                                                    zod.number(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                MinimumAgeUnit: zod
                                                  .union([
                                                    zod
                                                      .enum(["Days", "Years"])
                                                      .describe(
                                                        "Unit on :class:`AgeLimitRestrictionT` bounds.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                MaximumAge: zod
                                                  .union([
                                                    zod.number(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                MaximumAgeUnit: zod
                                                  .union([
                                                    zod
                                                      .enum(["Days", "Years"])
                                                      .describe(
                                                        "Unit on :class:`AgeLimitRestrictionT` bounds.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "`AgeLimitRestriction` entry on a `CoverageRestrictions`.",
                                              ),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                      GenderLimitRestrictions: zod
                                        .union([
                                          zod.array(
                                            zod
                                              .object({
                                                GenderAbbreviation: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                GenderDescription: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "`GenderLimitRestriction` entry on a `RealTimeFormularyCoverageRestrictions`.",
                                              ),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                      QuantityLimitRestrictions: zod
                                        .union([
                                          zod.array(
                                            zod
                                              .object({
                                                MaximumAmount: zod
                                                  .union([
                                                    zod.number(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                AmountUnit: zod
                                                  .union([
                                                    zod
                                                      .enum([
                                                        "DollarAmount",
                                                        "DaysSupply",
                                                        "Fills",
                                                        "Quantity",
                                                      ])
                                                      .describe(
                                                        "`QuantityLimitRestriction.AmountUnit` values.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                TimePeriodUnit: zod
                                                  .union([
                                                    zod
                                                      .enum([
                                                        "Days",
                                                        "Lifetime",
                                                        "PerDispensing",
                                                        "SpecificDateRange",
                                                        "CalendarYear",
                                                        "CalendarQuarter",
                                                        "CalendarMonth",
                                                      ])
                                                      .describe(
                                                        "`QuantityLimitRestriction.TimePeriodUnit` values.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                StartDate: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                EndDate: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                MaximumTimePeriodUnits: zod
                                                  .union([
                                                    zod.number(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "`QuantityLimitRestriction` entry on a `CoverageRestrictions`.",
                                              ),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                      StepMedicationRestrictions: zod
                                        .union([
                                          zod.array(
                                            zod
                                              .object({
                                                Ndc: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                StepDrugType: zod
                                                  .union([
                                                    zod
                                                      .enum([
                                                        "Unknown",
                                                        "SpecificMedication",
                                                        "PharmacologicalClass",
                                                      ])
                                                      .describe(
                                                        "`StepMedicationRestriction.StepDrugType` values.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                StepOrder: zod
                                                  .union([
                                                    zod.number(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                DisplayName: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                RxCUI: zod
                                                  .union([
                                                    zod.number(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                DispensableDrugId: zod
                                                  .union([
                                                    zod.number(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "`StepMedicationRestriction` entry on a `CoverageRestrictions`.",
                                              ),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                      Messages: zod
                                        .union([
                                          zod.array(
                                            zod
                                              .object({
                                                Message: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                LongMessage: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "`CoverageMessage` entry on a `CoverageRestrictions`.",
                                              ),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                      DrugResources: zod
                                        .union([
                                          zod.array(
                                            zod
                                              .object({
                                                Url: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                ResourceType: zod
                                                  .union([
                                                    zod
                                                      .enum([
                                                        "AgeLimits",
                                                        "ProductCoverageExclusion",
                                                        "GenderLimits",
                                                        "MedicalNecessity",
                                                        "PriorAuthorization",
                                                        "QuantityLimits",
                                                        "StepTherapy",
                                                        "General",
                                                        "Copay",
                                                        "Formulary",
                                                      ])
                                                      .describe(
                                                        "`CoverageResource.ResourceType` values.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "`CoverageResource` entry on a `CoverageRestrictions`.",
                                              ),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                      SummaryResources: zod
                                        .union([
                                          zod.array(
                                            zod
                                              .object({
                                                Url: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                ResourceType: zod
                                                  .union([
                                                    zod
                                                      .enum([
                                                        "AgeLimits",
                                                        "ProductCoverageExclusion",
                                                        "GenderLimits",
                                                        "MedicalNecessity",
                                                        "PriorAuthorization",
                                                        "QuantityLimits",
                                                        "StepTherapy",
                                                        "General",
                                                        "Copay",
                                                        "Formulary",
                                                      ])
                                                      .describe(
                                                        "`CoverageResource.ResourceType` values.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "`CoverageResource` entry on a `CoverageRestrictions`.",
                                              ),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                    })
                                    .describe(
                                      "Realtime-only restriction slice (`RealTimeFormularyCoverageRestrictions`).\n\nAppears only on :class:`RepresentitiveFormularyCoverageT` (i.e. on each\nalternative drug), **not** on the primary drug's ``CoverageRestrictions``.\nThat asymmetry is per the v2 swagger: the primary drug's realtime PA\nbit is conveyed by ``/prescriptionbenefits`` (``PriorAuthRequired``)\nand its cached bit by ``CoverageRestrictions.HasPriorAuthorization``.\n\nField names match the swagger exactly — note ``HasMedicalNecessity``\n(not the legacy ``RequiresMedicalNecessity``) and ``HasAge`` /\n``HasQuantity`` rather than the plural ``…Limits`` spellings used on\n:class:`CoverageRestrictionsT`.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                            })
                            .describe(
                              "`RepresentitiveFormularyCoverage` on a :class:`PayerAlternativeT`.\n\nThe typo (``Representitive`` rather than ``Representative``) is\nDoseSpot's, not ours — the field name is verbatim from the v2 swagger\ndefinition so pydantic's ``model_validate`` of a raw DoseSpot\nresponse lines up.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      PatientSpecificPricingCoverages: zod
                        .union([
                          zod.array(
                            zod
                              .object({
                                Pharmacy: zod
                                  .union([
                                    zod
                                      .object({
                                        PharmacyType: zod
                                          .union([
                                            zod
                                              .enum([
                                                "Retail",
                                                "Mail",
                                                "Item90DayAtRetail",
                                                "Specialty",
                                                "LongTermCare",
                                              ])
                                              .describe(
                                                "`PrescriptionBenefitsPharmacy.PharmacyType` values.\n\nDistinct from :class:`PharmacySpecialtyTypeT` — DoseSpot uses a\ndifferent (smaller) vocabulary for the pharmacy slice returned on\nrealtime-benefits responses than for channel-level eligibility.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        Identifications: zod
                                          .union([
                                            zod.record(
                                              zod.string(),
                                              zod.unknown(),
                                            ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        PharmacistLastName: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PharmacistFirstName: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PharmacistMiddleName: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PharmacistSuffix: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PharmacistPrefix: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        Email: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        DistanceFromRequestedPharmacy: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        PharmacyId: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        StoreName: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        Address1: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        Address2: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        City: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        State: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        ZipCode: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PrimaryPhone: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PrimaryPhoneType: zod
                                          .union([
                                            zod
                                              .enum([
                                                "Undefined",
                                                "Beeper",
                                                "Cell",
                                                "Fax",
                                                "Home",
                                                "Work",
                                                "Night",
                                                "Primary",
                                              ])
                                              .describe(
                                                "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` / `PhoneAdditionalType*` values.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        PrimaryFax: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PhoneAdditional1: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PhoneAdditionalType1: zod
                                          .union([
                                            zod
                                              .enum([
                                                "Undefined",
                                                "Beeper",
                                                "Cell",
                                                "Fax",
                                                "Home",
                                                "Work",
                                                "Night",
                                                "Primary",
                                              ])
                                              .describe(
                                                "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` / `PhoneAdditionalType*` values.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        PhoneAdditional2: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PhoneAdditionalType2: zod
                                          .union([
                                            zod
                                              .enum([
                                                "Undefined",
                                                "Beeper",
                                                "Cell",
                                                "Fax",
                                                "Home",
                                                "Work",
                                                "Night",
                                                "Primary",
                                              ])
                                              .describe(
                                                "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` / `PhoneAdditionalType*` values.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        PhoneAdditional3: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PhoneAdditionalType3: zod
                                          .union([
                                            zod
                                              .enum([
                                                "Undefined",
                                                "Beeper",
                                                "Cell",
                                                "Fax",
                                                "Home",
                                                "Work",
                                                "Night",
                                                "Primary",
                                              ])
                                              .describe(
                                                "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` / `PhoneAdditionalType*` values.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        PharmacySpecialties: zod
                                          .union([
                                            zod.array(zod.string()),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        ServiceLevel: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        Latitude: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        Longitude: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        NCPDPID: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                      })
                                      .describe(
                                        "`PrescriptionBenefitsPharmacy` — pharmacy slice on RTPB responses.\n\nNarrower-use than :class:`PharmacyT`; mirrors the full swagger shape\nso callers can surface dispensing-pharmacy details (name, address,\nNCPDPID) alongside pricing / PA signals from a\n``PatientSpecificPricingCoverage`` entry.",
                                      ),
                                    zod.null(),
                                  ])
                                  .optional(),
                                PricingCoverage: zod
                                  .union([
                                    zod
                                      .object({
                                        DrugStatusCode: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        DrugStatus: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        QuantityPricedValue: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        QuantityPricedCodeListQualifier: zod
                                          .union([
                                            zod
                                              .enum([
                                                "Item38",
                                                "Item40",
                                                "Item87",
                                                "QS",
                                                "CF",
                                                "UQ",
                                              ])
                                              .describe(
                                                "`PricingCoverageFactors.QuantityPricedCodeListQualifier` values.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        QuantityPricedUnitOfMeasureType: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        QuantityPricedUnitOfMeasureTypeId: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        DaysSupplyPriced: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PlanPayAmount: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        EstimatedPatientPayAmount: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        OOPAppliedAmount: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        OOPRemainingAmount: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        DeductibleAppliedAmount: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        DeductibleRemainingAmount: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        CoverageAlerts: zod
                                          .union([
                                            zod.array(
                                              zod
                                                .object({
                                                  ReferenceCode: zod
                                                    .union([
                                                      zod
                                                        .enum([
                                                          "AgeLimits",
                                                          "DaysSupplyExceeded",
                                                          "DrugExclusion",
                                                          "ExcessiveUtilization",
                                                          "FullCostNotCovered",
                                                          "GenderLimits",
                                                          "MandatoryGeneric",
                                                          "MedicalNecessity",
                                                          "NotOnFormulary",
                                                          "PharmacyOutOfNetwork",
                                                          "PlanLimitExclusion",
                                                          "QuantityLimits",
                                                          "QuantityLimitExceeded",
                                                          "QuantityNotValid",
                                                          "ResourceLink",
                                                          "StepTherapy",
                                                          "TextMessage",
                                                        ])
                                                        .describe(
                                                          "`PricingCoverageFactorsCoverageAlerts.ReferenceCode` values.",
                                                        ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  ReferenceText: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                })
                                                .describe(
                                                  "`PricingCoverageFactorsCoverageAlerts` entry on :class:`PricingCoverageFactorsT`.\n\nDoseSpot returns coverage-alert *objects* here (not plain strings):\na ``ReferenceCode`` enum plus a human-readable ``ReferenceText``.",
                                                ),
                                            ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        FormularyStatus: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PriorAuthRequired: zod
                                          .union([zod.boolean(), zod.null()])
                                          .optional(),
                                      })
                                      .describe(
                                        "`PricingCoverageFactors` — `PricingCoverage` sub-object on RTPB.\n\nThe realtime gate's authoritative PA source: ``PriorAuthRequired=true``\non any pharmacy-specific pricing coverage flips the gate to\n:attr:`PA_REQUIRED`. Pricing fields are kept for downstream UI — they\nare not consulted by the gate but are cheap to carry.",
                                      ),
                                    zod.null(),
                                  ])
                                  .optional(),
                              })
                              .describe(
                                "`PatientSpecificPricingCoverage` — one (pharmacy × coverage) pricing row.\n\nA coverage can yield multiple entries — one per pharmacy the payer\npriced against — so the gate has to OR the ``PriorAuthRequired`` bits\nacross the list to get a conservative answer.",
                              ),
                          ),
                          zod.null(),
                        ])
                        .optional(),
                    })
                    .describe(
                      "`PayerAlternativeAPI` — payer-preferred alternative for an NDC.\n\nSurfaced alongside a gate decision of :attr:`EXCLUDED` or\n:attr:`PA_REQUIRED` so the clinician can rewrite to a preferred drug\ninstead of fighting a PA. Returned both on the formulary response\n(``MedicationCoverageResponse.Alternatives``) and on the RTPB\nresponse (``GetPrescriptionBenefitResponse.Alternatives``).",
                    ),
                ),
                zod.null(),
              ])
              .optional(),
            TherapeuticAlternatives: zod
              .union([
                zod.array(
                  zod
                    .object({
                      Ndc: zod.union([zod.string(), zod.null()]).optional(),
                      FormularyStatus: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Copay: zod
                        .union([
                          zod
                            .object({
                              IsDrugSpecific: zod
                                .union([zod.boolean(), zod.null()])
                                .optional(),
                              PharmacyType: zod
                                .union([
                                  zod
                                    .enum([
                                      "Any",
                                      "FaxPharmacy",
                                      "EPCS",
                                      "TwentyFourHourPharmacy",
                                      "LongTermCarePharmacy",
                                      "MailOrder",
                                      "Retail",
                                      "SpecialtyPharmacy",
                                    ])
                                    .describe(
                                      "Valid pharmacy specialty types for DoseSpot.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              FlatCopayAmount: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              PercentCopayAmount: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              FlatCopayAmountFirst: zod
                                .union([zod.boolean(), zod.null()])
                                .optional(),
                              MinimumCopayAmount: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              MaximumCopayAmount: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              DaysSupply: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              CopayTier: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              MaximumCopayTier: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              OutOfPocketMinimum: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              OutOfPocketMaximum: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                            })
                            .describe(
                              "Single copay tier (`PayerCopay`).\n\nPer-channel pricing rule returned on formulary responses and on the\n``RepresentitiveFormularyCoverage`` slice of each alternative. The\ngate doesn't consult any of these fields directly — they're carried\nthrough for UI display next to an ``EXCLUDED`` / ``PA_REQUIRED``\nbanner.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      DisplayName: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      FormularyInfo: zod
                        .union([
                          zod
                            .object({
                              ProductId: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              Ndc: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              FormularyStatusId: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              FormularyAbbreviation: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              FormularyStatusMessage: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              OrderRank: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              IsGeneric: zod
                                .union([zod.boolean(), zod.null()])
                                .optional(),
                              IsRx: zod
                                .union([zod.boolean(), zod.null()])
                                .optional(),
                            })
                            .describe(
                              "`FormularyInfo` nested on :class:`TherapeuticAlternativesT`.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      FullDisplayString: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DisplayStrength: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DefaultDispenseUnitID: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      DispensableDrugId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Schedule: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      IsDetox: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      HasGHB: zod.union([zod.boolean(), zod.null()]).optional(),
                      RxCUI: zod.union([zod.number(), zod.null()]).optional(),
                    })
                    .describe(
                      "`TherapeuticAlternatives` entry on a formulary response.\n\nV2 replaces the v1 ``/therapeuticAlternatives`` endpoint with a\n``TherapeuticAlternatives`` list returned inline on the formulary\nresponse. Surfaced alongside :attr:`EXCLUDED` / :attr:`PA_REQUIRED`\noutcomes so the clinician can rewrite to a preferred drug without a\nsecond round trip.",
                    ),
                ),
                zod.null(),
              ])
              .optional(),
            Restrictions: zod
              .union([
                zod
                  .object({
                    IsExcluded: zod
                      .union([zod.boolean(), zod.null()])
                      .optional(),
                    HasMedicalNecessity: zod
                      .union([zod.boolean(), zod.null()])
                      .optional(),
                    HasPriorAuthorization: zod
                      .union([zod.boolean(), zod.null()])
                      .optional(),
                    HasStepTherapy: zod
                      .union([zod.boolean(), zod.null()])
                      .optional(),
                    HasQuantityLimit: zod
                      .union([zod.boolean(), zod.null()])
                      .optional(),
                    HasAgeLimit: zod
                      .union([zod.boolean(), zod.null()])
                      .optional(),
                    AgeLimitRestrictions: zod
                      .union([
                        zod.array(
                          zod
                            .object({
                              MinimumAge: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              MinimumAgeUnit: zod
                                .union([
                                  zod
                                    .enum(["Days", "Years"])
                                    .describe(
                                      "Unit on :class:`AgeLimitRestrictionT` bounds.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              MaximumAge: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              MaximumAgeUnit: zod
                                .union([
                                  zod
                                    .enum(["Days", "Years"])
                                    .describe(
                                      "Unit on :class:`AgeLimitRestrictionT` bounds.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                            })
                            .describe(
                              "`AgeLimitRestriction` entry on a `CoverageRestrictions`.",
                            ),
                        ),
                        zod.null(),
                      ])
                      .optional(),
                    GenderRestriction: zod
                      .union([
                        zod
                          .enum(["Male", "Female", "Unknown"])
                          .describe(
                            "`PayerDemographics.Gender` and `CoverageRestrictions.GenderRestriction` values.",
                          ),
                        zod.null(),
                      ])
                      .optional(),
                    QuantityLimitRestrictions: zod
                      .union([
                        zod.array(
                          zod
                            .object({
                              MaximumAmount: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              AmountUnit: zod
                                .union([
                                  zod
                                    .enum([
                                      "DollarAmount",
                                      "DaysSupply",
                                      "Fills",
                                      "Quantity",
                                    ])
                                    .describe(
                                      "`QuantityLimitRestriction.AmountUnit` values.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              TimePeriodUnit: zod
                                .union([
                                  zod
                                    .enum([
                                      "Days",
                                      "Lifetime",
                                      "PerDispensing",
                                      "SpecificDateRange",
                                      "CalendarYear",
                                      "CalendarQuarter",
                                      "CalendarMonth",
                                    ])
                                    .describe(
                                      "`QuantityLimitRestriction.TimePeriodUnit` values.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              StartDate: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              EndDate: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              MaximumTimePeriodUnits: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                            })
                            .describe(
                              "`QuantityLimitRestriction` entry on a `CoverageRestrictions`.",
                            ),
                        ),
                        zod.null(),
                      ])
                      .optional(),
                    StepMedicationRestrictions: zod
                      .union([
                        zod.array(
                          zod
                            .object({
                              Ndc: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              StepDrugType: zod
                                .union([
                                  zod
                                    .enum([
                                      "Unknown",
                                      "SpecificMedication",
                                      "PharmacologicalClass",
                                    ])
                                    .describe(
                                      "`StepMedicationRestriction.StepDrugType` values.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              StepOrder: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              DisplayName: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              RxCUI: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              DispensableDrugId: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                            })
                            .describe(
                              "`StepMedicationRestriction` entry on a `CoverageRestrictions`.",
                            ),
                        ),
                        zod.null(),
                      ])
                      .optional(),
                    Messages: zod
                      .union([
                        zod.array(
                          zod
                            .object({
                              Message: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              LongMessage: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                            })
                            .describe(
                              "`CoverageMessage` entry on a `CoverageRestrictions`.",
                            ),
                        ),
                        zod.null(),
                      ])
                      .optional(),
                    DrugResources: zod
                      .union([
                        zod.array(
                          zod
                            .object({
                              Url: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              ResourceType: zod
                                .union([
                                  zod
                                    .enum([
                                      "AgeLimits",
                                      "ProductCoverageExclusion",
                                      "GenderLimits",
                                      "MedicalNecessity",
                                      "PriorAuthorization",
                                      "QuantityLimits",
                                      "StepTherapy",
                                      "General",
                                      "Copay",
                                      "Formulary",
                                    ])
                                    .describe(
                                      "`CoverageResource.ResourceType` values.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                            })
                            .describe(
                              "`CoverageResource` entry on a `CoverageRestrictions`.",
                            ),
                        ),
                        zod.null(),
                      ])
                      .optional(),
                    SummaryResources: zod
                      .union([
                        zod.array(
                          zod
                            .object({
                              Url: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              ResourceType: zod
                                .union([
                                  zod
                                    .enum([
                                      "AgeLimits",
                                      "ProductCoverageExclusion",
                                      "GenderLimits",
                                      "MedicalNecessity",
                                      "PriorAuthorization",
                                      "QuantityLimits",
                                      "StepTherapy",
                                      "General",
                                      "Copay",
                                      "Formulary",
                                    ])
                                    .describe(
                                      "`CoverageResource.ResourceType` values.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                            })
                            .describe(
                              "`CoverageResource` entry on a `CoverageRestrictions`.",
                            ),
                        ),
                        zod.null(),
                      ])
                      .optional(),
                  })
                  .describe(
                    "Coverage restrictions on the primary drug (`CoverageRestrictions`).\n\n``HasPriorAuthorization`` is the primary bit the gate consults when\n`/prescriptionbenefits` is unavailable. ``IsExcluded`` shortcuts to\nthe `EXCLUDED` gate outcome: no point initiating a PA for a drug the\npayer will never cover.\n\nField-name alignment with the v2 swagger: ``HasAgeLimit`` /\n``HasQuantityLimit`` are singular here (not plural as on\n:class:`RealTimeFormularyCoverageRestrictionsT`); there is no\n``HasGenderLimit`` — use ``GenderRestriction`` for that.",
                  ),
                zod.null(),
              ])
              .optional(),
            RealTimeFormularyRequestStatus: zod
              .union([zod.number(), zod.null()])
              .optional(),
          })
          .describe(
            "`MedicationCoverageResponse` — inner item of ``ItemResponse[…]`` on\n``GET /api/patients/{patient_id}/formulary``.\n\nRetained under the historical ``FormularyResponseT`` name so in-repo\ncallers don't need to rename types; the shape is now the v2 swagger's\nunwrapped `Item` (see :class:`FormularyItemResponseT` for the wire-\nlevel wrapper).\n\nKey fields for the gate:\n\n- ``Restrictions.HasPriorAuthorization`` — cached-formulary PA bit.\n- ``Restrictions.IsExcluded`` — drug is flatly not covered; maps to\n  the :attr:`EXCLUDED` gate outcome.\n- ``RealTimeFormularyRequestStatus`` — non-OK here means \"realtime\n  call didn't land\"; the gate falls back to the cached slice before\n  declaring :attr:`UNKNOWN`.\n\nNotably absent: ``PatientEligibilityId`` / ``NDC`` / ``DrugName``.\nV2's `MedicationCoverageResponse` does not echo the request context\nback; the gate tracks that out-of-band.",
          ),
        zod.null(),
      ])
      .optional(),
    benefits: zod
      .union([
        zod
          .object({
            PatientFormularyId: zod
              .union([zod.number(), zod.null()])
              .optional(),
            Brand: zod.union([zod.boolean(), zod.null()]).optional(),
            Otc: zod.union([zod.boolean(), zod.null()]).optional(),
            Alternatives: zod
              .union([
                zod.array(
                  zod
                    .object({
                      Ndc: zod.union([zod.string(), zod.null()]).optional(),
                      DisplayName: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      RxCUI: zod.union([zod.number(), zod.null()]).optional(),
                      DispensableDrugId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Brand: zod.union([zod.boolean(), zod.null()]).optional(),
                      Otc: zod.union([zod.boolean(), zod.null()]).optional(),
                      Details: zod
                        .union([
                          zod.array(
                            zod
                              .object({
                                PatientSpecificPricingCoverages: zod
                                  .union([
                                    zod.array(
                                      zod
                                        .object({
                                          Pharmacy: zod
                                            .union([
                                              zod
                                                .object({
                                                  PharmacyType: zod
                                                    .union([
                                                      zod
                                                        .enum([
                                                          "Retail",
                                                          "Mail",
                                                          "Item90DayAtRetail",
                                                          "Specialty",
                                                          "LongTermCare",
                                                        ])
                                                        .describe(
                                                          "`PrescriptionBenefitsPharmacy.PharmacyType` values.\n\nDistinct from :class:`PharmacySpecialtyTypeT` — DoseSpot uses a\ndifferent (smaller) vocabulary for the pharmacy slice returned on\nrealtime-benefits responses than for channel-level eligibility.",
                                                        ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  Identifications: zod
                                                    .union([
                                                      zod.record(
                                                        zod.string(),
                                                        zod.unknown(),
                                                      ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PharmacistLastName: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PharmacistFirstName: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PharmacistMiddleName: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PharmacistSuffix: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PharmacistPrefix: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  Email: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  DistanceFromRequestedPharmacy:
                                                    zod
                                                      .union([
                                                        zod.number(),
                                                        zod.null(),
                                                      ])
                                                      .optional(),
                                                  PharmacyId: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  StoreName: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  Address1: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  Address2: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  City: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  State: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  ZipCode: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PrimaryPhone: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PrimaryPhoneType: zod
                                                    .union([
                                                      zod
                                                        .enum([
                                                          "Undefined",
                                                          "Beeper",
                                                          "Cell",
                                                          "Fax",
                                                          "Home",
                                                          "Work",
                                                          "Night",
                                                          "Primary",
                                                        ])
                                                        .describe(
                                                          "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` / `PhoneAdditionalType*` values.",
                                                        ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PrimaryFax: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PhoneAdditional1: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PhoneAdditionalType1: zod
                                                    .union([
                                                      zod
                                                        .enum([
                                                          "Undefined",
                                                          "Beeper",
                                                          "Cell",
                                                          "Fax",
                                                          "Home",
                                                          "Work",
                                                          "Night",
                                                          "Primary",
                                                        ])
                                                        .describe(
                                                          "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` / `PhoneAdditionalType*` values.",
                                                        ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PhoneAdditional2: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PhoneAdditionalType2: zod
                                                    .union([
                                                      zod
                                                        .enum([
                                                          "Undefined",
                                                          "Beeper",
                                                          "Cell",
                                                          "Fax",
                                                          "Home",
                                                          "Work",
                                                          "Night",
                                                          "Primary",
                                                        ])
                                                        .describe(
                                                          "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` / `PhoneAdditionalType*` values.",
                                                        ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PhoneAdditional3: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PhoneAdditionalType3: zod
                                                    .union([
                                                      zod
                                                        .enum([
                                                          "Undefined",
                                                          "Beeper",
                                                          "Cell",
                                                          "Fax",
                                                          "Home",
                                                          "Work",
                                                          "Night",
                                                          "Primary",
                                                        ])
                                                        .describe(
                                                          "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` / `PhoneAdditionalType*` values.",
                                                        ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PharmacySpecialties: zod
                                                    .union([
                                                      zod.array(zod.string()),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  ServiceLevel: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  Latitude: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  Longitude: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  NCPDPID: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                })
                                                .describe(
                                                  "`PrescriptionBenefitsPharmacy` — pharmacy slice on RTPB responses.\n\nNarrower-use than :class:`PharmacyT`; mirrors the full swagger shape\nso callers can surface dispensing-pharmacy details (name, address,\nNCPDPID) alongside pricing / PA signals from a\n``PatientSpecificPricingCoverage`` entry.",
                                                ),
                                              zod.null(),
                                            ])
                                            .optional(),
                                          PricingCoverage: zod
                                            .union([
                                              zod
                                                .object({
                                                  DrugStatusCode: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  DrugStatus: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  QuantityPricedValue: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  QuantityPricedCodeListQualifier:
                                                    zod
                                                      .union([
                                                        zod
                                                          .enum([
                                                            "Item38",
                                                            "Item40",
                                                            "Item87",
                                                            "QS",
                                                            "CF",
                                                            "UQ",
                                                          ])
                                                          .describe(
                                                            "`PricingCoverageFactors.QuantityPricedCodeListQualifier` values.",
                                                          ),
                                                        zod.null(),
                                                      ])
                                                      .optional(),
                                                  QuantityPricedUnitOfMeasureType:
                                                    zod
                                                      .union([
                                                        zod.string(),
                                                        zod.null(),
                                                      ])
                                                      .optional(),
                                                  QuantityPricedUnitOfMeasureTypeId:
                                                    zod
                                                      .union([
                                                        zod.number(),
                                                        zod.null(),
                                                      ])
                                                      .optional(),
                                                  DaysSupplyPriced: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PlanPayAmount: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  EstimatedPatientPayAmount: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  OOPAppliedAmount: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  OOPRemainingAmount: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  DeductibleAppliedAmount: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  DeductibleRemainingAmount: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  CoverageAlerts: zod
                                                    .union([
                                                      zod.array(
                                                        zod
                                                          .object({
                                                            ReferenceCode: zod
                                                              .union([
                                                                zod
                                                                  .enum([
                                                                    "AgeLimits",
                                                                    "DaysSupplyExceeded",
                                                                    "DrugExclusion",
                                                                    "ExcessiveUtilization",
                                                                    "FullCostNotCovered",
                                                                    "GenderLimits",
                                                                    "MandatoryGeneric",
                                                                    "MedicalNecessity",
                                                                    "NotOnFormulary",
                                                                    "PharmacyOutOfNetwork",
                                                                    "PlanLimitExclusion",
                                                                    "QuantityLimits",
                                                                    "QuantityLimitExceeded",
                                                                    "QuantityNotValid",
                                                                    "ResourceLink",
                                                                    "StepTherapy",
                                                                    "TextMessage",
                                                                  ])
                                                                  .describe(
                                                                    "`PricingCoverageFactorsCoverageAlerts.ReferenceCode` values.",
                                                                  ),
                                                                zod.null(),
                                                              ])
                                                              .optional(),
                                                            ReferenceText: zod
                                                              .union([
                                                                zod.string(),
                                                                zod.null(),
                                                              ])
                                                              .optional(),
                                                          })
                                                          .describe(
                                                            "`PricingCoverageFactorsCoverageAlerts` entry on :class:`PricingCoverageFactorsT`.\n\nDoseSpot returns coverage-alert *objects* here (not plain strings):\na ``ReferenceCode`` enum plus a human-readable ``ReferenceText``.",
                                                          ),
                                                      ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  FormularyStatus: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PriorAuthRequired: zod
                                                    .union([
                                                      zod.boolean(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                })
                                                .describe(
                                                  "`PricingCoverageFactors` — `PricingCoverage` sub-object on RTPB.\n\nThe realtime gate's authoritative PA source: ``PriorAuthRequired=true``\non any pharmacy-specific pricing coverage flips the gate to\n:attr:`PA_REQUIRED`. Pricing fields are kept for downstream UI — they\nare not consulted by the gate but are cheap to carry.",
                                                ),
                                              zod.null(),
                                            ])
                                            .optional(),
                                        })
                                        .describe(
                                          "`PatientSpecificPricingCoverage` — one (pharmacy × coverage) pricing row.\n\nA coverage can yield multiple entries — one per pharmacy the payer\npriced against — so the gate has to OR the ``PriorAuthRequired`` bits\nacross the list to get a conservative answer.",
                                        ),
                                    ),
                                    zod.null(),
                                  ])
                                  .optional(),
                                Ndc: zod
                                  .union([zod.string(), zod.null()])
                                  .optional(),
                                DisplayName: zod
                                  .union([zod.string(), zod.null()])
                                  .optional(),
                                RxCUI: zod
                                  .union([zod.number(), zod.null()])
                                  .optional(),
                                DispensableDrugId: zod
                                  .union([zod.number(), zod.null()])
                                  .optional(),
                                Coverage: zod
                                  .union([
                                    zod
                                      .object({
                                        FormularyStatus: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        Copays: zod
                                          .union([
                                            zod.array(
                                              zod
                                                .object({
                                                  IsDrugSpecific: zod
                                                    .union([
                                                      zod.boolean(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PharmacyType: zod
                                                    .union([
                                                      zod
                                                        .enum([
                                                          "Any",
                                                          "FaxPharmacy",
                                                          "EPCS",
                                                          "TwentyFourHourPharmacy",
                                                          "LongTermCarePharmacy",
                                                          "MailOrder",
                                                          "Retail",
                                                          "SpecialtyPharmacy",
                                                        ])
                                                        .describe(
                                                          "Valid pharmacy specialty types for DoseSpot.",
                                                        ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  FlatCopayAmount: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PercentCopayAmount: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  FlatCopayAmountFirst: zod
                                                    .union([
                                                      zod.boolean(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  MinimumCopayAmount: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  MaximumCopayAmount: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  DaysSupply: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  CopayTier: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  MaximumCopayTier: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  OutOfPocketMinimum: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  OutOfPocketMaximum: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                })
                                                .describe(
                                                  "Single copay tier (`PayerCopay`).\n\nPer-channel pricing rule returned on formulary responses and on the\n``RepresentitiveFormularyCoverage`` slice of each alternative. The\ngate doesn't consult any of these fields directly — they're carried\nthrough for UI display next to an ``EXCLUDED`` / ``PA_REQUIRED``\nbanner.",
                                                ),
                                            ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        Alternatives: zod
                                          .union([
                                            zod.array(
                                              zod
                                                .object({
                                                  Ndc: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  Details: zod
                                                    .union([
                                                      zod.array(
                                                        zod
                                                          .object({
                                                            Ndc: zod
                                                              .union([
                                                                zod.string(),
                                                                zod.null(),
                                                              ])
                                                              .optional(),
                                                            Coverage: zod
                                                              .union([
                                                                zod.unknown(),
                                                                zod.null(),
                                                              ])
                                                              .optional(),
                                                          })
                                                          .describe(
                                                            "`PayerAlternativeDetail` — one detail under :class:`PayerAlternativeSimpleT`.",
                                                          ),
                                                      ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                })
                                                .describe(
                                                  "`PayerAlternative` — the narrower alternative shape nested in :class:`MedicationCoverageT`.\n\nPer v2 swagger, nested alternatives (alternatives of alternatives) only\ncarry ``Ndc`` and a ``Details`` list, not the full\n:class:`PayerAlternativeT` payload.",
                                                ),
                                            ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        Restrictions: zod
                                          .union([
                                            zod
                                              .object({
                                                IsExcluded: zod
                                                  .union([
                                                    zod.boolean(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                HasMedicalNecessity: zod
                                                  .union([
                                                    zod.boolean(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                HasPriorAuthorization: zod
                                                  .union([
                                                    zod.boolean(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                HasStepTherapy: zod
                                                  .union([
                                                    zod.boolean(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                HasQuantityLimit: zod
                                                  .union([
                                                    zod.boolean(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                HasAgeLimit: zod
                                                  .union([
                                                    zod.boolean(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                AgeLimitRestrictions: zod
                                                  .union([
                                                    zod.array(
                                                      zod
                                                        .object({
                                                          MinimumAge: zod
                                                            .union([
                                                              zod.number(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          MinimumAgeUnit: zod
                                                            .union([
                                                              zod
                                                                .enum([
                                                                  "Days",
                                                                  "Years",
                                                                ])
                                                                .describe(
                                                                  "Unit on :class:`AgeLimitRestrictionT` bounds.",
                                                                ),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          MaximumAge: zod
                                                            .union([
                                                              zod.number(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          MaximumAgeUnit: zod
                                                            .union([
                                                              zod
                                                                .enum([
                                                                  "Days",
                                                                  "Years",
                                                                ])
                                                                .describe(
                                                                  "Unit on :class:`AgeLimitRestrictionT` bounds.",
                                                                ),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                        })
                                                        .describe(
                                                          "`AgeLimitRestriction` entry on a `CoverageRestrictions`.",
                                                        ),
                                                    ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                GenderRestriction: zod
                                                  .union([
                                                    zod
                                                      .enum([
                                                        "Male",
                                                        "Female",
                                                        "Unknown",
                                                      ])
                                                      .describe(
                                                        "`PayerDemographics.Gender` and `CoverageRestrictions.GenderRestriction` values.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                QuantityLimitRestrictions: zod
                                                  .union([
                                                    zod.array(
                                                      zod
                                                        .object({
                                                          MaximumAmount: zod
                                                            .union([
                                                              zod.number(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          AmountUnit: zod
                                                            .union([
                                                              zod
                                                                .enum([
                                                                  "DollarAmount",
                                                                  "DaysSupply",
                                                                  "Fills",
                                                                  "Quantity",
                                                                ])
                                                                .describe(
                                                                  "`QuantityLimitRestriction.AmountUnit` values.",
                                                                ),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          TimePeriodUnit: zod
                                                            .union([
                                                              zod
                                                                .enum([
                                                                  "Days",
                                                                  "Lifetime",
                                                                  "PerDispensing",
                                                                  "SpecificDateRange",
                                                                  "CalendarYear",
                                                                  "CalendarQuarter",
                                                                  "CalendarMonth",
                                                                ])
                                                                .describe(
                                                                  "`QuantityLimitRestriction.TimePeriodUnit` values.",
                                                                ),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          StartDate: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          EndDate: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          MaximumTimePeriodUnits:
                                                            zod
                                                              .union([
                                                                zod.number(),
                                                                zod.null(),
                                                              ])
                                                              .optional(),
                                                        })
                                                        .describe(
                                                          "`QuantityLimitRestriction` entry on a `CoverageRestrictions`.",
                                                        ),
                                                    ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                StepMedicationRestrictions: zod
                                                  .union([
                                                    zod.array(
                                                      zod
                                                        .object({
                                                          Ndc: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          StepDrugType: zod
                                                            .union([
                                                              zod
                                                                .enum([
                                                                  "Unknown",
                                                                  "SpecificMedication",
                                                                  "PharmacologicalClass",
                                                                ])
                                                                .describe(
                                                                  "`StepMedicationRestriction.StepDrugType` values.",
                                                                ),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          StepOrder: zod
                                                            .union([
                                                              zod.number(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          DisplayName: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          RxCUI: zod
                                                            .union([
                                                              zod.number(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          DispensableDrugId: zod
                                                            .union([
                                                              zod.number(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                        })
                                                        .describe(
                                                          "`StepMedicationRestriction` entry on a `CoverageRestrictions`.",
                                                        ),
                                                    ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                Messages: zod
                                                  .union([
                                                    zod.array(
                                                      zod
                                                        .object({
                                                          Message: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          LongMessage: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                        })
                                                        .describe(
                                                          "`CoverageMessage` entry on a `CoverageRestrictions`.",
                                                        ),
                                                    ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                DrugResources: zod
                                                  .union([
                                                    zod.array(
                                                      zod
                                                        .object({
                                                          Url: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          ResourceType: zod
                                                            .union([
                                                              zod
                                                                .enum([
                                                                  "AgeLimits",
                                                                  "ProductCoverageExclusion",
                                                                  "GenderLimits",
                                                                  "MedicalNecessity",
                                                                  "PriorAuthorization",
                                                                  "QuantityLimits",
                                                                  "StepTherapy",
                                                                  "General",
                                                                  "Copay",
                                                                  "Formulary",
                                                                ])
                                                                .describe(
                                                                  "`CoverageResource.ResourceType` values.",
                                                                ),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                        })
                                                        .describe(
                                                          "`CoverageResource` entry on a `CoverageRestrictions`.",
                                                        ),
                                                    ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                SummaryResources: zod
                                                  .union([
                                                    zod.array(
                                                      zod
                                                        .object({
                                                          Url: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          ResourceType: zod
                                                            .union([
                                                              zod
                                                                .enum([
                                                                  "AgeLimits",
                                                                  "ProductCoverageExclusion",
                                                                  "GenderLimits",
                                                                  "MedicalNecessity",
                                                                  "PriorAuthorization",
                                                                  "QuantityLimits",
                                                                  "StepTherapy",
                                                                  "General",
                                                                  "Copay",
                                                                  "Formulary",
                                                                ])
                                                                .describe(
                                                                  "`CoverageResource.ResourceType` values.",
                                                                ),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                        })
                                                        .describe(
                                                          "`CoverageResource` entry on a `CoverageRestrictions`.",
                                                        ),
                                                    ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "Coverage restrictions on the primary drug (`CoverageRestrictions`).\n\n``HasPriorAuthorization`` is the primary bit the gate consults when\n`/prescriptionbenefits` is unavailable. ``IsExcluded`` shortcuts to\nthe `EXCLUDED` gate outcome: no point initiating a PA for a drug the\npayer will never cover.\n\nField-name alignment with the v2 swagger: ``HasAgeLimit`` /\n``HasQuantityLimit`` are singular here (not plural as on\n:class:`RealTimeFormularyCoverageRestrictionsT`); there is no\n``HasGenderLimit`` — use ``GenderRestriction`` for that.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                      })
                                      .describe(
                                        "`MedicationCoverage` — coverage slice nested under `PayerAlternativeDetail`.\n\nDistinct from :class:`MedicationCoverageResponseT` (the\n``/formulary`` response body): no ``Otc`` / ``Brand`` /\n``TherapeuticAlternatives`` / ``RealTimeFormularyRequestStatus``\nfields here.",
                                      ),
                                    zod.null(),
                                  ])
                                  .optional(),
                              })
                              .describe(
                                "`PrescriptionBenefitPayerAlternativeDetail` — one detail under :class:`PayerAlternativeT`.\n\nEach detail describes an NDC-level variant of the alternative drug\nalong with its patient-specific pricing.",
                              ),
                          ),
                          zod.null(),
                        ])
                        .optional(),
                      RepresentativeFormularyCoverage: zod
                        .union([
                          zod
                            .object({
                              CopayFactors: zod
                                .union([
                                  zod.array(
                                    zod
                                      .object({
                                        IsDrugSpecific: zod
                                          .union([zod.boolean(), zod.null()])
                                          .optional(),
                                        PharmacyType: zod
                                          .union([
                                            zod
                                              .enum([
                                                "Any",
                                                "FaxPharmacy",
                                                "EPCS",
                                                "TwentyFourHourPharmacy",
                                                "LongTermCarePharmacy",
                                                "MailOrder",
                                                "Retail",
                                                "SpecialtyPharmacy",
                                              ])
                                              .describe(
                                                "Valid pharmacy specialty types for DoseSpot.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        FlatCopayAmount: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        PercentCopayAmount: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        FlatCopayAmountFirst: zod
                                          .union([zod.boolean(), zod.null()])
                                          .optional(),
                                        MinimumCopayAmount: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        MaximumCopayAmount: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        DaysSupply: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        CopayTier: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        MaximumCopayTier: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        OutOfPocketMinimum: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        OutOfPocketMaximum: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                      })
                                      .describe(
                                        "Single copay tier (`PayerCopay`).\n\nPer-channel pricing rule returned on formulary responses and on the\n``RepresentitiveFormularyCoverage`` slice of each alternative. The\ngate doesn't consult any of these fields directly — they're carried\nthrough for UI display next to an ``EXCLUDED`` / ``PA_REQUIRED``\nbanner.",
                                      ),
                                  ),
                                  zod.null(),
                                ])
                                .optional(),
                              FormularyStatus: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              FormularyStatusText: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              RealTimeFormularyCoverageRestrictions: zod
                                .union([
                                  zod
                                    .object({
                                      HasCoverageRestrictions: zod
                                        .union([zod.boolean(), zod.null()])
                                        .optional(),
                                      IsExcluded: zod
                                        .union([zod.boolean(), zod.null()])
                                        .optional(),
                                      HasMedicalNecessity: zod
                                        .union([zod.boolean(), zod.null()])
                                        .optional(),
                                      HasPriorAuthorization: zod
                                        .union([zod.boolean(), zod.null()])
                                        .optional(),
                                      HasStepTherapy: zod
                                        .union([zod.boolean(), zod.null()])
                                        .optional(),
                                      AgeLimitRestrictions: zod
                                        .union([
                                          zod.array(
                                            zod
                                              .object({
                                                MinimumAge: zod
                                                  .union([
                                                    zod.number(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                MinimumAgeUnit: zod
                                                  .union([
                                                    zod
                                                      .enum(["Days", "Years"])
                                                      .describe(
                                                        "Unit on :class:`AgeLimitRestrictionT` bounds.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                MaximumAge: zod
                                                  .union([
                                                    zod.number(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                MaximumAgeUnit: zod
                                                  .union([
                                                    zod
                                                      .enum(["Days", "Years"])
                                                      .describe(
                                                        "Unit on :class:`AgeLimitRestrictionT` bounds.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "`AgeLimitRestriction` entry on a `CoverageRestrictions`.",
                                              ),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                      GenderLimitRestrictions: zod
                                        .union([
                                          zod.array(
                                            zod
                                              .object({
                                                GenderAbbreviation: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                GenderDescription: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "`GenderLimitRestriction` entry on a `RealTimeFormularyCoverageRestrictions`.",
                                              ),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                      QuantityLimitRestrictions: zod
                                        .union([
                                          zod.array(
                                            zod
                                              .object({
                                                MaximumAmount: zod
                                                  .union([
                                                    zod.number(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                AmountUnit: zod
                                                  .union([
                                                    zod
                                                      .enum([
                                                        "DollarAmount",
                                                        "DaysSupply",
                                                        "Fills",
                                                        "Quantity",
                                                      ])
                                                      .describe(
                                                        "`QuantityLimitRestriction.AmountUnit` values.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                TimePeriodUnit: zod
                                                  .union([
                                                    zod
                                                      .enum([
                                                        "Days",
                                                        "Lifetime",
                                                        "PerDispensing",
                                                        "SpecificDateRange",
                                                        "CalendarYear",
                                                        "CalendarQuarter",
                                                        "CalendarMonth",
                                                      ])
                                                      .describe(
                                                        "`QuantityLimitRestriction.TimePeriodUnit` values.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                StartDate: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                EndDate: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                MaximumTimePeriodUnits: zod
                                                  .union([
                                                    zod.number(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "`QuantityLimitRestriction` entry on a `CoverageRestrictions`.",
                                              ),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                      StepMedicationRestrictions: zod
                                        .union([
                                          zod.array(
                                            zod
                                              .object({
                                                Ndc: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                StepDrugType: zod
                                                  .union([
                                                    zod
                                                      .enum([
                                                        "Unknown",
                                                        "SpecificMedication",
                                                        "PharmacologicalClass",
                                                      ])
                                                      .describe(
                                                        "`StepMedicationRestriction.StepDrugType` values.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                StepOrder: zod
                                                  .union([
                                                    zod.number(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                DisplayName: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                RxCUI: zod
                                                  .union([
                                                    zod.number(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                DispensableDrugId: zod
                                                  .union([
                                                    zod.number(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "`StepMedicationRestriction` entry on a `CoverageRestrictions`.",
                                              ),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                      Messages: zod
                                        .union([
                                          zod.array(
                                            zod
                                              .object({
                                                Message: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                LongMessage: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "`CoverageMessage` entry on a `CoverageRestrictions`.",
                                              ),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                      DrugResources: zod
                                        .union([
                                          zod.array(
                                            zod
                                              .object({
                                                Url: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                ResourceType: zod
                                                  .union([
                                                    zod
                                                      .enum([
                                                        "AgeLimits",
                                                        "ProductCoverageExclusion",
                                                        "GenderLimits",
                                                        "MedicalNecessity",
                                                        "PriorAuthorization",
                                                        "QuantityLimits",
                                                        "StepTherapy",
                                                        "General",
                                                        "Copay",
                                                        "Formulary",
                                                      ])
                                                      .describe(
                                                        "`CoverageResource.ResourceType` values.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "`CoverageResource` entry on a `CoverageRestrictions`.",
                                              ),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                      SummaryResources: zod
                                        .union([
                                          zod.array(
                                            zod
                                              .object({
                                                Url: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                ResourceType: zod
                                                  .union([
                                                    zod
                                                      .enum([
                                                        "AgeLimits",
                                                        "ProductCoverageExclusion",
                                                        "GenderLimits",
                                                        "MedicalNecessity",
                                                        "PriorAuthorization",
                                                        "QuantityLimits",
                                                        "StepTherapy",
                                                        "General",
                                                        "Copay",
                                                        "Formulary",
                                                      ])
                                                      .describe(
                                                        "`CoverageResource.ResourceType` values.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "`CoverageResource` entry on a `CoverageRestrictions`.",
                                              ),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                    })
                                    .describe(
                                      "Realtime-only restriction slice (`RealTimeFormularyCoverageRestrictions`).\n\nAppears only on :class:`RepresentitiveFormularyCoverageT` (i.e. on each\nalternative drug), **not** on the primary drug's ``CoverageRestrictions``.\nThat asymmetry is per the v2 swagger: the primary drug's realtime PA\nbit is conveyed by ``/prescriptionbenefits`` (``PriorAuthRequired``)\nand its cached bit by ``CoverageRestrictions.HasPriorAuthorization``.\n\nField names match the swagger exactly — note ``HasMedicalNecessity``\n(not the legacy ``RequiresMedicalNecessity``) and ``HasAge`` /\n``HasQuantity`` rather than the plural ``…Limits`` spellings used on\n:class:`CoverageRestrictionsT`.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                            })
                            .describe(
                              "`RepresentitiveFormularyCoverage` on a :class:`PayerAlternativeT`.\n\nThe typo (``Representitive`` rather than ``Representative``) is\nDoseSpot's, not ours — the field name is verbatim from the v2 swagger\ndefinition so pydantic's ``model_validate`` of a raw DoseSpot\nresponse lines up.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      PatientSpecificPricingCoverages: zod
                        .union([
                          zod.array(
                            zod
                              .object({
                                Pharmacy: zod
                                  .union([
                                    zod
                                      .object({
                                        PharmacyType: zod
                                          .union([
                                            zod
                                              .enum([
                                                "Retail",
                                                "Mail",
                                                "Item90DayAtRetail",
                                                "Specialty",
                                                "LongTermCare",
                                              ])
                                              .describe(
                                                "`PrescriptionBenefitsPharmacy.PharmacyType` values.\n\nDistinct from :class:`PharmacySpecialtyTypeT` — DoseSpot uses a\ndifferent (smaller) vocabulary for the pharmacy slice returned on\nrealtime-benefits responses than for channel-level eligibility.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        Identifications: zod
                                          .union([
                                            zod.record(
                                              zod.string(),
                                              zod.unknown(),
                                            ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        PharmacistLastName: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PharmacistFirstName: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PharmacistMiddleName: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PharmacistSuffix: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PharmacistPrefix: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        Email: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        DistanceFromRequestedPharmacy: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        PharmacyId: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        StoreName: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        Address1: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        Address2: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        City: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        State: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        ZipCode: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PrimaryPhone: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PrimaryPhoneType: zod
                                          .union([
                                            zod
                                              .enum([
                                                "Undefined",
                                                "Beeper",
                                                "Cell",
                                                "Fax",
                                                "Home",
                                                "Work",
                                                "Night",
                                                "Primary",
                                              ])
                                              .describe(
                                                "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` / `PhoneAdditionalType*` values.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        PrimaryFax: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PhoneAdditional1: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PhoneAdditionalType1: zod
                                          .union([
                                            zod
                                              .enum([
                                                "Undefined",
                                                "Beeper",
                                                "Cell",
                                                "Fax",
                                                "Home",
                                                "Work",
                                                "Night",
                                                "Primary",
                                              ])
                                              .describe(
                                                "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` / `PhoneAdditionalType*` values.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        PhoneAdditional2: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PhoneAdditionalType2: zod
                                          .union([
                                            zod
                                              .enum([
                                                "Undefined",
                                                "Beeper",
                                                "Cell",
                                                "Fax",
                                                "Home",
                                                "Work",
                                                "Night",
                                                "Primary",
                                              ])
                                              .describe(
                                                "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` / `PhoneAdditionalType*` values.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        PhoneAdditional3: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PhoneAdditionalType3: zod
                                          .union([
                                            zod
                                              .enum([
                                                "Undefined",
                                                "Beeper",
                                                "Cell",
                                                "Fax",
                                                "Home",
                                                "Work",
                                                "Night",
                                                "Primary",
                                              ])
                                              .describe(
                                                "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` / `PhoneAdditionalType*` values.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        PharmacySpecialties: zod
                                          .union([
                                            zod.array(zod.string()),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        ServiceLevel: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        Latitude: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        Longitude: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        NCPDPID: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                      })
                                      .describe(
                                        "`PrescriptionBenefitsPharmacy` — pharmacy slice on RTPB responses.\n\nNarrower-use than :class:`PharmacyT`; mirrors the full swagger shape\nso callers can surface dispensing-pharmacy details (name, address,\nNCPDPID) alongside pricing / PA signals from a\n``PatientSpecificPricingCoverage`` entry.",
                                      ),
                                    zod.null(),
                                  ])
                                  .optional(),
                                PricingCoverage: zod
                                  .union([
                                    zod
                                      .object({
                                        DrugStatusCode: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        DrugStatus: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        QuantityPricedValue: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        QuantityPricedCodeListQualifier: zod
                                          .union([
                                            zod
                                              .enum([
                                                "Item38",
                                                "Item40",
                                                "Item87",
                                                "QS",
                                                "CF",
                                                "UQ",
                                              ])
                                              .describe(
                                                "`PricingCoverageFactors.QuantityPricedCodeListQualifier` values.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        QuantityPricedUnitOfMeasureType: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        QuantityPricedUnitOfMeasureTypeId: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        DaysSupplyPriced: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PlanPayAmount: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        EstimatedPatientPayAmount: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        OOPAppliedAmount: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        OOPRemainingAmount: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        DeductibleAppliedAmount: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        DeductibleRemainingAmount: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        CoverageAlerts: zod
                                          .union([
                                            zod.array(
                                              zod
                                                .object({
                                                  ReferenceCode: zod
                                                    .union([
                                                      zod
                                                        .enum([
                                                          "AgeLimits",
                                                          "DaysSupplyExceeded",
                                                          "DrugExclusion",
                                                          "ExcessiveUtilization",
                                                          "FullCostNotCovered",
                                                          "GenderLimits",
                                                          "MandatoryGeneric",
                                                          "MedicalNecessity",
                                                          "NotOnFormulary",
                                                          "PharmacyOutOfNetwork",
                                                          "PlanLimitExclusion",
                                                          "QuantityLimits",
                                                          "QuantityLimitExceeded",
                                                          "QuantityNotValid",
                                                          "ResourceLink",
                                                          "StepTherapy",
                                                          "TextMessage",
                                                        ])
                                                        .describe(
                                                          "`PricingCoverageFactorsCoverageAlerts.ReferenceCode` values.",
                                                        ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  ReferenceText: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                })
                                                .describe(
                                                  "`PricingCoverageFactorsCoverageAlerts` entry on :class:`PricingCoverageFactorsT`.\n\nDoseSpot returns coverage-alert *objects* here (not plain strings):\na ``ReferenceCode`` enum plus a human-readable ``ReferenceText``.",
                                                ),
                                            ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        FormularyStatus: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PriorAuthRequired: zod
                                          .union([zod.boolean(), zod.null()])
                                          .optional(),
                                      })
                                      .describe(
                                        "`PricingCoverageFactors` — `PricingCoverage` sub-object on RTPB.\n\nThe realtime gate's authoritative PA source: ``PriorAuthRequired=true``\non any pharmacy-specific pricing coverage flips the gate to\n:attr:`PA_REQUIRED`. Pricing fields are kept for downstream UI — they\nare not consulted by the gate but are cheap to carry.",
                                      ),
                                    zod.null(),
                                  ])
                                  .optional(),
                              })
                              .describe(
                                "`PatientSpecificPricingCoverage` — one (pharmacy × coverage) pricing row.\n\nA coverage can yield multiple entries — one per pharmacy the payer\npriced against — so the gate has to OR the ``PriorAuthRequired`` bits\nacross the list to get a conservative answer.",
                              ),
                          ),
                          zod.null(),
                        ])
                        .optional(),
                    })
                    .describe(
                      "`PayerAlternativeAPI` — payer-preferred alternative for an NDC.\n\nSurfaced alongside a gate decision of :attr:`EXCLUDED` or\n:attr:`PA_REQUIRED` so the clinician can rewrite to a preferred drug\ninstead of fighting a PA. Returned both on the formulary response\n(``MedicationCoverageResponse.Alternatives``) and on the RTPB\nresponse (``GetPrescriptionBenefitResponse.Alternatives``).",
                    ),
                ),
                zod.null(),
              ])
              .optional(),
            RealTimeFormularyRequestStatus: zod
              .union([zod.number(), zod.null()])
              .optional(),
            PatientSpecificPricingCoverages: zod
              .union([
                zod.array(
                  zod
                    .object({
                      Pharmacy: zod
                        .union([
                          zod
                            .object({
                              PharmacyType: zod
                                .union([
                                  zod
                                    .enum([
                                      "Retail",
                                      "Mail",
                                      "Item90DayAtRetail",
                                      "Specialty",
                                      "LongTermCare",
                                    ])
                                    .describe(
                                      "`PrescriptionBenefitsPharmacy.PharmacyType` values.\n\nDistinct from :class:`PharmacySpecialtyTypeT` — DoseSpot uses a\ndifferent (smaller) vocabulary for the pharmacy slice returned on\nrealtime-benefits responses than for channel-level eligibility.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              Identifications: zod
                                .union([
                                  zod.record(zod.string(), zod.unknown()),
                                  zod.null(),
                                ])
                                .optional(),
                              PharmacistLastName: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              PharmacistFirstName: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              PharmacistMiddleName: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              PharmacistSuffix: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              PharmacistPrefix: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              Email: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              DistanceFromRequestedPharmacy: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              PharmacyId: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              StoreName: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              Address1: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              Address2: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              City: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              State: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              ZipCode: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              PrimaryPhone: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              PrimaryPhoneType: zod
                                .union([
                                  zod
                                    .enum([
                                      "Undefined",
                                      "Beeper",
                                      "Cell",
                                      "Fax",
                                      "Home",
                                      "Work",
                                      "Night",
                                      "Primary",
                                    ])
                                    .describe(
                                      "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` / `PhoneAdditionalType*` values.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              PrimaryFax: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              PhoneAdditional1: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              PhoneAdditionalType1: zod
                                .union([
                                  zod
                                    .enum([
                                      "Undefined",
                                      "Beeper",
                                      "Cell",
                                      "Fax",
                                      "Home",
                                      "Work",
                                      "Night",
                                      "Primary",
                                    ])
                                    .describe(
                                      "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` / `PhoneAdditionalType*` values.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              PhoneAdditional2: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              PhoneAdditionalType2: zod
                                .union([
                                  zod
                                    .enum([
                                      "Undefined",
                                      "Beeper",
                                      "Cell",
                                      "Fax",
                                      "Home",
                                      "Work",
                                      "Night",
                                      "Primary",
                                    ])
                                    .describe(
                                      "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` / `PhoneAdditionalType*` values.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              PhoneAdditional3: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              PhoneAdditionalType3: zod
                                .union([
                                  zod
                                    .enum([
                                      "Undefined",
                                      "Beeper",
                                      "Cell",
                                      "Fax",
                                      "Home",
                                      "Work",
                                      "Night",
                                      "Primary",
                                    ])
                                    .describe(
                                      "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` / `PhoneAdditionalType*` values.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              PharmacySpecialties: zod
                                .union([zod.array(zod.string()), zod.null()])
                                .optional(),
                              ServiceLevel: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              Latitude: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              Longitude: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              NCPDPID: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                            })
                            .describe(
                              "`PrescriptionBenefitsPharmacy` — pharmacy slice on RTPB responses.\n\nNarrower-use than :class:`PharmacyT`; mirrors the full swagger shape\nso callers can surface dispensing-pharmacy details (name, address,\nNCPDPID) alongside pricing / PA signals from a\n``PatientSpecificPricingCoverage`` entry.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      PricingCoverage: zod
                        .union([
                          zod
                            .object({
                              DrugStatusCode: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              DrugStatus: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              QuantityPricedValue: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              QuantityPricedCodeListQualifier: zod
                                .union([
                                  zod
                                    .enum([
                                      "Item38",
                                      "Item40",
                                      "Item87",
                                      "QS",
                                      "CF",
                                      "UQ",
                                    ])
                                    .describe(
                                      "`PricingCoverageFactors.QuantityPricedCodeListQualifier` values.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              QuantityPricedUnitOfMeasureType: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              QuantityPricedUnitOfMeasureTypeId: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              DaysSupplyPriced: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              PlanPayAmount: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              EstimatedPatientPayAmount: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              OOPAppliedAmount: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              OOPRemainingAmount: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              DeductibleAppliedAmount: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              DeductibleRemainingAmount: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              CoverageAlerts: zod
                                .union([
                                  zod.array(
                                    zod
                                      .object({
                                        ReferenceCode: zod
                                          .union([
                                            zod
                                              .enum([
                                                "AgeLimits",
                                                "DaysSupplyExceeded",
                                                "DrugExclusion",
                                                "ExcessiveUtilization",
                                                "FullCostNotCovered",
                                                "GenderLimits",
                                                "MandatoryGeneric",
                                                "MedicalNecessity",
                                                "NotOnFormulary",
                                                "PharmacyOutOfNetwork",
                                                "PlanLimitExclusion",
                                                "QuantityLimits",
                                                "QuantityLimitExceeded",
                                                "QuantityNotValid",
                                                "ResourceLink",
                                                "StepTherapy",
                                                "TextMessage",
                                              ])
                                              .describe(
                                                "`PricingCoverageFactorsCoverageAlerts.ReferenceCode` values.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        ReferenceText: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                      })
                                      .describe(
                                        "`PricingCoverageFactorsCoverageAlerts` entry on :class:`PricingCoverageFactorsT`.\n\nDoseSpot returns coverage-alert *objects* here (not plain strings):\na ``ReferenceCode`` enum plus a human-readable ``ReferenceText``.",
                                      ),
                                  ),
                                  zod.null(),
                                ])
                                .optional(),
                              FormularyStatus: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              PriorAuthRequired: zod
                                .union([zod.boolean(), zod.null()])
                                .optional(),
                            })
                            .describe(
                              "`PricingCoverageFactors` — `PricingCoverage` sub-object on RTPB.\n\nThe realtime gate's authoritative PA source: ``PriorAuthRequired=true``\non any pharmacy-specific pricing coverage flips the gate to\n:attr:`PA_REQUIRED`. Pricing fields are kept for downstream UI — they\nare not consulted by the gate but are cheap to carry.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                    })
                    .describe(
                      "`PatientSpecificPricingCoverage` — one (pharmacy × coverage) pricing row.\n\nA coverage can yield multiple entries — one per pharmacy the payer\npriced against — so the gate has to OR the ``PriorAuthRequired`` bits\nacross the list to get a conservative answer.",
                    ),
                ),
                zod.null(),
              ])
              .optional(),
            OptionalPharmacy: zod
              .union([
                zod
                  .object({
                    PharmacyType: zod
                      .union([
                        zod
                          .enum([
                            "Retail",
                            "Mail",
                            "Item90DayAtRetail",
                            "Specialty",
                            "LongTermCare",
                          ])
                          .describe(
                            "`PrescriptionBenefitsPharmacy.PharmacyType` values.\n\nDistinct from :class:`PharmacySpecialtyTypeT` — DoseSpot uses a\ndifferent (smaller) vocabulary for the pharmacy slice returned on\nrealtime-benefits responses than for channel-level eligibility.",
                          ),
                        zod.null(),
                      ])
                      .optional(),
                    Identifications: zod
                      .union([
                        zod.record(zod.string(), zod.unknown()),
                        zod.null(),
                      ])
                      .optional(),
                    PharmacistLastName: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    PharmacistFirstName: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    PharmacistMiddleName: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    PharmacistSuffix: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    PharmacistPrefix: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    Email: zod.union([zod.string(), zod.null()]).optional(),
                    DistanceFromRequestedPharmacy: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    PharmacyId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    StoreName: zod.union([zod.string(), zod.null()]).optional(),
                    Address1: zod.union([zod.string(), zod.null()]).optional(),
                    Address2: zod.union([zod.string(), zod.null()]).optional(),
                    City: zod.union([zod.string(), zod.null()]).optional(),
                    State: zod.union([zod.string(), zod.null()]).optional(),
                    ZipCode: zod.union([zod.string(), zod.null()]).optional(),
                    PrimaryPhone: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    PrimaryPhoneType: zod
                      .union([
                        zod
                          .enum([
                            "Undefined",
                            "Beeper",
                            "Cell",
                            "Fax",
                            "Home",
                            "Work",
                            "Night",
                            "Primary",
                          ])
                          .describe(
                            "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` / `PhoneAdditionalType*` values.",
                          ),
                        zod.null(),
                      ])
                      .optional(),
                    PrimaryFax: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    PhoneAdditional1: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    PhoneAdditionalType1: zod
                      .union([
                        zod
                          .enum([
                            "Undefined",
                            "Beeper",
                            "Cell",
                            "Fax",
                            "Home",
                            "Work",
                            "Night",
                            "Primary",
                          ])
                          .describe(
                            "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` / `PhoneAdditionalType*` values.",
                          ),
                        zod.null(),
                      ])
                      .optional(),
                    PhoneAdditional2: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    PhoneAdditionalType2: zod
                      .union([
                        zod
                          .enum([
                            "Undefined",
                            "Beeper",
                            "Cell",
                            "Fax",
                            "Home",
                            "Work",
                            "Night",
                            "Primary",
                          ])
                          .describe(
                            "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` / `PhoneAdditionalType*` values.",
                          ),
                        zod.null(),
                      ])
                      .optional(),
                    PhoneAdditional3: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    PhoneAdditionalType3: zod
                      .union([
                        zod
                          .enum([
                            "Undefined",
                            "Beeper",
                            "Cell",
                            "Fax",
                            "Home",
                            "Work",
                            "Night",
                            "Primary",
                          ])
                          .describe(
                            "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` / `PhoneAdditionalType*` values.",
                          ),
                        zod.null(),
                      ])
                      .optional(),
                    PharmacySpecialties: zod
                      .union([zod.array(zod.string()), zod.null()])
                      .optional(),
                    ServiceLevel: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    Latitude: zod.union([zod.number(), zod.null()]).optional(),
                    Longitude: zod.union([zod.number(), zod.null()]).optional(),
                    NCPDPID: zod.union([zod.string(), zod.null()]).optional(),
                  })
                  .describe(
                    "`PrescriptionBenefitsPharmacy` — pharmacy slice on RTPB responses.\n\nNarrower-use than :class:`PharmacyT`; mirrors the full swagger shape\nso callers can surface dispensing-pharmacy details (name, address,\nNCPDPID) alongside pricing / PA signals from a\n``PatientSpecificPricingCoverage`` entry.",
                  ),
                zod.null(),
              ])
              .optional(),
          })
          .describe(
            "`GetPrescriptionBenefitResponse` — inner item of ``ItemResponse[…]`` on\n``GET /api/patients/{patient_id}/prescriptionbenefits``.\n\nRetained under the historical ``PrescriptionBenefitsResponseT`` name\nfor in-repo stability; the shape is now the v2 swagger's unwrapped\n`Item` (see :class:`PrescriptionBenefitsItemResponseT` for the wire\nwrapper).\n\nKey fields for the gate:\n\n- ``PatientSpecificPricingCoverages[*].PricingCoverage.PriorAuthRequired``\n  — authoritative per-fill PA bit. The gate ORs this across all\n  pricing coverages returned.\n- ``RealTimeFormularyRequestStatus`` — non-OK means the gate falls\n  back to `/formulary`.",
          ),
        zod.null(),
      ])
      .optional(),
    payerInformation: zod
      .union([
        zod
          .object({
            PatientEligibilityId: zod
              .union([zod.number(), zod.null()])
              .optional(),
            PayerName: zod.union([zod.string(), zod.null()]).optional(),
            PharmacyEligibilities: zod
              .union([
                zod.array(
                  zod
                    .object({
                      PharmacyType: zod
                        .union([
                          zod
                            .enum([
                              "Any",
                              "FaxPharmacy",
                              "EPCS",
                              "TwentyFourHourPharmacy",
                              "LongTermCarePharmacy",
                              "MailOrder",
                              "Retail",
                              "SpecialtyPharmacy",
                            ])
                            .describe(
                              "Valid pharmacy specialty types for DoseSpot.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      EligibilityStatus: zod
                        .union([
                          zod
                            .enum([
                              "Covered",
                              "NotCovered",
                              "OutOfPocket",
                              "Unknown",
                              "UnableToProcess",
                            ])
                            .describe(
                              "`EligibilityStatus` on a `PharmacyEligibility` entry.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      Name: zod.union([zod.string(), zod.null()]).optional(),
                    })
                    .describe(
                      "Per-channel eligibility entry on a `PayerInformationResponse`.\n\nEach coverage reports one of these per pharmacy type so the Rx-time\ngate can pick the coverage that actually covers the channel the\nprescription is routed to (e.g. Retail vs MailOrder).",
                    ),
                ),
                zod.null(),
              ])
              .optional(),
            PlanName: zod.union([zod.string(), zod.null()]).optional(),
            CoverageId: zod.union([zod.string(), zod.null()]).optional(),
            PayerId: zod.union([zod.string(), zod.null()]).optional(),
            BIN: zod.union([zod.string(), zod.null()]).optional(),
            PCN: zod.union([zod.string(), zod.null()]).optional(),
            FormularyId: zod.union([zod.string(), zod.null()]).optional(),
            AlternativesId: zod.union([zod.string(), zod.null()]).optional(),
            CopayId: zod.union([zod.string(), zod.null()]).optional(),
            DemographicChanges: zod
              .union([zod.boolean(), zod.null()])
              .optional(),
            Demographics: zod
              .union([
                zod
                  .object({
                    LastName: zod.union([zod.string(), zod.null()]).optional(),
                    FirstName: zod.union([zod.string(), zod.null()]).optional(),
                    MiddleName: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    Suffix: zod.union([zod.string(), zod.null()]).optional(),
                    DateOfBirth: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    Gender: zod
                      .union([
                        zod
                          .enum(["Male", "Female", "Unknown"])
                          .describe(
                            "`PayerDemographics.Gender` and `CoverageRestrictions.GenderRestriction` values.",
                          ),
                        zod.null(),
                      ])
                      .optional(),
                    Address: zod
                      .union([
                        zod
                          .object({
                            AddressLine1: zod
                              .union([zod.string(), zod.null()])
                              .optional(),
                            AddressLine2: zod
                              .union([zod.string(), zod.null()])
                              .optional(),
                            City: zod
                              .union([zod.string(), zod.null()])
                              .optional(),
                            State: zod
                              .union([zod.string(), zod.null()])
                              .optional(),
                            ZipCode: zod
                              .union([zod.string(), zod.null()])
                              .optional(),
                          })
                          .describe(
                            "`PayerAddress` sub-object on :class:`PayerDemographicsT`.",
                          ),
                        zod.null(),
                      ])
                      .optional(),
                  })
                  .describe(
                    "`PayerDemographics` block on :class:`PayerInformationT`.\n\nSurfaced when the payer returns updated member demographics on an\neligibility response (combined with ``DemographicChanges=true``).",
                  ),
                zod.null(),
              ])
              .optional(),
            ErrorMessage: zod.union([zod.string(), zod.null()]).optional(),
            InfoMessage: zod.union([zod.string(), zod.null()]).optional(),
            MemberId: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe(
            "One active coverage for a patient (`PayerInformationResponse`).\n\nReturned by `GET /api/patients/{patient_id}/eligibilities`. The gate\nkeys subsequent `/formulary` and `/prescriptionbenefits` calls on\n``PatientEligibilityId``; the other ids (`CoverageId`, `FormularyId`,\n...) are carried through for audit but not otherwise consulted.\n\nFields match the DoseSpot v2 swagger `PayerInformationResponse`\ndefinition exactly. No `GroupId` here — that's a legacy field from\nthe v1 shape and was dropped when v2 consolidated onto `MemberId` +\n``Demographics``.",
          ),
        zod.null(),
      ])
      .optional(),
  })
  .describe(
    "Wrapper over :class:`PriorAuthGateResultT` for the Rx form.\n\nIncludes the raw DoseSpot ``/formulary`` and ``/prescriptionbenefits``\npayloads so the UI can surface formulary status, copay tiers, and\ntherapeutic alternatives alongside the gate decision. The client\nshould branch on ``outcome`` only — the extra payloads are\ninformational.\n\n``payer_information`` carries the BenefitsCoordination details per\nACR PA.109.1 — PayerName, PayerId, BIN, PCN, MemberId from the\nSurescripts 271 message. Displayed to the clinician so they can\nconfirm coverage being sent with the PA initiation.",
  );

/**
 * Get transmission errors for the authenticated user's associated clinic(s).

This endpoint retrieves transmission errors for prescriptions from the clinician's
associated clinic(s), with optional pagination support.

Args:
    page_number: The page number to retrieve (1-based, optional)
    clinic: The clinic to filter by (optional)

Returns:
    TransmissionErrorsPagedListResponseT: Paged list of transmission errors

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record
 * @summary Get My Transmission Errors
 */
export const getMyTransmissionErrorsQueryParams = zod.object({
  page_number: zod.union([zod.number(), zod.null()]).optional(),
  clinic: zod.union([zod.string(), zod.null()]).optional(),
});

export const getMyTransmissionErrorsResponse = zod
  .object({
    Items: zod
      .union([
        zod.array(
          zod
            .object({
              PrescriptionId: zod.union([zod.number(), zod.null()]).optional(),
              DateWritten: zod.union([zod.string(), zod.null()]).optional(),
              ErrorDateTimeStamp: zod
                .union([zod.string(), zod.null()])
                .optional(),
              ErrorDetails: zod.union([zod.string(), zod.null()]).optional(),
              PatientId: zod.union([zod.number(), zod.null()]).optional(),
              ClinicId: zod.union([zod.number(), zod.null()]).optional(),
            })
            .describe("DoseSpot Transmission Error notification."),
        ),
        zod.null(),
      ])
      .optional(),
    PageResult: zod
      .union([
        zod
          .object({
            CurrentPage: zod.union([zod.number(), zod.null()]).optional(),
            TotalPages: zod.union([zod.number(), zod.null()]).optional(),
            PageSize: zod.union([zod.number(), zod.null()]).optional(),
            TotalCount: zod.union([zod.number(), zod.null()]).optional(),
            HasPrevious: zod.union([zod.boolean(), zod.null()]).optional(),
            HasNext: zod.union([zod.boolean(), zod.null()]).optional(),
          })
          .describe("DoseSpot page result information."),
        zod.null(),
      ])
      .optional(),
    Result: zod
      .union([
        zod
          .object({
            ResultCode: zod.string(),
            ResultDescription: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe("Standard DoseSpot API result object."),
        zod.null(),
      ])
      .optional(),
  })
  .describe("PagedListResponse wrapper for transmission error lists.");

/**
 * Get notification counts for the authenticated user at a single clinic.

This endpoint retrieves the number of refill requests, transmission errors,
and pending prescriptions for the clinician at a single clinic.

Args:
    clinic: The clinic to get counts for (optional)

Returns:
    PrescriberNotificationCountsT: Notification counts

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record
 * @summary Get My Notification Counts
 */
export const getMyNotificationCountsQueryParams = zod.object({
  clinic: zod.union([zod.string(), zod.null()]).optional(),
});

export const getMyNotificationCountsResponse = zod
  .object({
    RefillRequestsCount: zod.union([zod.number(), zod.null()]).optional(),
    TransactionErrorsCount: zod.union([zod.number(), zod.null()]).optional(),
    PendingPrescriptionsCount: zod.union([zod.number(), zod.null()]).optional(),
    PendingRxChangeCount: zod.union([zod.number(), zod.null()]).optional(),
  })
  .describe("DoseSpot notification counts for a prescriber.");

/**
 * Get prescription information by DoseSpot prescription ID.

This endpoint fetches prescription details using the prescription model,
useful for displaying transmission error details.

Args:
    dosespot_prescription_id: The DoseSpot prescription ID

Returns:
    PrescriptionT or None: The prescription information if found

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record
 * @summary Get Prescription By Dosespot Id
 */
export const getPrescriptionByDosespotIdParams = zod.object({
  patient_id: zod.string(),
  dosespot_prescription_id: zod.string(),
});

export const getPrescriptionByDosespotIdResponse = zod.union([
  zod
    .object({
      PrescriptionId: zod.union([zod.number(), zod.null()]).optional(),
      WrittenDate: zod.union([zod.string(), zod.null()]).optional(),
      Directions: zod.union([zod.string(), zod.null()]).optional(),
      Quantity: zod.union([zod.string(), zod.null()]).optional(),
      DispenseUnitId: zod.union([zod.number(), zod.null()]).optional(),
      Refills: zod.union([zod.string(), zod.null()]).optional(),
      DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
      PharmacyId: zod.union([zod.number(), zod.null()]).optional(),
      PharmacyNotes: zod.union([zod.string(), zod.null()]).optional(),
      NoSubstitutions: zod.union([zod.boolean(), zod.null()]).optional(),
      EffectiveDate: zod.union([zod.string(), zod.null()]).optional(),
      LastFillDate: zod.union([zod.string(), zod.null()]).optional(),
      PrescriberId: zod.union([zod.number(), zod.null()]).optional(),
      PrescriberAgentId: zod.union([zod.number(), zod.null()]).optional(),
      RxReferenceNumber: zod.union([zod.string(), zod.null()]).optional(),
      Status: zod
        .union([
          zod
            .enum([
              "Unknown",
              "Entered",
              "Printed",
              "Sending",
              "eRxSent",
              "FaxSent",
              "Error",
              "Deleted",
              "Requested",
              "Edited",
              "EpcsError",
              "EpcsSigned",
              "ReadyToSign",
              "PharmacyVerified",
              "PharmacySelect",
            ])
            .describe("Valid prescription status types for DoseSpot."),
          zod.null(),
        ])
        .optional(),
      Formulary: zod.union([zod.boolean(), zod.null()]).optional(),
      EligibilityId: zod.union([zod.number(), zod.null()]).optional(),
      Type: zod
        .union([
          zod
            .enum(["Coded", "FreeText", "NDC", "Supply", "Compound"])
            .describe("Valid prescription types for DoseSpot."),
          zod.null(),
        ])
        .optional(),
      NonDoseSpotPrescriptionId: zod
        .union([zod.string(), zod.null()])
        .optional(),
      ErrorIgnored: zod.union([zod.boolean(), zod.null()]).optional(),
      SupplyId: zod.union([zod.number(), zod.null()]).optional(),
      FreeTextType: zod
        .union([
          zod
            .enum(["Medication", "Supply", "Compound"])
            .describe("Valid free text types for DoseSpot prescriptions."),
          zod.null(),
        ])
        .optional(),
      ClinicId: zod.union([zod.number(), zod.null()]).optional(),
      SupervisorId: zod.union([zod.number(), zod.null()]).optional(),
      IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
      IsRxRenewal: zod.union([zod.boolean(), zod.null()]).optional(),
      RxRenewalNote: zod.union([zod.string(), zod.null()]).optional(),
      FirstPrescriptionDiagnosis: zod
        .union([
          zod
            .object({
              PrimaryDiagnosis: zod
                .union([
                  zod
                    .object({
                      DiagnosisId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      DiagnosisCode: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DiagnosisDescription: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                    })
                    .describe("DoseSpot diagnosis information."),
                  zod.null(),
                ])
                .optional(),
              SecondaryDiagnosis: zod
                .union([
                  zod
                    .object({
                      DiagnosisId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      DiagnosisCode: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DiagnosisDescription: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                    })
                    .describe("DoseSpot diagnosis information."),
                  zod.null(),
                ])
                .optional(),
            })
            .describe("DoseSpot prescription diagnosis information."),
          zod.null(),
        ])
        .optional(),
      SecondPrescriptionDiagnosis: zod
        .union([
          zod
            .object({
              PrimaryDiagnosis: zod
                .union([
                  zod
                    .object({
                      DiagnosisId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      DiagnosisCode: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DiagnosisDescription: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                    })
                    .describe("DoseSpot diagnosis information."),
                  zod.null(),
                ])
                .optional(),
              SecondaryDiagnosis: zod
                .union([
                  zod
                    .object({
                      DiagnosisId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      DiagnosisCode: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DiagnosisDescription: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                    })
                    .describe("DoseSpot diagnosis information."),
                  zod.null(),
                ])
                .optional(),
            })
            .describe("DoseSpot prescription diagnosis information."),
          zod.null(),
        ])
        .optional(),
      Strength: zod.union([zod.string(), zod.null()]).optional(),
      PatientMedicationId: zod.union([zod.number(), zod.null()]).optional(),
      MedicationStatus: zod
        .union([
          zod
            .enum([
              "Unknown",
              "Active",
              "Inactive",
              "Discontinued",
              "Deleted",
              "Completed",
              "CancelRequested",
              "CancelPending",
              "Cancelled",
              "CancelDenied",
              "Changed",
              "FullFill",
              "PartialFill",
              "NoFill",
            ])
            .describe("Valid medication status types for DoseSpot."),
          zod.null(),
        ])
        .optional(),
      Comment: zod.union([zod.string(), zod.null()]).optional(),
      DateInactive: zod.union([zod.string(), zod.null()]).optional(),
      Encounter: zod.union([zod.string(), zod.null()]).optional(),
      DisplayName: zod.union([zod.string(), zod.null()]).optional(),
      DispensableDrugId: zod.union([zod.number(), zod.null()]).optional(),
      Schedule: zod.union([zod.number(), zod.null()]).optional(),
      CompoundIngredients: zod
        .union([
          zod.array(
            zod
              .object({
                DispensableDrugId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                FreeText: zod.union([zod.string(), zod.null()]).optional(),
                DispenseUnitId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                Quantity: zod.string(),
                IsFreeTextEPCS: zod
                  .union([zod.boolean(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot compound ingredient information."),
          ),
          zod.null(),
        ])
        .optional(),
    })
    .describe("Complete prescription information from DoseSpot API."),
  zod.null(),
]);

/**
 * Get patient information by DoseSpot patient ID.

This endpoint fetches patient details directly from DoseSpot using the
patient ID, useful for displaying transmission error details.

Args:
    dosespot_patient_id: The DoseSpot patient ID

Returns:
    PatientT or None: The patient information if found

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record
 * @summary Get Patient By Dosespot Id
 */
export const getPatientByDosespotIdParams = zod.object({
  dosespot_patient_id: zod.string(),
});

export const getPatientByDosespotIdResponse = zod.union([
  zod
    .object({
      FirstName: zod.string(),
      LastName: zod.string(),
      DateOfBirth: zod.string(),
      Gender: zod.enum(["Male", "Female", "Unknown"]),
      Address1: zod.string(),
      City: zod.string(),
      State: zod.string(),
      ZipCode: zod.string(),
      PrimaryPhone: zod.union([zod.string(), zod.null()]).optional(),
      Active: zod.boolean(),
      PatientId: zod.union([zod.number(), zod.null()]).optional(),
      Prefix: zod.union([zod.string(), zod.null()]).optional(),
      MiddleName: zod.union([zod.string(), zod.null()]).optional(),
      Suffix: zod.union([zod.string(), zod.null()]).optional(),
      Email: zod.union([zod.string(), zod.null()]).optional(),
      Address2: zod.union([zod.string(), zod.null()]).optional(),
      PhoneAdditional1: zod.union([zod.string(), zod.null()]).optional(),
      PhoneAdditional2: zod.union([zod.string(), zod.null()]).optional(),
      PhoneAdditionalType1: zod
        .union([
          zod.enum([
            "Undefined",
            "Beeper",
            "Cell",
            "Fax",
            "Home",
            "Work",
            "Night",
            "Primary",
          ]),
          zod.null(),
        ])
        .optional(),
      PhoneAdditionalType2: zod
        .union([
          zod.enum([
            "Undefined",
            "Beeper",
            "Cell",
            "Fax",
            "Home",
            "Work",
            "Night",
            "Primary",
          ]),
          zod.null(),
        ])
        .optional(),
      PrimaryPhoneType: zod
        .union([
          zod.enum([
            "Undefined",
            "Beeper",
            "Cell",
            "Fax",
            "Home",
            "Work",
            "Night",
            "Primary",
          ]),
          zod.null(),
        ])
        .optional(),
      Weight: zod.union([zod.number(), zod.null()]).optional(),
      WeightMetric: zod
        .union([
          zod
            .enum(["lb", "kg"])
            .describe("Valid weight metrics for DoseSpot patients."),
          zod.null(),
        ])
        .optional(),
      Height: zod.union([zod.number(), zod.null()]).optional(),
      HeightMetric: zod
        .union([
          zod
            .enum(["inch", "cm"])
            .describe("Valid height metrics for DoseSpot patients."),
          zod.null(),
        ])
        .optional(),
      NonDoseSpotMedicalRecordNumber: zod
        .union([zod.string(), zod.null()])
        .optional(),
      Encounter: zod.union([zod.string(), zod.null()]).optional(),
      IsHospice: zod.union([zod.boolean(), zod.null()]).optional(),
      Last4SSN: zod.union([zod.string(), zod.null()]).optional(),
    })
    .describe("Patient demographic information from DoseSpot API."),
  zod.null(),
]);

/**
 * Get prescription logs (full history) for a specific prescription.

This endpoint retrieves the complete history of a prescription including all
status changes and updates.

Args:
    user_id: The patient's user ID
    dosespot_prescription_id: The DoseSpot prescription ID

Returns:
    List[PrescriptionLogT]: List of prescription log entries

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the prescription record is not found or request fails
 * @summary Get Prescription Logs
 */
export const getPrescriptionLogsParams = zod.object({
  user_id: zod.uuid(),
  dosespot_prescription_id: zod.string(),
});

export const getPrescriptionLogsResponseItem = zod
  .object({
    Status: zod
      .union([
        zod
          .enum([
            "Unknown",
            "Entered",
            "Printed",
            "Sending",
            "eRxSent",
            "FaxSent",
            "Error",
            "Deleted",
            "Requested",
            "Edited",
            "EpcsError",
            "EpcsSigned",
            "ReadyToSign",
            "PharmacyVerified",
            "PharmacySelect",
          ])
          .describe("Valid prescription status types for DoseSpot."),
        zod.null(),
      ])
      .optional(),
    DateTimeStamp: zod.union([zod.string(), zod.null()]).optional(),
    AdditionalInfo: zod.union([zod.string(), zod.null()]).optional(),
    Ignored: zod.union([zod.boolean(), zod.null()]).optional(),
    User: zod.union([zod.string(), zod.null()]).optional(),
    WasRefillRequest: zod.union([zod.boolean(), zod.null()]).optional(),
    MedicationStatus: zod
      .union([
        zod
          .enum([
            "Unknown",
            "Active",
            "Inactive",
            "Discontinued",
            "Deleted",
            "Completed",
            "CancelRequested",
            "CancelPending",
            "Cancelled",
            "CancelDenied",
            "Changed",
            "FullFill",
            "PartialFill",
            "NoFill",
          ])
          .describe("Valid medication status types for DoseSpot."),
        zod.null(),
      ])
      .optional(),
  })
  .describe("DoseSpot prescription log entry.");
export const getPrescriptionLogsResponse = zod.array(
  getPrescriptionLogsResponseItem,
);

/**
 * Get pending refill requests for the authenticated user's associated clinic(s).

This endpoint retrieves basic refill request information with optional filtering
by clinic and patient, with pagination support.

Args:
    clinic: The clinic to filter by (optional)
    patientId: The patient ID to filter by (optional)
    pageNumber: The page number to retrieve (1-based, optional)

Returns:
    RefillPagedListResponseT: Paged list of pending refill requests

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record
 * @summary Get Pending Refills
 */
export const getPendingRefillsQueryParams = zod.object({
  clinic: zod.union([zod.string(), zod.null()]).optional(),
  patientId: zod.union([zod.number(), zod.null()]).optional(),
  pageNumber: zod.union([zod.number(), zod.null()]).optional(),
});

export const getPendingRefillsResponse = zod
  .object({
    Items: zod
      .union([
        zod.array(
          zod
            .object({
              RefillId: zod.union([zod.number(), zod.null()]).optional(),
              NewPatient: zod.union([zod.boolean(), zod.null()]).optional(),
              Patient: zod
                .union([
                  zod
                    .object({
                      FirstName: zod.string(),
                      LastName: zod.string(),
                      DateOfBirth: zod.string(),
                      Gender: zod.enum(["Male", "Female", "Unknown"]),
                      Address1: zod.string(),
                      City: zod.string(),
                      State: zod.string(),
                      ZipCode: zod.string(),
                      PrimaryPhone: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Active: zod.boolean(),
                      PatientId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Prefix: zod.union([zod.string(), zod.null()]).optional(),
                      MiddleName: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Suffix: zod.union([zod.string(), zod.null()]).optional(),
                      Email: zod.union([zod.string(), zod.null()]).optional(),
                      Address2: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      PhoneAdditional1: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      PhoneAdditional2: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      PhoneAdditionalType1: zod
                        .union([
                          zod.enum([
                            "Undefined",
                            "Beeper",
                            "Cell",
                            "Fax",
                            "Home",
                            "Work",
                            "Night",
                            "Primary",
                          ]),
                          zod.null(),
                        ])
                        .optional(),
                      PhoneAdditionalType2: zod
                        .union([
                          zod.enum([
                            "Undefined",
                            "Beeper",
                            "Cell",
                            "Fax",
                            "Home",
                            "Work",
                            "Night",
                            "Primary",
                          ]),
                          zod.null(),
                        ])
                        .optional(),
                      PrimaryPhoneType: zod
                        .union([
                          zod.enum([
                            "Undefined",
                            "Beeper",
                            "Cell",
                            "Fax",
                            "Home",
                            "Work",
                            "Night",
                            "Primary",
                          ]),
                          zod.null(),
                        ])
                        .optional(),
                      Weight: zod.union([zod.number(), zod.null()]).optional(),
                      WeightMetric: zod
                        .union([
                          zod
                            .enum(["lb", "kg"])
                            .describe(
                              "Valid weight metrics for DoseSpot patients.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      Height: zod.union([zod.number(), zod.null()]).optional(),
                      HeightMetric: zod
                        .union([
                          zod
                            .enum(["inch", "cm"])
                            .describe(
                              "Valid height metrics for DoseSpot patients.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      NonDoseSpotMedicalRecordNumber: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Encounter: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      IsHospice: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      Last4SSN: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                    })
                    .describe(
                      "Patient demographic information from DoseSpot API.",
                    ),
                  zod.null(),
                ])
                .optional(),
              ClinicId: zod.union([zod.number(), zod.null()]).optional(),
              ClinicianId: zod.union([zod.number(), zod.null()]).optional(),
              RequestedPrescriptionId: zod
                .union([zod.number(), zod.null()])
                .optional(),
              DispensedPrescriptionId: zod
                .union([zod.number(), zod.null()])
                .optional(),
              OriginalPrescriptionId: zod
                .union([zod.number(), zod.null()])
                .optional(),
              PharmacyId: zod.union([zod.number(), zod.null()]).optional(),
              RequestedDate: zod.union([zod.string(), zod.null()]).optional(),
            })
            .describe("Basic refill request information."),
        ),
        zod.null(),
      ])
      .optional(),
    PageResult: zod
      .union([
        zod
          .object({
            CurrentPage: zod.union([zod.number(), zod.null()]).optional(),
            TotalPages: zod.union([zod.number(), zod.null()]).optional(),
            PageSize: zod.union([zod.number(), zod.null()]).optional(),
            TotalCount: zod.union([zod.number(), zod.null()]).optional(),
            HasPrevious: zod.union([zod.boolean(), zod.null()]).optional(),
            HasNext: zod.union([zod.boolean(), zod.null()]).optional(),
          })
          .describe("DoseSpot page result information."),
        zod.null(),
      ])
      .optional(),
    Result: zod
      .union([
        zod
          .object({
            ResultCode: zod.string(),
            ResultDescription: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe("Standard DoseSpot API result object."),
        zod.null(),
      ])
      .optional(),
  })
  .describe("Paged list response for basic refill requests.");

/**
 * Get detailed pending refill requests for the authenticated user's associated clinic(s).

This endpoint retrieves detailed refill request information including full prescription
details, with optional filtering by clinic and patient, and pagination support.

Args:
    clinic: The clinic to filter by (optional)
    patientId: The patient ID to filter by (optional)
    pageNumber: The page number to retrieve (1-based, optional)

Returns:
    RefillDetailedPagedListResponseT: Paged list of detailed pending refill requests

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record
 * @summary Get Pending Refills Detailed
 */
export const getPendingRefillsDetailedQueryParams = zod.object({
  clinic: zod.union([zod.string(), zod.null()]).optional(),
  patientId: zod.union([zod.number(), zod.null()]).optional(),
  pageNumber: zod.union([zod.number(), zod.null()]).optional(),
});

export const getPendingRefillsDetailedResponse = zod
  .object({
    Items: zod
      .union([
        zod.array(
          zod
            .object({
              RefillId: zod.union([zod.number(), zod.null()]).optional(),
              NewPatient: zod.union([zod.boolean(), zod.null()]).optional(),
              Patient: zod
                .union([
                  zod
                    .object({
                      FirstName: zod.string(),
                      LastName: zod.string(),
                      DateOfBirth: zod.string(),
                      Gender: zod.enum(["Male", "Female", "Unknown"]),
                      Address1: zod.string(),
                      City: zod.string(),
                      State: zod.string(),
                      ZipCode: zod.string(),
                      PrimaryPhone: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Active: zod.boolean(),
                      PatientId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Prefix: zod.union([zod.string(), zod.null()]).optional(),
                      MiddleName: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Suffix: zod.union([zod.string(), zod.null()]).optional(),
                      Email: zod.union([zod.string(), zod.null()]).optional(),
                      Address2: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      PhoneAdditional1: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      PhoneAdditional2: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      PhoneAdditionalType1: zod
                        .union([
                          zod.enum([
                            "Undefined",
                            "Beeper",
                            "Cell",
                            "Fax",
                            "Home",
                            "Work",
                            "Night",
                            "Primary",
                          ]),
                          zod.null(),
                        ])
                        .optional(),
                      PhoneAdditionalType2: zod
                        .union([
                          zod.enum([
                            "Undefined",
                            "Beeper",
                            "Cell",
                            "Fax",
                            "Home",
                            "Work",
                            "Night",
                            "Primary",
                          ]),
                          zod.null(),
                        ])
                        .optional(),
                      PrimaryPhoneType: zod
                        .union([
                          zod.enum([
                            "Undefined",
                            "Beeper",
                            "Cell",
                            "Fax",
                            "Home",
                            "Work",
                            "Night",
                            "Primary",
                          ]),
                          zod.null(),
                        ])
                        .optional(),
                      Weight: zod.union([zod.number(), zod.null()]).optional(),
                      WeightMetric: zod
                        .union([
                          zod
                            .enum(["lb", "kg"])
                            .describe(
                              "Valid weight metrics for DoseSpot patients.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      Height: zod.union([zod.number(), zod.null()]).optional(),
                      HeightMetric: zod
                        .union([
                          zod
                            .enum(["inch", "cm"])
                            .describe(
                              "Valid height metrics for DoseSpot patients.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      NonDoseSpotMedicalRecordNumber: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Encounter: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      IsHospice: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      Last4SSN: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                    })
                    .describe(
                      "Patient demographic information from DoseSpot API.",
                    ),
                  zod.null(),
                ])
                .optional(),
              ClinicId: zod.union([zod.number(), zod.null()]).optional(),
              ClinicianId: zod.union([zod.number(), zod.null()]).optional(),
              RequestedPrescription: zod
                .union([
                  zod
                    .object({
                      PrescriptionId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      WrittenDate: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Directions: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Quantity: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DispenseUnitId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Refills: zod.union([zod.string(), zod.null()]).optional(),
                      DaysSupply: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      PharmacyId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      PharmacyNotes: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      NoSubstitutions: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      EffectiveDate: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      LastFillDate: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      PrescriberId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      PrescriberAgentId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      RxReferenceNumber: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Status: zod
                        .union([
                          zod
                            .enum([
                              "Unknown",
                              "Entered",
                              "Printed",
                              "Sending",
                              "eRxSent",
                              "FaxSent",
                              "Error",
                              "Deleted",
                              "Requested",
                              "Edited",
                              "EpcsError",
                              "EpcsSigned",
                              "ReadyToSign",
                              "PharmacyVerified",
                              "PharmacySelect",
                            ])
                            .describe(
                              "Valid prescription status types for DoseSpot.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      Formulary: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      EligibilityId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Type: zod
                        .union([
                          zod
                            .enum([
                              "Coded",
                              "FreeText",
                              "NDC",
                              "Supply",
                              "Compound",
                            ])
                            .describe("Valid prescription types for DoseSpot."),
                          zod.null(),
                        ])
                        .optional(),
                      NonDoseSpotPrescriptionId: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      ErrorIgnored: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      SupplyId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      FreeTextType: zod
                        .union([
                          zod
                            .enum(["Medication", "Supply", "Compound"])
                            .describe(
                              "Valid free text types for DoseSpot prescriptions.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      ClinicId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      SupervisorId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      IsUrgent: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      IsRxRenewal: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      RxRenewalNote: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      FirstPrescriptionDiagnosis: zod
                        .union([
                          zod
                            .object({
                              PrimaryDiagnosis: zod
                                .union([
                                  zod
                                    .object({
                                      DiagnosisId: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      DiagnosisCode: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      DiagnosisDescription: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "DoseSpot diagnosis information.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              SecondaryDiagnosis: zod
                                .union([
                                  zod
                                    .object({
                                      DiagnosisId: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      DiagnosisCode: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      DiagnosisDescription: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "DoseSpot diagnosis information.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                            })
                            .describe(
                              "DoseSpot prescription diagnosis information.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      SecondPrescriptionDiagnosis: zod
                        .union([
                          zod
                            .object({
                              PrimaryDiagnosis: zod
                                .union([
                                  zod
                                    .object({
                                      DiagnosisId: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      DiagnosisCode: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      DiagnosisDescription: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "DoseSpot diagnosis information.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              SecondaryDiagnosis: zod
                                .union([
                                  zod
                                    .object({
                                      DiagnosisId: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      DiagnosisCode: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      DiagnosisDescription: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "DoseSpot diagnosis information.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                            })
                            .describe(
                              "DoseSpot prescription diagnosis information.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      Strength: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      PatientMedicationId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      MedicationStatus: zod
                        .union([
                          zod
                            .enum([
                              "Unknown",
                              "Active",
                              "Inactive",
                              "Discontinued",
                              "Deleted",
                              "Completed",
                              "CancelRequested",
                              "CancelPending",
                              "Cancelled",
                              "CancelDenied",
                              "Changed",
                              "FullFill",
                              "PartialFill",
                              "NoFill",
                            ])
                            .describe(
                              "Valid medication status types for DoseSpot.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      Comment: zod.union([zod.string(), zod.null()]).optional(),
                      DateInactive: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Encounter: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DisplayName: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DispensableDrugId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Schedule: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      CompoundIngredients: zod
                        .union([
                          zod.array(
                            zod
                              .object({
                                DispensableDrugId: zod
                                  .union([zod.number(), zod.null()])
                                  .optional(),
                                FreeText: zod
                                  .union([zod.string(), zod.null()])
                                  .optional(),
                                DispenseUnitId: zod
                                  .union([zod.number(), zod.null()])
                                  .optional(),
                                Quantity: zod.string(),
                                IsFreeTextEPCS: zod
                                  .union([zod.boolean(), zod.null()])
                                  .optional(),
                              })
                              .describe(
                                "DoseSpot compound ingredient information.",
                              ),
                          ),
                          zod.null(),
                        ])
                        .optional(),
                    })
                    .describe(
                      "Complete prescription information from DoseSpot API.",
                    ),
                  zod.null(),
                ])
                .optional(),
              DispensedPrescription: zod
                .union([
                  zod
                    .object({
                      PrescriptionId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      WrittenDate: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Directions: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Quantity: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DispenseUnitId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Refills: zod.union([zod.string(), zod.null()]).optional(),
                      DaysSupply: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      PharmacyId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      PharmacyNotes: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      NoSubstitutions: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      EffectiveDate: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      LastFillDate: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      PrescriberId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      PrescriberAgentId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      RxReferenceNumber: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Status: zod
                        .union([
                          zod
                            .enum([
                              "Unknown",
                              "Entered",
                              "Printed",
                              "Sending",
                              "eRxSent",
                              "FaxSent",
                              "Error",
                              "Deleted",
                              "Requested",
                              "Edited",
                              "EpcsError",
                              "EpcsSigned",
                              "ReadyToSign",
                              "PharmacyVerified",
                              "PharmacySelect",
                            ])
                            .describe(
                              "Valid prescription status types for DoseSpot.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      Formulary: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      EligibilityId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Type: zod
                        .union([
                          zod
                            .enum([
                              "Coded",
                              "FreeText",
                              "NDC",
                              "Supply",
                              "Compound",
                            ])
                            .describe("Valid prescription types for DoseSpot."),
                          zod.null(),
                        ])
                        .optional(),
                      NonDoseSpotPrescriptionId: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      ErrorIgnored: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      SupplyId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      FreeTextType: zod
                        .union([
                          zod
                            .enum(["Medication", "Supply", "Compound"])
                            .describe(
                              "Valid free text types for DoseSpot prescriptions.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      ClinicId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      SupervisorId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      IsUrgent: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      IsRxRenewal: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      RxRenewalNote: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      FirstPrescriptionDiagnosis: zod
                        .union([
                          zod
                            .object({
                              PrimaryDiagnosis: zod
                                .union([
                                  zod
                                    .object({
                                      DiagnosisId: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      DiagnosisCode: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      DiagnosisDescription: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "DoseSpot diagnosis information.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              SecondaryDiagnosis: zod
                                .union([
                                  zod
                                    .object({
                                      DiagnosisId: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      DiagnosisCode: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      DiagnosisDescription: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "DoseSpot diagnosis information.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                            })
                            .describe(
                              "DoseSpot prescription diagnosis information.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      SecondPrescriptionDiagnosis: zod
                        .union([
                          zod
                            .object({
                              PrimaryDiagnosis: zod
                                .union([
                                  zod
                                    .object({
                                      DiagnosisId: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      DiagnosisCode: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      DiagnosisDescription: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "DoseSpot diagnosis information.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              SecondaryDiagnosis: zod
                                .union([
                                  zod
                                    .object({
                                      DiagnosisId: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      DiagnosisCode: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      DiagnosisDescription: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "DoseSpot diagnosis information.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                            })
                            .describe(
                              "DoseSpot prescription diagnosis information.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      Strength: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      PatientMedicationId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      MedicationStatus: zod
                        .union([
                          zod
                            .enum([
                              "Unknown",
                              "Active",
                              "Inactive",
                              "Discontinued",
                              "Deleted",
                              "Completed",
                              "CancelRequested",
                              "CancelPending",
                              "Cancelled",
                              "CancelDenied",
                              "Changed",
                              "FullFill",
                              "PartialFill",
                              "NoFill",
                            ])
                            .describe(
                              "Valid medication status types for DoseSpot.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      Comment: zod.union([zod.string(), zod.null()]).optional(),
                      DateInactive: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Encounter: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DisplayName: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DispensableDrugId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Schedule: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      CompoundIngredients: zod
                        .union([
                          zod.array(
                            zod
                              .object({
                                DispensableDrugId: zod
                                  .union([zod.number(), zod.null()])
                                  .optional(),
                                FreeText: zod
                                  .union([zod.string(), zod.null()])
                                  .optional(),
                                DispenseUnitId: zod
                                  .union([zod.number(), zod.null()])
                                  .optional(),
                                Quantity: zod.string(),
                                IsFreeTextEPCS: zod
                                  .union([zod.boolean(), zod.null()])
                                  .optional(),
                              })
                              .describe(
                                "DoseSpot compound ingredient information.",
                              ),
                          ),
                          zod.null(),
                        ])
                        .optional(),
                    })
                    .describe(
                      "Complete prescription information from DoseSpot API.",
                    ),
                  zod.null(),
                ])
                .optional(),
              OriginalPrescription: zod
                .union([
                  zod
                    .object({
                      PrescriptionId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      WrittenDate: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Directions: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Quantity: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DispenseUnitId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Refills: zod.union([zod.string(), zod.null()]).optional(),
                      DaysSupply: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      PharmacyId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      PharmacyNotes: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      NoSubstitutions: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      EffectiveDate: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      LastFillDate: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      PrescriberId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      PrescriberAgentId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      RxReferenceNumber: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Status: zod
                        .union([
                          zod
                            .enum([
                              "Unknown",
                              "Entered",
                              "Printed",
                              "Sending",
                              "eRxSent",
                              "FaxSent",
                              "Error",
                              "Deleted",
                              "Requested",
                              "Edited",
                              "EpcsError",
                              "EpcsSigned",
                              "ReadyToSign",
                              "PharmacyVerified",
                              "PharmacySelect",
                            ])
                            .describe(
                              "Valid prescription status types for DoseSpot.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      Formulary: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      EligibilityId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Type: zod
                        .union([
                          zod
                            .enum([
                              "Coded",
                              "FreeText",
                              "NDC",
                              "Supply",
                              "Compound",
                            ])
                            .describe("Valid prescription types for DoseSpot."),
                          zod.null(),
                        ])
                        .optional(),
                      NonDoseSpotPrescriptionId: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      ErrorIgnored: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      SupplyId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      FreeTextType: zod
                        .union([
                          zod
                            .enum(["Medication", "Supply", "Compound"])
                            .describe(
                              "Valid free text types for DoseSpot prescriptions.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      ClinicId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      SupervisorId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      IsUrgent: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      IsRxRenewal: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      RxRenewalNote: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      FirstPrescriptionDiagnosis: zod
                        .union([
                          zod
                            .object({
                              PrimaryDiagnosis: zod
                                .union([
                                  zod
                                    .object({
                                      DiagnosisId: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      DiagnosisCode: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      DiagnosisDescription: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "DoseSpot diagnosis information.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              SecondaryDiagnosis: zod
                                .union([
                                  zod
                                    .object({
                                      DiagnosisId: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      DiagnosisCode: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      DiagnosisDescription: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "DoseSpot diagnosis information.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                            })
                            .describe(
                              "DoseSpot prescription diagnosis information.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      SecondPrescriptionDiagnosis: zod
                        .union([
                          zod
                            .object({
                              PrimaryDiagnosis: zod
                                .union([
                                  zod
                                    .object({
                                      DiagnosisId: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      DiagnosisCode: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      DiagnosisDescription: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "DoseSpot diagnosis information.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              SecondaryDiagnosis: zod
                                .union([
                                  zod
                                    .object({
                                      DiagnosisId: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      DiagnosisCode: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      DiagnosisDescription: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "DoseSpot diagnosis information.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                            })
                            .describe(
                              "DoseSpot prescription diagnosis information.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      Strength: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      PatientMedicationId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      MedicationStatus: zod
                        .union([
                          zod
                            .enum([
                              "Unknown",
                              "Active",
                              "Inactive",
                              "Discontinued",
                              "Deleted",
                              "Completed",
                              "CancelRequested",
                              "CancelPending",
                              "Cancelled",
                              "CancelDenied",
                              "Changed",
                              "FullFill",
                              "PartialFill",
                              "NoFill",
                            ])
                            .describe(
                              "Valid medication status types for DoseSpot.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      Comment: zod.union([zod.string(), zod.null()]).optional(),
                      DateInactive: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Encounter: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DisplayName: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DispensableDrugId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Schedule: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      CompoundIngredients: zod
                        .union([
                          zod.array(
                            zod
                              .object({
                                DispensableDrugId: zod
                                  .union([zod.number(), zod.null()])
                                  .optional(),
                                FreeText: zod
                                  .union([zod.string(), zod.null()])
                                  .optional(),
                                DispenseUnitId: zod
                                  .union([zod.number(), zod.null()])
                                  .optional(),
                                Quantity: zod.string(),
                                IsFreeTextEPCS: zod
                                  .union([zod.boolean(), zod.null()])
                                  .optional(),
                              })
                              .describe(
                                "DoseSpot compound ingredient information.",
                              ),
                          ),
                          zod.null(),
                        ])
                        .optional(),
                    })
                    .describe(
                      "Complete prescription information from DoseSpot API.",
                    ),
                  zod.null(),
                ])
                .optional(),
              PharmacyId: zod.union([zod.number(), zod.null()]).optional(),
              RequestedDate: zod.union([zod.string(), zod.null()]).optional(),
            })
            .describe(
              "Detailed refill request information with prescription details.",
            ),
        ),
        zod.null(),
      ])
      .optional(),
    PageResult: zod
      .union([
        zod
          .object({
            CurrentPage: zod.union([zod.number(), zod.null()]).optional(),
            TotalPages: zod.union([zod.number(), zod.null()]).optional(),
            PageSize: zod.union([zod.number(), zod.null()]).optional(),
            TotalCount: zod.union([zod.number(), zod.null()]).optional(),
            HasPrevious: zod.union([zod.boolean(), zod.null()]).optional(),
            HasNext: zod.union([zod.boolean(), zod.null()]).optional(),
          })
          .describe("DoseSpot page result information."),
        zod.null(),
      ])
      .optional(),
    Result: zod
      .union([
        zod
          .object({
            ResultCode: zod.string(),
            ResultDescription: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe("Standard DoseSpot API result object."),
        zod.null(),
      ])
      .optional(),
  })
  .describe("Paged list response for detailed refill requests.");

/**
 * Approve a pending refill request.

This endpoint approves a refill request by providing the number of refills
and optional comment and effective date.

Args:
    refill_id: The refill ID to approve
    request: The approval request containing refills count and optional fields

Returns:
    IdentifierResponseT: Response from the approval operation

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record or approval fails
 * @summary Approve Refill
 */
export const approveRefillParams = zod.object({
  refill_id: zod.number(),
});

export const approveRefillBody = zod
  .object({
    Refills: zod.number(),
    Comment: zod.union([zod.string(), zod.null()]).optional(),
    EffectiveDate: zod.union([zod.string(), zod.null()]).optional(),
  })
  .describe("Request to approve a refill.");

export const approveRefillResponse = zod
  .object({
    Id: zod.union([zod.number(), zod.null()]).optional(),
    Result: zod
      .union([
        zod
          .object({
            ResultCode: zod.string(),
            ResultDescription: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe("Standard DoseSpot API result object."),
        zod.null(),
      ])
      .optional(),
  })
  .describe(
    "Response wrapper for operations that return an entity identifier.",
  );

/**
 * Deny a pending refill request.

This endpoint denies a refill request by providing the denial reason
and optional note.

Args:
    refill_id: The refill ID to deny
    request: The denial request containing denial reason and optional note

Returns:
    IdentifierResponseT: Response from the denial operation

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record or denial fails
 * @summary Deny Refill
 */
export const denyRefillParams = zod.object({
  refill_id: zod.number(),
});

export const denyRefillBody = zod
  .object({
    DenialReason: zod
      .enum([
        "DeniedPatientUnknown",
        "DeniedPatientNotUnderCare",
        "DeniedPatientNoLongerUnderPatientCare",
        "DeniedTooSoon",
        "DeniedNeverPrescribed",
        "DeniedHavePatientContact",
        "DeniedRefillInappropriate",
        "DeniedAlreadyPickedUp",
        "DeniedAlreadyPickedUpPartialFill",
        "DeniedNotPickedUp",
        "DeniedChangeInappropriate",
        "DeniedNeedAppointment",
        "DeniedPrescriberNotAssociateWithLocation",
        "DeniedNoPriorAuthAttempt",
        "DeniedAlreadyHandled",
        "DeniedAtPatientRequest",
        "DeniedPatientAllergicToRequestMed",
        "DeniedMedicationDiscontinued",
      ])
      .describe("Valid denial reasons for refill requests."),
    Note: zod.union([zod.string(), zod.null()]).optional(),
  })
  .describe("Request to deny a refill.");

export const denyRefillResponse = zod
  .object({
    Id: zod.union([zod.number(), zod.null()]).optional(),
    Result: zod
      .union([
        zod
          .object({
            ResultCode: zod.string(),
            ResultDescription: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe("Standard DoseSpot API result object."),
        zod.null(),
      ])
      .optional(),
  })
  .describe(
    "Response wrapper for operations that return an entity identifier.",
  );

/**
 * Replace a refill request with a new prescription.

This endpoint replaces a refill request with a different prescription.
Only one of NewPrescription, NewSupplyPrescription, NewCompoundPrescription,
or NewFreeTextPrescription should be provided.

Args:
    refill_id: The refill ID to replace
    request: The replacement request containing patient ID and new prescription details

Returns:
    IdentifierResponseT: Response from the replacement operation

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record or replacement fails
 * @summary Replace Refill
 */
export const replaceRefillParams = zod.object({
  refill_id: zod.number(),
});

export const replaceRefillBody = zod
  .object({
    PatientID: zod.number(),
    Pin: zod.union([zod.string(), zod.null()]).optional(),
    Otp: zod.union([zod.string(), zod.null()]).optional(),
    NewPrescription: zod
      .union([
        zod
          .object({
            DispensableDrugId: zod.number(),
            PatientFormularyId: zod
              .union([zod.number(), zod.null()])
              .optional(),
            Refills: zod.number(),
            DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
            DispenseUnitId: zod.number(),
            Quantity: zod.number(),
            Directions: zod.string(),
            PharmacyId: zod.number(),
            PharmacyNotes: zod.union([zod.string(), zod.null()]).optional(),
            NoSubstitutions: zod.union([zod.boolean(), zod.null()]).optional(),
            EffectiveDate: zod.string(),
            RxReferenceNumber: zod.union([zod.string(), zod.null()]).optional(),
            EligibilityId: zod.union([zod.number(), zod.null()]).optional(),
            NonDoseSpotPrescriptionId: zod
              .union([zod.string(), zod.null()])
              .optional(),
            FirstPrescriptionDiagnosis: zod
              .union([
                zod
                  .object({
                    PrimaryDiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    SecondaryDiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                  })
                  .describe(
                    "DoseSpot prescription diagnosis IDs for requests.",
                  ),
                zod.null(),
              ])
              .optional(),
            SecondPrescriptionDiagnosis: zod
              .union([
                zod
                  .object({
                    PrimaryDiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    SecondaryDiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                  })
                  .describe(
                    "DoseSpot prescription diagnosis IDs for requests.",
                  ),
                zod.null(),
              ])
              .optional(),
            IsRefillReplace: zod.union([zod.boolean(), zod.null()]).optional(),
            IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
            SupervisorId: zod.union([zod.number(), zod.null()]).optional(),
            RetailPharmacyToMailToPatient: zod
              .union([zod.boolean(), zod.null()])
              .optional(),
            Status: zod
              .enum([
                "Unknown",
                "Active",
                "Inactive",
                "Discontinued",
                "Deleted",
                "Completed",
                "CancelRequested",
                "CancelPending",
                "Cancelled",
                "CancelDenied",
                "Changed",
                "FullFill",
                "PartialFill",
                "NoFill",
              ])
              .describe("Valid medication status types for DoseSpot."),
            InactiveDate: zod.union([zod.string(), zod.null()]).optional(),
            Comment: zod.union([zod.string(), zod.null()]).optional(),
            Encounter: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe("Request for coded prescription creation/editing."),
        zod.null(),
      ])
      .optional(),
    NewSupplyPrescription: zod
      .union([
        zod
          .object({
            SupplyId: zod.number(),
            Refills: zod.number(),
            DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
            DispenseUnitId: zod.number(),
            Quantity: zod.number(),
            Directions: zod.string(),
            PharmacyId: zod.number(),
            PharmacyNotes: zod.union([zod.string(), zod.null()]).optional(),
            NoSubstitutions: zod.union([zod.boolean(), zod.null()]).optional(),
            EffectiveDate: zod.string(),
            RxReferenceNumber: zod.union([zod.string(), zod.null()]).optional(),
            EligibilityId: zod.union([zod.number(), zod.null()]).optional(),
            NonDoseSpotPrescriptionId: zod
              .union([zod.string(), zod.null()])
              .optional(),
            FirstPrescriptionDiagnosis: zod
              .union([
                zod
                  .object({
                    PrimaryDiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    SecondaryDiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                  })
                  .describe(
                    "DoseSpot prescription diagnosis IDs for requests.",
                  ),
                zod.null(),
              ])
              .optional(),
            SecondPrescriptionDiagnosis: zod
              .union([
                zod
                  .object({
                    PrimaryDiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    SecondaryDiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                  })
                  .describe(
                    "DoseSpot prescription diagnosis IDs for requests.",
                  ),
                zod.null(),
              ])
              .optional(),
            IsRefillReplace: zod.union([zod.boolean(), zod.null()]).optional(),
            IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
            SupervisorId: zod.union([zod.number(), zod.null()]).optional(),
            RetailPharmacyToMailToPatient: zod
              .union([zod.boolean(), zod.null()])
              .optional(),
            Status: zod
              .enum([
                "Unknown",
                "Active",
                "Inactive",
                "Discontinued",
                "Deleted",
                "Completed",
                "CancelRequested",
                "CancelPending",
                "Cancelled",
                "CancelDenied",
                "Changed",
                "FullFill",
                "PartialFill",
                "NoFill",
              ])
              .describe("Valid medication status types for DoseSpot."),
            InactiveDate: zod.union([zod.string(), zod.null()]).optional(),
            Comment: zod.union([zod.string(), zod.null()]).optional(),
            Encounter: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe("Request for coded supply prescription creation/editing."),
        zod.null(),
      ])
      .optional(),
    NewCompoundPrescription: zod
      .union([
        zod
          .object({
            CompoundDescription: zod.string(),
            CompoundIngredients: zod.array(
              zod
                .object({
                  DispensableDrugId: zod
                    .union([zod.number(), zod.null()])
                    .optional(),
                  FreeText: zod.union([zod.string(), zod.null()]).optional(),
                  DispenseUnitId: zod
                    .union([zod.number(), zod.null()])
                    .optional(),
                  Quantity: zod.string(),
                  IsFreeTextEPCS: zod
                    .union([zod.boolean(), zod.null()])
                    .optional(),
                })
                .describe("DoseSpot compound ingredient information."),
            ),
            Refills: zod.number(),
            DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
            DispenseUnitId: zod.number(),
            Quantity: zod.number(),
            Directions: zod.string(),
            PharmacyId: zod.number(),
            PharmacyNotes: zod.union([zod.string(), zod.null()]).optional(),
            NoSubstitutions: zod.union([zod.boolean(), zod.null()]).optional(),
            EffectiveDate: zod.string(),
            RxReferenceNumber: zod.union([zod.string(), zod.null()]).optional(),
            EligibilityId: zod.union([zod.number(), zod.null()]).optional(),
            NonDoseSpotPrescriptionId: zod
              .union([zod.string(), zod.null()])
              .optional(),
            FirstPrescriptionDiagnosis: zod
              .union([
                zod
                  .object({
                    PrimaryDiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    SecondaryDiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                  })
                  .describe(
                    "DoseSpot prescription diagnosis IDs for requests.",
                  ),
                zod.null(),
              ])
              .optional(),
            SecondPrescriptionDiagnosis: zod
              .union([
                zod
                  .object({
                    PrimaryDiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    SecondaryDiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                  })
                  .describe(
                    "DoseSpot prescription diagnosis IDs for requests.",
                  ),
                zod.null(),
              ])
              .optional(),
            IsRefillReplace: zod.union([zod.boolean(), zod.null()]).optional(),
            IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
            SupervisorId: zod.union([zod.number(), zod.null()]).optional(),
            RetailPharmacyToMailToPatient: zod
              .union([zod.boolean(), zod.null()])
              .optional(),
            Status: zod
              .enum([
                "Unknown",
                "Active",
                "Inactive",
                "Discontinued",
                "Deleted",
                "Completed",
                "CancelRequested",
                "CancelPending",
                "Cancelled",
                "CancelDenied",
                "Changed",
                "FullFill",
                "PartialFill",
                "NoFill",
              ])
              .describe("Valid medication status types for DoseSpot."),
            InactiveDate: zod.union([zod.string(), zod.null()]).optional(),
            Comment: zod.union([zod.string(), zod.null()]).optional(),
            Encounter: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe("Request for compound prescription creation/editing."),
        zod.null(),
      ])
      .optional(),
    NewFreeTextPrescription: zod
      .union([
        zod
          .object({
            DisplayName: zod.string(),
            NotControlled: zod.boolean(),
            Refills: zod.number(),
            DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
            DispenseUnitId: zod.number(),
            Quantity: zod.number(),
            Directions: zod.string(),
            PharmacyId: zod.number(),
            PharmacyNotes: zod.union([zod.string(), zod.null()]).optional(),
            NoSubstitutions: zod.union([zod.boolean(), zod.null()]).optional(),
            EffectiveDate: zod.string(),
            RxReferenceNumber: zod.union([zod.string(), zod.null()]).optional(),
            EligibilityId: zod.union([zod.number(), zod.null()]).optional(),
            NonDoseSpotPrescriptionId: zod
              .union([zod.string(), zod.null()])
              .optional(),
            FirstPrescriptionDiagnosis: zod
              .union([
                zod
                  .object({
                    PrimaryDiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    SecondaryDiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                  })
                  .describe(
                    "DoseSpot prescription diagnosis IDs for requests.",
                  ),
                zod.null(),
              ])
              .optional(),
            SecondPrescriptionDiagnosis: zod
              .union([
                zod
                  .object({
                    PrimaryDiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    SecondaryDiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                  })
                  .describe(
                    "DoseSpot prescription diagnosis IDs for requests.",
                  ),
                zod.null(),
              ])
              .optional(),
            IsRefillReplace: zod.union([zod.boolean(), zod.null()]).optional(),
            IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
            SupervisorId: zod.union([zod.number(), zod.null()]).optional(),
            RetailPharmacyToMailToPatient: zod
              .union([zod.boolean(), zod.null()])
              .optional(),
            Status: zod
              .enum([
                "Unknown",
                "Active",
                "Inactive",
                "Discontinued",
                "Deleted",
                "Completed",
                "CancelRequested",
                "CancelPending",
                "Cancelled",
                "CancelDenied",
                "Changed",
                "FullFill",
                "PartialFill",
                "NoFill",
              ])
              .describe("Valid medication status types for DoseSpot."),
            InactiveDate: zod.union([zod.string(), zod.null()]).optional(),
            Comment: zod.union([zod.string(), zod.null()]).optional(),
            Encounter: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe(
            "Request for free text supply prescription creation/editing.",
          ),
        zod.null(),
      ])
      .optional(),
  })
  .describe("Request to replace a refill with a new prescription.");

export const replaceRefillResponse = zod
  .object({
    Id: zod.union([zod.number(), zod.null()]).optional(),
    Result: zod
      .union([
        zod
          .object({
            ResultCode: zod.string(),
            ResultDescription: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe("Standard DoseSpot API result object."),
        zod.null(),
      ])
      .optional(),
  })
  .describe(
    "Response wrapper for operations that return an entity identifier.",
  );

/**
 * Perform an action on a pending refill request.

Accepts a discriminated-union body whose ``action`` field selects
approve, deny, or replace.  Used by the copilot proposed-action
form so the clinician can review and submit in one step.
 * @summary Refill Action
 */
export const refillActionParams = zod.object({
  refill_id: zod.number(),
});

export const refillActionBodyActionDefault = "approve";
export const refillActionBodyRefillsDefault = 0;
export const refillActionBodyActionDefaultOne = "deny";
export const refillActionBodyActionDefaultTwo = "replace";

export const refillActionBody = zod.union([
  zod.object({
    action: zod.literal("approve").default(refillActionBodyActionDefault),
    refills: zod.number().optional(),
    comment: zod.union([zod.string(), zod.null()]).optional(),
    effectiveDate: zod.union([zod.string(), zod.null()]).optional(),
  }),
  zod.object({
    action: zod.literal("deny").default(refillActionBodyActionDefaultOne),
    denialReason: zod
      .enum([
        "DeniedPatientUnknown",
        "DeniedPatientNotUnderCare",
        "DeniedPatientNoLongerUnderPatientCare",
        "DeniedTooSoon",
        "DeniedNeverPrescribed",
        "DeniedHavePatientContact",
        "DeniedRefillInappropriate",
        "DeniedAlreadyPickedUp",
        "DeniedAlreadyPickedUpPartialFill",
        "DeniedNotPickedUp",
        "DeniedChangeInappropriate",
        "DeniedNeedAppointment",
        "DeniedPrescriberNotAssociateWithLocation",
        "DeniedNoPriorAuthAttempt",
        "DeniedAlreadyHandled",
        "DeniedAtPatientRequest",
        "DeniedPatientAllergicToRequestMed",
        "DeniedMedicationDiscontinued",
      ])
      .optional()
      .describe("Valid denial reasons for refill requests."),
    note: zod.union([zod.string(), zod.null()]).optional(),
  }),
  zod.object({
    action: zod.literal("replace").default(refillActionBodyActionDefaultTwo),
    patientUserId: zod.string(),
    newPrescription: zod
      .object({
        DispensableDrugId: zod.number(),
        PatientFormularyId: zod.union([zod.number(), zod.null()]).optional(),
        Refills: zod.number(),
        DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
        DispenseUnitId: zod.number(),
        Quantity: zod.number(),
        Directions: zod.string(),
        PharmacyId: zod.number(),
        PharmacyNotes: zod.union([zod.string(), zod.null()]).optional(),
        NoSubstitutions: zod.union([zod.boolean(), zod.null()]).optional(),
        EffectiveDate: zod.string(),
        RxReferenceNumber: zod.union([zod.string(), zod.null()]).optional(),
        EligibilityId: zod.union([zod.number(), zod.null()]).optional(),
        NonDoseSpotPrescriptionId: zod
          .union([zod.string(), zod.null()])
          .optional(),
        FirstPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                SecondaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis IDs for requests."),
            zod.null(),
          ])
          .optional(),
        SecondPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                SecondaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis IDs for requests."),
            zod.null(),
          ])
          .optional(),
        IsRefillReplace: zod.union([zod.boolean(), zod.null()]).optional(),
        IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
        SupervisorId: zod.union([zod.number(), zod.null()]).optional(),
        RetailPharmacyToMailToPatient: zod
          .union([zod.boolean(), zod.null()])
          .optional(),
        Status: zod
          .enum([
            "Unknown",
            "Active",
            "Inactive",
            "Discontinued",
            "Deleted",
            "Completed",
            "CancelRequested",
            "CancelPending",
            "Cancelled",
            "CancelDenied",
            "Changed",
            "FullFill",
            "PartialFill",
            "NoFill",
          ])
          .describe("Valid medication status types for DoseSpot."),
        InactiveDate: zod.union([zod.string(), zod.null()]).optional(),
        Comment: zod.union([zod.string(), zod.null()]).optional(),
        Encounter: zod.union([zod.string(), zod.null()]).optional(),
      })
      .describe("Request for coded prescription creation/editing."),
  }),
]);

export const refillActionResponse = zod
  .object({
    Id: zod.union([zod.number(), zod.null()]).optional(),
    Result: zod
      .union([
        zod
          .object({
            ResultCode: zod.string(),
            ResultDescription: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe("Standard DoseSpot API result object."),
        zod.null(),
      ])
      .optional(),
  })
  .describe(
    "Response wrapper for operations that return an entity identifier.",
  );

/**
 * Get detailed pending RxChange requests for the authenticated user's associated clinic(s).

This endpoint retrieves detailed RxChange request information including full prescription
details, with optional filtering by clinic and patient, and pagination support.

Args:
    clinic: The clinic to filter by (optional)
    patientId: The patient ID to filter by (optional)
    pageNumber: The page number to retrieve (1-based, optional)

Returns:
    RxChangeDetailedPagedListResponseT: Paged list of detailed pending RxChange requests

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record
 * @summary Get Pending Rx Changes Detailed
 */
export const getPendingRxChangesDetailedQueryParams = zod.object({
  clinic: zod.union([zod.string(), zod.null()]).optional(),
  patientId: zod.union([zod.number(), zod.null()]).optional(),
  pageNumber: zod.union([zod.number(), zod.null()]).optional(),
});

export const getPendingRxChangesDetailedResponse = zod
  .object({
    Items: zod
      .union([
        zod.array(
          zod
            .object({
              RxChangeRequestId: zod
                .union([zod.number(), zod.null()])
                .optional(),
              RxChangeType: zod.union([zod.string(), zod.null()]).optional(),
              RxChangeSubType: zod.union([zod.string(), zod.null()]).optional(),
              Source: zod.union([zod.string(), zod.null()]).optional(),
              NewPatient: zod.union([zod.boolean(), zod.null()]).optional(),
              Patient: zod
                .union([
                  zod
                    .object({
                      FirstName: zod.string(),
                      LastName: zod.string(),
                      DateOfBirth: zod.string(),
                      Gender: zod.enum(["Male", "Female", "Unknown"]),
                      Address1: zod.string(),
                      City: zod.string(),
                      State: zod.string(),
                      ZipCode: zod.string(),
                      PrimaryPhone: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Active: zod.boolean(),
                      PatientId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Prefix: zod.union([zod.string(), zod.null()]).optional(),
                      MiddleName: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Suffix: zod.union([zod.string(), zod.null()]).optional(),
                      Email: zod.union([zod.string(), zod.null()]).optional(),
                      Address2: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      PhoneAdditional1: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      PhoneAdditional2: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      PhoneAdditionalType1: zod
                        .union([
                          zod.enum([
                            "Undefined",
                            "Beeper",
                            "Cell",
                            "Fax",
                            "Home",
                            "Work",
                            "Night",
                            "Primary",
                          ]),
                          zod.null(),
                        ])
                        .optional(),
                      PhoneAdditionalType2: zod
                        .union([
                          zod.enum([
                            "Undefined",
                            "Beeper",
                            "Cell",
                            "Fax",
                            "Home",
                            "Work",
                            "Night",
                            "Primary",
                          ]),
                          zod.null(),
                        ])
                        .optional(),
                      PrimaryPhoneType: zod
                        .union([
                          zod.enum([
                            "Undefined",
                            "Beeper",
                            "Cell",
                            "Fax",
                            "Home",
                            "Work",
                            "Night",
                            "Primary",
                          ]),
                          zod.null(),
                        ])
                        .optional(),
                      Weight: zod.union([zod.number(), zod.null()]).optional(),
                      WeightMetric: zod
                        .union([
                          zod
                            .enum(["lb", "kg"])
                            .describe(
                              "Valid weight metrics for DoseSpot patients.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      Height: zod.union([zod.number(), zod.null()]).optional(),
                      HeightMetric: zod
                        .union([
                          zod
                            .enum(["inch", "cm"])
                            .describe(
                              "Valid height metrics for DoseSpot patients.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      NonDoseSpotMedicalRecordNumber: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Encounter: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      IsHospice: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      Last4SSN: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                    })
                    .describe(
                      "Patient demographic information from DoseSpot API.",
                    ),
                  zod.null(),
                ])
                .optional(),
              UnmatchedChange: zod
                .union([zod.boolean(), zod.null()])
                .optional(),
              PrescribedPrescription: zod
                .union([
                  zod
                    .object({
                      PrescriptionId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      WrittenDate: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Directions: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Quantity: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DispenseUnitId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Refills: zod.union([zod.string(), zod.null()]).optional(),
                      DaysSupply: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      PharmacyId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      PharmacyNotes: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      NoSubstitutions: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      EffectiveDate: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      LastFillDate: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      PrescriberId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      PrescriberAgentId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      RxReferenceNumber: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Status: zod
                        .union([
                          zod
                            .enum([
                              "Unknown",
                              "Entered",
                              "Printed",
                              "Sending",
                              "eRxSent",
                              "FaxSent",
                              "Error",
                              "Deleted",
                              "Requested",
                              "Edited",
                              "EpcsError",
                              "EpcsSigned",
                              "ReadyToSign",
                              "PharmacyVerified",
                              "PharmacySelect",
                            ])
                            .describe(
                              "Valid prescription status types for DoseSpot.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      Formulary: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      EligibilityId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Type: zod
                        .union([
                          zod
                            .enum([
                              "Coded",
                              "FreeText",
                              "NDC",
                              "Supply",
                              "Compound",
                            ])
                            .describe("Valid prescription types for DoseSpot."),
                          zod.null(),
                        ])
                        .optional(),
                      NonDoseSpotPrescriptionId: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      ErrorIgnored: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      SupplyId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      FreeTextType: zod
                        .union([
                          zod
                            .enum(["Medication", "Supply", "Compound"])
                            .describe(
                              "Valid free text types for DoseSpot prescriptions.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      ClinicId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      SupervisorId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      IsUrgent: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      IsRxRenewal: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      RxRenewalNote: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      FirstPrescriptionDiagnosis: zod
                        .union([
                          zod
                            .object({
                              PrimaryDiagnosis: zod
                                .union([
                                  zod
                                    .object({
                                      DiagnosisId: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      DiagnosisCode: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      DiagnosisDescription: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "DoseSpot diagnosis information.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              SecondaryDiagnosis: zod
                                .union([
                                  zod
                                    .object({
                                      DiagnosisId: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      DiagnosisCode: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      DiagnosisDescription: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "DoseSpot diagnosis information.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                            })
                            .describe(
                              "DoseSpot prescription diagnosis information.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      SecondPrescriptionDiagnosis: zod
                        .union([
                          zod
                            .object({
                              PrimaryDiagnosis: zod
                                .union([
                                  zod
                                    .object({
                                      DiagnosisId: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      DiagnosisCode: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      DiagnosisDescription: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "DoseSpot diagnosis information.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              SecondaryDiagnosis: zod
                                .union([
                                  zod
                                    .object({
                                      DiagnosisId: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      DiagnosisCode: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      DiagnosisDescription: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "DoseSpot diagnosis information.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                            })
                            .describe(
                              "DoseSpot prescription diagnosis information.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      Strength: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      PatientMedicationId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      MedicationStatus: zod
                        .union([
                          zod
                            .enum([
                              "Unknown",
                              "Active",
                              "Inactive",
                              "Discontinued",
                              "Deleted",
                              "Completed",
                              "CancelRequested",
                              "CancelPending",
                              "Cancelled",
                              "CancelDenied",
                              "Changed",
                              "FullFill",
                              "PartialFill",
                              "NoFill",
                            ])
                            .describe(
                              "Valid medication status types for DoseSpot.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      Comment: zod.union([zod.string(), zod.null()]).optional(),
                      DateInactive: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Encounter: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DisplayName: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DispensableDrugId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Schedule: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      CompoundIngredients: zod
                        .union([
                          zod.array(
                            zod
                              .object({
                                DispensableDrugId: zod
                                  .union([zod.number(), zod.null()])
                                  .optional(),
                                FreeText: zod
                                  .union([zod.string(), zod.null()])
                                  .optional(),
                                DispenseUnitId: zod
                                  .union([zod.number(), zod.null()])
                                  .optional(),
                                Quantity: zod.string(),
                                IsFreeTextEPCS: zod
                                  .union([zod.boolean(), zod.null()])
                                  .optional(),
                              })
                              .describe(
                                "DoseSpot compound ingredient information.",
                              ),
                          ),
                          zod.null(),
                        ])
                        .optional(),
                    })
                    .describe(
                      "Complete prescription information from DoseSpot API.",
                    ),
                  zod.null(),
                ])
                .optional(),
              RequestedMedications: zod
                .union([
                  zod.array(
                    zod
                      .object({
                        PrescriptionId: zod
                          .union([zod.number(), zod.null()])
                          .optional(),
                        WrittenDate: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        Directions: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        Quantity: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        DispenseUnitId: zod
                          .union([zod.number(), zod.null()])
                          .optional(),
                        Refills: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        DaysSupply: zod
                          .union([zod.number(), zod.null()])
                          .optional(),
                        PharmacyId: zod
                          .union([zod.number(), zod.null()])
                          .optional(),
                        PharmacyNotes: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        NoSubstitutions: zod
                          .union([zod.boolean(), zod.null()])
                          .optional(),
                        EffectiveDate: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        LastFillDate: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        PrescriberId: zod
                          .union([zod.number(), zod.null()])
                          .optional(),
                        PrescriberAgentId: zod
                          .union([zod.number(), zod.null()])
                          .optional(),
                        RxReferenceNumber: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        Status: zod
                          .union([
                            zod
                              .enum([
                                "Unknown",
                                "Entered",
                                "Printed",
                                "Sending",
                                "eRxSent",
                                "FaxSent",
                                "Error",
                                "Deleted",
                                "Requested",
                                "Edited",
                                "EpcsError",
                                "EpcsSigned",
                                "ReadyToSign",
                                "PharmacyVerified",
                                "PharmacySelect",
                              ])
                              .describe(
                                "Valid prescription status types for DoseSpot.",
                              ),
                            zod.null(),
                          ])
                          .optional(),
                        Formulary: zod
                          .union([zod.boolean(), zod.null()])
                          .optional(),
                        EligibilityId: zod
                          .union([zod.number(), zod.null()])
                          .optional(),
                        Type: zod
                          .union([
                            zod
                              .enum([
                                "Coded",
                                "FreeText",
                                "NDC",
                                "Supply",
                                "Compound",
                              ])
                              .describe(
                                "Valid prescription types for DoseSpot.",
                              ),
                            zod.null(),
                          ])
                          .optional(),
                        NonDoseSpotPrescriptionId: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        ErrorIgnored: zod
                          .union([zod.boolean(), zod.null()])
                          .optional(),
                        SupplyId: zod
                          .union([zod.number(), zod.null()])
                          .optional(),
                        FreeTextType: zod
                          .union([
                            zod
                              .enum(["Medication", "Supply", "Compound"])
                              .describe(
                                "Valid free text types for DoseSpot prescriptions.",
                              ),
                            zod.null(),
                          ])
                          .optional(),
                        ClinicId: zod
                          .union([zod.number(), zod.null()])
                          .optional(),
                        SupervisorId: zod
                          .union([zod.number(), zod.null()])
                          .optional(),
                        IsUrgent: zod
                          .union([zod.boolean(), zod.null()])
                          .optional(),
                        IsRxRenewal: zod
                          .union([zod.boolean(), zod.null()])
                          .optional(),
                        RxRenewalNote: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        FirstPrescriptionDiagnosis: zod
                          .union([
                            zod
                              .object({
                                PrimaryDiagnosis: zod
                                  .union([
                                    zod
                                      .object({
                                        DiagnosisId: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        DiagnosisCode: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        DiagnosisDescription: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                      })
                                      .describe(
                                        "DoseSpot diagnosis information.",
                                      ),
                                    zod.null(),
                                  ])
                                  .optional(),
                                SecondaryDiagnosis: zod
                                  .union([
                                    zod
                                      .object({
                                        DiagnosisId: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        DiagnosisCode: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        DiagnosisDescription: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                      })
                                      .describe(
                                        "DoseSpot diagnosis information.",
                                      ),
                                    zod.null(),
                                  ])
                                  .optional(),
                              })
                              .describe(
                                "DoseSpot prescription diagnosis information.",
                              ),
                            zod.null(),
                          ])
                          .optional(),
                        SecondPrescriptionDiagnosis: zod
                          .union([
                            zod
                              .object({
                                PrimaryDiagnosis: zod
                                  .union([
                                    zod
                                      .object({
                                        DiagnosisId: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        DiagnosisCode: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        DiagnosisDescription: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                      })
                                      .describe(
                                        "DoseSpot diagnosis information.",
                                      ),
                                    zod.null(),
                                  ])
                                  .optional(),
                                SecondaryDiagnosis: zod
                                  .union([
                                    zod
                                      .object({
                                        DiagnosisId: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        DiagnosisCode: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        DiagnosisDescription: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                      })
                                      .describe(
                                        "DoseSpot diagnosis information.",
                                      ),
                                    zod.null(),
                                  ])
                                  .optional(),
                              })
                              .describe(
                                "DoseSpot prescription diagnosis information.",
                              ),
                            zod.null(),
                          ])
                          .optional(),
                        Strength: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        PatientMedicationId: zod
                          .union([zod.number(), zod.null()])
                          .optional(),
                        MedicationStatus: zod
                          .union([
                            zod
                              .enum([
                                "Unknown",
                                "Active",
                                "Inactive",
                                "Discontinued",
                                "Deleted",
                                "Completed",
                                "CancelRequested",
                                "CancelPending",
                                "Cancelled",
                                "CancelDenied",
                                "Changed",
                                "FullFill",
                                "PartialFill",
                                "NoFill",
                              ])
                              .describe(
                                "Valid medication status types for DoseSpot.",
                              ),
                            zod.null(),
                          ])
                          .optional(),
                        Comment: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        DateInactive: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        Encounter: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        DisplayName: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        DispensableDrugId: zod
                          .union([zod.number(), zod.null()])
                          .optional(),
                        Schedule: zod
                          .union([zod.number(), zod.null()])
                          .optional(),
                        CompoundIngredients: zod
                          .union([
                            zod.array(
                              zod
                                .object({
                                  DispensableDrugId: zod
                                    .union([zod.number(), zod.null()])
                                    .optional(),
                                  FreeText: zod
                                    .union([zod.string(), zod.null()])
                                    .optional(),
                                  DispenseUnitId: zod
                                    .union([zod.number(), zod.null()])
                                    .optional(),
                                  Quantity: zod.string(),
                                  IsFreeTextEPCS: zod
                                    .union([zod.boolean(), zod.null()])
                                    .optional(),
                                })
                                .describe(
                                  "DoseSpot compound ingredient information.",
                                ),
                            ),
                            zod.null(),
                          ])
                          .optional(),
                      })
                      .describe(
                        "Complete prescription information from DoseSpot API.",
                      ),
                  ),
                  zod.null(),
                ])
                .optional(),
              ClinicianId: zod.union([zod.number(), zod.null()]).optional(),
              ClinicId: zod.union([zod.number(), zod.null()]).optional(),
              PharmacyId: zod.union([zod.number(), zod.null()]).optional(),
              RequestedDate: zod.union([zod.string(), zod.null()]).optional(),
              OriginalPrescription: zod
                .union([
                  zod
                    .object({
                      PrescriptionId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      WrittenDate: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Directions: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Quantity: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DispenseUnitId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Refills: zod.union([zod.string(), zod.null()]).optional(),
                      DaysSupply: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      PharmacyId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      PharmacyNotes: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      NoSubstitutions: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      EffectiveDate: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      LastFillDate: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      PrescriberId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      PrescriberAgentId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      RxReferenceNumber: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Status: zod
                        .union([
                          zod
                            .enum([
                              "Unknown",
                              "Entered",
                              "Printed",
                              "Sending",
                              "eRxSent",
                              "FaxSent",
                              "Error",
                              "Deleted",
                              "Requested",
                              "Edited",
                              "EpcsError",
                              "EpcsSigned",
                              "ReadyToSign",
                              "PharmacyVerified",
                              "PharmacySelect",
                            ])
                            .describe(
                              "Valid prescription status types for DoseSpot.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      Formulary: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      EligibilityId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Type: zod
                        .union([
                          zod
                            .enum([
                              "Coded",
                              "FreeText",
                              "NDC",
                              "Supply",
                              "Compound",
                            ])
                            .describe("Valid prescription types for DoseSpot."),
                          zod.null(),
                        ])
                        .optional(),
                      NonDoseSpotPrescriptionId: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      ErrorIgnored: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      SupplyId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      FreeTextType: zod
                        .union([
                          zod
                            .enum(["Medication", "Supply", "Compound"])
                            .describe(
                              "Valid free text types for DoseSpot prescriptions.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      ClinicId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      SupervisorId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      IsUrgent: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      IsRxRenewal: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      RxRenewalNote: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      FirstPrescriptionDiagnosis: zod
                        .union([
                          zod
                            .object({
                              PrimaryDiagnosis: zod
                                .union([
                                  zod
                                    .object({
                                      DiagnosisId: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      DiagnosisCode: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      DiagnosisDescription: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "DoseSpot diagnosis information.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              SecondaryDiagnosis: zod
                                .union([
                                  zod
                                    .object({
                                      DiagnosisId: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      DiagnosisCode: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      DiagnosisDescription: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "DoseSpot diagnosis information.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                            })
                            .describe(
                              "DoseSpot prescription diagnosis information.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      SecondPrescriptionDiagnosis: zod
                        .union([
                          zod
                            .object({
                              PrimaryDiagnosis: zod
                                .union([
                                  zod
                                    .object({
                                      DiagnosisId: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      DiagnosisCode: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      DiagnosisDescription: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "DoseSpot diagnosis information.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              SecondaryDiagnosis: zod
                                .union([
                                  zod
                                    .object({
                                      DiagnosisId: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      DiagnosisCode: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      DiagnosisDescription: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "DoseSpot diagnosis information.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                            })
                            .describe(
                              "DoseSpot prescription diagnosis information.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      Strength: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      PatientMedicationId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      MedicationStatus: zod
                        .union([
                          zod
                            .enum([
                              "Unknown",
                              "Active",
                              "Inactive",
                              "Discontinued",
                              "Deleted",
                              "Completed",
                              "CancelRequested",
                              "CancelPending",
                              "Cancelled",
                              "CancelDenied",
                              "Changed",
                              "FullFill",
                              "PartialFill",
                              "NoFill",
                            ])
                            .describe(
                              "Valid medication status types for DoseSpot.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      Comment: zod.union([zod.string(), zod.null()]).optional(),
                      DateInactive: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Encounter: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DisplayName: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DispensableDrugId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Schedule: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      CompoundIngredients: zod
                        .union([
                          zod.array(
                            zod
                              .object({
                                DispensableDrugId: zod
                                  .union([zod.number(), zod.null()])
                                  .optional(),
                                FreeText: zod
                                  .union([zod.string(), zod.null()])
                                  .optional(),
                                DispenseUnitId: zod
                                  .union([zod.number(), zod.null()])
                                  .optional(),
                                Quantity: zod.string(),
                                IsFreeTextEPCS: zod
                                  .union([zod.boolean(), zod.null()])
                                  .optional(),
                              })
                              .describe(
                                "DoseSpot compound ingredient information.",
                              ),
                          ),
                          zod.null(),
                        ])
                        .optional(),
                    })
                    .describe(
                      "Complete prescription information from DoseSpot API.",
                    ),
                  zod.null(),
                ])
                .optional(),
              PayerName: zod.union([zod.string(), zod.null()]).optional(),
              DrugUseEvaluations: zod
                .union([
                  zod.array(
                    zod
                      .object({
                        Reason: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        Service: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        AckReason: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        Result: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        Significance: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                      })
                      .describe("Drug use evaluation information."),
                  ),
                  zod.null(),
                ])
                .optional(),
            })
            .describe("Detailed RxChange request information."),
        ),
        zod.null(),
      ])
      .optional(),
    PageResult: zod
      .union([
        zod
          .object({
            CurrentPage: zod.union([zod.number(), zod.null()]).optional(),
            TotalPages: zod.union([zod.number(), zod.null()]).optional(),
            PageSize: zod.union([zod.number(), zod.null()]).optional(),
            TotalCount: zod.union([zod.number(), zod.null()]).optional(),
            HasPrevious: zod.union([zod.boolean(), zod.null()]).optional(),
            HasNext: zod.union([zod.boolean(), zod.null()]).optional(),
          })
          .describe("DoseSpot page result information."),
        zod.null(),
      ])
      .optional(),
    Result: zod
      .union([
        zod
          .object({
            ResultCode: zod.string(),
            ResultDescription: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe("Standard DoseSpot API result object."),
        zod.null(),
      ])
      .optional(),
  })
  .describe("Paged list response for detailed RxChange requests.");

/**
 * Approve a pending RxChange request.

This endpoint approves an RxChange request, optionally providing a new prescription
or selecting from the requested medications.

Args:
    rx_change_id: The RxChange ID to approve
    request: The approval request containing optional new prescription details

Returns:
    IdentifierResponseT: Response from the approval operation

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record or approval fails
 * @summary Approve Rx Change
 */
export const approveRxChangeParams = zod.object({
  rx_change_id: zod.number(),
});

export const approveRxChangeBody = zod
  .object({
    PriorAuthNumber: zod.union([zod.string(), zod.null()]).optional(),
    SelectedMedicationId: zod.union([zod.number(), zod.null()]).optional(),
    NewPrescriptionPatientId: zod.union([zod.number(), zod.null()]).optional(),
    NewPrescription: zod
      .union([
        zod
          .object({
            DispensableDrugId: zod.number(),
            PatientFormularyId: zod
              .union([zod.number(), zod.null()])
              .optional(),
            Refills: zod.number(),
            DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
            DispenseUnitId: zod.number(),
            Quantity: zod.number(),
            Directions: zod.string(),
            PharmacyId: zod.number(),
            PharmacyNotes: zod.union([zod.string(), zod.null()]).optional(),
            NoSubstitutions: zod.union([zod.boolean(), zod.null()]).optional(),
            EffectiveDate: zod.string(),
            RxReferenceNumber: zod.union([zod.string(), zod.null()]).optional(),
            EligibilityId: zod.union([zod.number(), zod.null()]).optional(),
            NonDoseSpotPrescriptionId: zod
              .union([zod.string(), zod.null()])
              .optional(),
            FirstPrescriptionDiagnosis: zod
              .union([
                zod
                  .object({
                    PrimaryDiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    SecondaryDiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                  })
                  .describe(
                    "DoseSpot prescription diagnosis IDs for requests.",
                  ),
                zod.null(),
              ])
              .optional(),
            SecondPrescriptionDiagnosis: zod
              .union([
                zod
                  .object({
                    PrimaryDiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    SecondaryDiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                  })
                  .describe(
                    "DoseSpot prescription diagnosis IDs for requests.",
                  ),
                zod.null(),
              ])
              .optional(),
            IsRefillReplace: zod.union([zod.boolean(), zod.null()]).optional(),
            IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
            SupervisorId: zod.union([zod.number(), zod.null()]).optional(),
            RetailPharmacyToMailToPatient: zod
              .union([zod.boolean(), zod.null()])
              .optional(),
            Status: zod
              .enum([
                "Unknown",
                "Active",
                "Inactive",
                "Discontinued",
                "Deleted",
                "Completed",
                "CancelRequested",
                "CancelPending",
                "Cancelled",
                "CancelDenied",
                "Changed",
                "FullFill",
                "PartialFill",
                "NoFill",
              ])
              .describe("Valid medication status types for DoseSpot."),
            InactiveDate: zod.union([zod.string(), zod.null()]).optional(),
            Comment: zod.union([zod.string(), zod.null()]).optional(),
            Encounter: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe("Request for coded prescription creation/editing."),
        zod.null(),
      ])
      .optional(),
    Comment: zod.union([zod.string(), zod.null()]).optional(),
    PrescriberAuthorizationData: zod
      .union([zod.string(), zod.null()])
      .optional(),
    PrescriberLicenseInactive: zod
      .union([zod.boolean(), zod.null()])
      .optional(),
  })
  .describe("Request to approve an RxChange.");

export const approveRxChangeResponse = zod
  .object({
    Id: zod.union([zod.number(), zod.null()]).optional(),
    Result: zod
      .union([
        zod
          .object({
            ResultCode: zod.string(),
            ResultDescription: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe("Standard DoseSpot API result object."),
        zod.null(),
      ])
      .optional(),
  })
  .describe(
    "Response wrapper for operations that return an entity identifier.",
  );

/**
 * Deny a pending RxChange request.

This endpoint denies an RxChange request by providing the denial reason
and optional comment.

Args:
    rx_change_id: The RxChange ID to deny
    request: The denial request containing denial reason and optional comment

Returns:
    ResponseT: Response from the denial operation

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record or denial fails
 * @summary Deny Rx Change
 */
export const denyRxChangeParams = zod.object({
  rx_change_id: zod.number(),
});

export const denyRxChangeBody = zod
  .object({
    Reason: zod
      .enum([
        "DeniedPatientUnknown",
        "DeniedPatientNotUnderCare",
        "DeniedPatientNoLongerUnderPatientCare",
        "DeniedNeverPrescribed",
        "DeniedHavePatientContact",
        "DeniedChangeInappropriate",
        "DeniedNeedAppointment",
        "DeniedPrescriberNotAssociateWithLocation",
        "DeniedNoPriorAuthAttempt",
        "DeniedAlreadyHandled",
        "DeniedAtPatientRequest",
        "DeniedPriorAuthNoAttempt",
        "DeniedPriorAuthInProgress",
        "DeniedOrderNotFound",
        "DeniedPayerNoPriorAuth",
        "DeniedPatientNoRecord",
        "DeniedOrderExpired",
        "DeniedPharmacyNotRecognized",
      ])
      .describe("Reasons for denying an RxChange request."),
    Comment: zod.union([zod.string(), zod.null()]).optional(),
  })
  .describe("Request to deny an RxChange.");

export const denyRxChangeResponse = zod
  .object({
    Result: zod
      .union([
        zod
          .object({
            ResultCode: zod.string(),
            ResultDescription: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe("Standard DoseSpot API result object."),
        zod.null(),
      ])
      .optional(),
  })
  .describe("Generic response wrapper for operations that don't return data.");

/**
 * Perform an action on a pending RxChange request.

Accepts a discriminated-union body whose ``action`` field selects
approve, deny, or approve_with_changes.  Used by the copilot
proposed-action form so the clinician can review and submit in one step.
 * @summary Rx Change Action
 */
export const rxChangeActionParams = zod.object({
  rx_change_id: zod.number(),
});

export const rxChangeActionBodyActionDefault = "approve";
export const rxChangeActionBodyActionDefaultOne = "deny";
export const rxChangeActionBodyActionDefaultTwo = "approve_with_changes";

export const rxChangeActionBody = zod.union([
  zod.object({
    action: zod.literal("approve").default(rxChangeActionBodyActionDefault),
    selectedMedicationId: zod.union([zod.number(), zod.null()]).optional(),
    priorAuthNumber: zod.union([zod.string(), zod.null()]).optional(),
    comment: zod.union([zod.string(), zod.null()]).optional(),
  }),
  zod.object({
    action: zod.literal("deny").default(rxChangeActionBodyActionDefaultOne),
    denialReason: zod
      .enum([
        "DeniedPatientUnknown",
        "DeniedPatientNotUnderCare",
        "DeniedPatientNoLongerUnderPatientCare",
        "DeniedNeverPrescribed",
        "DeniedHavePatientContact",
        "DeniedChangeInappropriate",
        "DeniedNeedAppointment",
        "DeniedPrescriberNotAssociateWithLocation",
        "DeniedNoPriorAuthAttempt",
        "DeniedAlreadyHandled",
        "DeniedAtPatientRequest",
        "DeniedPriorAuthNoAttempt",
        "DeniedPriorAuthInProgress",
        "DeniedOrderNotFound",
        "DeniedPayerNoPriorAuth",
        "DeniedPatientNoRecord",
        "DeniedOrderExpired",
        "DeniedPharmacyNotRecognized",
      ])
      .optional()
      .describe("Reasons for denying an RxChange request."),
    comment: zod.union([zod.string(), zod.null()]).optional(),
  }),
  zod.object({
    action: zod
      .literal("approve_with_changes")
      .default(rxChangeActionBodyActionDefaultTwo),
    patientUserId: zod.string(),
    newPrescription: zod
      .object({
        DispensableDrugId: zod.number(),
        PatientFormularyId: zod.union([zod.number(), zod.null()]).optional(),
        Refills: zod.number(),
        DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
        DispenseUnitId: zod.number(),
        Quantity: zod.number(),
        Directions: zod.string(),
        PharmacyId: zod.number(),
        PharmacyNotes: zod.union([zod.string(), zod.null()]).optional(),
        NoSubstitutions: zod.union([zod.boolean(), zod.null()]).optional(),
        EffectiveDate: zod.string(),
        RxReferenceNumber: zod.union([zod.string(), zod.null()]).optional(),
        EligibilityId: zod.union([zod.number(), zod.null()]).optional(),
        NonDoseSpotPrescriptionId: zod
          .union([zod.string(), zod.null()])
          .optional(),
        FirstPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                SecondaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis IDs for requests."),
            zod.null(),
          ])
          .optional(),
        SecondPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                SecondaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis IDs for requests."),
            zod.null(),
          ])
          .optional(),
        IsRefillReplace: zod.union([zod.boolean(), zod.null()]).optional(),
        IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
        SupervisorId: zod.union([zod.number(), zod.null()]).optional(),
        RetailPharmacyToMailToPatient: zod
          .union([zod.boolean(), zod.null()])
          .optional(),
        Status: zod
          .enum([
            "Unknown",
            "Active",
            "Inactive",
            "Discontinued",
            "Deleted",
            "Completed",
            "CancelRequested",
            "CancelPending",
            "Cancelled",
            "CancelDenied",
            "Changed",
            "FullFill",
            "PartialFill",
            "NoFill",
          ])
          .describe("Valid medication status types for DoseSpot."),
        InactiveDate: zod.union([zod.string(), zod.null()]).optional(),
        Comment: zod.union([zod.string(), zod.null()]).optional(),
        Encounter: zod.union([zod.string(), zod.null()]).optional(),
      })
      .describe("Request for coded prescription creation/editing."),
    comment: zod.union([zod.string(), zod.null()]).optional(),
  }),
]);

export const rxChangeActionResponse = zod.union([
  zod
    .object({
      Id: zod.union([zod.number(), zod.null()]).optional(),
      Result: zod
        .union([
          zod
            .object({
              ResultCode: zod.string(),
              ResultDescription: zod
                .union([zod.string(), zod.null()])
                .optional(),
            })
            .describe("Standard DoseSpot API result object."),
          zod.null(),
        ])
        .optional(),
    })
    .describe(
      "Response wrapper for operations that return an entity identifier.",
    ),
  zod
    .object({
      Result: zod
        .union([
          zod
            .object({
              ResultCode: zod.string(),
              ResultDescription: zod
                .union([zod.string(), zod.null()])
                .optional(),
            })
            .describe("Standard DoseSpot API result object."),
          zod.null(),
        ])
        .optional(),
    })
    .describe(
      "Generic response wrapper for operations that don't return data.",
    ),
]);

/**
 * Reconcile an RxChange request by linking it to a patient record.

This endpoint links an existing RxChange request to a patient record
and associates it with a referenced prescription.

Args:
    rx_change_id: The RxChange ID to reconcile
    user_id: The patient's user ID
    request: The reconciliation request containing the referenced prescription ID

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the patient has no DoseSpot record or reconciliation fails
 * @summary Reconcile Rx Change
 */
export const reconcileRxChangeParams = zod.object({
  rx_change_id: zod.number(),
  user_id: zod.uuid(),
});

export const reconcileRxChangeBody = zod.object({
  referencedPrescriptionId: zod.string(),
});

export const reconcileRxChangeResponse = zod.unknown();

/**
 * Change the patient linked to an RxChange request.

This endpoint links the RxChange request to a different, existing patient
in the same clinic.

Args:
    rx_change_id: The RxChange ID to update
    request: The request containing the new patient's user ID

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the patient has no DoseSpot record or change fails
 * @summary Change Rx Change Patient
 */
export const changeRxChangePatientParams = zod.object({
  rx_change_id: zod.number(),
});

export const changeRxChangePatientBody = zod.object({
  patientUserId: zod.uuid(),
});

export const changeRxChangePatientResponse = zod.unknown();

/**
 * List all prior authorization cases for a given patient.

Drives the Prior Auths tab in the copilot patient workspace. Results
are served from our SQL mirror (``DosespotPriorAuthRecord``), not live
DoseSpot, so the list stays consistent with the clinician inbox even
when DoseSpot is slow.
 * @summary List Patient Prior Auths
 */
export const listPatientPriorAuthsParams = zod.object({
  user_id: zod.uuid(),
});

export const listPatientPriorAuthsResponseItem = zod
  .object({
    id: zod.string(),
    dosespotPriorAuthCaseNumber: zod
      .union([zod.string(), zod.null()])
      .optional(),
    dosespotPrescriptionId: zod.string(),
    prescriptionRecordId: zod.string(),
    status: zod
      .enum([
        "Requested",
        "Appealing",
        "Cancel Requested",
        "Action Required",
        "Approved",
        "Partially Approved",
        "Not Required",
        "Denied",
        "Cancelled",
        "Error",
        "Sent to Pharmacy",
      ])
      .describe(
        'Normalized prior-authorization status.\n\nCollapses DoseSpot\'s 17-value `PriorAuthorizationStatusType` plus the\n25-value `ClosedReasonCodeId` super-status into an \"owns it right now\"\noriented enum. The full mapping from raw DoseSpot status lives on the PA\npoller (`_map_dosespot_status`) and is documented in `PRIOR_AUTH.md`.\n\n``NOT_REQUIRED`` is deliberately distinct from ``APPROVED`` (no auth\nnumber) and ``PARTIALLY_APPROVED`` is distinct from ``APPROVED`` because\nit comes with a narrower Quantity/DaysSupply/NumberOfRefills that the\nclinician must acknowledge or appeal.\n\n``StrEnum`` (not plain ``Enum``) because the values round-trip through\nthe ``dosespot_prior_auth_records.normalized_status`` ``TEXT`` column:\nasyncpg only accepts ``str`` for ``TEXT`` bind parameters, and a plain\n``Enum`` instance is not a ``str`` subclass.',
      ),
    currentStatus: zod.string(),
    isExpedited: zod.boolean(),
    attachmentRequired: zod.boolean(),
    isOffline: zod.boolean(),
    canAppeal: zod.union([zod.boolean(), zod.null()]).optional(),
    authorizationNumber: zod.union([zod.string(), zod.null()]).optional(),
    nextResponseDeadline: zod.union([zod.string(), zod.null()]).optional(),
    currentStatusDate: zod.string(),
    lastSeenAt: zod.union([zod.string(), zod.null()]).optional(),
  })
  .describe(
    "Slim per-patient listing item.\n\nThe ``/greenfield/dosespot/patients/{user_id}/prior_auths`` endpoint\nreturns a list of these so the Prior Auths tab can render without\npulling the full cached DoseSpot case for every row.",
  );
export const listPatientPriorAuthsResponse = zod.array(
  listPatientPriorAuthsResponseItem,
);

/**
 * Live ``GET /api/patients/{id}/eligibilities`` against DoseSpot.

Drives the Eligibilities sub-section under the Prior Auths tab in
the copilot patient workspace. Unlike the prior-auth list, this is
*live* against DoseSpot — coverages can change as PBM data updates
and we don't mirror them locally. The fake DoseSpot answers from its
in-memory ``CoverageEntry`` table; staging answers from real PBM
data.

Authenticates as the requesting clinician so the audit trail
attributes the eligibility lookup correctly. Falls back to the
clinic admin user when the requesting user has no DoseSpot
clinician record (so non-prescriber roles can still read coverages).
 * @summary List Patient Eligibilities
 */
export const listPatientEligibilitiesParams = zod.object({
  user_id: zod.uuid(),
});

export const listPatientEligibilitiesResponse = zod
  .object({
    dosespotPatientId: zod.number(),
    items: zod.array(
      zod
        .object({
          PatientEligibilityId: zod
            .union([zod.number(), zod.null()])
            .optional(),
          PayerName: zod.union([zod.string(), zod.null()]).optional(),
          PharmacyEligibilities: zod
            .union([
              zod.array(
                zod
                  .object({
                    PharmacyType: zod
                      .union([
                        zod
                          .enum([
                            "Any",
                            "FaxPharmacy",
                            "EPCS",
                            "TwentyFourHourPharmacy",
                            "LongTermCarePharmacy",
                            "MailOrder",
                            "Retail",
                            "SpecialtyPharmacy",
                          ])
                          .describe(
                            "Valid pharmacy specialty types for DoseSpot.",
                          ),
                        zod.null(),
                      ])
                      .optional(),
                    EligibilityStatus: zod
                      .union([
                        zod
                          .enum([
                            "Covered",
                            "NotCovered",
                            "OutOfPocket",
                            "Unknown",
                            "UnableToProcess",
                          ])
                          .describe(
                            "`EligibilityStatus` on a `PharmacyEligibility` entry.",
                          ),
                        zod.null(),
                      ])
                      .optional(),
                    Name: zod.union([zod.string(), zod.null()]).optional(),
                  })
                  .describe(
                    "Per-channel eligibility entry on a `PayerInformationResponse`.\n\nEach coverage reports one of these per pharmacy type so the Rx-time\ngate can pick the coverage that actually covers the channel the\nprescription is routed to (e.g. Retail vs MailOrder).",
                  ),
              ),
              zod.null(),
            ])
            .optional(),
          PlanName: zod.union([zod.string(), zod.null()]).optional(),
          CoverageId: zod.union([zod.string(), zod.null()]).optional(),
          PayerId: zod.union([zod.string(), zod.null()]).optional(),
          BIN: zod.union([zod.string(), zod.null()]).optional(),
          PCN: zod.union([zod.string(), zod.null()]).optional(),
          FormularyId: zod.union([zod.string(), zod.null()]).optional(),
          AlternativesId: zod.union([zod.string(), zod.null()]).optional(),
          CopayId: zod.union([zod.string(), zod.null()]).optional(),
          DemographicChanges: zod.union([zod.boolean(), zod.null()]).optional(),
          Demographics: zod
            .union([
              zod
                .object({
                  LastName: zod.union([zod.string(), zod.null()]).optional(),
                  FirstName: zod.union([zod.string(), zod.null()]).optional(),
                  MiddleName: zod.union([zod.string(), zod.null()]).optional(),
                  Suffix: zod.union([zod.string(), zod.null()]).optional(),
                  DateOfBirth: zod.union([zod.string(), zod.null()]).optional(),
                  Gender: zod
                    .union([
                      zod
                        .enum(["Male", "Female", "Unknown"])
                        .describe(
                          "`PayerDemographics.Gender` and `CoverageRestrictions.GenderRestriction` values.",
                        ),
                      zod.null(),
                    ])
                    .optional(),
                  Address: zod
                    .union([
                      zod
                        .object({
                          AddressLine1: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                          AddressLine2: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                          City: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                          State: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                          ZipCode: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                        })
                        .describe(
                          "`PayerAddress` sub-object on :class:`PayerDemographicsT`.",
                        ),
                      zod.null(),
                    ])
                    .optional(),
                })
                .describe(
                  "`PayerDemographics` block on :class:`PayerInformationT`.\n\nSurfaced when the payer returns updated member demographics on an\neligibility response (combined with ``DemographicChanges=true``).",
                ),
              zod.null(),
            ])
            .optional(),
          ErrorMessage: zod.union([zod.string(), zod.null()]).optional(),
          InfoMessage: zod.union([zod.string(), zod.null()]).optional(),
          MemberId: zod.union([zod.string(), zod.null()]).optional(),
        })
        .describe(
          "One active coverage for a patient (`PayerInformationResponse`).\n\nReturned by `GET /api/patients/{patient_id}/eligibilities`. The gate\nkeys subsequent `/formulary` and `/prescriptionbenefits` calls on\n``PatientEligibilityId``; the other ids (`CoverageId`, `FormularyId`,\n...) are carried through for audit but not otherwise consulted.\n\nFields match the DoseSpot v2 swagger `PayerInformationResponse`\ndefinition exactly. No `GroupId` here — that's a legacy field from\nthe v1 shape and was dropped when v2 consolidated onto `MemberId` +\n``Demographics``.",
        ),
    ),
  })
  .describe(
    'Wrapper around DoseSpot\'s ``/eligibilities`` payload for the copilot UI.\n\nCarries the resolved ``dosespot_patient_id`` alongside the items so\nthe UI can deep-link into the fake DoseSpot admin (or just show\n\"patient #50000\" for debugging) without a second round-trip.\n``items`` is empty (not omitted) when the patient has no active\ncoverages — same shape DoseSpot itself returns.',
  );

/**
 * Full detail view of a PA case, including the pending question.

``record_id`` is our internal ``DosespotPriorAuthRecord.id`` (UUID7),
not DoseSpot's integer case id — this keeps the copilot URL scheme
stable across patient re-syncs. The handler resolves to the DoseSpot
case id on the server side. Every persisted record has a case
number, so that resolution never fails on an unset case id.

Returns 404 when the record is unknown.
 * @summary Get Prior Auth Details
 */
export const getPriorAuthDetailsParams = zod.object({
  record_id: zod.uuid(),
});

export const getPriorAuthDetailsResponse = zod
  .object({
    case: zod
      .object({
        PriorAuthorizationCaseId: zod
          .union([zod.number(), zod.null()])
          .optional(),
        PrescriptionId: zod.union([zod.number(), zod.null()]).optional(),
        CaseAlias: zod.union([zod.string(), zod.null()]).optional(),
        Note: zod.union([zod.string(), zod.null()]).optional(),
        IsOffline: zod.union([zod.boolean(), zod.null()]).optional(),
        InitializedDate: zod
          .union([zod.iso.datetime({}), zod.null()])
          .optional(),
        NextResponseDeadline: zod
          .union([zod.iso.datetime({}), zod.null()])
          .optional(),
        CurrentStatus: zod
          .union([
            zod
              .enum([
                "Unknown",
                "Requested",
                "NotRequired",
                "Closed",
                "Deferred",
                "ActionRequired",
                "Pending",
                "Approved",
                "Denied",
                "AppealRequested",
                "CancelRequested",
                "Canceled",
                "CancelDenied",
                "Error",
                "Deleted",
                "PartiallyDenied",
                "InProcess",
              ])
              .describe(
                "Raw `PriorAuthorizationStatusType` values returned by DoseSpot.\n\nAll 17 values from the v2 `PriorAuthorizationStatusType` enum. We collapse\nthese (plus `ClosedReasonCodeId` on `Closed`) into a smaller internal\n`CareStatePriorAuthStatusT` in the poller; the raw string is still stored\non `DosespotPriorAuthRecord.current_status` for observability.",
              ),
            zod.null(),
          ])
          .optional(),
        CurrentStatusDate: zod
          .union([zod.iso.datetime({}), zod.null()])
          .optional(),
        ExpectedResponseDate: zod
          .union([zod.iso.datetime({}), zod.null()])
          .optional(),
        AttachmentRequired: zod.union([zod.boolean(), zod.null()]).optional(),
        NextQuestionId: zod.union([zod.number(), zod.null()]).optional(),
        IsExpedited: zod.union([zod.boolean(), zod.null()]).optional(),
        FinalStatus: zod
          .union([
            zod
              .object({
                PriorAuthorizationStatusType: zod
                  .union([
                    zod
                      .enum([
                        "Unknown",
                        "Requested",
                        "NotRequired",
                        "Closed",
                        "Deferred",
                        "ActionRequired",
                        "Pending",
                        "Approved",
                        "Denied",
                        "AppealRequested",
                        "CancelRequested",
                        "Canceled",
                        "CancelDenied",
                        "Error",
                        "Deleted",
                        "PartiallyDenied",
                        "InProcess",
                      ])
                      .describe(
                        "Raw `PriorAuthorizationStatusType` values returned by DoseSpot.\n\nAll 17 values from the v2 `PriorAuthorizationStatusType` enum. We collapse\nthese (plus `ClosedReasonCodeId` on `Closed`) into a smaller internal\n`CareStatePriorAuthStatusT` in the poller; the raw string is still stored\non `DosespotPriorAuthRecord.current_status` for observability.",
                      ),
                    zod.null(),
                  ])
                  .optional(),
                ClosedReasonCodeId: zod
                  .union([
                    zod
                      .enum([
                        "Unknown",
                        "ElectronicPriorAuthNotSupported",
                        "Other",
                        "PriorAuthNotRequired",
                        "CannotFindMatchingPatient",
                        "PatientNotEligible",
                        "PriorAuthDuplicateApproved",
                        "PriorAuthDuplicateInProcess",
                        "ClosedByPayer",
                        "ClosedByProvider",
                        "ClosedByMember",
                        "AttachmentTypeNotSupported",
                        "PrescriberNotAllowedToSubmitPARequest",
                        "ResponseInconsistentWithQuestion",
                        "ReceiverNotPAProcessorForThisPatient",
                        "ReceiverNotPAProcessorForPatientMedicationCombo",
                        "DuplicateDenied",
                        "ProviderRespondedAfterDeadlineToReply",
                        "ProductNotCoveredByThisPlanPriorAuthorizationNotAvailable",
                        "PrescriptionWithinPrescribingLimitsPriorAuthorizationNotRequiredForPatientMedication",
                        "CoverageLimitsMayExistForQuantityAndOrDaysSupply",
                        "CoverageLimitsHaveBeenExceededExceptionNotAvailable",
                        "ActivePAOnFile",
                        "SubmittedProductCodeIsNotValid",
                      ])
                      .describe(
                        "Raw `ClosedReasonCodeId` values on a `Closed` PA case.\n\nAll 25 values from the v2 `ClosedReasonCodeId` enum. Combined with the\n`Closed` super-status these disambiguate terminal outcomes (see\n`PRIOR_AUTH.md` for the mapping to our normalized status).",
                      ),
                    zod.null(),
                  ])
                  .optional(),
                AuthorizationNumber: zod
                  .union([zod.string(), zod.null()])
                  .optional(),
                AuthorizationPeriodStart: zod
                  .union([zod.iso.datetime({}), zod.null()])
                  .optional(),
                AuthorizationPeriodEnd: zod
                  .union([zod.iso.datetime({}), zod.null()])
                  .optional(),
                PharmacyType: zod
                  .union([
                    zod
                      .enum([
                        "Unknown",
                        "Retail",
                        "MailOrder",
                        "SpecialtyPharmacy",
                        "LongTermCarePharmacy",
                        "Any",
                        "TwentyFourHourPharmacy",
                        "FaxPharmacy",
                        "EPCS",
                        "InHouseDispensing",
                        "Compounding",
                        "DME",
                        "Kiosk",
                        "SupportsDigitalSignature",
                        "FaxPharmacyExternal",
                      ])
                      .describe(
                        "Raw `PharmacyType` values returned on `PAFinalStatus`.\n\nAll 15 values from the v2 `PharmacyType` enum. Carried through to\n`DosespotPriorAuthRecord.pharmacy_type` so downstream Rx routing can be\nconstrained to match the approved channel.",
                      ),
                    zod.null(),
                  ])
                  .optional(),
                Quantity: zod.union([zod.string(), zod.null()]).optional(),
                DaysSupply: zod.union([zod.string(), zod.null()]).optional(),
                NumberOfCycles: zod
                  .union([zod.string(), zod.null()])
                  .optional(),
                NumberOfRefills: zod
                  .union([zod.string(), zod.null()])
                  .optional(),
                Note: zod.union([zod.string(), zod.null()]).optional(),
                CanAppeal: zod.union([zod.boolean(), zod.null()]).optional(),
              })
              .describe(
                "Terminal-state details on a closed PA case (`PAFinalStatus`).\n\n`PriorAuthorizationStatusType` holds the underlying DoseSpot status; for\ntruly closed cases `ClosedReasonCodeId` disambiguates approval vs. denial\nvs. not-required. `Quantity`, `DaysSupply`, `NumberOfCycles`, and\n`NumberOfRefills` are the payer's narrowed scope — all strings per the\nswagger — and drive downstream prescription-constraint enforcement.",
              ),
            zod.null(),
          ])
          .optional(),
        AppealDetails: zod
          .union([
            zod
              .object({
                AppealCaseId: zod.union([zod.string(), zod.null()]).optional(),
                NotesForAppeal: zod
                  .union([zod.string(), zod.null()])
                  .optional(),
                AppealReason: zod.union([zod.string(), zod.null()]).optional(),
              })
              .describe(
                "Appeal metadata for an appealed PA case (`PAAppealDetails`).",
              ),
            zod.null(),
          ])
          .optional(),
        CancelDetails: zod
          .union([
            zod
              .object({
                CancelReason: zod.union([zod.string(), zod.null()]).optional(),
              })
              .describe(
                "Cancellation metadata for a cancelled PA case (`PACancelDetails`).",
              ),
            zod.null(),
          ])
          .optional(),
        Attachments: zod
          .union([
            zod.array(
              zod
                .object({
                  AttachmentId: zod
                    .union([zod.number(), zod.null()])
                    .optional(),
                  CreatedDateStamp: zod
                    .union([zod.iso.datetime({}), zod.null()])
                    .optional(),
                  FileName: zod.union([zod.string(), zod.null()]).optional(),
                  IsOutbound: zod.union([zod.boolean(), zod.null()]).optional(),
                })
                .describe("A single attachment on a PA case (`PAAttachment`)."),
            ),
            zod.null(),
          ])
          .optional(),
      })
      .describe(
        "Full details of a PA case (`PriorAuthorizationCaseFullDetails`).\n\nReturned by `GET /api/priorAuths/{id}` and list items under\n`GET /api/patients/{patientId}/priorAuths`. The whole payload is also\nstored verbatim on `DosespotPriorAuthRecord.cached_case` so downstream\nprocessing has access to every field (including `FinalStatus.Quantity` /\n`DaysSupply` / `NumberOfCycles` / `NumberOfRefills`).",
      ),
    history: zod
      .object({
        FinalStatus: zod.union([zod.string(), zod.null()]).optional(),
        AuthorizationNumber: zod.union([zod.string(), zod.null()]).optional(),
        EffectiveDate: zod.union([zod.iso.datetime({}), zod.null()]).optional(),
        ExpirationDate: zod
          .union([zod.iso.datetime({}), zod.null()])
          .optional(),
        Note: zod.union([zod.string(), zod.null()]).optional(),
        CanAppeal: zod.union([zod.string(), zod.null()]).optional(),
        IsOffline: zod.union([zod.boolean(), zod.null()]).optional(),
        Attachments: zod
          .union([
            zod.array(
              zod
                .object({
                  AttachmentId: zod
                    .union([zod.number(), zod.null()])
                    .optional(),
                  CreatedDateStamp: zod
                    .union([zod.iso.datetime({}), zod.null()])
                    .optional(),
                  FileName: zod.union([zod.string(), zod.null()]).optional(),
                  IsOutbound: zod.union([zod.boolean(), zod.null()]).optional(),
                })
                .describe("A single attachment on a PA case (`PAAttachment`)."),
            ),
            zod.null(),
          ])
          .optional(),
        StatusLogs: zod
          .union([
            zod.array(
              zod
                .object({
                  Status: zod.union([zod.string(), zod.null()]).optional(),
                  AdditionalInfo: zod
                    .union([zod.string(), zod.null()])
                    .optional(),
                  AdditionalInfoAttachmentId: zod
                    .union([zod.number(), zod.null()])
                    .optional(),
                  CreatedDateStamp: zod
                    .union([zod.iso.datetime({}), zod.null()])
                    .optional(),
                  Attachment: zod
                    .union([
                      zod
                        .object({
                          AttachmentId: zod
                            .union([zod.number(), zod.null()])
                            .optional(),
                          CreatedDateStamp: zod
                            .union([zod.iso.datetime({}), zod.null()])
                            .optional(),
                          FileName: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                          IsOutbound: zod
                            .union([zod.boolean(), zod.null()])
                            .optional(),
                        })
                        .describe(
                          "A single attachment on a PA case (`PAAttachment`).",
                        ),
                      zod.null(),
                    ])
                    .optional(),
                })
                .describe(
                  "A single row in a PA status log.\n\nUnified shape covering both `PAStatusLog` (embedded in the history\nresponse — carries `AdditionalInfoAttachmentId`) and `PriorAuthStatusLogUI`\n(the `/statusLog` endpoint — carries a fully-expanded `Attachment`). Only\none of the attachment fields is populated per row depending on the source.",
                ),
            ),
            zod.null(),
          ])
          .optional(),
        QuestionSets: zod
          .union([
            zod.array(
              zod
                .object({
                  PriorAuthorizationQuestionSetId: zod
                    .union([zod.number(), zod.null()])
                    .optional(),
                  QuestionSetAlias: zod
                    .union([zod.string(), zod.null()])
                    .optional(),
                  Title: zod.union([zod.string(), zod.null()]).optional(),
                  AnsweredQuestions: zod
                    .union([
                      zod.array(
                        zod
                          .object({
                            Question: zod
                              .union([zod.string(), zod.null()])
                              .optional(),
                            Answers: zod
                              .union([
                                zod.array(
                                  zod
                                    .object({
                                      Answer: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      AnswerDateTime: zod
                                        .union([
                                          zod.iso.datetime({}),
                                          zod.null(),
                                        ])
                                        .optional(),
                                      AnswerNumeric: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      AnswerFreeText: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "One captured answer in a PA question history (`PAAnswers`).\n\nOnly one of `AnswerDateTime` / `AnswerNumeric` / `AnswerFreeText` /\n`Answer` is populated per row, determined by the question's\n`PriorAuthorizationAnswerTypeT`.",
                                    ),
                                ),
                                zod.null(),
                              ])
                              .optional(),
                          })
                          .describe(
                            "A question together with its answers (`PAAnsweredQuestions`).",
                          ),
                      ),
                      zod.null(),
                    ])
                    .optional(),
                  Attachments: zod
                    .union([
                      zod.array(
                        zod
                          .object({
                            AttachmentId: zod
                              .union([zod.number(), zod.null()])
                              .optional(),
                            CreatedDateStamp: zod
                              .union([zod.iso.datetime({}), zod.null()])
                              .optional(),
                            FileName: zod
                              .union([zod.string(), zod.null()])
                              .optional(),
                            IsOutbound: zod
                              .union([zod.boolean(), zod.null()])
                              .optional(),
                          })
                          .describe(
                            "A single attachment on a PA case (`PAAttachment`).",
                          ),
                      ),
                      zod.null(),
                    ])
                    .optional(),
                })
                .describe(
                  "One question-set block inside a PA history (`PAHistoryQuestionSet`).",
                ),
            ),
            zod.null(),
          ])
          .optional(),
        Result: zod
          .union([
            zod
              .object({
                ResultCode: zod.string(),
                ResultDescription: zod
                  .union([zod.string(), zod.null()])
                  .optional(),
              })
              .describe("Standard DoseSpot API result object."),
            zod.null(),
          ])
          .optional(),
      })
      .describe(
        "Full PA history payload (`PriorAuthorizationHistoryResponse`).\n\nStored verbatim on `DosespotPriorAuthRecord.cached_history` so the\nquestion/answer trail and status log remain available for audit and\ncopilot context.",
      ),
    statusLog: zod
      .object({
        StatusLog: zod
          .union([
            zod.array(
              zod
                .object({
                  Status: zod.union([zod.string(), zod.null()]).optional(),
                  AdditionalInfo: zod
                    .union([zod.string(), zod.null()])
                    .optional(),
                  AdditionalInfoAttachmentId: zod
                    .union([zod.number(), zod.null()])
                    .optional(),
                  CreatedDateStamp: zod
                    .union([zod.iso.datetime({}), zod.null()])
                    .optional(),
                  Attachment: zod
                    .union([
                      zod
                        .object({
                          AttachmentId: zod
                            .union([zod.number(), zod.null()])
                            .optional(),
                          CreatedDateStamp: zod
                            .union([zod.iso.datetime({}), zod.null()])
                            .optional(),
                          FileName: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                          IsOutbound: zod
                            .union([zod.boolean(), zod.null()])
                            .optional(),
                        })
                        .describe(
                          "A single attachment on a PA case (`PAAttachment`).",
                        ),
                      zod.null(),
                    ])
                    .optional(),
                })
                .describe(
                  "A single row in a PA status log.\n\nUnified shape covering both `PAStatusLog` (embedded in the history\nresponse — carries `AdditionalInfoAttachmentId`) and `PriorAuthStatusLogUI`\n(the `/statusLog` endpoint — carries a fully-expanded `Attachment`). Only\none of the attachment fields is populated per row depending on the source.",
                ),
            ),
            zod.null(),
          ])
          .optional(),
        Result: zod
          .union([
            zod
              .object({
                ResultCode: zod.string(),
                ResultDescription: zod
                  .union([zod.string(), zod.null()])
                  .optional(),
              })
              .describe("Standard DoseSpot API result object."),
            zod.null(),
          ])
          .optional(),
      })
      .describe(
        "UI-oriented status log response (`PriorAuthorizationStatusLogUIResponse`).",
      ),
    pendingQuestion: zod
      .union([
        zod
          .object({
            QuestionText: zod.union([zod.string(), zod.null()]).optional(),
            AnswerType: zod
              .union([
                zod
                  .enum([
                    "Select",
                    "Multiselect",
                    "Date",
                    "DateTime",
                    "Numeric",
                    "FreeText",
                  ])
                  .describe(
                    "Kind of answer a PA question expects.\n\nDrives which form widget the clinician UI renders for each question and,\nconsequently, which field(s) of ``PriorAuthorizationAnswerRequestT`` must\nbe populated when submitting the answer.",
                  ),
                zod.null(),
              ])
              .optional(),
            AnswerChoices: zod
              .union([
                zod.array(
                  zod
                    .object({
                      QuestionChoiceId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      QuestionChoiceText: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      AdditionalFreeTextRequired: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      AdditionalFreeTextAllowed: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                    })
                    .describe(
                      "One selectable choice on a PA question (`PriorAuthorizationQuestionResponseChoice`).",
                    ),
                ),
                zod.null(),
              ])
              .optional(),
            Result: zod
              .union([
                zod
                  .object({
                    ResultCode: zod.string(),
                    ResultDescription: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                  })
                  .describe("Standard DoseSpot API result object."),
                zod.null(),
              ])
              .optional(),
          })
          .describe("Single PA question detail (`PriorAuthQuestionResponse`)."),
        zod.null(),
      ])
      .optional(),
    attachments: zod.array(
      zod
        .object({
          AttachmentId: zod.union([zod.number(), zod.null()]).optional(),
          CreatedDateStamp: zod
            .union([zod.iso.datetime({}), zod.null()])
            .optional(),
          FileName: zod.union([zod.string(), zod.null()]).optional(),
          IsOutbound: zod.union([zod.boolean(), zod.null()]).optional(),
        })
        .describe("A single attachment on a PA case (`PAAttachment`)."),
    ),
  })
  .describe(
    "Full-fidelity PA view returned to the copilot when the clinician\nopens a case.\n\nWraps the three DoseSpot read-only payloads (case details, history,\nstatus log) alongside the payer's currently-pending question when there\nis one. The frontend renders the question form from\n``pending_question`` when ``case.NextQuestionId`` is populated and\nstatus is ``ACTION_REQUIRED``.",
  );

/**
 * Perform an action on a PA case.

Accepts a discriminated-union body whose ``action`` field selects one
of: ``answer_question``, ``submit``, ``upload_attachment``, ``cancel``,
``appeal``, ``deny``. Used by the copilot proposed-action form so the
clinician can review and submit in one step.

``case_id`` is the DoseSpot ``PriorAuthorizationCaseId`` (integer), not
our internal record UUID — the proposed-action payloads carry
``priorAuthId`` which is this DoseSpot case id, so the wire shape
matches what the tool-executor already has on hand.
 * @summary Prior Auth Action
 */
export const priorAuthActionParams = zod.object({
  case_id: zod.number(),
});

export const priorAuthActionBodyActionDefault = "answer_question";
export const priorAuthActionBodyActionDefaultOne = "submit";
export const priorAuthActionBodyActionDefaultTwo = "upload_attachment";
export const priorAuthActionBodyActionDefaultThree = "cancel";
export const priorAuthActionBodyActionDefaultFour = "appeal";
export const priorAuthActionBodyActionDefaultFive = "deny";

export const priorAuthActionBody = zod.union([
  zod.object({
    action: zod
      .literal("answer_question")
      .default(priorAuthActionBodyActionDefault),
    questionId: zod.number(),
    answer: zod
      .object({
        PriorAuthorizationQuestionChoices: zod
          .union([
            zod.array(
              zod
                .object({
                  PriorAuthorizationQuestionChoiceId: zod
                    .union([zod.number(), zod.null()])
                    .optional(),
                  PriorAuthorizationQuestionChoiceText: zod
                    .union([zod.string(), zod.null()])
                    .optional(),
                })
                .describe(
                  "A single chosen answer value (`PriorAuthorizationChoiceAnswer`).\n\nUsed inside `PriorAuthorizationAnswerRequestT.PriorAuthorizationQuestionChoices`\nfor `Select`/`Multiselect` question types.",
                ),
            ),
            zod.null(),
          ])
          .optional(),
        DateTimeAnswer: zod
          .union([zod.iso.datetime({}), zod.null()])
          .optional(),
        NumericAnswer: zod.union([zod.number(), zod.null()]).optional(),
        FreeTextAnswer: zod.union([zod.string(), zod.null()]).optional(),
      })
      .describe(
        "Body for `POST /priorAuths/{id}/questions/{qid}/answer` (`PriorAuthAnswerRequest`).\n\nExactly one of these fields should be populated, matching the question's\n`AnswerType`:\n\n- `Select`/`Multiselect` → `PriorAuthorizationQuestionChoices`\n- `Date`/`DateTime`      → `DateTimeAnswer`\n- `Numeric`              → `NumericAnswer`\n- `FreeText`             → `FreeTextAnswer`",
      ),
  }),
  zod.object({
    action: zod.literal("submit").default(priorAuthActionBodyActionDefaultOne),
  }),
  zod
    .object({
      action: zod
        .literal("upload_attachment")
        .default(priorAuthActionBodyActionDefaultTwo),
      fileName: zod.string(),
      contentType: zod.string(),
      contentBase64: zod.string(),
    })
    .describe(
      "Upload an attachment to a PA case.\n\n``content`` is base64-encoded on the wire; the handler decodes it before\nforwarding to DoseSpot. Using a JSON body (rather than multipart) keeps\nthe endpoint uniform with the other PA actions and avoids the OpenAPI\ncodegen limitations around multipart/form-data in our JS SDK.",
    ),
  zod.object({
    action: zod
      .literal("cancel")
      .default(priorAuthActionBodyActionDefaultThree),
  }),
  zod.object({
    action: zod.literal("appeal").default(priorAuthActionBodyActionDefaultFour),
    appealReason: zod.string(),
  }),
  zod.object({
    action: zod.literal("deny").default(priorAuthActionBodyActionDefaultFive),
  }),
]);

export const priorAuthActionResponse = zod
  .object({
    action: zod.string(),
    nextQuestionId: zod.union([zod.number(), zod.null()]).optional(),
  })
  .describe(
    "Envelope returned by ``POST /greenfield/dosespot/prior_auths/{id}/action``.\n\nAll PA actions eventually just acknowledge success (DoseSpot's own\nresponse is a success envelope), except for ``answer_question`` which\nadditionally returns the ``next_question_id`` in the same question set,\nso the UI can auto-advance to it without an extra round-trip.",
  );

/**
 * Stream a PA attachment back to the browser as a file download.

Proxies DoseSpot's binary endpoint through cortex so the browser can
use our normal Firebase auth instead of needing a DoseSpot bearer
token. Returns ``application/octet-stream`` because DoseSpot doesn't
expose a content-type for attachments and we don't trust filenames
enough to guess; the caller already knows the filename from the
case detail and can pick the right MIME on the client side.

404 when the case or attachment is unknown to DoseSpot — surfaced as
a ``ValueError`` from ``download_attachment`` and translated below.
 * @summary Download Prior Auth Attachment
 */
export const downloadPriorAuthAttachmentParams = zod.object({
  case_id: zod.number(),
  attachment_id: zod.number(),
});

export const downloadPriorAuthAttachmentResponse = zod.unknown();

/**
 * Delete a previously-uploaded PA attachment.

Real DoseSpot is hazy on whether DELETE is allowed once the case has
moved into a payer-owned status (e.g. ``Pending``). We just forward the
call and let DoseSpot decide; on a 4xx we surface a 422 to the browser
so the wizard can show a "couldn't remove this one" toast without
pretending the attachment is gone.
 * @summary Delete Prior Auth Attachment
 */
export const deletePriorAuthAttachmentParams = zod.object({
  case_id: zod.number(),
  attachment_id: zod.number(),
});

export const deletePriorAuthAttachmentResponse = zod.record(
  zod.string(),
  zod.boolean(),
);

/**
 * Force an immediate PA poll + processor pass.

This is the manual equivalent of the scheduled ``poll_pending_prior_auths``
+ ``process_all_dirty_rows`` jobs wired in ``proxy_main.py``. It exists
so a clinician (or a dev poking the fake DoseSpot) can click "Sync" on
the Prior Auths tab and see CareState reflect the latest case status
without waiting for the next scheduler tick.

Scope is global (not per-patient) for the same reason the scheduler is
global: the poller works from our SQL ``fetch_pending`` view, and the
processor drains every dirty row — limiting either to a single patient
would just move that filtering logic into the handler for no benefit.
The work is bounded by ``fetch_pending``'s 500-row ceiling.
 * @summary Sync Prior Auths
 */
export const syncPriorAuthsResponse = zod
  .object({
    polled: zod.number(),
    transitions: zod.number(),
    pollErrored: zod.number(),
    processed: zod.number(),
    requestsOpened: zod.number(),
    requestsResolved: zod.number(),
  })
  .describe(
    'Response from the manual PA sync endpoint.\n\nMirrors the fields of ``PollResultT`` + ``ProcessResultT`` so the UI can\nshow a tiny toast (\"Polled 3 cases, 1 transitioned, 1 request opened\")\nwithout needing to know about the two-stage pipeline.',
  );

/**
 * @summary Fetch Employee Roll
 */
export const fetchEmployeeRollParams = zod.object({
  level: zod.enum(["demo", "app"]),
});

export const fetchEmployeeRollResponse = zod.object({
  possibleGroups: zod.array(
    zod.enum([
      "lotus_admin",
      "lotus_developer",
      "lotus_test_user",
      "doctor",
      "practitioners",
      "evaluator_bot",
      "banned",
      "any_user",
      "anonymous_user",
      "partially_gated_user",
      "limited_access_user",
      "app_reviewer",
      "full_access_user",
      "invite_loop_group_1",
      "invite_loop_group_2",
      "invite_loop_group_3",
      "skip_service_area_check",
    ]),
  ),
  roll: zod.object({
    employees: zod.array(
      zod.object({
        userId: zod.uuid(),
        groups: zod.array(
          zod.enum([
            "lotus_admin",
            "lotus_developer",
            "lotus_test_user",
            "doctor",
            "practitioners",
            "evaluator_bot",
            "banned",
            "any_user",
            "anonymous_user",
            "partially_gated_user",
            "limited_access_user",
            "app_reviewer",
            "full_access_user",
            "invite_loop_group_1",
            "invite_loop_group_2",
            "invite_loop_group_3",
            "skip_service_area_check",
          ]),
        ),
        record: zod.object({
          displayName: zod.union([zod.string(), zod.null()]),
          phoneNumber: zod.union([zod.string(), zod.null()]),
          email: zod.union([zod.string(), zod.null()]),
          licensedStates: zod.union([zod.array(zod.string()), zod.null()]),
          licensedPracticeAreas: zod.union([
            zod.array(zod.string()),
            zod.null(),
          ]),
          originPractices: zod.union([zod.array(zod.string()), zod.null()]),
          mailingAddressStreet: zod
            .union([zod.string(), zod.null()])
            .optional(),
          mailingAddressCity: zod.union([zod.string(), zod.null()]).optional(),
          mailingAddressState: zod.union([zod.string(), zod.null()]).optional(),
          mailingAddressZip: zod.union([zod.string(), zod.null()]).optional(),
          dateOfBirth: zod.union([zod.iso.date(), zod.null()]).optional(),
          npiNumber: zod.union([zod.string(), zod.null()]).optional(),
          headshotFileId: zod.union([zod.uuid(), zod.null()]).optional(),
        }),
      }),
    ),
  }),
});

/**
 * @summary Update Employee From Roll
 */
export const updateEmployeeFromRollParams = zod.object({
  level: zod.enum(["demo", "app"]),
  user_id: zod.uuid(),
});

export const updateEmployeeFromRollBody = zod.object({
  newRecord: zod.union([
    zod.object({
      displayName: zod.union([zod.string(), zod.null()]),
      email: zod.union([zod.string(), zod.null()]),
      licensedStates: zod
        .union([zod.array(zod.string()), zod.null()])
        .optional(),
      licensedPracticeAreas: zod
        .union([zod.array(zod.string()), zod.null()])
        .optional(),
      originPractices: zod
        .union([zod.array(zod.string()), zod.null()])
        .optional(),
    }),
    zod.null(),
  ]),
  newGroups: zod.union([
    zod.array(
      zod.enum([
        "lotus_admin",
        "lotus_developer",
        "lotus_test_user",
        "doctor",
        "practitioners",
        "evaluator_bot",
        "banned",
        "any_user",
        "anonymous_user",
        "partially_gated_user",
        "limited_access_user",
        "app_reviewer",
        "full_access_user",
        "invite_loop_group_1",
        "invite_loop_group_2",
        "invite_loop_group_3",
        "skip_service_area_check",
      ]),
    ),
    zod.null(),
  ]),
});

export const updateEmployeeFromRollResponse = zod.object({
  entry: zod.object({
    userId: zod.uuid(),
    groups: zod.array(
      zod.enum([
        "lotus_admin",
        "lotus_developer",
        "lotus_test_user",
        "doctor",
        "practitioners",
        "evaluator_bot",
        "banned",
        "any_user",
        "anonymous_user",
        "partially_gated_user",
        "limited_access_user",
        "app_reviewer",
        "full_access_user",
        "invite_loop_group_1",
        "invite_loop_group_2",
        "invite_loop_group_3",
        "skip_service_area_check",
      ]),
    ),
    record: zod.object({
      displayName: zod.union([zod.string(), zod.null()]),
      phoneNumber: zod.union([zod.string(), zod.null()]),
      email: zod.union([zod.string(), zod.null()]),
      licensedStates: zod.union([zod.array(zod.string()), zod.null()]),
      licensedPracticeAreas: zod.union([zod.array(zod.string()), zod.null()]),
      originPractices: zod.union([zod.array(zod.string()), zod.null()]),
      mailingAddressStreet: zod.union([zod.string(), zod.null()]).optional(),
      mailingAddressCity: zod.union([zod.string(), zod.null()]).optional(),
      mailingAddressState: zod.union([zod.string(), zod.null()]).optional(),
      mailingAddressZip: zod.union([zod.string(), zod.null()]).optional(),
      dateOfBirth: zod.union([zod.iso.date(), zod.null()]).optional(),
      npiNumber: zod.union([zod.string(), zod.null()]).optional(),
      headshotFileId: zod.union([zod.uuid(), zod.null()]).optional(),
    }),
  }),
});

/**
 * @summary Fetch Identification
 */
export const fetchIdentificationParams = zod.object({
  level: zod.enum(["demo", "app"]),
});

export const fetchIdentificationResponseIdentificationHomeExperienceKindDefault =
  "full_access";
export const fetchIdentificationResponseIdentificationHomeExperienceDefault: {
  kind: "full_access";
} = { kind: "full_access" };
export const fetchIdentificationResponseIdentificationFallbackHomeExperienceKindDefault =
  "full_access";
export const fetchIdentificationResponseIdentificationFallbackHomeExperienceDefault: {
  kind: "full_access";
} = { kind: "full_access" };

export const fetchIdentificationResponse = zod.object({
  identification: zod.object({
    devId: zod.union([zod.string(), zod.null()]).optional(),
    userId: zod.uuid(),
    intercomJwt: zod.union([zod.string(), zod.null()]).optional(),
    homeExperience: zod
      .union([
        zod.object({
          kind: zod
            .literal("full_access")
            .default(
              fetchIdentificationResponseIdentificationHomeExperienceKindDefault,
            ),
        }),
        zod.null(),
      ])
      .default(fetchIdentificationResponseIdentificationHomeExperienceDefault),
    fallbackHomeExperience: zod
      .union([
        zod.object({
          kind: zod
            .literal("full_access")
            .default(
              fetchIdentificationResponseIdentificationFallbackHomeExperienceKindDefault,
            ),
        }),
        zod.null(),
      ])
      .default(
        fetchIdentificationResponseIdentificationFallbackHomeExperienceDefault,
      ),
  }),
});

/**
 * @summary Fetch Employee Record
 */
export const fetchEmployeeRecordParams = zod.object({
  level: zod.enum(["demo", "app"]),
});

export const fetchEmployeeRecordResponse = zod.object({
  employeeRecord: zod.object({
    displayName: zod.union([zod.string(), zod.null()]),
    phoneNumber: zod.union([zod.string(), zod.null()]),
    email: zod.union([zod.string(), zod.null()]),
    licensedStates: zod.union([zod.array(zod.string()), zod.null()]),
    licensedPracticeAreas: zod.union([zod.array(zod.string()), zod.null()]),
    originPractices: zod.union([zod.array(zod.string()), zod.null()]),
    mailingAddressStreet: zod.union([zod.string(), zod.null()]).optional(),
    mailingAddressCity: zod.union([zod.string(), zod.null()]).optional(),
    mailingAddressState: zod.union([zod.string(), zod.null()]).optional(),
    mailingAddressZip: zod.union([zod.string(), zod.null()]).optional(),
    dateOfBirth: zod.union([zod.iso.date(), zod.null()]).optional(),
    npiNumber: zod.union([zod.string(), zod.null()]).optional(),
    headshotFileId: zod.union([zod.uuid(), zod.null()]).optional(),
  }),
});

/**
 * @summary Update Employee Record
 */
export const updateEmployeeRecordParams = zod.object({
  level: zod.enum(["demo", "app"]),
});

export const updateEmployeeRecordBody = zod.object({
  displayName: zod.union([zod.string(), zod.null()]),
  email: zod.union([zod.string(), zod.null()]),
  licensedStates: zod.union([zod.array(zod.string()), zod.null()]).optional(),
  licensedPracticeAreas: zod
    .union([zod.array(zod.string()), zod.null()])
    .optional(),
  originPractices: zod.union([zod.array(zod.string()), zod.null()]).optional(),
});

export const updateEmployeeRecordResponse = zod.object({
  message: zod.string(),
});

/**
 * Fetch the full Personal Health Record (PHR) for the current user.

Returns a structured representation of all PHR tables including:
- Medications
- Conditions
- Labs
# - Diagnostics (not a part of the PHR yet)
- Procedures
- Vitals
- Notes

Returns:
    FetchPHRResponseT containing the full FrontendPHRT
 * @summary Fetch Phr
 */
export const fetchPhrParams = zod.object({
  user_id: zod.string(),
});

export const fetchPhrResponse = zod
  .object({
    phr: zod
      .object({
        medications: zod.array(
          zod
            .object({
              name: zod.string(),
              start: zod.union([zod.iso.date(), zod.null()]).optional(),
              end: zod.union([zod.iso.date(), zod.null()]).optional(),
              status: zod.enum(["Unknown", "Active", "Stopped", "Completed"]),
              dosage_instructions: zod.string(),
            })
            .describe("Frontend representation of a medication record."),
        ),
        conditions: zod.array(
          zod
            .object({
              name: zod.string(),
              start: zod.union([zod.iso.date(), zod.null()]).optional(),
              end: zod.union([zod.iso.date(), zod.null()]).optional(),
              status: zod.enum(["Active", "Resolved", "Unknown"]),
              classification: zod.enum([
                "Acute",
                "Chronic",
                "Remission",
                "Unknown",
              ]),
            })
            .describe("Frontend representation of a condition record."),
        ),
        labs: zod.array(
          zod
            .object({
              name: zod.string(),
              start: zod.union([zod.iso.date(), zod.null()]).optional(),
              end: zod.union([zod.iso.date(), zod.null()]).optional(),
              status: zod.enum([
                "Unknown",
                "Registered",
                "Preliminary",
                "Final",
                "Amended",
                "Corrected",
              ]),
              performers: zod.array(zod.string()),
              value: zod.string(),
            })
            .describe("Frontend representation of a lab result record."),
        ),
        procedures: zod.array(
          zod
            .object({
              name: zod.string(),
              start: zod.union([zod.iso.date(), zod.null()]).optional(),
              end: zod.union([zod.iso.date(), zod.null()]).optional(),
              status: zod.enum([
                "Planned",
                "Completed",
                "In-Progress",
                "Canceled",
                "Not Done",
                "Unknown",
              ]),
              performers: zod.array(zod.string()),
            })
            .describe("Frontend representation of a procedure record."),
        ),
        vitals: zod.array(
          zod
            .object({
              name: zod.string(),
              start: zod.union([zod.iso.date(), zod.null()]).optional(),
              end: zod.union([zod.iso.date(), zod.null()]).optional(),
              status: zod.enum([
                "Unknown",
                "Registered",
                "Preliminary",
                "Final",
                "Amended",
                "Corrected",
              ]),
              value: zod.string(),
              unit: zod.string(),
            })
            .describe("Frontend representation of a vital sign record."),
        ),
        notes: zod.array(
          zod
            .object({
              name: zod.string(),
              start: zod.union([zod.iso.date(), zod.null()]).optional(),
              end: zod.union([zod.iso.date(), zod.null()]).optional(),
              title: zod.string(),
              authors: zod.array(zod.string()),
              description: zod.string(),
            })
            .describe("Frontend representation of a clinical note record."),
        ),
      })
      .describe(
        "Frontend representation of the full PHR.\n\nContains lists for each entity type, providing a structured view of\nall patient health records suitable for API responses.",
      ),
  })
  .describe("Response containing the full PHR data.");

/**
 * Validate the staging input.

Providing this API makes sure the openapi schema includes a definition of HostageStagingInputT.
 * @summary Validate Staging Input
 */
export const validateStagingInputBody = zod.object({
  injections: zod.object({
    model_slug: zod.union([zod.string(), zod.null()]).optional(),
    base_prompt: zod.union([zod.string(), zod.null()]).optional(),
    prompt_fragment: zod.string(),
    tool_definitions: zod.array(
      zod.object({
        name: zod.string(),
        description: zod.string(),
        input_schema: zod.record(zod.string(), zod.unknown()),
      }),
    ),
  }),
});

export const validateStagingInputResponse = zod.string();

/**
 * @summary Host
 */
export const hostParams = zod.object({
  user_id: zod.uuid(),
});

export const hostResponse = zod.unknown();

/**
 * Fetch the list of conversations for a patient.

Returns all non-abandoned conversations for the specified user,
ordered by last interaction time (most recent first).

Args:
    user_id: The patient's user ID

Returns:
    FetchConversationsResponseT containing the list of conversations
 * @summary Fetch Conversations
 */
export const fetchConversationsParams = zod.object({
  user_id: zod.uuid(),
});

export const fetchConversationsResponseConversationsItemIsPrimaryDefault = false;

export const fetchConversationsResponse = zod
  .object({
    conversations: zod.array(
      zod.object({
        id: zod.uuid(),
        createdAt: zod.iso.datetime({}),
        displayName: zod.string(),
        lastInteractedAt: zod.iso.datetime({}),
        isPrimary: zod.boolean().optional(),
        conversationType: zod
          .enum(["onboarding", "evaluation", "clinician_request", "intake"])
          .optional(),
      }),
    ),
  })
  .describe("Response containing the list of conversations for a user.");

/**
 * Fetch chat messages for a specific conversation.

Supports pagination via before/after message IDs:
- Use `before` to fetch messages older than the specified message ID
- Use `after` to fetch messages newer than the specified message ID

Args:
    user_id: The patient's user ID
    conversation_id: The conversation ID to fetch messages from
    before: Optional message ID to fetch messages before (older than)
    after: Optional message ID to fetch messages after (newer than)

Returns:
    FetchChatResponseT containing the list of messages and conversation ID
 * @summary Fetch Chat
 */
export const fetchChatParams = zod.object({
  user_id: zod.uuid(),
  conversation_id: zod.uuid(),
});

export const fetchChatQueryParams = zod.object({
  before: zod.union([zod.uuid(), zod.null()]).optional(),
  after: zod.union([zod.uuid(), zod.null()]).optional(),
});

export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefault =
  "text";
export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOne =
  "choiceChip";
export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultTwo =
  "error";
export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultThree =
  "chart";
export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultFour =
  "toolUse";
export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultFive =
  "article";
export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultSix =
  "sources_v2";
export const fetchChatResponseMessagesItemContentBlocksItemBodySourcesItemContentTypeDefault =
  "table";
export const fetchChatResponseMessagesItemContentBlocksItemBodySourcesItemContentColumnSchemaDefault =
  {};
export const fetchChatResponseMessagesItemContentBlocksItemBodySourcesItemContentTypeDefaultOne =
  "link";
export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultSeven =
  "pendingReview";
export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultEight =
  "chainOfThought";
export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultNine =
  "revised";
export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnezero =
  "origin";
export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOneone =
  "stagingStatus";
export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnetwo =
  "completeStatus";
export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnethree =
  "retryStatus";
export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnefour =
  "assessmentResult";
export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnefive =
  "voiceMessageMarker";
export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnesix =
  "debug";
export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOneseven =
  "blank";
export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOneeight =
  "answerPartSuggestion";
export const fetchChatResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefault =
  "revise_message";
export const fetchChatResponseMessagesItemContentBlocksItemBodyAnswerPartSendToPatientDefault = true;
export const fetchChatResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultOne =
  "note";
export const fetchChatResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultTwo =
  "rejected";
export const fetchChatResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultThree =
  "prescription";
export const fetchChatResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultFour =
  "prescription_suggestion";
export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnenine =
  "fileAttachment";
export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultTwozero =
  "actionChip";

export const fetchChatResponse = zod
  .object({
    messages: zod.array(
      zod.object({
        id: zod.uuid(),
        createdAt: zod.iso.datetime({}),
        sender: zod.enum(["Lotus", "Debug", "User", "Clinician"]),
        status: zod.enum(["committed", "staged"]).optional(),
        contentBlocks: zod.array(
          zod.object({
            id: zod.uuid(),
            body: zod.union([
              zod.union([
                zod.object({
                  type: zod
                    .literal("text")
                    .default(
                      fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefault,
                    ),
                  stream: zod.enum(["Chat", "Thinking"]).optional(),
                  text: zod.string(),
                }),
                zod.object({
                  type: zod
                    .literal("choiceChip")
                    .default(
                      fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOne,
                    ),
                  text: zod.string(),
                }),
                zod.object({
                  type: zod
                    .literal("error")
                    .default(
                      fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultTwo,
                    ),
                  text: zod.string(),
                }),
                zod.object({
                  type: zod
                    .literal("chart")
                    .default(
                      fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultThree,
                    ),
                  chartData: zod.record(zod.string(), zod.unknown()),
                }),
                zod.object({
                  type: zod
                    .literal("toolUse")
                    .default(
                      fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultFour,
                    ),
                  text: zod.string(),
                }),
                zod.object({
                  type: zod
                    .literal("article")
                    .default(
                      fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultFive,
                    ),
                  articleData: zod.object({
                    title: zod.string(),
                    citation: zod.string(),
                    abstract: zod.string(),
                    published_date: zod.iso.datetime({}),
                    pmcid: zod.string(),
                    pmid: zod.string(),
                    chunks: zod.array(zod.string()),
                    citation_data: zod.object({
                      pmcid: zod.string(),
                      title: zod.string(),
                      authors: zod.array(
                        zod.object({
                          surname: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                          given_names: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                          full_name: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                        }),
                      ),
                      author_string: zod.string(),
                      journal: zod.string(),
                      pub_date: zod.string(),
                      volume: zod.union([zod.string(), zod.null()]).optional(),
                      issue: zod.union([zod.string(), zod.null()]).optional(),
                      pages: zod.union([zod.string(), zod.null()]).optional(),
                      doi: zod.union([zod.string(), zod.null()]).optional(),
                      issn: zod.union([zod.string(), zod.null()]).optional(),
                      pubmed_link: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      formatted: zod.object({
                        apa: zod.string(),
                        mla: zod.string(),
                        vancouver: zod.string(),
                      }),
                    }),
                  }),
                }),
                zod.object({
                  type: zod
                    .literal("sources_v2")
                    .default(
                      fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultSix,
                    ),
                  sources: zod.array(
                    zod.object({
                      title: zod.string(),
                      subtitle: zod.string(),
                      content: zod.union([
                        zod.object({
                          type: zod
                            .literal("table")
                            .default(
                              fetchChatResponseMessagesItemContentBlocksItemBodySourcesItemContentTypeDefault,
                            ),
                          rows: zod.array(
                            zod.record(zod.string(), zod.unknown()),
                          ),
                          columns: zod.array(zod.string()),
                          note: zod.string(),
                          column_schema: zod
                            .record(
                              zod.string(),
                              zod.enum([
                                "string",
                                "integer",
                                "float",
                                "boolean",
                                "datetime",
                              ]),
                            )
                            .default(
                              fetchChatResponseMessagesItemContentBlocksItemBodySourcesItemContentColumnSchemaDefault,
                            ),
                        }),
                        zod.object({
                          type: zod
                            .literal("link")
                            .default(
                              fetchChatResponseMessagesItemContentBlocksItemBodySourcesItemContentTypeDefaultOne,
                            ),
                          link: zod.string(),
                        }),
                      ]),
                      icon: zod
                        .union([
                          zod
                            .string()
                            .describe(
                              "An icon identifier - opaque to the client.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                    }),
                  ),
                }),
                zod.object({
                  type: zod
                    .literal("pendingReview")
                    .default(
                      fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultSeven,
                    ),
                }),
                zod.object({
                  type: zod
                    .literal("chainOfThought")
                    .default(
                      fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultEight,
                    ),
                  text: zod.string(),
                }),
                zod.object({
                  type: zod
                    .literal("revised")
                    .default(
                      fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultNine,
                    ),
                  text: zod.string(),
                }),
                zod.object({
                  type: zod
                    .literal("origin")
                    .default(
                      fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnezero,
                    ),
                  origin: zod.union([zod.enum(["insight"]), zod.unknown()]),
                }),
                zod.object({
                  type: zod
                    .literal("stagingStatus")
                    .default(
                      fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOneone,
                    ),
                  status: zod.enum(["committed", "staged"]),
                }),
                zod.object({
                  type: zod
                    .literal("completeStatus")
                    .default(
                      fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnetwo,
                    ),
                  status: zod.enum(["incomplete", "complete"]),
                }),
                zod.object({
                  type: zod
                    .literal("retryStatus")
                    .default(
                      fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnethree,
                    ),
                  status: zod.enum(["retry", "handled"]),
                  error: zod
                    .union([
                      zod.object({
                        message: zod.string(),
                        trace: zod.string(),
                      }),
                      zod.null(),
                    ])
                    .optional(),
                }),
                zod.object({
                  type: zod
                    .literal("assessmentResult")
                    .default(
                      fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnefour,
                    ),
                  assessmentResult: zod.unknown(),
                }),
                zod.object({
                  type: zod
                    .literal("voiceMessageMarker")
                    .default(
                      fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnefive,
                    ),
                  obscured: zod.boolean(),
                }),
                zod.object({
                  type: zod
                    .literal("debug")
                    .default(
                      fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnesix,
                    ),
                  title: zod.string(),
                  content: zod.string(),
                }),
                zod.object({
                  type: zod
                    .literal("blank")
                    .default(
                      fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOneseven,
                    ),
                }),
                zod.object({
                  type: zod
                    .literal("answerPartSuggestion")
                    .default(
                      fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOneeight,
                    ),
                  answerPart: zod.union([
                    zod
                      .object({
                        answer_part_type: zod
                          .literal("revise_message")
                          .default(
                            fetchChatResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefault,
                          ),
                        message_id: zod.uuid(),
                        response: zod.enum(["accept", "revise"]),
                        new_response: zod.string(),
                        explanation: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        send_to_patient: zod
                          .boolean()
                          .default(
                            fetchChatResponseMessagesItemContentBlocksItemBodyAnswerPartSendToPatientDefault,
                          ),
                      })
                      .describe(
                        "This is a response to a ReviseMessageAnswerPartRequestT. It stores the clinician's judgement on the message.",
                      ),
                    zod
                      .object({
                        answer_part_type: zod
                          .literal("note")
                          .default(
                            fetchChatResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultOne,
                          ),
                        patient_id: zod.uuid(),
                        note: zod.string(),
                      })
                      .describe(
                        "This is a response to a NoteAnswerPartRequestT. It is a note that will be entered into the EHR system.",
                      ),
                    zod
                      .object({
                        answer_part_type: zod
                          .literal("rejected")
                          .default(
                            fetchChatResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultTwo,
                          ),
                        reason: zod
                          .union([zod.string(), zod.null()])
                          .optional()
                          .describe("Optional reason for rejection"),
                      })
                      .describe(
                        "This is a response to a RejectedAnswerPartRequestT. It indicates the clinician is rejecting the entire request.",
                      ),
                    zod
                      .object({
                        answer_part_type: zod
                          .literal("prescription")
                          .default(
                            fetchChatResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultThree,
                          ),
                        patient_id: zod.uuid(),
                        dosespot_prescription_id: zod.string(),
                      })
                      .describe(
                        "This is a response to a PrescriptionAnswerPartRequestT. It stores a prescription ID that will be sent to pharmacy.",
                      ),
                    zod
                      .object({
                        answer_part_type: zod
                          .literal("prescription_suggestion")
                          .default(
                            fetchChatResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultFour,
                          ),
                        dispensable_drug_id: zod
                          .union([zod.number(), zod.null()])
                          .optional()
                          .describe(
                            "DoseSpot DispensableDrugId for the medication",
                          ),
                        pharmacy_id: zod
                          .union([zod.number(), zod.null()])
                          .optional()
                          .describe("DoseSpot PharmacyId for the pharmacy"),
                        directions: zod
                          .union([zod.string(), zod.null()])
                          .optional()
                          .describe("Suggested directions for use"),
                        quantity: zod
                          .union([zod.number(), zod.null()])
                          .optional()
                          .describe("Suggested quantity"),
                        refills: zod
                          .union([zod.number(), zod.null()])
                          .optional()
                          .describe("Suggested number of refills"),
                        notes: zod
                          .union([zod.string(), zod.null()])
                          .optional()
                          .describe("Additional notes about the prescription"),
                      })
                      .describe(
                        "Suggested prescription data that can be used to prepopulate a prescription form.",
                      ),
                  ]),
                }),
                zod
                  .object({
                    type: zod
                      .literal("fileAttachment")
                      .default(
                        fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnenine,
                      ),
                    attachmentId: zod.uuid(),
                    filename: zod.union([zod.string(), zod.null()]).optional(),
                    mimeType: zod.union([zod.string(), zod.null()]).optional(),
                    fileType: zod
                      .union([
                        zod
                          .enum(["image", "document", "audio"])
                          .describe("Type of file attachment."),
                        zod.null(),
                      ])
                      .optional(),
                  })
                  .describe(
                    "Reference to an uploaded file (image or PDF).\nAll metadata is stored in the database and fetched when needed.",
                  ),
                zod.object({
                  type: zod
                    .literal("actionChip")
                    .default(
                      fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultTwozero,
                    ),
                  label: zod.string(),
                  action: zod.string(),
                }),
              ]),
              zod.unknown(),
            ]),
            createdAt: zod.iso.datetime({}).optional(),
          }),
        ),
        completionState: zod.enum(["incomplete", "complete"]).optional(),
      }),
    ),
    conversationId: zod.uuid(),
  })
  .describe("Response containing chat messages for a conversation.");

/**
 * Fetch chat messages for the primary conversation.

If no conversation ID is specified, this endpoint returns messages from
the user's primary conversation.

Supports pagination via before/after message IDs:
- Use `before` to fetch messages older than the specified message ID
- Use `after` to fetch messages newer than the specified message ID

Args:
    user_id: The patient's user ID
    before: Optional message ID to fetch messages before (older than)
    after: Optional message ID to fetch messages after (newer than)

Returns:
    FetchChatResponseT containing the list of messages and conversation ID

Raises:
    ValueError: If the user has no primary conversation
 * @summary Fetch Primary Chat
 */
export const fetchPrimaryChatParams = zod.object({
  user_id: zod.uuid(),
});

export const fetchPrimaryChatQueryParams = zod.object({
  before: zod.union([zod.uuid(), zod.null()]).optional(),
  after: zod.union([zod.uuid(), zod.null()]).optional(),
});

export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefault =
  "text";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOne =
  "choiceChip";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultTwo =
  "error";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultThree =
  "chart";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultFour =
  "toolUse";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultFive =
  "article";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultSix =
  "sources_v2";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodySourcesItemContentTypeDefault =
  "table";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodySourcesItemContentColumnSchemaDefault =
  {};
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodySourcesItemContentTypeDefaultOne =
  "link";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultSeven =
  "pendingReview";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultEight =
  "chainOfThought";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultNine =
  "revised";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnezero =
  "origin";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOneone =
  "stagingStatus";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnetwo =
  "completeStatus";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnethree =
  "retryStatus";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnefour =
  "assessmentResult";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnefive =
  "voiceMessageMarker";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnesix =
  "debug";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOneseven =
  "blank";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOneeight =
  "answerPartSuggestion";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefault =
  "revise_message";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyAnswerPartSendToPatientDefault = true;
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultOne =
  "note";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultTwo =
  "rejected";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultThree =
  "prescription";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultFour =
  "prescription_suggestion";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnenine =
  "fileAttachment";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultTwozero =
  "actionChip";

export const fetchPrimaryChatResponse = zod
  .object({
    messages: zod.array(
      zod.object({
        id: zod.uuid(),
        createdAt: zod.iso.datetime({}),
        sender: zod.enum(["Lotus", "Debug", "User", "Clinician"]),
        status: zod.enum(["committed", "staged"]).optional(),
        contentBlocks: zod.array(
          zod.object({
            id: zod.uuid(),
            body: zod.union([
              zod.union([
                zod.object({
                  type: zod
                    .literal("text")
                    .default(
                      fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefault,
                    ),
                  stream: zod.enum(["Chat", "Thinking"]).optional(),
                  text: zod.string(),
                }),
                zod.object({
                  type: zod
                    .literal("choiceChip")
                    .default(
                      fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOne,
                    ),
                  text: zod.string(),
                }),
                zod.object({
                  type: zod
                    .literal("error")
                    .default(
                      fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultTwo,
                    ),
                  text: zod.string(),
                }),
                zod.object({
                  type: zod
                    .literal("chart")
                    .default(
                      fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultThree,
                    ),
                  chartData: zod.record(zod.string(), zod.unknown()),
                }),
                zod.object({
                  type: zod
                    .literal("toolUse")
                    .default(
                      fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultFour,
                    ),
                  text: zod.string(),
                }),
                zod.object({
                  type: zod
                    .literal("article")
                    .default(
                      fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultFive,
                    ),
                  articleData: zod.object({
                    title: zod.string(),
                    citation: zod.string(),
                    abstract: zod.string(),
                    published_date: zod.iso.datetime({}),
                    pmcid: zod.string(),
                    pmid: zod.string(),
                    chunks: zod.array(zod.string()),
                    citation_data: zod.object({
                      pmcid: zod.string(),
                      title: zod.string(),
                      authors: zod.array(
                        zod.object({
                          surname: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                          given_names: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                          full_name: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                        }),
                      ),
                      author_string: zod.string(),
                      journal: zod.string(),
                      pub_date: zod.string(),
                      volume: zod.union([zod.string(), zod.null()]).optional(),
                      issue: zod.union([zod.string(), zod.null()]).optional(),
                      pages: zod.union([zod.string(), zod.null()]).optional(),
                      doi: zod.union([zod.string(), zod.null()]).optional(),
                      issn: zod.union([zod.string(), zod.null()]).optional(),
                      pubmed_link: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      formatted: zod.object({
                        apa: zod.string(),
                        mla: zod.string(),
                        vancouver: zod.string(),
                      }),
                    }),
                  }),
                }),
                zod.object({
                  type: zod
                    .literal("sources_v2")
                    .default(
                      fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultSix,
                    ),
                  sources: zod.array(
                    zod.object({
                      title: zod.string(),
                      subtitle: zod.string(),
                      content: zod.union([
                        zod.object({
                          type: zod
                            .literal("table")
                            .default(
                              fetchPrimaryChatResponseMessagesItemContentBlocksItemBodySourcesItemContentTypeDefault,
                            ),
                          rows: zod.array(
                            zod.record(zod.string(), zod.unknown()),
                          ),
                          columns: zod.array(zod.string()),
                          note: zod.string(),
                          column_schema: zod
                            .record(
                              zod.string(),
                              zod.enum([
                                "string",
                                "integer",
                                "float",
                                "boolean",
                                "datetime",
                              ]),
                            )
                            .default(
                              fetchPrimaryChatResponseMessagesItemContentBlocksItemBodySourcesItemContentColumnSchemaDefault,
                            ),
                        }),
                        zod.object({
                          type: zod
                            .literal("link")
                            .default(
                              fetchPrimaryChatResponseMessagesItemContentBlocksItemBodySourcesItemContentTypeDefaultOne,
                            ),
                          link: zod.string(),
                        }),
                      ]),
                      icon: zod
                        .union([
                          zod
                            .string()
                            .describe(
                              "An icon identifier - opaque to the client.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                    }),
                  ),
                }),
                zod.object({
                  type: zod
                    .literal("pendingReview")
                    .default(
                      fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultSeven,
                    ),
                }),
                zod.object({
                  type: zod
                    .literal("chainOfThought")
                    .default(
                      fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultEight,
                    ),
                  text: zod.string(),
                }),
                zod.object({
                  type: zod
                    .literal("revised")
                    .default(
                      fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultNine,
                    ),
                  text: zod.string(),
                }),
                zod.object({
                  type: zod
                    .literal("origin")
                    .default(
                      fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnezero,
                    ),
                  origin: zod.union([zod.enum(["insight"]), zod.unknown()]),
                }),
                zod.object({
                  type: zod
                    .literal("stagingStatus")
                    .default(
                      fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOneone,
                    ),
                  status: zod.enum(["committed", "staged"]),
                }),
                zod.object({
                  type: zod
                    .literal("completeStatus")
                    .default(
                      fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnetwo,
                    ),
                  status: zod.enum(["incomplete", "complete"]),
                }),
                zod.object({
                  type: zod
                    .literal("retryStatus")
                    .default(
                      fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnethree,
                    ),
                  status: zod.enum(["retry", "handled"]),
                  error: zod
                    .union([
                      zod.object({
                        message: zod.string(),
                        trace: zod.string(),
                      }),
                      zod.null(),
                    ])
                    .optional(),
                }),
                zod.object({
                  type: zod
                    .literal("assessmentResult")
                    .default(
                      fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnefour,
                    ),
                  assessmentResult: zod.unknown(),
                }),
                zod.object({
                  type: zod
                    .literal("voiceMessageMarker")
                    .default(
                      fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnefive,
                    ),
                  obscured: zod.boolean(),
                }),
                zod.object({
                  type: zod
                    .literal("debug")
                    .default(
                      fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnesix,
                    ),
                  title: zod.string(),
                  content: zod.string(),
                }),
                zod.object({
                  type: zod
                    .literal("blank")
                    .default(
                      fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOneseven,
                    ),
                }),
                zod.object({
                  type: zod
                    .literal("answerPartSuggestion")
                    .default(
                      fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOneeight,
                    ),
                  answerPart: zod.union([
                    zod
                      .object({
                        answer_part_type: zod
                          .literal("revise_message")
                          .default(
                            fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefault,
                          ),
                        message_id: zod.uuid(),
                        response: zod.enum(["accept", "revise"]),
                        new_response: zod.string(),
                        explanation: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        send_to_patient: zod
                          .boolean()
                          .default(
                            fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyAnswerPartSendToPatientDefault,
                          ),
                      })
                      .describe(
                        "This is a response to a ReviseMessageAnswerPartRequestT. It stores the clinician's judgement on the message.",
                      ),
                    zod
                      .object({
                        answer_part_type: zod
                          .literal("note")
                          .default(
                            fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultOne,
                          ),
                        patient_id: zod.uuid(),
                        note: zod.string(),
                      })
                      .describe(
                        "This is a response to a NoteAnswerPartRequestT. It is a note that will be entered into the EHR system.",
                      ),
                    zod
                      .object({
                        answer_part_type: zod
                          .literal("rejected")
                          .default(
                            fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultTwo,
                          ),
                        reason: zod
                          .union([zod.string(), zod.null()])
                          .optional()
                          .describe("Optional reason for rejection"),
                      })
                      .describe(
                        "This is a response to a RejectedAnswerPartRequestT. It indicates the clinician is rejecting the entire request.",
                      ),
                    zod
                      .object({
                        answer_part_type: zod
                          .literal("prescription")
                          .default(
                            fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultThree,
                          ),
                        patient_id: zod.uuid(),
                        dosespot_prescription_id: zod.string(),
                      })
                      .describe(
                        "This is a response to a PrescriptionAnswerPartRequestT. It stores a prescription ID that will be sent to pharmacy.",
                      ),
                    zod
                      .object({
                        answer_part_type: zod
                          .literal("prescription_suggestion")
                          .default(
                            fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultFour,
                          ),
                        dispensable_drug_id: zod
                          .union([zod.number(), zod.null()])
                          .optional()
                          .describe(
                            "DoseSpot DispensableDrugId for the medication",
                          ),
                        pharmacy_id: zod
                          .union([zod.number(), zod.null()])
                          .optional()
                          .describe("DoseSpot PharmacyId for the pharmacy"),
                        directions: zod
                          .union([zod.string(), zod.null()])
                          .optional()
                          .describe("Suggested directions for use"),
                        quantity: zod
                          .union([zod.number(), zod.null()])
                          .optional()
                          .describe("Suggested quantity"),
                        refills: zod
                          .union([zod.number(), zod.null()])
                          .optional()
                          .describe("Suggested number of refills"),
                        notes: zod
                          .union([zod.string(), zod.null()])
                          .optional()
                          .describe("Additional notes about the prescription"),
                      })
                      .describe(
                        "Suggested prescription data that can be used to prepopulate a prescription form.",
                      ),
                  ]),
                }),
                zod
                  .object({
                    type: zod
                      .literal("fileAttachment")
                      .default(
                        fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnenine,
                      ),
                    attachmentId: zod.uuid(),
                    filename: zod.union([zod.string(), zod.null()]).optional(),
                    mimeType: zod.union([zod.string(), zod.null()]).optional(),
                    fileType: zod
                      .union([
                        zod
                          .enum(["image", "document", "audio"])
                          .describe("Type of file attachment."),
                        zod.null(),
                      ])
                      .optional(),
                  })
                  .describe(
                    "Reference to an uploaded file (image or PDF).\nAll metadata is stored in the database and fetched when needed.",
                  ),
                zod.object({
                  type: zod
                    .literal("actionChip")
                    .default(
                      fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultTwozero,
                    ),
                  label: zod.string(),
                  action: zod.string(),
                }),
              ]),
              zod.unknown(),
            ]),
            createdAt: zod.iso.datetime({}).optional(),
          }),
        ),
        completionState: zod.enum(["incomplete", "complete"]).optional(),
      }),
    ),
    conversationId: zod.uuid(),
  })
  .describe("Response containing chat messages for a conversation.");

/**
 * Fetch a presigned S3 URL for a specific variant of a patient's file attachment.

Clinicians can request a specific variant (dimensions and zoom type for images,
page truncation for documents).
Returns null if the variant is not meaningful for the content or is unknown to Lotus.

Args:
    user_id: The patient's user ID
    attachment_id: The attachment ID
    args: The variant request

Returns:
    FetchViewUrlForVariantReplyT with the presigned URL if the variant
    is applicable, or with view_url=None if the variant is not meaningful
    for the content type.
 * @summary Fetch Attachment Variant
 */
export const fetchAttachmentVariantParams = zod.object({
  user_id: zod.uuid(),
  attachment_id: zod.uuid(),
});

export const fetchAttachmentVariantBody = zod
  .object({
    variant: zod.union([
      zod
        .object({
          variantType: zod
            .enum(["original", "square", "same_aspect_ratio"])
            .describe("Type of image variant."),
          dimensions: zod
            .object({
              width: zod.number(),
              height: zod.number(),
            })
            .describe("Dimensions for image variant."),
          zoomType: zod
            .enum(["content"])
            .optional()
            .describe("Type of zoom for image variants."),
        })
        .describe("Request for a specific image variant."),
      zod
        .object({
          variantType: zod
            .enum(["original", "truncated", "textualize_over"])
            .describe("Type of document variant."),
          pages: zod.number(),
          bytesOfText: zod.number(),
        })
        .describe("Request for a specific document variant."),
    ]),
  })
  .describe("Request for fetching a specific variant of a file attachment.");

export const fetchAttachmentVariantResponse = zod.object({
  viewUrl: zod.union([zod.string(), zod.null()]).optional(),
  fileType: zod
    .enum(["image", "document", "audio"])
    .describe("Type of file attachment."),
  filename: zod.string(),
  mimeType: zod.string(),
  expiresInSeconds: zod.union([zod.number(), zod.null()]).optional(),
});

/**
 * Fetch patient demographic information for the specified user.

All fields are derived from the dossier — the single source of truth used
by insurance discovery, lab-order billing, and the rest of the care
pipeline.
 * @summary Fetch Patient Info
 */
export const fetchPatientInfoParams = zod.object({
  user_id: zod.string(),
});

export const fetchPatientInfoResponsePatientInfoOriginIdsDefault = [];

export const fetchPatientInfoResponse = zod
  .object({
    patientInfo: zod.object({
      id: zod.string(),
      name: zod.string(),
      age: zod.union([zod.number(), zod.null()]).optional(),
      date_of_birth: zod.union([zod.string(), zod.null()]).optional(),
      sex: zod
        .union([zod.enum(["male", "female", "other", "unknown"]), zod.null()])
        .optional(),
      primary_language: zod.union([zod.string(), zod.null()]).optional(),
      phone: zod.union([zod.string(), zod.null()]).optional(),
      email: zod.union([zod.string(), zod.null()]).optional(),
      address: zod.union([zod.string(), zod.null()]).optional(),
      insurance: zod.union([zod.string(), zod.null()]).optional(),
      primary_pharmacy: zod.union([zod.string(), zod.null()]).optional(),
      emergency_contact: zod.union([zod.string(), zod.null()]).optional(),
      origin_ids: zod
        .array(zod.string())
        .default(fetchPatientInfoResponsePatientInfoOriginIdsDefault),
    }),
  })
  .describe("Response containing patient demographic information.");

/**
 * @summary Search Patients
 */
export const searchPatientsBodyLimitDefault = 1000;

export const searchPatientsBody = zod.object({
  limit: zod.number().default(searchPatientsBodyLimitDefault),
  query: zod.string(),
  desired_relationship: zod
    .enum(["actionable", "licensed", "unlicensed"])
    .optional(),
});

export const searchPatientsResponsePatientsItemPolicyResultDebugYouTagsUsStatesDefault =
  [];
export const searchPatientsResponsePatientsItemPolicyResultDebugYouTagsPracticeAreasDefault =
  [];
export const searchPatientsResponsePatientsItemPolicyResultDebugYouTagsOriginPracticesDefault =
  [];
export const searchPatientsResponsePatientsItemPolicyResultDebugPatientTagsUsStatesDefault =
  [];
export const searchPatientsResponsePatientsItemPolicyResultDebugPatientTagsPracticeAreasDefault =
  [];
export const searchPatientsResponsePatientsItemPolicyResultDebugPatientTagsOriginPracticesDefault =
  [];

export const searchPatientsResponse = zod.object({
  patients: zod.array(
    zod.object({
      user_id: zod.uuid(),
      full_name: zod.string(),
      display_name: zod.string(),
      oldest_request_at: zod.union([zod.iso.datetime({}), zod.null()]),
      urgent_count: zod.number(),
      routine_count: zod.number(),
      unread_count: zod.number(),
      viewer_count: zod.number(),
      total_karma_offer: zod.number(),
      policy_result: zod.object({
        debug: zod.union([
          zod.object({
            you: zod
              .object({
                tags: zod
                  .object({
                    us_states: zod
                      .array(zod.string())
                      .default(
                        searchPatientsResponsePatientsItemPolicyResultDebugYouTagsUsStatesDefault,
                      ),
                    practice_areas: zod
                      .array(zod.enum(["Primary Care", "Psychiatry"]))
                      .default(
                        searchPatientsResponsePatientsItemPolicyResultDebugYouTagsPracticeAreasDefault,
                      ),
                    origin_practices: zod
                      .array(zod.string())
                      .default(
                        searchPatientsResponsePatientsItemPolicyResultDebugYouTagsOriginPracticesDefault,
                      ),
                  })
                  .describe(
                    "Fully typed tag set — each routing dimension is an explicit field.",
                  ),
              })
              .describe(
                "Criteria representing what a clinician is licensed to do.\n\nUses a RoutingTagSetT so that matching generalizes across\nall routing dimensions (state, practice area, origin practice, etc.).",
              ),
            patient: zod
              .object({
                tags: zod
                  .object({
                    us_states: zod
                      .array(zod.string())
                      .default(
                        searchPatientsResponsePatientsItemPolicyResultDebugPatientTagsUsStatesDefault,
                      ),
                    practice_areas: zod
                      .array(zod.enum(["Primary Care", "Psychiatry"]))
                      .default(
                        searchPatientsResponsePatientsItemPolicyResultDebugPatientTagsPracticeAreasDefault,
                      ),
                    origin_practices: zod
                      .array(zod.string())
                      .default(
                        searchPatientsResponsePatientsItemPolicyResultDebugPatientTagsOriginPracticesDefault,
                      ),
                  })
                  .describe(
                    "Fully typed tag set — each routing dimension is an explicit field.",
                  ),
              })
              .describe(
                "What a patient (or a specific request) needs from a clinician.",
              ),
          }),
          zod.string(),
        ]),
        relationship: zod.enum(["actionable", "licensed", "unlicensed"]),
        notes: zod.array(
          zod.object({
            title: zod.string(),
            detail: zod.string(),
          }),
        ),
      }),
      origin_practice: zod.union([zod.string(), zod.null()]).optional(),
    }),
  ),
});

/**
 * @summary Hydrate Patients
 */
export const hydratePatientsBody = zod.object({
  patient_ids: zod.array(zod.uuid()),
});

export const hydratePatientsResponsePatientsPolicyResultDebugYouTagsUsStatesDefault =
  [];
export const hydratePatientsResponsePatientsPolicyResultDebugYouTagsPracticeAreasDefault =
  [];
export const hydratePatientsResponsePatientsPolicyResultDebugYouTagsOriginPracticesDefault =
  [];
export const hydratePatientsResponsePatientsPolicyResultDebugPatientTagsUsStatesDefault =
  [];
export const hydratePatientsResponsePatientsPolicyResultDebugPatientTagsPracticeAreasDefault =
  [];
export const hydratePatientsResponsePatientsPolicyResultDebugPatientTagsOriginPracticesDefault =
  [];

export const hydratePatientsResponse = zod.object({
  patients: zod.record(
    zod.string(),
    zod.object({
      user_id: zod.uuid(),
      full_name: zod.string(),
      display_name: zod.string(),
      oldest_request_at: zod.union([zod.iso.datetime({}), zod.null()]),
      urgent_count: zod.number(),
      routine_count: zod.number(),
      unread_count: zod.number(),
      viewer_count: zod.number(),
      total_karma_offer: zod.number(),
      policy_result: zod.object({
        debug: zod.union([
          zod.object({
            you: zod
              .object({
                tags: zod
                  .object({
                    us_states: zod
                      .array(zod.string())
                      .default(
                        hydratePatientsResponsePatientsPolicyResultDebugYouTagsUsStatesDefault,
                      ),
                    practice_areas: zod
                      .array(zod.enum(["Primary Care", "Psychiatry"]))
                      .default(
                        hydratePatientsResponsePatientsPolicyResultDebugYouTagsPracticeAreasDefault,
                      ),
                    origin_practices: zod
                      .array(zod.string())
                      .default(
                        hydratePatientsResponsePatientsPolicyResultDebugYouTagsOriginPracticesDefault,
                      ),
                  })
                  .describe(
                    "Fully typed tag set — each routing dimension is an explicit field.",
                  ),
              })
              .describe(
                "Criteria representing what a clinician is licensed to do.\n\nUses a RoutingTagSetT so that matching generalizes across\nall routing dimensions (state, practice area, origin practice, etc.).",
              ),
            patient: zod
              .object({
                tags: zod
                  .object({
                    us_states: zod
                      .array(zod.string())
                      .default(
                        hydratePatientsResponsePatientsPolicyResultDebugPatientTagsUsStatesDefault,
                      ),
                    practice_areas: zod
                      .array(zod.enum(["Primary Care", "Psychiatry"]))
                      .default(
                        hydratePatientsResponsePatientsPolicyResultDebugPatientTagsPracticeAreasDefault,
                      ),
                    origin_practices: zod
                      .array(zod.string())
                      .default(
                        hydratePatientsResponsePatientsPolicyResultDebugPatientTagsOriginPracticesDefault,
                      ),
                  })
                  .describe(
                    "Fully typed tag set — each routing dimension is an explicit field.",
                  ),
              })
              .describe(
                "What a patient (or a specific request) needs from a clinician.",
              ),
          }),
          zod.string(),
        ]),
        relationship: zod.enum(["actionable", "licensed", "unlicensed"]),
        notes: zod.array(
          zod.object({
            title: zod.string(),
            detail: zod.string(),
          }),
        ),
      }),
      origin_practice: zod.union([zod.string(), zod.null()]).optional(),
    }),
  ),
});

/**
 * Suggest the most urgent actionable patient that currently has no viewers.

This endpoint uses a mutex (ActiveLock) to ensure that two clinicians
cannot be suggested the same patient simultaneously. When a patient is
suggested, a "view claim" is automatically created for the requesting
clinician.

Returns None if no actionable patients are available (either there are
no actionable patients, or all actionable patients already have viewers).
 * @summary Suggest Patient Endpoint
 */
export const suggestPatientEndpointResponsePatientPolicyResultDebugYouTagsUsStatesDefault =
  [];
export const suggestPatientEndpointResponsePatientPolicyResultDebugYouTagsPracticeAreasDefault =
  [];
export const suggestPatientEndpointResponsePatientPolicyResultDebugYouTagsOriginPracticesDefault =
  [];
export const suggestPatientEndpointResponsePatientPolicyResultDebugPatientTagsUsStatesDefault =
  [];
export const suggestPatientEndpointResponsePatientPolicyResultDebugPatientTagsPracticeAreasDefault =
  [];
export const suggestPatientEndpointResponsePatientPolicyResultDebugPatientTagsOriginPracticesDefault =
  [];

export const suggestPatientEndpointResponse = zod.object({
  patient: zod.union([
    zod.object({
      user_id: zod.uuid(),
      full_name: zod.string(),
      display_name: zod.string(),
      oldest_request_at: zod.union([zod.iso.datetime({}), zod.null()]),
      urgent_count: zod.number(),
      routine_count: zod.number(),
      unread_count: zod.number(),
      viewer_count: zod.number(),
      total_karma_offer: zod.number(),
      policy_result: zod.object({
        debug: zod.union([
          zod.object({
            you: zod
              .object({
                tags: zod
                  .object({
                    us_states: zod
                      .array(zod.string())
                      .default(
                        suggestPatientEndpointResponsePatientPolicyResultDebugYouTagsUsStatesDefault,
                      ),
                    practice_areas: zod
                      .array(zod.enum(["Primary Care", "Psychiatry"]))
                      .default(
                        suggestPatientEndpointResponsePatientPolicyResultDebugYouTagsPracticeAreasDefault,
                      ),
                    origin_practices: zod
                      .array(zod.string())
                      .default(
                        suggestPatientEndpointResponsePatientPolicyResultDebugYouTagsOriginPracticesDefault,
                      ),
                  })
                  .describe(
                    "Fully typed tag set — each routing dimension is an explicit field.",
                  ),
              })
              .describe(
                "Criteria representing what a clinician is licensed to do.\n\nUses a RoutingTagSetT so that matching generalizes across\nall routing dimensions (state, practice area, origin practice, etc.).",
              ),
            patient: zod
              .object({
                tags: zod
                  .object({
                    us_states: zod
                      .array(zod.string())
                      .default(
                        suggestPatientEndpointResponsePatientPolicyResultDebugPatientTagsUsStatesDefault,
                      ),
                    practice_areas: zod
                      .array(zod.enum(["Primary Care", "Psychiatry"]))
                      .default(
                        suggestPatientEndpointResponsePatientPolicyResultDebugPatientTagsPracticeAreasDefault,
                      ),
                    origin_practices: zod
                      .array(zod.string())
                      .default(
                        suggestPatientEndpointResponsePatientPolicyResultDebugPatientTagsOriginPracticesDefault,
                      ),
                  })
                  .describe(
                    "Fully typed tag set — each routing dimension is an explicit field.",
                  ),
              })
              .describe(
                "What a patient (or a specific request) needs from a clinician.",
              ),
          }),
          zod.string(),
        ]),
        relationship: zod.enum(["actionable", "licensed", "unlicensed"]),
        notes: zod.array(
          zod.object({
            title: zod.string(),
            detail: zod.string(),
          }),
        ),
      }),
      origin_practice: zod.union([zod.string(), zod.null()]).optional(),
    }),
    zod.null(),
  ]),
});

/**
 * Fetch the current care state snapshot for a patient.

Returns the full care state including all tables (patients, problems,
requests, internal notes, follow-ups) along with a cursor for fetching
subsequent events.

Also records the clinician as a viewer of this patient.
 * @summary Fetch State
 */
export const fetchStateParams = zod.object({
  user_id: zod.uuid(),
});

export const fetchStateResponseStateRequestsItemLinkTypeDefault = "patient";
export const fetchStateResponseStateRequestsItemLinkTypeDefaultOne = "problem";
export const fetchStateResponseStateRequestsItemLinkTypeDefaultTwo = "request";
export const fetchStateResponseStateRequestsItemLinkTypeDefaultThree = "orphan";
export const fetchStateResponseStateRequestsItemChatLinkTypeDefault =
  "chat_message";
export const fetchStateResponseStateRequestsItemChatLinkTypeDefaultOne =
  "chat_conversation";
export const fetchStateResponseStateInternalNotesItemLinkTypeDefault =
  "patient";
export const fetchStateResponseStateInternalNotesItemLinkTypeDefaultOne =
  "problem";
export const fetchStateResponseStateInternalNotesItemLinkTypeDefaultTwo =
  "request";
export const fetchStateResponseStateInternalNotesItemLinkTypeDefaultThree =
  "orphan";
export const fetchStateResponseStateFollowUpsItemLinkTypeDefault = "patient";
export const fetchStateResponseStateFollowUpsItemLinkTypeDefaultOne = "problem";
export const fetchStateResponseStateFollowUpsItemLinkTypeDefaultTwo = "request";
export const fetchStateResponseStateFollowUpsItemLinkTypeDefaultThree =
  "orphan";
export const fetchStateResponseStateFollowUpsItemUnreadDefault = false;
export const fetchStateResponseStateFollowUpsItemTransmissionLinkTypeDefault =
  "chat_message";
export const fetchStateResponseStateFollowUpsItemTransmissionLinkTypeDefaultOne =
  "chat_conversation";
export const fetchStateResponseStateFollowUpsItemAcknowledgementLinkTypeDefault =
  "chat_message";
export const fetchStateResponseStateFollowUpsItemAcknowledgementLinkTypeDefaultOne =
  "chat_conversation";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionTypeDefault =
  "string";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultOne =
  "int";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultTwo =
  "simple_address";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultThree =
  "list";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefault =
  "string";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultOne =
  "int";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultTwo =
  "simple_address";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionTypeDefault =
  "string";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionTypeDefaultOne =
  "int";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionTypeDefaultTwo =
  "simple_address";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionTypeDefaultThree =
  "list";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefault =
  "string";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultOne =
  "int";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultTwo =
  "simple_address";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefault =
  "non_empty_string";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultOne =
  "date";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultTwo =
  "coded_choice";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultThree =
  "phone_number";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultFour =
  "email";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultFive =
  "city_state_zip";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultSix =
  "optional";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefault =
  "non_empty_string";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOne =
  "date";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultTwo =
  "coded_choice";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultThree =
  "phone_number";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFour =
  "email";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFive =
  "city_state_zip";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSix =
  "list";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefault =
  "non_empty_string";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOne =
  "date";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultTwo =
  "coded_choice";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultThree =
  "phone_number";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFour =
  "email";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFive =
  "city_state_zip";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultSeven =
  "list";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSeven =
  "non_empty_string";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultEight =
  "date";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultNine =
  "coded_choice";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnezero =
  "phone_number";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOneone =
  "email";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnetwo =
  "city_state_zip";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnethree =
  "optional";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSix =
  "non_empty_string";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSeven =
  "date";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultEight =
  "coded_choice";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultNine =
  "phone_number";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOnezero =
  "email";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOneone =
  "city_state_zip";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentSubmissionsSubmissionsTypeDefault =
  "string";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentSubmissionsSubmissionsTypeDefaultOne =
  "int";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentSubmissionsSubmissionsTypeDefaultTwo =
  "simple_address";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentSubmissionsSubmissionsTypeDefaultThree =
  "list";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentSubmissionsSubmissionsValuesItemTypeDefault =
  "string";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentSubmissionsSubmissionsValuesItemTypeDefaultOne =
  "int";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentSubmissionsSubmissionsValuesItemTypeDefaultTwo =
  "simple_address";
export const fetchStateResponseStateLabOrdersItemLinkTypeDefault = "patient";
export const fetchStateResponseStateLabOrdersItemLinkTypeDefaultOne = "problem";
export const fetchStateResponseStateLabOrdersItemLinkTypeDefaultTwo = "request";
export const fetchStateResponseStateLabOrdersItemLinkTypeDefaultThree =
  "orphan";
export const fetchStateResponseStateLabOrdersItemOrderDataTypeDefault = "vital";
export const fetchStateResponseStateLabOrdersItemOrderDataValueLabTestMarkersItemMetadataProviderDefault =
  "vital";
export const fetchStateResponseStateLabOrdersItemOrderDataValueLabTestMarkersItemMetadataALaCarteEnabledDefault = false;
export const fetchStateResponseStateLabOrdersItemOrderDataValueLabTestMetadataProviderDefault =
  "vital";
export const fetchStateResponseStateLabOrdersItemOrderDataValueMetadataProviderDefault =
  "vital";
export const fetchStateResponseStateLabOrdersItemOrderDataValueMetadataDetailsTypeDefault =
  "testkit";
export const fetchStateResponseStateLabOrdersItemOrderDataValueMetadataDetailsTypeDefaultOne =
  "walk_in_test";
export const fetchStateResponseStateLabOrdersItemOrderDataValueMetadataDetailsTypeDefaultTwo =
  "at_home_phlebotomy";
export const fetchStateResponseStateLabOrdersItemOrderDataValueMetadataDetailsTypeDefaultThree =
  "on_site_collection";
export const fetchStateResponseStateLabOrdersItemOrderDataValueMetadataPriorityDefault = false;
export const fetchStateResponseStateLabOrdersItemOrderDataValueMetadataEventsDefault =
  [];
export const fetchStateResponseStatePrescriptionsItemLinkTypeDefault =
  "patient";
export const fetchStateResponseStatePrescriptionsItemLinkTypeDefaultOne =
  "problem";
export const fetchStateResponseStatePrescriptionsItemLinkTypeDefaultTwo =
  "request";
export const fetchStateResponseStatePrescriptionsItemLinkTypeDefaultThree =
  "orphan";
export const fetchStateResponseStatePriorAuthRequestsItemLinkTypeDefault =
  "patient";
export const fetchStateResponseStatePriorAuthRequestsItemLinkTypeDefaultOne =
  "problem";
export const fetchStateResponseStatePriorAuthRequestsItemLinkTypeDefaultTwo =
  "request";
export const fetchStateResponseStatePriorAuthRequestsItemLinkTypeDefaultThree =
  "orphan";
export const fetchStateResponseStatePriorAuthRequestsItemIsOfflineDefault = false;
export const fetchStateResponseStatePreRequestsItemChatLinkTypeDefault =
  "chat_message";
export const fetchStateResponseStatePreRequestsItemChatLinkTypeDefaultOne =
  "chat_conversation";
export const fetchStateResponseStateProposedActionsItemLinkTypeDefault =
  "patient";
export const fetchStateResponseStateProposedActionsItemLinkTypeDefaultOne =
  "problem";
export const fetchStateResponseStateProposedActionsItemLinkTypeDefaultTwo =
  "request";
export const fetchStateResponseStateProposedActionsItemLinkTypeDefaultThree =
  "orphan";

export const fetchStateResponse = zod.object({
  state: zod.object({
    patients: zod.array(
      zod.object({
        id: zod.literal("root"),
        note: zod.object({
          value: zod.string(),
          expiry: zod.object({
            basis: zod.union([zod.string(), zod.null()]),
            time: zod.union([zod.iso.datetime({}), zod.null()]),
          }),
        }),
      }),
    ),
    problems: zod.array(
      zod.object({
        id: zod.uuid(),
        title: zod.string(),
        note: zod.object({
          value: zod.string(),
          expiry: zod.object({
            basis: zod.union([zod.string(), zod.null()]),
            time: zod.union([zod.iso.datetime({}), zod.null()]),
          }),
        }),
      }),
    ),
    requests: zod.array(
      zod.object({
        id: zod.uuid(),
        link: zod.union([
          zod.object({
            type: zod
              .literal("patient")
              .default(fetchStateResponseStateRequestsItemLinkTypeDefault),
          }),
          zod.object({
            type: zod
              .literal("problem")
              .default(fetchStateResponseStateRequestsItemLinkTypeDefaultOne),
            id: zod.uuid(),
          }),
          zod.object({
            type: zod
              .literal("request")
              .default(fetchStateResponseStateRequestsItemLinkTypeDefaultTwo),
            id: zod.uuid(),
          }),
          zod.object({
            type: zod
              .literal("orphan")
              .default(fetchStateResponseStateRequestsItemLinkTypeDefaultThree),
          }),
        ]),
        chat_link: zod
          .union([
            zod.union([
              zod.object({
                type: zod
                  .literal("chat_message")
                  .default(
                    fetchStateResponseStateRequestsItemChatLinkTypeDefault,
                  ),
                conversation_id: zod.uuid(),
                message_id: zod.uuid(),
              }),
              zod.object({
                type: zod
                  .literal("chat_conversation")
                  .default(
                    fetchStateResponseStateRequestsItemChatLinkTypeDefaultOne,
                  ),
                conversation_id: zod.uuid(),
              }),
            ]),
            zod.null(),
          ])
          .optional(),
        title: zod.string(),
        note: zod.object({
          value: zod.string(),
          expiry: zod.object({
            basis: zod.union([zod.string(), zod.null()]),
            time: zod.union([zod.iso.datetime({}), zod.null()]),
          }),
        }),
        status: zod.enum([
          "Open",
          "Pending Follow Up",
          "Resolved",
          "Cancelled",
        ]),
        urgency: zod.enum(["Routine", "Urgent"]),
        assignee: zod.enum(["Patient", "Clinician"]),
        kind: zod
          .enum(["General", "Refill", "Rx Change", "Prior Auth"])
          .optional()
          .describe(
            "Machine-readable discriminator for inbox request type.\n\nKind-specific data lives on paired rows (CareStatePriorAuthRequestT,\nCareStateProposedActionT payload, SQL dosespot_*_records). ``kind`` is\na facet for routing/filtering, never a row-shape discriminator.\n\nDefaulted to GENERAL so historical rows decode cleanly without migration.",
          ),
        practice_area: zod.enum(["Primary Care", "Psychiatry"]).optional(),
        origin_practice: zod.union([zod.string(), zod.null()]).optional(),
        cpt_code: zod
          .union([
            zod
              .enum(["99212", "99213", "99214", "99215"])
              .describe(
                "E/M office visit CPT codes used to classify request complexity by MDM level.",
              ),
            zod.null(),
          ])
          .optional(),
      }),
    ),
    internal_notes: zod.array(
      zod.object({
        id: zod.uuid(),
        link: zod.union([
          zod.object({
            type: zod
              .literal("patient")
              .default(fetchStateResponseStateInternalNotesItemLinkTypeDefault),
          }),
          zod.object({
            type: zod
              .literal("problem")
              .default(
                fetchStateResponseStateInternalNotesItemLinkTypeDefaultOne,
              ),
            id: zod.uuid(),
          }),
          zod.object({
            type: zod
              .literal("request")
              .default(
                fetchStateResponseStateInternalNotesItemLinkTypeDefaultTwo,
              ),
            id: zod.uuid(),
          }),
          zod.object({
            type: zod
              .literal("orphan")
              .default(
                fetchStateResponseStateInternalNotesItemLinkTypeDefaultThree,
              ),
          }),
        ]),
        note: zod.object({
          value: zod.string(),
          expiry: zod.object({
            basis: zod.union([zod.string(), zod.null()]),
            time: zod.union([zod.iso.datetime({}), zod.null()]),
          }),
        }),
        created_by: zod.uuid(),
      }),
    ),
    follow_ups: zod.array(
      zod.object({
        id: zod.uuid(),
        link: zod.union([
          zod.object({
            type: zod
              .literal("patient")
              .default(fetchStateResponseStateFollowUpsItemLinkTypeDefault),
          }),
          zod.object({
            type: zod
              .literal("problem")
              .default(fetchStateResponseStateFollowUpsItemLinkTypeDefaultOne),
            id: zod.uuid(),
          }),
          zod.object({
            type: zod
              .literal("request")
              .default(fetchStateResponseStateFollowUpsItemLinkTypeDefaultTwo),
            id: zod.uuid(),
          }),
          zod.object({
            type: zod
              .literal("orphan")
              .default(
                fetchStateResponseStateFollowUpsItemLinkTypeDefaultThree,
              ),
          }),
        ]),
        title: zod.string(),
        status: zod
          .enum([
            "Pending",
            "Awaiting Response from Patient",
            "Response Received from Patient",
          ])
          .optional(),
        unread: zod.boolean().optional(),
        transmission_link: zod
          .union([
            zod.union([
              zod.object({
                type: zod
                  .literal("chat_message")
                  .default(
                    fetchStateResponseStateFollowUpsItemTransmissionLinkTypeDefault,
                  ),
                conversation_id: zod.uuid(),
                message_id: zod.uuid(),
              }),
              zod.object({
                type: zod
                  .literal("chat_conversation")
                  .default(
                    fetchStateResponseStateFollowUpsItemTransmissionLinkTypeDefaultOne,
                  ),
                conversation_id: zod.uuid(),
              }),
            ]),
            zod.null(),
          ])
          .optional(),
        acknowledgement_link: zod
          .union([
            zod.union([
              zod.object({
                type: zod
                  .literal("chat_message")
                  .default(
                    fetchStateResponseStateFollowUpsItemAcknowledgementLinkTypeDefault,
                  ),
                conversation_id: zod.uuid(),
                message_id: zod.uuid(),
              }),
              zod.object({
                type: zod
                  .literal("chat_conversation")
                  .default(
                    fetchStateResponseStateFollowUpsItemAcknowledgementLinkTypeDefaultOne,
                  ),
                conversation_id: zod.uuid(),
              }),
            ]),
            zod.null(),
          ])
          .optional(),
        content_to_transmit: zod.string(),
        response_instrument: zod
          .union([
            zod
              .object({
                instrument_id: zod.string(),
                form_definition: zod.object({
                  fields: zod.array(
                    zod.object({
                      id: zod.string(),
                      profile: zod.object({
                        name: zod.string(),
                        description: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                      }),
                      suggested_submission: zod
                        .union([
                          zod.union([
                            zod.object({
                              type: zod
                                .literal("string")
                                .default(
                                  fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionTypeDefault,
                                ),
                              value: zod.string(),
                            }),
                            zod.object({
                              type: zod
                                .literal("int")
                                .default(
                                  fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultOne,
                                ),
                              value: zod.number(),
                            }),
                            zod.object({
                              type: zod
                                .literal("simple_address")
                                .default(
                                  fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultTwo,
                                ),
                              street_address: zod.string(),
                              city_state_zip: zod.string(),
                            }),
                            zod.object({
                              type: zod
                                .literal("list")
                                .default(
                                  fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultThree,
                                ),
                              values: zod.array(
                                zod.union([
                                  zod.object({
                                    type: zod
                                      .literal("string")
                                      .default(
                                        fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefault,
                                      ),
                                    value: zod.string(),
                                  }),
                                  zod.object({
                                    type: zod
                                      .literal("int")
                                      .default(
                                        fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultOne,
                                      ),
                                    value: zod.number(),
                                  }),
                                  zod.object({
                                    type: zod
                                      .literal("simple_address")
                                      .default(
                                        fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultTwo,
                                      ),
                                    street_address: zod.string(),
                                    city_state_zip: zod.string(),
                                  }),
                                  zod.unknown(),
                                ]),
                              ),
                            }),
                          ]),
                          zod.null(),
                        ])
                        .optional(),
                      default_submission: zod
                        .union([
                          zod.union([
                            zod.object({
                              type: zod
                                .literal("string")
                                .default(
                                  fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionTypeDefault,
                                ),
                              value: zod.string(),
                            }),
                            zod.object({
                              type: zod
                                .literal("int")
                                .default(
                                  fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionTypeDefaultOne,
                                ),
                              value: zod.number(),
                            }),
                            zod.object({
                              type: zod
                                .literal("simple_address")
                                .default(
                                  fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionTypeDefaultTwo,
                                ),
                              street_address: zod.string(),
                              city_state_zip: zod.string(),
                            }),
                            zod.object({
                              type: zod
                                .literal("list")
                                .default(
                                  fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionTypeDefaultThree,
                                ),
                              values: zod.array(
                                zod.union([
                                  zod.object({
                                    type: zod
                                      .literal("string")
                                      .default(
                                        fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefault,
                                      ),
                                    value: zod.string(),
                                  }),
                                  zod.object({
                                    type: zod
                                      .literal("int")
                                      .default(
                                        fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultOne,
                                      ),
                                    value: zod.number(),
                                  }),
                                  zod.object({
                                    type: zod
                                      .literal("simple_address")
                                      .default(
                                        fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultTwo,
                                      ),
                                    street_address: zod.string(),
                                    city_state_zip: zod.string(),
                                  }),
                                  zod.unknown(),
                                ]),
                              ),
                            }),
                          ]),
                          zod.null(),
                        ])
                        .optional(),
                      validator: zod.union([
                        zod
                          .object({
                            type: zod
                              .literal("non_empty_string")
                              .default(
                                fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefault,
                              ),
                          })
                          .describe(
                            "Validator that accepts arbitrary non-empty strings.",
                          ),
                        zod
                          .object({
                            type: zod
                              .literal("date")
                              .default(
                                fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultOne,
                              ),
                          })
                          .describe("Validator that accepts arbitrary dates."),
                        zod
                          .object({
                            type: zod
                              .literal("coded_choice")
                              .default(
                                fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultTwo,
                              ),
                            options: zod.array(
                              zod
                                .object({
                                  code: zod.string(),
                                  display: zod.string(),
                                })
                                .describe("An option from a list of choices."),
                            ),
                          })
                          .describe(
                            "Validator that accepts any option from a list of choices.",
                          ),
                        zod
                          .object({
                            type: zod
                              .literal("phone_number")
                              .default(
                                fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultThree,
                              ),
                          })
                          .describe(
                            "Validator that accepts arbitrary phone numbers.",
                          ),
                        zod
                          .object({
                            type: zod
                              .literal("email")
                              .default(
                                fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultFour,
                              ),
                          })
                          .describe("Validator that accepts arbitrary emails."),
                        zod
                          .object({
                            type: zod
                              .literal("city_state_zip")
                              .default(
                                fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultFive,
                              ),
                          })
                          .describe(
                            "Validator that accepts city, state, and ZIP code combinations.",
                          ),
                        zod
                          .object({
                            type: zod
                              .literal("optional")
                              .default(
                                fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultSix,
                              ),
                            raw_validator: zod.union([
                              zod
                                .object({
                                  type: zod
                                    .literal("non_empty_string")
                                    .default(
                                      fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefault,
                                    ),
                                })
                                .describe(
                                  "Validator that accepts arbitrary non-empty strings.",
                                ),
                              zod
                                .object({
                                  type: zod
                                    .literal("date")
                                    .default(
                                      fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOne,
                                    ),
                                })
                                .describe(
                                  "Validator that accepts arbitrary dates.",
                                ),
                              zod
                                .object({
                                  type: zod
                                    .literal("coded_choice")
                                    .default(
                                      fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultTwo,
                                    ),
                                  options: zod.array(
                                    zod
                                      .object({
                                        code: zod.string(),
                                        display: zod.string(),
                                      })
                                      .describe(
                                        "An option from a list of choices.",
                                      ),
                                  ),
                                })
                                .describe(
                                  "Validator that accepts any option from a list of choices.",
                                ),
                              zod
                                .object({
                                  type: zod
                                    .literal("phone_number")
                                    .default(
                                      fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultThree,
                                    ),
                                })
                                .describe(
                                  "Validator that accepts arbitrary phone numbers.",
                                ),
                              zod
                                .object({
                                  type: zod
                                    .literal("email")
                                    .default(
                                      fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFour,
                                    ),
                                })
                                .describe(
                                  "Validator that accepts arbitrary emails.",
                                ),
                              zod
                                .object({
                                  type: zod
                                    .literal("city_state_zip")
                                    .default(
                                      fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFive,
                                    ),
                                })
                                .describe(
                                  "Validator that accepts city, state, and ZIP code combinations.",
                                ),
                              zod.unknown(),
                              zod
                                .object({
                                  type: zod
                                    .literal("list")
                                    .default(
                                      fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSix,
                                    ),
                                  raw_validator: zod.union([
                                    zod
                                      .object({
                                        type: zod
                                          .literal("non_empty_string")
                                          .default(
                                            fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefault,
                                          ),
                                      })
                                      .describe(
                                        "Validator that accepts arbitrary non-empty strings.",
                                      ),
                                    zod
                                      .object({
                                        type: zod
                                          .literal("date")
                                          .default(
                                            fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOne,
                                          ),
                                      })
                                      .describe(
                                        "Validator that accepts arbitrary dates.",
                                      ),
                                    zod
                                      .object({
                                        type: zod
                                          .literal("coded_choice")
                                          .default(
                                            fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultTwo,
                                          ),
                                        options: zod.array(
                                          zod
                                            .object({
                                              code: zod.string(),
                                              display: zod.string(),
                                            })
                                            .describe(
                                              "An option from a list of choices.",
                                            ),
                                        ),
                                      })
                                      .describe(
                                        "Validator that accepts any option from a list of choices.",
                                      ),
                                    zod
                                      .object({
                                        type: zod
                                          .literal("phone_number")
                                          .default(
                                            fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultThree,
                                          ),
                                      })
                                      .describe(
                                        "Validator that accepts arbitrary phone numbers.",
                                      ),
                                    zod
                                      .object({
                                        type: zod
                                          .literal("email")
                                          .default(
                                            fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFour,
                                          ),
                                      })
                                      .describe(
                                        "Validator that accepts arbitrary emails.",
                                      ),
                                    zod
                                      .object({
                                        type: zod
                                          .literal("city_state_zip")
                                          .default(
                                            fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFive,
                                          ),
                                      })
                                      .describe(
                                        "Validator that accepts city, state, and ZIP code combinations.",
                                      ),
                                    zod.unknown(),
                                    zod.unknown(),
                                  ]),
                                })
                                .describe(
                                  "Validator that accepts lists of items.",
                                ),
                            ]),
                          })
                          .describe("Validator that accepts optional fields."),
                        zod
                          .object({
                            type: zod
                              .literal("list")
                              .default(
                                fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultSeven,
                              ),
                            raw_validator: zod.union([
                              zod
                                .object({
                                  type: zod
                                    .literal("non_empty_string")
                                    .default(
                                      fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSeven,
                                    ),
                                })
                                .describe(
                                  "Validator that accepts arbitrary non-empty strings.",
                                ),
                              zod
                                .object({
                                  type: zod
                                    .literal("date")
                                    .default(
                                      fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultEight,
                                    ),
                                })
                                .describe(
                                  "Validator that accepts arbitrary dates.",
                                ),
                              zod
                                .object({
                                  type: zod
                                    .literal("coded_choice")
                                    .default(
                                      fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultNine,
                                    ),
                                  options: zod.array(
                                    zod
                                      .object({
                                        code: zod.string(),
                                        display: zod.string(),
                                      })
                                      .describe(
                                        "An option from a list of choices.",
                                      ),
                                  ),
                                })
                                .describe(
                                  "Validator that accepts any option from a list of choices.",
                                ),
                              zod
                                .object({
                                  type: zod
                                    .literal("phone_number")
                                    .default(
                                      fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnezero,
                                    ),
                                })
                                .describe(
                                  "Validator that accepts arbitrary phone numbers.",
                                ),
                              zod
                                .object({
                                  type: zod
                                    .literal("email")
                                    .default(
                                      fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOneone,
                                    ),
                                })
                                .describe(
                                  "Validator that accepts arbitrary emails.",
                                ),
                              zod
                                .object({
                                  type: zod
                                    .literal("city_state_zip")
                                    .default(
                                      fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnetwo,
                                    ),
                                })
                                .describe(
                                  "Validator that accepts city, state, and ZIP code combinations.",
                                ),
                              zod
                                .object({
                                  type: zod
                                    .literal("optional")
                                    .default(
                                      fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnethree,
                                    ),
                                  raw_validator: zod.union([
                                    zod
                                      .object({
                                        type: zod
                                          .literal("non_empty_string")
                                          .default(
                                            fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSix,
                                          ),
                                      })
                                      .describe(
                                        "Validator that accepts arbitrary non-empty strings.",
                                      ),
                                    zod
                                      .object({
                                        type: zod
                                          .literal("date")
                                          .default(
                                            fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSeven,
                                          ),
                                      })
                                      .describe(
                                        "Validator that accepts arbitrary dates.",
                                      ),
                                    zod
                                      .object({
                                        type: zod
                                          .literal("coded_choice")
                                          .default(
                                            fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultEight,
                                          ),
                                        options: zod.array(
                                          zod
                                            .object({
                                              code: zod.string(),
                                              display: zod.string(),
                                            })
                                            .describe(
                                              "An option from a list of choices.",
                                            ),
                                        ),
                                      })
                                      .describe(
                                        "Validator that accepts any option from a list of choices.",
                                      ),
                                    zod
                                      .object({
                                        type: zod
                                          .literal("phone_number")
                                          .default(
                                            fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultNine,
                                          ),
                                      })
                                      .describe(
                                        "Validator that accepts arbitrary phone numbers.",
                                      ),
                                    zod
                                      .object({
                                        type: zod
                                          .literal("email")
                                          .default(
                                            fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOnezero,
                                          ),
                                      })
                                      .describe(
                                        "Validator that accepts arbitrary emails.",
                                      ),
                                    zod
                                      .object({
                                        type: zod
                                          .literal("city_state_zip")
                                          .default(
                                            fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOneone,
                                          ),
                                      })
                                      .describe(
                                        "Validator that accepts city, state, and ZIP code combinations.",
                                      ),
                                    zod.unknown(),
                                    zod.unknown(),
                                  ]),
                                })
                                .describe(
                                  "Validator that accepts optional fields.",
                                ),
                              zod.unknown(),
                            ]),
                          })
                          .describe("Validator that accepts lists of items."),
                      ]),
                    }),
                  ),
                }),
                submissions: zod.object({
                  submissions: zod.record(
                    zod.string(),
                    zod.union([
                      zod.object({
                        type: zod
                          .literal("string")
                          .default(
                            fetchStateResponseStateFollowUpsItemResponseInstrumentSubmissionsSubmissionsTypeDefault,
                          ),
                        value: zod.string(),
                      }),
                      zod.object({
                        type: zod
                          .literal("int")
                          .default(
                            fetchStateResponseStateFollowUpsItemResponseInstrumentSubmissionsSubmissionsTypeDefaultOne,
                          ),
                        value: zod.number(),
                      }),
                      zod.object({
                        type: zod
                          .literal("simple_address")
                          .default(
                            fetchStateResponseStateFollowUpsItemResponseInstrumentSubmissionsSubmissionsTypeDefaultTwo,
                          ),
                        street_address: zod.string(),
                        city_state_zip: zod.string(),
                      }),
                      zod.object({
                        type: zod
                          .literal("list")
                          .default(
                            fetchStateResponseStateFollowUpsItemResponseInstrumentSubmissionsSubmissionsTypeDefaultThree,
                          ),
                        values: zod.array(
                          zod.union([
                            zod.object({
                              type: zod
                                .literal("string")
                                .default(
                                  fetchStateResponseStateFollowUpsItemResponseInstrumentSubmissionsSubmissionsValuesItemTypeDefault,
                                ),
                              value: zod.string(),
                            }),
                            zod.object({
                              type: zod
                                .literal("int")
                                .default(
                                  fetchStateResponseStateFollowUpsItemResponseInstrumentSubmissionsSubmissionsValuesItemTypeDefaultOne,
                                ),
                              value: zod.number(),
                            }),
                            zod.object({
                              type: zod
                                .literal("simple_address")
                                .default(
                                  fetchStateResponseStateFollowUpsItemResponseInstrumentSubmissionsSubmissionsValuesItemTypeDefaultTwo,
                                ),
                              street_address: zod.string(),
                              city_state_zip: zod.string(),
                            }),
                            zod.unknown(),
                          ]),
                        ),
                      }),
                    ]),
                  ),
                }),
                problems: zod.record(zod.string(), zod.string()),
                interpretation: zod.union([
                  zod.object({
                    type: zod.enum(["complete", "incomplete", "error"]),
                    text: zod.string(),
                  }),
                  zod.null(),
                ]),
              })
              .describe(
                'An \"instrument session\" links the immediate state of a form with an instrumnet,\nwhich\n\nThis captures the instrument type, its form definition, and the user\'s\ncurrent submissions so that follow-ups can be processed without needing\nto look up the instrument again.',
              ),
            zod.null(),
          ])
          .optional(),
        response_from_patient: zod.union([zod.string(), zod.null()]).optional(),
        practice_area: zod.enum(["Primary Care", "Psychiatry"]).optional(),
        origin_practice: zod.union([zod.string(), zod.null()]).optional(),
      }),
    ),
    lab_orders: zod.array(
      zod
        .object({
          id: zod.uuid(),
          link: zod.union([
            zod.object({
              type: zod
                .literal("patient")
                .default(fetchStateResponseStateLabOrdersItemLinkTypeDefault),
            }),
            zod.object({
              type: zod
                .literal("problem")
                .default(
                  fetchStateResponseStateLabOrdersItemLinkTypeDefaultOne,
                ),
              id: zod.uuid(),
            }),
            zod.object({
              type: zod
                .literal("request")
                .default(
                  fetchStateResponseStateLabOrdersItemLinkTypeDefaultTwo,
                ),
              id: zod.uuid(),
            }),
            zod.object({
              type: zod
                .literal("orphan")
                .default(
                  fetchStateResponseStateLabOrdersItemLinkTypeDefaultThree,
                ),
            }),
          ]),
          remote_id: zod.string(),
          provider: zod.string(),
          status: zod.enum([
            "received",
            "collecting_sample",
            "sample_with_lab",
            "completed",
            "cancelled",
            "failed",
            "unknown",
          ]),
          interpretation: zod.enum([
            "normal",
            "abnormal",
            "critical",
            "unknown",
          ]),
          ordered_at: zod.iso.datetime({}),
          updated_at: zod.iso.datetime({}),
          version: zod.uuid(),
          order_data: zod
            .object({
              type: zod
                .literal("vital")
                .default(
                  fetchStateResponseStateLabOrdersItemOrderDataTypeDefault,
                ),
              value: zod.object({
                remote_id: zod.uuid(),
                user_id: zod.uuid(),
                created_at: zod.iso.datetime({}),
                updated_at: zod.iso.datetime({}),
                lab_test: zod.object({
                  id: zod.string(),
                  name: zod.string(),
                  sample_type: zod.enum([
                    "dried_blood_spot",
                    "arm_collector",
                    "serum",
                    "saliva",
                    "urine",
                  ]),
                  method: zod.enum([
                    "testkit",
                    "walk_in_test",
                    "at_home_phlebotomy",
                    "on_site_collection",
                  ]),
                  laboratory: zod.union([
                    zod
                      .object({
                        name: zod.string(),
                        formatted_address: zod.string(),
                        collection_methods: zod.array(
                          zod.enum([
                            "testkit",
                            "walk_in_test",
                            "at_home_phlebotomy",
                            "on_site_collection",
                          ]),
                        ),
                        sample_types: zod.array(
                          zod.enum([
                            "dried_blood_spot",
                            "arm_collector",
                            "serum",
                            "saliva",
                            "urine",
                          ]),
                        ),
                      })
                      .describe("Information about a lab facility."),
                    zod.null(),
                  ]),
                  markers: zod.array(
                    zod.object({
                      id: zod.string(),
                      name: zod.string(),
                      description: zod.union([zod.string(), zod.null()]),
                      unit: zod.union([zod.string(), zod.null()]),
                      metadata: zod
                        .object({
                          provider: zod
                            .literal("vital")
                            .default(
                              fetchStateResponseStateLabOrdersItemOrderDataValueLabTestMarkersItemMetadataProviderDefault,
                            ),
                          slug: zod.string(),
                          type: zod.union([
                            zod.enum(["biomarker", "panel"]),
                            zod.null(),
                          ]),
                          provider_id: zod.union([zod.string(), zod.null()]),
                          price: zod.union([zod.string(), zod.null()]),
                          a_la_carte_enabled: zod.boolean().optional(),
                          questions: zod.array(
                            zod
                              .object({
                                marker_id: zod.string(),
                                question_id: zod.string(),
                                body: zod.object({
                                  required: zod.boolean(),
                                  code: zod.string(),
                                  value: zod.string(),
                                  constraint: zod.union([
                                    zod.string(),
                                    zod.null(),
                                  ]),
                                  validator: zod.union([
                                    zod.object({
                                      type: zod.literal("choice"),
                                      answers: zod.array(
                                        zod.object({
                                          code: zod.string(),
                                          value: zod.string(),
                                        }),
                                      ),
                                    }),
                                    zod.object({
                                      type: zod.literal("text"),
                                    }),
                                    zod.object({
                                      type: zod.literal("numeric"),
                                    }),
                                    zod.object({
                                      type: zod.literal("multi_choice"),
                                      answers: zod.array(
                                        zod.object({
                                          code: zod.string(),
                                          value: zod.string(),
                                        }),
                                      ),
                                    }),
                                  ]),
                                  default: zod.union([
                                    zod.string(),
                                    zod.null(),
                                  ]),
                                }),
                              })
                              .describe("Vital-specific lab marker question."),
                          ),
                          lab_info: zod
                            .union([
                              zod
                                .object({
                                  lab_id: zod.string(),
                                  name: zod
                                    .enum([
                                      "MyUTI",
                                      "Nexus",
                                      "Precision Analytical",
                                      "Boston Heart At-Home Kit",
                                      "Quest",
                                      "Labcorp",
                                      "BioReference",
                                      "IHD",
                                      "SanoCardio",
                                      "Ayumetrix",
                                      "Diagnostic Solutions",
                                      "Cell Science Systems",
                                      "Genova Diagnostics",
                                      "ZRT Laboratory",
                                      "USSL",
                                      "Spiriplex",
                                      "US Biotek",
                                    ])
                                    .describe("Lab names from Vital."),
                                })
                                .describe(
                                  "Short lab information containing ID and name.",
                                ),
                              zod.null(),
                            ])
                            .optional(),
                        })
                        .describe("Vital-specific lab marker metadata."),
                    }),
                  ),
                  metadata: zod
                    .object({
                      provider: zod
                        .literal("vital")
                        .default(
                          fetchStateResponseStateLabOrdersItemOrderDataValueLabTestMetadataProviderDefault,
                        ),
                      slug: zod.string(),
                      price: zod.number(),
                      is_active: zod.boolean(),
                      status: zod.enum([
                        "active",
                        "pending_approval",
                        "inactive",
                        "unknown",
                      ]),
                      fasting: zod.union([zod.boolean(), zod.null()]),
                    })
                    .describe("Vital-specific lab test metadata."),
                  aoe_schema: zod
                    .object({
                      sections: zod.array(
                        zod
                          .object({
                            title: zod.string(),
                            description: zod.union([zod.string(), zod.null()]),
                            questions: zod.array(
                              zod
                                .object({
                                  id: zod.string(),
                                  body: zod.object({
                                    required: zod.boolean(),
                                    code: zod.string(),
                                    value: zod.string(),
                                    constraint: zod.union([
                                      zod.string(),
                                      zod.null(),
                                    ]),
                                    validator: zod.union([
                                      zod.object({
                                        type: zod.literal("choice"),
                                        answers: zod.array(
                                          zod.object({
                                            code: zod.string(),
                                            value: zod.string(),
                                          }),
                                        ),
                                      }),
                                      zod.object({
                                        type: zod.literal("text"),
                                      }),
                                      zod.object({
                                        type: zod.literal("numeric"),
                                      }),
                                      zod.object({
                                        type: zod.literal("multi_choice"),
                                        answers: zod.array(
                                          zod.object({
                                            code: zod.string(),
                                            value: zod.string(),
                                          }),
                                        ),
                                      }),
                                    ]),
                                    default: zod.union([
                                      zod.string(),
                                      zod.null(),
                                    ]),
                                  }),
                                })
                                .describe(
                                  "A required question (AOE - Ask on Entry) for a lab marker.",
                                ),
                            ),
                          })
                          .describe(
                            "A section of AOE questions grouped by marker.\n\nEach section represents questions from a single marker/biomarker,\nwith the marker's name and description as context for the questions.",
                          ),
                      ),
                    })
                    .describe(
                      "Schema for AOE (Ask on Entry) questions organized by sections.\n\nEach section corresponds to a marker and contains all questions\nassociated with that marker.",
                    ),
                  clinician: zod
                    .union([
                      zod
                        .object({
                          first_name: zod.string(),
                          last_name: zod.string(),
                          dob: zod.iso.date(),
                          address: zod
                            .object({
                              address1: zod.string(),
                              address2: zod.union([zod.string(), zod.null()]),
                              city: zod.string(),
                              state: zod.string(),
                              zip_code: zod.string(),
                            })
                            .describe(
                              "Clinician's address for lab order attribution.",
                            ),
                          npi: zod.string(),
                          email: zod.union([zod.string(), zod.null()]),
                          phone: zod.union([zod.string(), zod.null()]),
                        })
                        .describe(
                          "Clinician information required for lab orders.\n\nThis information is extracted from DoseSpot clinician records\nand validated before allowing clinicians to submit lab orders\nor create lab tests.",
                        ),
                      zod.null(),
                    ])
                    .optional(),
                }),
                metadata: zod
                  .object({
                    provider: zod
                      .literal("vital")
                      .default(
                        fetchStateResponseStateLabOrdersItemOrderDataValueMetadataProviderDefault,
                      ),
                    details: zod.union([
                      zod
                        .object({
                          type: zod
                            .literal("testkit")
                            .default(
                              fetchStateResponseStateLabOrdersItemOrderDataValueMetadataDetailsTypeDefault,
                            ),
                          id: zod.uuid(),
                          shipment: zod.union([
                            zod
                              .object({
                                id: zod.uuid(),
                                outbound: zod.union([
                                  zod
                                    .object({
                                      tracking_number: zod.union([
                                        zod.string(),
                                        zod.null(),
                                      ]),
                                      tracking_url: zod.union([
                                        zod.string(),
                                        zod.null(),
                                      ]),
                                      courier: zod.union([
                                        zod.string(),
                                        zod.null(),
                                      ]),
                                    })
                                    .describe(
                                      "Tracking information for a shipment direction (outbound or inbound).",
                                    ),
                                  zod.null(),
                                ]),
                                inbound: zod.union([
                                  zod
                                    .object({
                                      tracking_number: zod.union([
                                        zod.string(),
                                        zod.null(),
                                      ]),
                                      tracking_url: zod.union([
                                        zod.string(),
                                        zod.null(),
                                      ]),
                                      courier: zod.union([
                                        zod.string(),
                                        zod.null(),
                                      ]),
                                    })
                                    .describe(
                                      "Tracking information for a shipment direction (outbound or inbound).",
                                    ),
                                  zod.null(),
                                ]),
                                notes: zod.union([zod.string(), zod.null()]),
                              })
                              .describe(
                                "Shipment tracking information for testkit orders.",
                              ),
                            zod.null(),
                          ]),
                          created_at: zod.iso.datetime({}),
                          updated_at: zod.iso.datetime({}),
                        })
                        .describe("Details for testkit orders."),
                      zod
                        .object({
                          type: zod
                            .literal("walk_in_test")
                            .default(
                              fetchStateResponseStateLabOrdersItemOrderDataValueMetadataDetailsTypeDefaultOne,
                            ),
                          id: zod.uuid(),
                          appointment_id: zod.union([zod.uuid(), zod.null()]),
                          created_at: zod.iso.datetime({}),
                          updated_at: zod.iso.datetime({}),
                        })
                        .describe("Details for walk-in test orders."),
                      zod
                        .object({
                          type: zod
                            .literal("at_home_phlebotomy")
                            .default(
                              fetchStateResponseStateLabOrdersItemOrderDataValueMetadataDetailsTypeDefaultTwo,
                            ),
                          id: zod.uuid(),
                          appointment_id: zod.union([zod.uuid(), zod.null()]),
                          created_at: zod.iso.datetime({}),
                          updated_at: zod.iso.datetime({}),
                        })
                        .describe("Details for at-home phlebotomy orders."),
                      zod
                        .object({
                          type: zod
                            .literal("on_site_collection")
                            .default(
                              fetchStateResponseStateLabOrdersItemOrderDataValueMetadataDetailsTypeDefaultThree,
                            ),
                          id: zod.uuid(),
                          created_at: zod.iso.datetime({}),
                          updated_at: zod.iso.datetime({}),
                        })
                        .describe("Details for on-site collection orders."),
                    ]),
                    sample_id: zod.union([zod.string(), zod.null()]),
                    notes: zod.union([zod.string(), zod.null()]),
                    priority: zod.boolean().optional(),
                    events: zod
                      .array(
                        zod
                          .object({
                            remote_id: zod.number(),
                            created_at: zod.iso.datetime({}),
                            status: zod.union([
                              zod.enum([
                                "received.walk_in_test.ordered",
                                "received.walk_in_test.requisition_created",
                                "received.walk_in_test.requisition_bypassed",
                                "completed.walk_in_test.completed",
                                "sample_with_lab.walk_in_test.partial_results",
                                "failed.walk_in_test.sample_error",
                                "cancelled.walk_in_test.cancelled",
                                "collecting_sample.walk_in_test.appointment_pending",
                                "collecting_sample.walk_in_test.appointment_scheduled",
                                "collecting_sample.walk_in_test.appointment_cancelled",
                                "collecting_sample.walk_in_test.redraw_available",
                                "received.at_home_phlebotomy.ordered",
                                "received.at_home_phlebotomy.requisition_created",
                                "received.at_home_phlebotomy.requisition_bypassed",
                                "collecting_sample.at_home_phlebotomy.appointment_pending",
                                "collecting_sample.at_home_phlebotomy.appointment_scheduled",
                                "collecting_sample.at_home_phlebotomy.draw_completed",
                                "collecting_sample.at_home_phlebotomy.appointment_cancelled",
                                "completed.at_home_phlebotomy.completed",
                                "sample_with_lab.at_home_phlebotomy.partial_results",
                                "cancelled.at_home_phlebotomy.cancelled",
                                "failed.at_home_phlebotomy.sample_error",
                                "received.testkit.ordered",
                                "received.testkit.awaiting_registration",
                                "received.testkit.requisition_created",
                                "received.testkit.requisition_bypassed",
                                "received.testkit.registered",
                                "collecting_sample.testkit.transit_customer",
                                "collecting_sample.testkit.out_for_delivery",
                                "collecting_sample.testkit.with_customer",
                                "collecting_sample.testkit.transit_lab",
                                "sample_with_lab.testkit.delivered_to_lab",
                                "completed.testkit.completed",
                                "failed.testkit.failure_to_deliver_to_customer",
                                "failed.testkit.failure_to_deliver_to_lab",
                                "failed.testkit.sample_error",
                                "failed.testkit.lost",
                                "cancelled.testkit.cancelled",
                                "cancelled.testkit.do_not_process",
                                "collecting_sample.testkit.problem_in_transit_customer",
                                "collecting_sample.testkit.problem_in_transit_lab",
                                "received.on_site_collection.ordered",
                                "received.on_site_collection.requisition_created",
                                "received.on_site_collection.requisition_bypassed",
                                "sample_with_lab.on_site_collection.draw_completed",
                                "completed.on_site_collection.completed",
                                "cancelled.on_site_collection.cancelled",
                                "sample_with_lab.on_site_collection.partial_results",
                                "failed.on_site_collection.sample_error",
                              ]),
                              zod.string(),
                            ]),
                          })
                          .describe("An event in the lifecycle of an order."),
                      )
                      .default(
                        fetchStateResponseStateLabOrdersItemOrderDataValueMetadataEventsDefault,
                      ),
                  })
                  .describe("Vital-specific order metadata."),
                interpretation: zod.enum([
                  "normal",
                  "abnormal",
                  "critical",
                  "unknown",
                ]),
                status: zod.enum([
                  "received",
                  "collecting_sample",
                  "sample_with_lab",
                  "completed",
                  "cancelled",
                  "failed",
                  "unknown",
                ]),
              }),
            })
            .describe("Tagged lab order for Vital provider."),
        })
        .describe(
          "A lab order in the care state.\n\nThis mirrors the LabOrder SQL entity but in the diff-based CareState store,\nenabling change tracking and integration with other care state entities.",
        ),
    ),
    prescriptions: zod.array(
      zod
        .object({
          id: zod.uuid(),
          link: zod.union([
            zod.object({
              type: zod
                .literal("patient")
                .default(
                  fetchStateResponseStatePrescriptionsItemLinkTypeDefault,
                ),
            }),
            zod.object({
              type: zod
                .literal("problem")
                .default(
                  fetchStateResponseStatePrescriptionsItemLinkTypeDefaultOne,
                ),
              id: zod.uuid(),
            }),
            zod.object({
              type: zod
                .literal("request")
                .default(
                  fetchStateResponseStatePrescriptionsItemLinkTypeDefaultTwo,
                ),
              id: zod.uuid(),
            }),
            zod.object({
              type: zod
                .literal("orphan")
                .default(
                  fetchStateResponseStatePrescriptionsItemLinkTypeDefaultThree,
                ),
            }),
          ]),
          dosespot_prescription_id: zod.string(),
          prescription_record_id: zod.uuid(),
          cached_info: zod
            .union([
              zod
                .object({
                  PrescriptionId: zod
                    .union([zod.number(), zod.null()])
                    .optional(),
                  WrittenDate: zod.union([zod.string(), zod.null()]).optional(),
                  Directions: zod.union([zod.string(), zod.null()]).optional(),
                  Quantity: zod.union([zod.string(), zod.null()]).optional(),
                  DispenseUnitId: zod
                    .union([zod.number(), zod.null()])
                    .optional(),
                  Refills: zod.union([zod.string(), zod.null()]).optional(),
                  DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
                  PharmacyId: zod.union([zod.number(), zod.null()]).optional(),
                  PharmacyNotes: zod
                    .union([zod.string(), zod.null()])
                    .optional(),
                  NoSubstitutions: zod
                    .union([zod.boolean(), zod.null()])
                    .optional(),
                  EffectiveDate: zod
                    .union([zod.string(), zod.null()])
                    .optional(),
                  LastFillDate: zod
                    .union([zod.string(), zod.null()])
                    .optional(),
                  PrescriberId: zod
                    .union([zod.number(), zod.null()])
                    .optional(),
                  PrescriberAgentId: zod
                    .union([zod.number(), zod.null()])
                    .optional(),
                  RxReferenceNumber: zod
                    .union([zod.string(), zod.null()])
                    .optional(),
                  Status: zod
                    .union([
                      zod
                        .enum([
                          "Unknown",
                          "Entered",
                          "Printed",
                          "Sending",
                          "eRxSent",
                          "FaxSent",
                          "Error",
                          "Deleted",
                          "Requested",
                          "Edited",
                          "EpcsError",
                          "EpcsSigned",
                          "ReadyToSign",
                          "PharmacyVerified",
                          "PharmacySelect",
                        ])
                        .describe(
                          "Valid prescription status types for DoseSpot.",
                        ),
                      zod.null(),
                    ])
                    .optional(),
                  Formulary: zod.union([zod.boolean(), zod.null()]).optional(),
                  EligibilityId: zod
                    .union([zod.number(), zod.null()])
                    .optional(),
                  Type: zod
                    .union([
                      zod
                        .enum([
                          "Coded",
                          "FreeText",
                          "NDC",
                          "Supply",
                          "Compound",
                        ])
                        .describe("Valid prescription types for DoseSpot."),
                      zod.null(),
                    ])
                    .optional(),
                  NonDoseSpotPrescriptionId: zod
                    .union([zod.string(), zod.null()])
                    .optional(),
                  ErrorIgnored: zod
                    .union([zod.boolean(), zod.null()])
                    .optional(),
                  SupplyId: zod.union([zod.number(), zod.null()]).optional(),
                  FreeTextType: zod
                    .union([
                      zod
                        .enum(["Medication", "Supply", "Compound"])
                        .describe(
                          "Valid free text types for DoseSpot prescriptions.",
                        ),
                      zod.null(),
                    ])
                    .optional(),
                  ClinicId: zod.union([zod.number(), zod.null()]).optional(),
                  SupervisorId: zod
                    .union([zod.number(), zod.null()])
                    .optional(),
                  IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
                  IsRxRenewal: zod
                    .union([zod.boolean(), zod.null()])
                    .optional(),
                  RxRenewalNote: zod
                    .union([zod.string(), zod.null()])
                    .optional(),
                  FirstPrescriptionDiagnosis: zod
                    .union([
                      zod
                        .object({
                          PrimaryDiagnosis: zod
                            .union([
                              zod
                                .object({
                                  DiagnosisId: zod
                                    .union([zod.number(), zod.null()])
                                    .optional(),
                                  DiagnosisCode: zod
                                    .union([zod.string(), zod.null()])
                                    .optional(),
                                  DiagnosisDescription: zod
                                    .union([zod.string(), zod.null()])
                                    .optional(),
                                })
                                .describe("DoseSpot diagnosis information."),
                              zod.null(),
                            ])
                            .optional(),
                          SecondaryDiagnosis: zod
                            .union([
                              zod
                                .object({
                                  DiagnosisId: zod
                                    .union([zod.number(), zod.null()])
                                    .optional(),
                                  DiagnosisCode: zod
                                    .union([zod.string(), zod.null()])
                                    .optional(),
                                  DiagnosisDescription: zod
                                    .union([zod.string(), zod.null()])
                                    .optional(),
                                })
                                .describe("DoseSpot diagnosis information."),
                              zod.null(),
                            ])
                            .optional(),
                        })
                        .describe(
                          "DoseSpot prescription diagnosis information.",
                        ),
                      zod.null(),
                    ])
                    .optional(),
                  SecondPrescriptionDiagnosis: zod
                    .union([
                      zod
                        .object({
                          PrimaryDiagnosis: zod
                            .union([
                              zod
                                .object({
                                  DiagnosisId: zod
                                    .union([zod.number(), zod.null()])
                                    .optional(),
                                  DiagnosisCode: zod
                                    .union([zod.string(), zod.null()])
                                    .optional(),
                                  DiagnosisDescription: zod
                                    .union([zod.string(), zod.null()])
                                    .optional(),
                                })
                                .describe("DoseSpot diagnosis information."),
                              zod.null(),
                            ])
                            .optional(),
                          SecondaryDiagnosis: zod
                            .union([
                              zod
                                .object({
                                  DiagnosisId: zod
                                    .union([zod.number(), zod.null()])
                                    .optional(),
                                  DiagnosisCode: zod
                                    .union([zod.string(), zod.null()])
                                    .optional(),
                                  DiagnosisDescription: zod
                                    .union([zod.string(), zod.null()])
                                    .optional(),
                                })
                                .describe("DoseSpot diagnosis information."),
                              zod.null(),
                            ])
                            .optional(),
                        })
                        .describe(
                          "DoseSpot prescription diagnosis information.",
                        ),
                      zod.null(),
                    ])
                    .optional(),
                  Strength: zod.union([zod.string(), zod.null()]).optional(),
                  PatientMedicationId: zod
                    .union([zod.number(), zod.null()])
                    .optional(),
                  MedicationStatus: zod
                    .union([
                      zod
                        .enum([
                          "Unknown",
                          "Active",
                          "Inactive",
                          "Discontinued",
                          "Deleted",
                          "Completed",
                          "CancelRequested",
                          "CancelPending",
                          "Cancelled",
                          "CancelDenied",
                          "Changed",
                          "FullFill",
                          "PartialFill",
                          "NoFill",
                        ])
                        .describe(
                          "Valid medication status types for DoseSpot.",
                        ),
                      zod.null(),
                    ])
                    .optional(),
                  Comment: zod.union([zod.string(), zod.null()]).optional(),
                  DateInactive: zod
                    .union([zod.string(), zod.null()])
                    .optional(),
                  Encounter: zod.union([zod.string(), zod.null()]).optional(),
                  DisplayName: zod.union([zod.string(), zod.null()]).optional(),
                  DispensableDrugId: zod
                    .union([zod.number(), zod.null()])
                    .optional(),
                  Schedule: zod.union([zod.number(), zod.null()]).optional(),
                  CompoundIngredients: zod
                    .union([
                      zod.array(
                        zod
                          .object({
                            DispensableDrugId: zod
                              .union([zod.number(), zod.null()])
                              .optional(),
                            FreeText: zod
                              .union([zod.string(), zod.null()])
                              .optional(),
                            DispenseUnitId: zod
                              .union([zod.number(), zod.null()])
                              .optional(),
                            Quantity: zod.string(),
                            IsFreeTextEPCS: zod
                              .union([zod.boolean(), zod.null()])
                              .optional(),
                          })
                          .describe(
                            "DoseSpot compound ingredient information.",
                          ),
                      ),
                      zod.null(),
                    ])
                    .optional(),
                })
                .describe(
                  "Complete prescription information from DoseSpot API.",
                ),
              zod.null(),
            ])
            .optional(),
        })
        .describe(
          'A prescription written by a clinician, mirrored into care state for\nunified audit and timeline tracking.\n\nCare State owns identity and linkage (``id``, ``link``,\n``dosespot_prescription_id``, ``prescription_record_id``); the full\nDoseSpot clinical payload is carried verbatim in ``cached_info`` so the\nCare State row is a self-contained snapshot. ``cached_info`` is\noptional because DoseSpot populates fields lazily across the\nprescription lifecycle; consumers needing clinical detail should treat\na ``None`` payload as \"row exists but not yet hydrated.\"',
        ),
    ),
    prior_auth_requests: zod.array(
      zod
        .object({
          id: zod.uuid(),
          link: zod.union([
            zod.object({
              type: zod
                .literal("patient")
                .default(
                  fetchStateResponseStatePriorAuthRequestsItemLinkTypeDefault,
                ),
            }),
            zod.object({
              type: zod
                .literal("problem")
                .default(
                  fetchStateResponseStatePriorAuthRequestsItemLinkTypeDefaultOne,
                ),
              id: zod.uuid(),
            }),
            zod.object({
              type: zod
                .literal("request")
                .default(
                  fetchStateResponseStatePriorAuthRequestsItemLinkTypeDefaultTwo,
                ),
              id: zod.uuid(),
            }),
            zod.object({
              type: zod
                .literal("orphan")
                .default(
                  fetchStateResponseStatePriorAuthRequestsItemLinkTypeDefaultThree,
                ),
            }),
          ]),
          dosespot_prescription_id: zod.string(),
          prescription_record_id: zod.uuid(),
          dosespot_prior_auth_case_number: zod
            .union([zod.string(), zod.null()])
            .optional(),
          status: zod
            .enum([
              "Requested",
              "Appealing",
              "Cancel Requested",
              "Action Required",
              "Approved",
              "Partially Approved",
              "Not Required",
              "Denied",
              "Cancelled",
              "Error",
              "Sent to Pharmacy",
            ])
            .describe(
              'Normalized prior-authorization status.\n\nCollapses DoseSpot\'s 17-value `PriorAuthorizationStatusType` plus the\n25-value `ClosedReasonCodeId` super-status into an \"owns it right now\"\noriented enum. The full mapping from raw DoseSpot status lives on the PA\npoller (`_map_dosespot_status`) and is documented in `PRIOR_AUTH.md`.\n\n``NOT_REQUIRED`` is deliberately distinct from ``APPROVED`` (no auth\nnumber) and ``PARTIALLY_APPROVED`` is distinct from ``APPROVED`` because\nit comes with a narrower Quantity/DaysSupply/NumberOfRefills that the\nclinician must acknowledge or appeal.\n\n``StrEnum`` (not plain ``Enum``) because the values round-trip through\nthe ``dosespot_prior_auth_records.normalized_status`` ``TEXT`` column:\nasyncpg only accepts ``str`` for ``TEXT`` bind parameters, and a plain\n``Enum`` instance is not a ``str`` subclass.',
            ),
          note: zod.object({
            value: zod.string(),
            expiry: zod.object({
              basis: zod.union([zod.string(), zod.null()]),
              time: zod.union([zod.iso.datetime({}), zod.null()]),
            }),
          }),
          is_offline: zod.boolean().optional(),
          prior_auth_number: zod.union([zod.string(), zod.null()]).optional(),
          denial_reason: zod.union([zod.string(), zod.null()]).optional(),
        })
        .describe(
          "A prior-authorization case mirrored into CareState.\n\nThin and denormalized for patient-timeline rendering. The full cached\nDoseSpot payload lives on ``DosespotPriorAuthRecord`` (SQL); this row\ncarries only what the timeline, inbox, and copilot need.",
        ),
    ),
    pre_requests: zod.array(
      zod
        .object({
          id: zod.uuid(),
          title: zod.string(),
          message: zod.string(),
          urgency: zod.enum(["Routine", "Urgent"]),
          status: zod
            .enum(["Pending", "Processed"])
            .describe("Status of a pre-request in the escalation pipeline."),
          chat_link: zod
            .union([
              zod.union([
                zod.object({
                  type: zod
                    .literal("chat_message")
                    .default(
                      fetchStateResponseStatePreRequestsItemChatLinkTypeDefault,
                    ),
                  conversation_id: zod.uuid(),
                  message_id: zod.uuid(),
                }),
                zod.object({
                  type: zod
                    .literal("chat_conversation")
                    .default(
                      fetchStateResponseStatePreRequestsItemChatLinkTypeDefaultOne,
                    ),
                  conversation_id: zod.uuid(),
                }),
              ]),
              zod.null(),
            ])
            .optional(),
        })
        .describe(
          "A pre-request created by the AI when it identifies something requiring clinician attention.\n\nPre-requests are staged here until the librarian processes them into proper requests.\nThis decoupling allows:\n- The AI to not worry about deduplication\n- The librarian to merge similar escalations intelligently\n- Clinicians to never see incomplete or duplicate requests",
        ),
    ),
    proposed_actions: zod.array(
      zod
        .object({
          id: zod.uuid(),
          external_id: zod.string(),
          link: zod.union([
            zod.object({
              type: zod
                .literal("patient")
                .default(
                  fetchStateResponseStateProposedActionsItemLinkTypeDefault,
                ),
            }),
            zod.object({
              type: zod
                .literal("problem")
                .default(
                  fetchStateResponseStateProposedActionsItemLinkTypeDefaultOne,
                ),
              id: zod.uuid(),
            }),
            zod.object({
              type: zod
                .literal("request")
                .default(
                  fetchStateResponseStateProposedActionsItemLinkTypeDefaultTwo,
                ),
              id: zod.uuid(),
            }),
            zod.object({
              type: zod
                .literal("orphan")
                .default(
                  fetchStateResponseStateProposedActionsItemLinkTypeDefaultThree,
                ),
            }),
          ]),
          title: zod.string(),
          todo_status: zod.enum(["Open", "Done", "Archived"]),
          decision: zod.enum([
            "Pending",
            "Approved",
            "AutoApproved",
            "Rejected",
          ]),
          payload: zod
            .object({
              payload_id: zod.string(),
              tool_name: zod.string(),
              tool_input: zod.record(zod.string(), zod.unknown()),
              justification: zod.string(),
            })
            .describe(
              "A frozen tool call: the exact invocation to execute when the action is run.\n\nThis type is shared between CareState rows and REST API modification\nrecords. It deliberately does NOT use ``APIVIEW_MODEL_CONFIG`` because\nCareState serialisation (``model_dump()``) must produce snake_case keys\nand the SDK type must match that runtime shape. The REST API input layer\nconverts camelCase payload fields to snake_case before Pydantic sees them.\n\nThe opaque ``tool_input`` dict keys are never converted — they preserve\nwhatever casing the LLM originally used (typically camelCase).",
            ),
          alternatives: zod.array(
            zod
              .object({
                payload_id: zod.string(),
                tool_name: zod.string(),
                tool_input: zod.record(zod.string(), zod.unknown()),
                justification: zod.string(),
              })
              .describe(
                "A frozen tool call: the exact invocation to execute when the action is run.\n\nThis type is shared between CareState rows and REST API modification\nrecords. It deliberately does NOT use ``APIVIEW_MODEL_CONFIG`` because\nCareState serialisation (``model_dump()``) must produce snake_case keys\nand the SDK type must match that runtime shape. The REST API input layer\nconverts camelCase payload fields to snake_case before Pydantic sees them.\n\nThe opaque ``tool_input`` dict keys are never converted — they preserve\nwhatever casing the LLM originally used (typically camelCase).",
              ),
          ),
          justification: zod.string(),
          depends_on_action_external_ids: zod.array(zod.string()),
          run_status: zod
            .enum(["Idle", "Running", "Succeeded", "Failed"])
            .optional(),
          tool_output: zod
            .union([zod.record(zod.string(), zod.unknown()), zod.null()])
            .optional(),
          run_error: zod.union([zod.string(), zod.null()]).optional(),
        })
        .describe(
          "A discrete action in a patient's care plan that a clinician can approve/reject.\n\nOnce approved, it behaves as a frozen tool call: executing it runs the exact\nprecomputed tool invocation without additional LLM reasoning.\n\nActions may form a workflow graph via depends_on_action_external_ids.\nExecution state (run_status, tool_output, run_error) lives directly on the\naction row rather than in a separate runs table.",
        ),
    ),
  }),
  cursor: zod.number(),
});

/**
 * Apply updates to the care state.

Accepts a dictionary of updates keyed by client-provided update IDs.
Returns a dictionary of replies indicating whether each update was
accepted or rejected.
 * @summary Update State
 */
export const updateStateParams = zod.object({
  user_id: zod.uuid(),
});

export const updateStateBodyUpdatesTypeDefault = "create";
export const updateStateBodyUpdatesTypeDefaultOne = "update";
export const updateStateBodyUpdatesTypeDefaultTwo = "delete";

export const updateStateBody = zod.object({
  updates: zod.record(
    zod.string(),
    zod.union([
      zod.object({
        type: zod.literal("create").default(updateStateBodyUpdatesTypeDefault),
        table: zod.string(),
        row: zod.record(zod.string(), zod.unknown()),
      }),
      zod.object({
        type: zod
          .literal("update")
          .default(updateStateBodyUpdatesTypeDefaultOne),
        table: zod.string(),
        id: zod.string(),
        new_value: zod.record(zod.string(), zod.unknown()),
        conditional_old_value: zod.union([
          zod.record(zod.string(), zod.unknown()),
          zod.null(),
        ]),
      }),
      zod.object({
        type: zod
          .literal("delete")
          .default(updateStateBodyUpdatesTypeDefaultTwo),
        table: zod.string(),
        id: zod.string(),
        conditional_old_value: zod.union([
          zod.record(zod.string(), zod.unknown()),
          zod.null(),
        ]),
      }),
    ]),
  ),
});

export const updateStateResponseRepliesTypeDefault = "acceptedUpdate";
export const updateStateResponseRepliesTypeDefaultOne = "rejectedUpdate";

export const updateStateResponse = zod.object({
  replies: zod.record(
    zod.string(),
    zod.union([
      zod.object({
        type: zod
          .literal("acceptedUpdate")
          .default(updateStateResponseRepliesTypeDefault),
        cursor: zod.number(),
      }),
      zod.object({
        type: zod
          .literal("rejectedUpdate")
          .default(updateStateResponseRepliesTypeDefaultOne),
        reason: zod.string(),
      }),
    ]),
  ),
});

/**
 * Stream care state events as they come down.

Returns ping events when no data is available, and a disconnect
event before closing.
 * @summary Stream State Events
 */
export const streamStateEventsParams = zod.object({
  user_id: zod.uuid(),
});

export const streamStateEventsQueryParams = zod.object({
  cursor: zod.number(),
});

/**
 * Fetch the care state timeline for a patient.

Returns a paginated list of human-readable timeline events describing
changes to the care state, such as "<identity> updated <row> in <table>".
 * @summary Fetch Timeline
 */
export const fetchTimelineParams = zod.object({
  user_id: zod.uuid(),
});

export const fetchTimelineQueryLimitDefault = 50;

export const fetchTimelineQueryParams = zod.object({
  limit: zod.number().default(fetchTimelineQueryLimitDefault),
  before_cursor: zod.union([zod.uuid(), zod.null()]).optional(),
  after_cursor: zod.union([zod.uuid(), zod.null()]).optional(),
});

export const fetchTimelineResponseEventsItemContextIdentityTypeDefault =
  "clinician";
export const fetchTimelineResponseEventsItemContextIdentityTypeDefaultOne =
  "system";

export const fetchTimelineResponse = zod.object({
  events: zod.array(
    zod
      .object({
        context: zod.object({
          identity: zod.union([
            zod.object({
              type: zod
                .literal("clinician")
                .default(
                  fetchTimelineResponseEventsItemContextIdentityTypeDefault,
                ),
              clinician_id: zod.string(),
            }),
            zod
              .object({
                type: zod
                  .literal("system")
                  .default(
                    fetchTimelineResponseEventsItemContextIdentityTypeDefaultOne,
                  ),
                source: zod.string(),
              })
              .describe(
                "Identity for system-initiated updates to the care state.\nUsed when automated processes (like clinician escalations) need to\nmodify the care state without a specific clinician acting.",
              ),
          ]),
          table: zod.string(),
          row: zod.string(),
        }),
        identity_display: zod.string(),
        when: zod.iso.datetime({}),
        message: zod.string(),
        structured_events: zod.object({}),
      })
      .describe(
        "A public timeline event representing, in some friendly format\n\nMultiple updates can be consolidated if they occur within an hour\nand share the same identity, row, and table.",
      ),
  ),
  beforeCursor: zod.union([zod.uuid(), zod.null()]),
  afterCursor: zod.union([zod.uuid(), zod.null()]),
});

/**
 * Search for available lab tests.

Returns a list of lab tests that can be ordered based on the
provided search criteria. Results include AOE question schemas
when applicable.
 * @summary Search Lab Tests
 */
export const searchLabTestsBody = zod
  .object({
    name: zod.union([zod.string(), zod.null()]).optional(),
    sampleType: zod
      .union([
        zod.enum([
          "dried_blood_spot",
          "arm_collector",
          "serum",
          "saliva",
          "urine",
        ]),
        zod.null(),
      ])
      .optional(),
    method: zod
      .union([
        zod.enum([
          "testkit",
          "walk_in_test",
          "at_home_phlebotomy",
          "on_site_collection",
        ]),
        zod.null(),
      ])
      .optional(),
  })
  .describe("Request to search for available lab tests.");

export const searchLabTestsResponseLabTestsItemMarkersItemMetadataProviderDefault =
  "vital";
export const searchLabTestsResponseLabTestsItemMarkersItemMetadataALaCarteEnabledDefault = false;
export const searchLabTestsResponseLabTestsItemMetadataProviderDefault =
  "vital";

export const searchLabTestsResponse = zod
  .object({
    labTests: zod.array(
      zod.object({
        id: zod.string(),
        name: zod.string(),
        sample_type: zod.enum([
          "dried_blood_spot",
          "arm_collector",
          "serum",
          "saliva",
          "urine",
        ]),
        method: zod.enum([
          "testkit",
          "walk_in_test",
          "at_home_phlebotomy",
          "on_site_collection",
        ]),
        laboratory: zod.union([
          zod
            .object({
              name: zod.string(),
              formatted_address: zod.string(),
              collection_methods: zod.array(
                zod.enum([
                  "testkit",
                  "walk_in_test",
                  "at_home_phlebotomy",
                  "on_site_collection",
                ]),
              ),
              sample_types: zod.array(
                zod.enum([
                  "dried_blood_spot",
                  "arm_collector",
                  "serum",
                  "saliva",
                  "urine",
                ]),
              ),
            })
            .describe("Information about a lab facility."),
          zod.null(),
        ]),
        markers: zod.array(
          zod.object({
            id: zod.string(),
            name: zod.string(),
            description: zod.union([zod.string(), zod.null()]),
            unit: zod.union([zod.string(), zod.null()]),
            metadata: zod
              .object({
                provider: zod
                  .literal("vital")
                  .default(
                    searchLabTestsResponseLabTestsItemMarkersItemMetadataProviderDefault,
                  ),
                slug: zod.string(),
                type: zod.union([zod.enum(["biomarker", "panel"]), zod.null()]),
                provider_id: zod.union([zod.string(), zod.null()]),
                price: zod.union([zod.string(), zod.null()]),
                a_la_carte_enabled: zod.boolean().optional(),
                questions: zod.array(
                  zod
                    .object({
                      marker_id: zod.string(),
                      question_id: zod.string(),
                      body: zod.object({
                        required: zod.boolean(),
                        code: zod.string(),
                        value: zod.string(),
                        constraint: zod.union([zod.string(), zod.null()]),
                        validator: zod.union([
                          zod.object({
                            type: zod.literal("choice"),
                            answers: zod.array(
                              zod.object({
                                code: zod.string(),
                                value: zod.string(),
                              }),
                            ),
                          }),
                          zod.object({
                            type: zod.literal("text"),
                          }),
                          zod.object({
                            type: zod.literal("numeric"),
                          }),
                          zod.object({
                            type: zod.literal("multi_choice"),
                            answers: zod.array(
                              zod.object({
                                code: zod.string(),
                                value: zod.string(),
                              }),
                            ),
                          }),
                        ]),
                        default: zod.union([zod.string(), zod.null()]),
                      }),
                    })
                    .describe("Vital-specific lab marker question."),
                ),
                lab_info: zod
                  .union([
                    zod
                      .object({
                        lab_id: zod.string(),
                        name: zod
                          .enum([
                            "MyUTI",
                            "Nexus",
                            "Precision Analytical",
                            "Boston Heart At-Home Kit",
                            "Quest",
                            "Labcorp",
                            "BioReference",
                            "IHD",
                            "SanoCardio",
                            "Ayumetrix",
                            "Diagnostic Solutions",
                            "Cell Science Systems",
                            "Genova Diagnostics",
                            "ZRT Laboratory",
                            "USSL",
                            "Spiriplex",
                            "US Biotek",
                          ])
                          .describe("Lab names from Vital."),
                      })
                      .describe(
                        "Short lab information containing ID and name.",
                      ),
                    zod.null(),
                  ])
                  .optional(),
              })
              .describe("Vital-specific lab marker metadata."),
          }),
        ),
        metadata: zod
          .object({
            provider: zod
              .literal("vital")
              .default(
                searchLabTestsResponseLabTestsItemMetadataProviderDefault,
              ),
            slug: zod.string(),
            price: zod.number(),
            is_active: zod.boolean(),
            status: zod.enum([
              "active",
              "pending_approval",
              "inactive",
              "unknown",
            ]),
            fasting: zod.union([zod.boolean(), zod.null()]),
          })
          .describe("Vital-specific lab test metadata."),
        aoe_schema: zod
          .object({
            sections: zod.array(
              zod
                .object({
                  title: zod.string(),
                  description: zod.union([zod.string(), zod.null()]),
                  questions: zod.array(
                    zod
                      .object({
                        id: zod.string(),
                        body: zod.object({
                          required: zod.boolean(),
                          code: zod.string(),
                          value: zod.string(),
                          constraint: zod.union([zod.string(), zod.null()]),
                          validator: zod.union([
                            zod.object({
                              type: zod.literal("choice"),
                              answers: zod.array(
                                zod.object({
                                  code: zod.string(),
                                  value: zod.string(),
                                }),
                              ),
                            }),
                            zod.object({
                              type: zod.literal("text"),
                            }),
                            zod.object({
                              type: zod.literal("numeric"),
                            }),
                            zod.object({
                              type: zod.literal("multi_choice"),
                              answers: zod.array(
                                zod.object({
                                  code: zod.string(),
                                  value: zod.string(),
                                }),
                              ),
                            }),
                          ]),
                          default: zod.union([zod.string(), zod.null()]),
                        }),
                      })
                      .describe(
                        "A required question (AOE - Ask on Entry) for a lab marker.",
                      ),
                  ),
                })
                .describe(
                  "A section of AOE questions grouped by marker.\n\nEach section represents questions from a single marker/biomarker,\nwith the marker's name and description as context for the questions.",
                ),
            ),
          })
          .describe(
            "Schema for AOE (Ask on Entry) questions organized by sections.\n\nEach section corresponds to a marker and contains all questions\nassociated with that marker.",
          ),
        clinician: zod
          .union([
            zod
              .object({
                first_name: zod.string(),
                last_name: zod.string(),
                dob: zod.iso.date(),
                address: zod
                  .object({
                    address1: zod.string(),
                    address2: zod.union([zod.string(), zod.null()]),
                    city: zod.string(),
                    state: zod.string(),
                    zip_code: zod.string(),
                  })
                  .describe("Clinician's address for lab order attribution."),
                npi: zod.string(),
                email: zod.union([zod.string(), zod.null()]),
                phone: zod.union([zod.string(), zod.null()]),
              })
              .describe(
                "Clinician information required for lab orders.\n\nThis information is extracted from DoseSpot clinician records\nand validated before allowing clinicians to submit lab orders\nor create lab tests.",
              ),
            zod.null(),
          ])
          .optional(),
      }),
    ),
  })
  .describe("Response containing available lab tests.");

/**
 * Submit a new lab order for a patient.

Creates an order for the specified lab test with the provided
AOE answers and order options. The order is submitted to the
lab testing provider (Vital) and persisted locally.
 * @summary Submit Lab Order
 */
export const submitLabOrderParams = zod.object({
  user_id: zod.uuid(),
});

export const submitLabOrderBodyAoeAnswersDefault = [];
export const submitLabOrderBodyPriorityDefault = false;

export const submitLabOrderBody = zod
  .object({
    labTestId: zod.string(),
    aoeAnswers: zod
      .array(
        zod
          .object({
            question_id: zod.string(),
            answer_code: zod.string(),
          })
          .describe("A user's answer to an AOE question."),
      )
      .default(submitLabOrderBodyAoeAnswersDefault),
    notes: zod.union([zod.string(), zod.null()]).optional(),
    priority: zod.boolean().optional(),
    icdCodes: zod.union([zod.array(zod.string()), zod.null()]).optional(),
  })
  .describe("Request to submit a lab order.");

export const submitLabOrderResponseOrderLabTestMarkersItemMetadataProviderDefault =
  "vital";
export const submitLabOrderResponseOrderLabTestMarkersItemMetadataALaCarteEnabledDefault = false;
export const submitLabOrderResponseOrderLabTestMetadataProviderDefault =
  "vital";
export const submitLabOrderResponseOrderMetadataProviderDefault = "vital";
export const submitLabOrderResponseOrderMetadataDetailsTypeDefault = "testkit";
export const submitLabOrderResponseOrderMetadataDetailsTypeDefaultOne =
  "walk_in_test";
export const submitLabOrderResponseOrderMetadataDetailsTypeDefaultTwo =
  "at_home_phlebotomy";
export const submitLabOrderResponseOrderMetadataDetailsTypeDefaultThree =
  "on_site_collection";
export const submitLabOrderResponseOrderMetadataPriorityDefault = false;
export const submitLabOrderResponseOrderMetadataEventsDefault = [];

export const submitLabOrderResponse = zod
  .object({
    order: zod.object({
      remote_id: zod.uuid(),
      user_id: zod.uuid(),
      created_at: zod.iso.datetime({}),
      updated_at: zod.iso.datetime({}),
      lab_test: zod.object({
        id: zod.string(),
        name: zod.string(),
        sample_type: zod.enum([
          "dried_blood_spot",
          "arm_collector",
          "serum",
          "saliva",
          "urine",
        ]),
        method: zod.enum([
          "testkit",
          "walk_in_test",
          "at_home_phlebotomy",
          "on_site_collection",
        ]),
        laboratory: zod.union([
          zod
            .object({
              name: zod.string(),
              formatted_address: zod.string(),
              collection_methods: zod.array(
                zod.enum([
                  "testkit",
                  "walk_in_test",
                  "at_home_phlebotomy",
                  "on_site_collection",
                ]),
              ),
              sample_types: zod.array(
                zod.enum([
                  "dried_blood_spot",
                  "arm_collector",
                  "serum",
                  "saliva",
                  "urine",
                ]),
              ),
            })
            .describe("Information about a lab facility."),
          zod.null(),
        ]),
        markers: zod.array(
          zod.object({
            id: zod.string(),
            name: zod.string(),
            description: zod.union([zod.string(), zod.null()]),
            unit: zod.union([zod.string(), zod.null()]),
            metadata: zod
              .object({
                provider: zod
                  .literal("vital")
                  .default(
                    submitLabOrderResponseOrderLabTestMarkersItemMetadataProviderDefault,
                  ),
                slug: zod.string(),
                type: zod.union([zod.enum(["biomarker", "panel"]), zod.null()]),
                provider_id: zod.union([zod.string(), zod.null()]),
                price: zod.union([zod.string(), zod.null()]),
                a_la_carte_enabled: zod.boolean().optional(),
                questions: zod.array(
                  zod
                    .object({
                      marker_id: zod.string(),
                      question_id: zod.string(),
                      body: zod.object({
                        required: zod.boolean(),
                        code: zod.string(),
                        value: zod.string(),
                        constraint: zod.union([zod.string(), zod.null()]),
                        validator: zod.union([
                          zod.object({
                            type: zod.literal("choice"),
                            answers: zod.array(
                              zod.object({
                                code: zod.string(),
                                value: zod.string(),
                              }),
                            ),
                          }),
                          zod.object({
                            type: zod.literal("text"),
                          }),
                          zod.object({
                            type: zod.literal("numeric"),
                          }),
                          zod.object({
                            type: zod.literal("multi_choice"),
                            answers: zod.array(
                              zod.object({
                                code: zod.string(),
                                value: zod.string(),
                              }),
                            ),
                          }),
                        ]),
                        default: zod.union([zod.string(), zod.null()]),
                      }),
                    })
                    .describe("Vital-specific lab marker question."),
                ),
                lab_info: zod
                  .union([
                    zod
                      .object({
                        lab_id: zod.string(),
                        name: zod
                          .enum([
                            "MyUTI",
                            "Nexus",
                            "Precision Analytical",
                            "Boston Heart At-Home Kit",
                            "Quest",
                            "Labcorp",
                            "BioReference",
                            "IHD",
                            "SanoCardio",
                            "Ayumetrix",
                            "Diagnostic Solutions",
                            "Cell Science Systems",
                            "Genova Diagnostics",
                            "ZRT Laboratory",
                            "USSL",
                            "Spiriplex",
                            "US Biotek",
                          ])
                          .describe("Lab names from Vital."),
                      })
                      .describe(
                        "Short lab information containing ID and name.",
                      ),
                    zod.null(),
                  ])
                  .optional(),
              })
              .describe("Vital-specific lab marker metadata."),
          }),
        ),
        metadata: zod
          .object({
            provider: zod
              .literal("vital")
              .default(
                submitLabOrderResponseOrderLabTestMetadataProviderDefault,
              ),
            slug: zod.string(),
            price: zod.number(),
            is_active: zod.boolean(),
            status: zod.enum([
              "active",
              "pending_approval",
              "inactive",
              "unknown",
            ]),
            fasting: zod.union([zod.boolean(), zod.null()]),
          })
          .describe("Vital-specific lab test metadata."),
        aoe_schema: zod
          .object({
            sections: zod.array(
              zod
                .object({
                  title: zod.string(),
                  description: zod.union([zod.string(), zod.null()]),
                  questions: zod.array(
                    zod
                      .object({
                        id: zod.string(),
                        body: zod.object({
                          required: zod.boolean(),
                          code: zod.string(),
                          value: zod.string(),
                          constraint: zod.union([zod.string(), zod.null()]),
                          validator: zod.union([
                            zod.object({
                              type: zod.literal("choice"),
                              answers: zod.array(
                                zod.object({
                                  code: zod.string(),
                                  value: zod.string(),
                                }),
                              ),
                            }),
                            zod.object({
                              type: zod.literal("text"),
                            }),
                            zod.object({
                              type: zod.literal("numeric"),
                            }),
                            zod.object({
                              type: zod.literal("multi_choice"),
                              answers: zod.array(
                                zod.object({
                                  code: zod.string(),
                                  value: zod.string(),
                                }),
                              ),
                            }),
                          ]),
                          default: zod.union([zod.string(), zod.null()]),
                        }),
                      })
                      .describe(
                        "A required question (AOE - Ask on Entry) for a lab marker.",
                      ),
                  ),
                })
                .describe(
                  "A section of AOE questions grouped by marker.\n\nEach section represents questions from a single marker/biomarker,\nwith the marker's name and description as context for the questions.",
                ),
            ),
          })
          .describe(
            "Schema for AOE (Ask on Entry) questions organized by sections.\n\nEach section corresponds to a marker and contains all questions\nassociated with that marker.",
          ),
        clinician: zod
          .union([
            zod
              .object({
                first_name: zod.string(),
                last_name: zod.string(),
                dob: zod.iso.date(),
                address: zod
                  .object({
                    address1: zod.string(),
                    address2: zod.union([zod.string(), zod.null()]),
                    city: zod.string(),
                    state: zod.string(),
                    zip_code: zod.string(),
                  })
                  .describe("Clinician's address for lab order attribution."),
                npi: zod.string(),
                email: zod.union([zod.string(), zod.null()]),
                phone: zod.union([zod.string(), zod.null()]),
              })
              .describe(
                "Clinician information required for lab orders.\n\nThis information is extracted from DoseSpot clinician records\nand validated before allowing clinicians to submit lab orders\nor create lab tests.",
              ),
            zod.null(),
          ])
          .optional(),
      }),
      metadata: zod
        .object({
          provider: zod
            .literal("vital")
            .default(submitLabOrderResponseOrderMetadataProviderDefault),
          details: zod.union([
            zod
              .object({
                type: zod
                  .literal("testkit")
                  .default(
                    submitLabOrderResponseOrderMetadataDetailsTypeDefault,
                  ),
                id: zod.uuid(),
                shipment: zod.union([
                  zod
                    .object({
                      id: zod.uuid(),
                      outbound: zod.union([
                        zod
                          .object({
                            tracking_number: zod.union([
                              zod.string(),
                              zod.null(),
                            ]),
                            tracking_url: zod.union([zod.string(), zod.null()]),
                            courier: zod.union([zod.string(), zod.null()]),
                          })
                          .describe(
                            "Tracking information for a shipment direction (outbound or inbound).",
                          ),
                        zod.null(),
                      ]),
                      inbound: zod.union([
                        zod
                          .object({
                            tracking_number: zod.union([
                              zod.string(),
                              zod.null(),
                            ]),
                            tracking_url: zod.union([zod.string(), zod.null()]),
                            courier: zod.union([zod.string(), zod.null()]),
                          })
                          .describe(
                            "Tracking information for a shipment direction (outbound or inbound).",
                          ),
                        zod.null(),
                      ]),
                      notes: zod.union([zod.string(), zod.null()]),
                    })
                    .describe(
                      "Shipment tracking information for testkit orders.",
                    ),
                  zod.null(),
                ]),
                created_at: zod.iso.datetime({}),
                updated_at: zod.iso.datetime({}),
              })
              .describe("Details for testkit orders."),
            zod
              .object({
                type: zod
                  .literal("walk_in_test")
                  .default(
                    submitLabOrderResponseOrderMetadataDetailsTypeDefaultOne,
                  ),
                id: zod.uuid(),
                appointment_id: zod.union([zod.uuid(), zod.null()]),
                created_at: zod.iso.datetime({}),
                updated_at: zod.iso.datetime({}),
              })
              .describe("Details for walk-in test orders."),
            zod
              .object({
                type: zod
                  .literal("at_home_phlebotomy")
                  .default(
                    submitLabOrderResponseOrderMetadataDetailsTypeDefaultTwo,
                  ),
                id: zod.uuid(),
                appointment_id: zod.union([zod.uuid(), zod.null()]),
                created_at: zod.iso.datetime({}),
                updated_at: zod.iso.datetime({}),
              })
              .describe("Details for at-home phlebotomy orders."),
            zod
              .object({
                type: zod
                  .literal("on_site_collection")
                  .default(
                    submitLabOrderResponseOrderMetadataDetailsTypeDefaultThree,
                  ),
                id: zod.uuid(),
                created_at: zod.iso.datetime({}),
                updated_at: zod.iso.datetime({}),
              })
              .describe("Details for on-site collection orders."),
          ]),
          sample_id: zod.union([zod.string(), zod.null()]),
          notes: zod.union([zod.string(), zod.null()]),
          priority: zod.boolean().optional(),
          events: zod
            .array(
              zod
                .object({
                  remote_id: zod.number(),
                  created_at: zod.iso.datetime({}),
                  status: zod.union([
                    zod.enum([
                      "received.walk_in_test.ordered",
                      "received.walk_in_test.requisition_created",
                      "received.walk_in_test.requisition_bypassed",
                      "completed.walk_in_test.completed",
                      "sample_with_lab.walk_in_test.partial_results",
                      "failed.walk_in_test.sample_error",
                      "cancelled.walk_in_test.cancelled",
                      "collecting_sample.walk_in_test.appointment_pending",
                      "collecting_sample.walk_in_test.appointment_scheduled",
                      "collecting_sample.walk_in_test.appointment_cancelled",
                      "collecting_sample.walk_in_test.redraw_available",
                      "received.at_home_phlebotomy.ordered",
                      "received.at_home_phlebotomy.requisition_created",
                      "received.at_home_phlebotomy.requisition_bypassed",
                      "collecting_sample.at_home_phlebotomy.appointment_pending",
                      "collecting_sample.at_home_phlebotomy.appointment_scheduled",
                      "collecting_sample.at_home_phlebotomy.draw_completed",
                      "collecting_sample.at_home_phlebotomy.appointment_cancelled",
                      "completed.at_home_phlebotomy.completed",
                      "sample_with_lab.at_home_phlebotomy.partial_results",
                      "cancelled.at_home_phlebotomy.cancelled",
                      "failed.at_home_phlebotomy.sample_error",
                      "received.testkit.ordered",
                      "received.testkit.awaiting_registration",
                      "received.testkit.requisition_created",
                      "received.testkit.requisition_bypassed",
                      "received.testkit.registered",
                      "collecting_sample.testkit.transit_customer",
                      "collecting_sample.testkit.out_for_delivery",
                      "collecting_sample.testkit.with_customer",
                      "collecting_sample.testkit.transit_lab",
                      "sample_with_lab.testkit.delivered_to_lab",
                      "completed.testkit.completed",
                      "failed.testkit.failure_to_deliver_to_customer",
                      "failed.testkit.failure_to_deliver_to_lab",
                      "failed.testkit.sample_error",
                      "failed.testkit.lost",
                      "cancelled.testkit.cancelled",
                      "cancelled.testkit.do_not_process",
                      "collecting_sample.testkit.problem_in_transit_customer",
                      "collecting_sample.testkit.problem_in_transit_lab",
                      "received.on_site_collection.ordered",
                      "received.on_site_collection.requisition_created",
                      "received.on_site_collection.requisition_bypassed",
                      "sample_with_lab.on_site_collection.draw_completed",
                      "completed.on_site_collection.completed",
                      "cancelled.on_site_collection.cancelled",
                      "sample_with_lab.on_site_collection.partial_results",
                      "failed.on_site_collection.sample_error",
                    ]),
                    zod.string(),
                  ]),
                })
                .describe("An event in the lifecycle of an order."),
            )
            .default(submitLabOrderResponseOrderMetadataEventsDefault),
        })
        .describe("Vital-specific order metadata."),
      interpretation: zod.enum(["normal", "abnormal", "critical", "unknown"]),
      status: zod.enum([
        "received",
        "collecting_sample",
        "sample_with_lab",
        "completed",
        "cancelled",
        "failed",
        "unknown",
      ]),
    }),
  })
  .describe("Response after submitting a lab order.");

/**
 * Fetch lab orders for a patient.

Returns a paginated list of lab orders for the specified patient,
synced with the lab testing provider (Vital).
 * @summary Fetch Lab Orders
 */
export const fetchLabOrdersParams = zod.object({
  user_id: zod.uuid(),
});

export const fetchLabOrdersQueryPageDefault = 1;
export const fetchLabOrdersQuerySizeDefault = 50;

export const fetchLabOrdersQueryParams = zod.object({
  page: zod.number().default(fetchLabOrdersQueryPageDefault),
  size: zod.number().default(fetchLabOrdersQuerySizeDefault),
});

export const fetchLabOrdersResponseOrdersItemLabTestMarkersItemMetadataProviderDefault =
  "vital";
export const fetchLabOrdersResponseOrdersItemLabTestMarkersItemMetadataALaCarteEnabledDefault = false;
export const fetchLabOrdersResponseOrdersItemLabTestMetadataProviderDefault =
  "vital";
export const fetchLabOrdersResponseOrdersItemMetadataProviderDefault = "vital";
export const fetchLabOrdersResponseOrdersItemMetadataDetailsTypeDefault =
  "testkit";
export const fetchLabOrdersResponseOrdersItemMetadataDetailsTypeDefaultOne =
  "walk_in_test";
export const fetchLabOrdersResponseOrdersItemMetadataDetailsTypeDefaultTwo =
  "at_home_phlebotomy";
export const fetchLabOrdersResponseOrdersItemMetadataDetailsTypeDefaultThree =
  "on_site_collection";
export const fetchLabOrdersResponseOrdersItemMetadataPriorityDefault = false;
export const fetchLabOrdersResponseOrdersItemMetadataEventsDefault = [];

export const fetchLabOrdersResponse = zod
  .object({
    orders: zod.array(
      zod.object({
        remote_id: zod.uuid(),
        user_id: zod.uuid(),
        created_at: zod.iso.datetime({}),
        updated_at: zod.iso.datetime({}),
        lab_test: zod.object({
          id: zod.string(),
          name: zod.string(),
          sample_type: zod.enum([
            "dried_blood_spot",
            "arm_collector",
            "serum",
            "saliva",
            "urine",
          ]),
          method: zod.enum([
            "testkit",
            "walk_in_test",
            "at_home_phlebotomy",
            "on_site_collection",
          ]),
          laboratory: zod.union([
            zod
              .object({
                name: zod.string(),
                formatted_address: zod.string(),
                collection_methods: zod.array(
                  zod.enum([
                    "testkit",
                    "walk_in_test",
                    "at_home_phlebotomy",
                    "on_site_collection",
                  ]),
                ),
                sample_types: zod.array(
                  zod.enum([
                    "dried_blood_spot",
                    "arm_collector",
                    "serum",
                    "saliva",
                    "urine",
                  ]),
                ),
              })
              .describe("Information about a lab facility."),
            zod.null(),
          ]),
          markers: zod.array(
            zod.object({
              id: zod.string(),
              name: zod.string(),
              description: zod.union([zod.string(), zod.null()]),
              unit: zod.union([zod.string(), zod.null()]),
              metadata: zod
                .object({
                  provider: zod
                    .literal("vital")
                    .default(
                      fetchLabOrdersResponseOrdersItemLabTestMarkersItemMetadataProviderDefault,
                    ),
                  slug: zod.string(),
                  type: zod.union([
                    zod.enum(["biomarker", "panel"]),
                    zod.null(),
                  ]),
                  provider_id: zod.union([zod.string(), zod.null()]),
                  price: zod.union([zod.string(), zod.null()]),
                  a_la_carte_enabled: zod.boolean().optional(),
                  questions: zod.array(
                    zod
                      .object({
                        marker_id: zod.string(),
                        question_id: zod.string(),
                        body: zod.object({
                          required: zod.boolean(),
                          code: zod.string(),
                          value: zod.string(),
                          constraint: zod.union([zod.string(), zod.null()]),
                          validator: zod.union([
                            zod.object({
                              type: zod.literal("choice"),
                              answers: zod.array(
                                zod.object({
                                  code: zod.string(),
                                  value: zod.string(),
                                }),
                              ),
                            }),
                            zod.object({
                              type: zod.literal("text"),
                            }),
                            zod.object({
                              type: zod.literal("numeric"),
                            }),
                            zod.object({
                              type: zod.literal("multi_choice"),
                              answers: zod.array(
                                zod.object({
                                  code: zod.string(),
                                  value: zod.string(),
                                }),
                              ),
                            }),
                          ]),
                          default: zod.union([zod.string(), zod.null()]),
                        }),
                      })
                      .describe("Vital-specific lab marker question."),
                  ),
                  lab_info: zod
                    .union([
                      zod
                        .object({
                          lab_id: zod.string(),
                          name: zod
                            .enum([
                              "MyUTI",
                              "Nexus",
                              "Precision Analytical",
                              "Boston Heart At-Home Kit",
                              "Quest",
                              "Labcorp",
                              "BioReference",
                              "IHD",
                              "SanoCardio",
                              "Ayumetrix",
                              "Diagnostic Solutions",
                              "Cell Science Systems",
                              "Genova Diagnostics",
                              "ZRT Laboratory",
                              "USSL",
                              "Spiriplex",
                              "US Biotek",
                            ])
                            .describe("Lab names from Vital."),
                        })
                        .describe(
                          "Short lab information containing ID and name.",
                        ),
                      zod.null(),
                    ])
                    .optional(),
                })
                .describe("Vital-specific lab marker metadata."),
            }),
          ),
          metadata: zod
            .object({
              provider: zod
                .literal("vital")
                .default(
                  fetchLabOrdersResponseOrdersItemLabTestMetadataProviderDefault,
                ),
              slug: zod.string(),
              price: zod.number(),
              is_active: zod.boolean(),
              status: zod.enum([
                "active",
                "pending_approval",
                "inactive",
                "unknown",
              ]),
              fasting: zod.union([zod.boolean(), zod.null()]),
            })
            .describe("Vital-specific lab test metadata."),
          aoe_schema: zod
            .object({
              sections: zod.array(
                zod
                  .object({
                    title: zod.string(),
                    description: zod.union([zod.string(), zod.null()]),
                    questions: zod.array(
                      zod
                        .object({
                          id: zod.string(),
                          body: zod.object({
                            required: zod.boolean(),
                            code: zod.string(),
                            value: zod.string(),
                            constraint: zod.union([zod.string(), zod.null()]),
                            validator: zod.union([
                              zod.object({
                                type: zod.literal("choice"),
                                answers: zod.array(
                                  zod.object({
                                    code: zod.string(),
                                    value: zod.string(),
                                  }),
                                ),
                              }),
                              zod.object({
                                type: zod.literal("text"),
                              }),
                              zod.object({
                                type: zod.literal("numeric"),
                              }),
                              zod.object({
                                type: zod.literal("multi_choice"),
                                answers: zod.array(
                                  zod.object({
                                    code: zod.string(),
                                    value: zod.string(),
                                  }),
                                ),
                              }),
                            ]),
                            default: zod.union([zod.string(), zod.null()]),
                          }),
                        })
                        .describe(
                          "A required question (AOE - Ask on Entry) for a lab marker.",
                        ),
                    ),
                  })
                  .describe(
                    "A section of AOE questions grouped by marker.\n\nEach section represents questions from a single marker/biomarker,\nwith the marker's name and description as context for the questions.",
                  ),
              ),
            })
            .describe(
              "Schema for AOE (Ask on Entry) questions organized by sections.\n\nEach section corresponds to a marker and contains all questions\nassociated with that marker.",
            ),
          clinician: zod
            .union([
              zod
                .object({
                  first_name: zod.string(),
                  last_name: zod.string(),
                  dob: zod.iso.date(),
                  address: zod
                    .object({
                      address1: zod.string(),
                      address2: zod.union([zod.string(), zod.null()]),
                      city: zod.string(),
                      state: zod.string(),
                      zip_code: zod.string(),
                    })
                    .describe("Clinician's address for lab order attribution."),
                  npi: zod.string(),
                  email: zod.union([zod.string(), zod.null()]),
                  phone: zod.union([zod.string(), zod.null()]),
                })
                .describe(
                  "Clinician information required for lab orders.\n\nThis information is extracted from DoseSpot clinician records\nand validated before allowing clinicians to submit lab orders\nor create lab tests.",
                ),
              zod.null(),
            ])
            .optional(),
        }),
        metadata: zod
          .object({
            provider: zod
              .literal("vital")
              .default(fetchLabOrdersResponseOrdersItemMetadataProviderDefault),
            details: zod.union([
              zod
                .object({
                  type: zod
                    .literal("testkit")
                    .default(
                      fetchLabOrdersResponseOrdersItemMetadataDetailsTypeDefault,
                    ),
                  id: zod.uuid(),
                  shipment: zod.union([
                    zod
                      .object({
                        id: zod.uuid(),
                        outbound: zod.union([
                          zod
                            .object({
                              tracking_number: zod.union([
                                zod.string(),
                                zod.null(),
                              ]),
                              tracking_url: zod.union([
                                zod.string(),
                                zod.null(),
                              ]),
                              courier: zod.union([zod.string(), zod.null()]),
                            })
                            .describe(
                              "Tracking information for a shipment direction (outbound or inbound).",
                            ),
                          zod.null(),
                        ]),
                        inbound: zod.union([
                          zod
                            .object({
                              tracking_number: zod.union([
                                zod.string(),
                                zod.null(),
                              ]),
                              tracking_url: zod.union([
                                zod.string(),
                                zod.null(),
                              ]),
                              courier: zod.union([zod.string(), zod.null()]),
                            })
                            .describe(
                              "Tracking information for a shipment direction (outbound or inbound).",
                            ),
                          zod.null(),
                        ]),
                        notes: zod.union([zod.string(), zod.null()]),
                      })
                      .describe(
                        "Shipment tracking information for testkit orders.",
                      ),
                    zod.null(),
                  ]),
                  created_at: zod.iso.datetime({}),
                  updated_at: zod.iso.datetime({}),
                })
                .describe("Details for testkit orders."),
              zod
                .object({
                  type: zod
                    .literal("walk_in_test")
                    .default(
                      fetchLabOrdersResponseOrdersItemMetadataDetailsTypeDefaultOne,
                    ),
                  id: zod.uuid(),
                  appointment_id: zod.union([zod.uuid(), zod.null()]),
                  created_at: zod.iso.datetime({}),
                  updated_at: zod.iso.datetime({}),
                })
                .describe("Details for walk-in test orders."),
              zod
                .object({
                  type: zod
                    .literal("at_home_phlebotomy")
                    .default(
                      fetchLabOrdersResponseOrdersItemMetadataDetailsTypeDefaultTwo,
                    ),
                  id: zod.uuid(),
                  appointment_id: zod.union([zod.uuid(), zod.null()]),
                  created_at: zod.iso.datetime({}),
                  updated_at: zod.iso.datetime({}),
                })
                .describe("Details for at-home phlebotomy orders."),
              zod
                .object({
                  type: zod
                    .literal("on_site_collection")
                    .default(
                      fetchLabOrdersResponseOrdersItemMetadataDetailsTypeDefaultThree,
                    ),
                  id: zod.uuid(),
                  created_at: zod.iso.datetime({}),
                  updated_at: zod.iso.datetime({}),
                })
                .describe("Details for on-site collection orders."),
            ]),
            sample_id: zod.union([zod.string(), zod.null()]),
            notes: zod.union([zod.string(), zod.null()]),
            priority: zod.boolean().optional(),
            events: zod
              .array(
                zod
                  .object({
                    remote_id: zod.number(),
                    created_at: zod.iso.datetime({}),
                    status: zod.union([
                      zod.enum([
                        "received.walk_in_test.ordered",
                        "received.walk_in_test.requisition_created",
                        "received.walk_in_test.requisition_bypassed",
                        "completed.walk_in_test.completed",
                        "sample_with_lab.walk_in_test.partial_results",
                        "failed.walk_in_test.sample_error",
                        "cancelled.walk_in_test.cancelled",
                        "collecting_sample.walk_in_test.appointment_pending",
                        "collecting_sample.walk_in_test.appointment_scheduled",
                        "collecting_sample.walk_in_test.appointment_cancelled",
                        "collecting_sample.walk_in_test.redraw_available",
                        "received.at_home_phlebotomy.ordered",
                        "received.at_home_phlebotomy.requisition_created",
                        "received.at_home_phlebotomy.requisition_bypassed",
                        "collecting_sample.at_home_phlebotomy.appointment_pending",
                        "collecting_sample.at_home_phlebotomy.appointment_scheduled",
                        "collecting_sample.at_home_phlebotomy.draw_completed",
                        "collecting_sample.at_home_phlebotomy.appointment_cancelled",
                        "completed.at_home_phlebotomy.completed",
                        "sample_with_lab.at_home_phlebotomy.partial_results",
                        "cancelled.at_home_phlebotomy.cancelled",
                        "failed.at_home_phlebotomy.sample_error",
                        "received.testkit.ordered",
                        "received.testkit.awaiting_registration",
                        "received.testkit.requisition_created",
                        "received.testkit.requisition_bypassed",
                        "received.testkit.registered",
                        "collecting_sample.testkit.transit_customer",
                        "collecting_sample.testkit.out_for_delivery",
                        "collecting_sample.testkit.with_customer",
                        "collecting_sample.testkit.transit_lab",
                        "sample_with_lab.testkit.delivered_to_lab",
                        "completed.testkit.completed",
                        "failed.testkit.failure_to_deliver_to_customer",
                        "failed.testkit.failure_to_deliver_to_lab",
                        "failed.testkit.sample_error",
                        "failed.testkit.lost",
                        "cancelled.testkit.cancelled",
                        "cancelled.testkit.do_not_process",
                        "collecting_sample.testkit.problem_in_transit_customer",
                        "collecting_sample.testkit.problem_in_transit_lab",
                        "received.on_site_collection.ordered",
                        "received.on_site_collection.requisition_created",
                        "received.on_site_collection.requisition_bypassed",
                        "sample_with_lab.on_site_collection.draw_completed",
                        "completed.on_site_collection.completed",
                        "cancelled.on_site_collection.cancelled",
                        "sample_with_lab.on_site_collection.partial_results",
                        "failed.on_site_collection.sample_error",
                      ]),
                      zod.string(),
                    ]),
                  })
                  .describe("An event in the lifecycle of an order."),
              )
              .default(fetchLabOrdersResponseOrdersItemMetadataEventsDefault),
          })
          .describe("Vital-specific order metadata."),
        interpretation: zod.enum(["normal", "abnormal", "critical", "unknown"]),
        status: zod.enum([
          "received",
          "collecting_sample",
          "sample_with_lab",
          "completed",
          "cancelled",
          "failed",
          "unknown",
        ]),
      }),
    ),
  })
  .describe("Response containing lab orders.");

/**
 * Search for available biomarkers.

Returns a paginated list of biomarkers that can be used to create
custom lab tests. Supports filtering by name and lab ID.
 * @summary Search Biomarkers
 */
export const searchBiomarkersBodyPageDefault = 1;
export const searchBiomarkersBodySizeDefault = 50;

export const searchBiomarkersBody = zod
  .object({
    name: zod.union([zod.string(), zod.null()]).optional(),
    aLaCarteEnabled: zod.union([zod.boolean(), zod.null()]).optional(),
    page: zod.number().default(searchBiomarkersBodyPageDefault),
    size: zod.number().default(searchBiomarkersBodySizeDefault),
  })
  .describe("Request to search for biomarkers.");

export const searchBiomarkersResponseMarkersItemMetadataProviderDefault =
  "vital";
export const searchBiomarkersResponseMarkersItemMetadataALaCarteEnabledDefault = false;

export const searchBiomarkersResponse = zod
  .object({
    markers: zod.array(
      zod.object({
        id: zod.string(),
        name: zod.string(),
        description: zod.union([zod.string(), zod.null()]),
        unit: zod.union([zod.string(), zod.null()]),
        metadata: zod
          .object({
            provider: zod
              .literal("vital")
              .default(
                searchBiomarkersResponseMarkersItemMetadataProviderDefault,
              ),
            slug: zod.string(),
            type: zod.union([zod.enum(["biomarker", "panel"]), zod.null()]),
            provider_id: zod.union([zod.string(), zod.null()]),
            price: zod.union([zod.string(), zod.null()]),
            a_la_carte_enabled: zod.boolean().optional(),
            questions: zod.array(
              zod
                .object({
                  marker_id: zod.string(),
                  question_id: zod.string(),
                  body: zod.object({
                    required: zod.boolean(),
                    code: zod.string(),
                    value: zod.string(),
                    constraint: zod.union([zod.string(), zod.null()]),
                    validator: zod.union([
                      zod.object({
                        type: zod.literal("choice"),
                        answers: zod.array(
                          zod.object({
                            code: zod.string(),
                            value: zod.string(),
                          }),
                        ),
                      }),
                      zod.object({
                        type: zod.literal("text"),
                      }),
                      zod.object({
                        type: zod.literal("numeric"),
                      }),
                      zod.object({
                        type: zod.literal("multi_choice"),
                        answers: zod.array(
                          zod.object({
                            code: zod.string(),
                            value: zod.string(),
                          }),
                        ),
                      }),
                    ]),
                    default: zod.union([zod.string(), zod.null()]),
                  }),
                })
                .describe("Vital-specific lab marker question."),
            ),
            lab_info: zod
              .union([
                zod
                  .object({
                    lab_id: zod.string(),
                    name: zod
                      .enum([
                        "MyUTI",
                        "Nexus",
                        "Precision Analytical",
                        "Boston Heart At-Home Kit",
                        "Quest",
                        "Labcorp",
                        "BioReference",
                        "IHD",
                        "SanoCardio",
                        "Ayumetrix",
                        "Diagnostic Solutions",
                        "Cell Science Systems",
                        "Genova Diagnostics",
                        "ZRT Laboratory",
                        "USSL",
                        "Spiriplex",
                        "US Biotek",
                      ])
                      .describe("Lab names from Vital."),
                  })
                  .describe("Short lab information containing ID and name."),
                zod.null(),
              ])
              .optional(),
          })
          .describe("Vital-specific lab marker metadata."),
      }),
    ),
    total: zod.union([zod.number(), zod.null()]),
    page: zod.union([zod.number(), zod.null()]),
    size: zod.union([zod.number(), zod.null()]),
    pages: zod.union([zod.number(), zod.null()]),
  })
  .describe("Response containing biomarkers.");

/**
 * Create a new custom lab test.

Creates a lab test with the specified biomarkers. The test can then
be ordered for patients. Only registered clinicians can create tests.
 * @summary Create Lab Test
 */
export const createLabTestBody = zod
  .object({
    name: zod.string(),
    description: zod.string(),
    method: zod.enum([
      "testkit",
      "walk_in_test",
      "at_home_phlebotomy",
      "on_site_collection",
    ]),
    markerIds: zod.array(zod.string()),
  })
  .describe("Request to create a new lab test.");

export const createLabTestResponseLabTestMarkersItemMetadataProviderDefault =
  "vital";
export const createLabTestResponseLabTestMarkersItemMetadataALaCarteEnabledDefault = false;
export const createLabTestResponseLabTestMetadataProviderDefault = "vital";

export const createLabTestResponse = zod
  .object({
    labTest: zod.object({
      id: zod.string(),
      name: zod.string(),
      sample_type: zod.enum([
        "dried_blood_spot",
        "arm_collector",
        "serum",
        "saliva",
        "urine",
      ]),
      method: zod.enum([
        "testkit",
        "walk_in_test",
        "at_home_phlebotomy",
        "on_site_collection",
      ]),
      laboratory: zod.union([
        zod
          .object({
            name: zod.string(),
            formatted_address: zod.string(),
            collection_methods: zod.array(
              zod.enum([
                "testkit",
                "walk_in_test",
                "at_home_phlebotomy",
                "on_site_collection",
              ]),
            ),
            sample_types: zod.array(
              zod.enum([
                "dried_blood_spot",
                "arm_collector",
                "serum",
                "saliva",
                "urine",
              ]),
            ),
          })
          .describe("Information about a lab facility."),
        zod.null(),
      ]),
      markers: zod.array(
        zod.object({
          id: zod.string(),
          name: zod.string(),
          description: zod.union([zod.string(), zod.null()]),
          unit: zod.union([zod.string(), zod.null()]),
          metadata: zod
            .object({
              provider: zod
                .literal("vital")
                .default(
                  createLabTestResponseLabTestMarkersItemMetadataProviderDefault,
                ),
              slug: zod.string(),
              type: zod.union([zod.enum(["biomarker", "panel"]), zod.null()]),
              provider_id: zod.union([zod.string(), zod.null()]),
              price: zod.union([zod.string(), zod.null()]),
              a_la_carte_enabled: zod.boolean().optional(),
              questions: zod.array(
                zod
                  .object({
                    marker_id: zod.string(),
                    question_id: zod.string(),
                    body: zod.object({
                      required: zod.boolean(),
                      code: zod.string(),
                      value: zod.string(),
                      constraint: zod.union([zod.string(), zod.null()]),
                      validator: zod.union([
                        zod.object({
                          type: zod.literal("choice"),
                          answers: zod.array(
                            zod.object({
                              code: zod.string(),
                              value: zod.string(),
                            }),
                          ),
                        }),
                        zod.object({
                          type: zod.literal("text"),
                        }),
                        zod.object({
                          type: zod.literal("numeric"),
                        }),
                        zod.object({
                          type: zod.literal("multi_choice"),
                          answers: zod.array(
                            zod.object({
                              code: zod.string(),
                              value: zod.string(),
                            }),
                          ),
                        }),
                      ]),
                      default: zod.union([zod.string(), zod.null()]),
                    }),
                  })
                  .describe("Vital-specific lab marker question."),
              ),
              lab_info: zod
                .union([
                  zod
                    .object({
                      lab_id: zod.string(),
                      name: zod
                        .enum([
                          "MyUTI",
                          "Nexus",
                          "Precision Analytical",
                          "Boston Heart At-Home Kit",
                          "Quest",
                          "Labcorp",
                          "BioReference",
                          "IHD",
                          "SanoCardio",
                          "Ayumetrix",
                          "Diagnostic Solutions",
                          "Cell Science Systems",
                          "Genova Diagnostics",
                          "ZRT Laboratory",
                          "USSL",
                          "Spiriplex",
                          "US Biotek",
                        ])
                        .describe("Lab names from Vital."),
                    })
                    .describe("Short lab information containing ID and name."),
                  zod.null(),
                ])
                .optional(),
            })
            .describe("Vital-specific lab marker metadata."),
        }),
      ),
      metadata: zod
        .object({
          provider: zod
            .literal("vital")
            .default(createLabTestResponseLabTestMetadataProviderDefault),
          slug: zod.string(),
          price: zod.number(),
          is_active: zod.boolean(),
          status: zod.enum([
            "active",
            "pending_approval",
            "inactive",
            "unknown",
          ]),
          fasting: zod.union([zod.boolean(), zod.null()]),
        })
        .describe("Vital-specific lab test metadata."),
      aoe_schema: zod
        .object({
          sections: zod.array(
            zod
              .object({
                title: zod.string(),
                description: zod.union([zod.string(), zod.null()]),
                questions: zod.array(
                  zod
                    .object({
                      id: zod.string(),
                      body: zod.object({
                        required: zod.boolean(),
                        code: zod.string(),
                        value: zod.string(),
                        constraint: zod.union([zod.string(), zod.null()]),
                        validator: zod.union([
                          zod.object({
                            type: zod.literal("choice"),
                            answers: zod.array(
                              zod.object({
                                code: zod.string(),
                                value: zod.string(),
                              }),
                            ),
                          }),
                          zod.object({
                            type: zod.literal("text"),
                          }),
                          zod.object({
                            type: zod.literal("numeric"),
                          }),
                          zod.object({
                            type: zod.literal("multi_choice"),
                            answers: zod.array(
                              zod.object({
                                code: zod.string(),
                                value: zod.string(),
                              }),
                            ),
                          }),
                        ]),
                        default: zod.union([zod.string(), zod.null()]),
                      }),
                    })
                    .describe(
                      "A required question (AOE - Ask on Entry) for a lab marker.",
                    ),
                ),
              })
              .describe(
                "A section of AOE questions grouped by marker.\n\nEach section represents questions from a single marker/biomarker,\nwith the marker's name and description as context for the questions.",
              ),
          ),
        })
        .describe(
          "Schema for AOE (Ask on Entry) questions organized by sections.\n\nEach section corresponds to a marker and contains all questions\nassociated with that marker.",
        ),
      clinician: zod
        .union([
          zod
            .object({
              first_name: zod.string(),
              last_name: zod.string(),
              dob: zod.iso.date(),
              address: zod
                .object({
                  address1: zod.string(),
                  address2: zod.union([zod.string(), zod.null()]),
                  city: zod.string(),
                  state: zod.string(),
                  zip_code: zod.string(),
                })
                .describe("Clinician's address for lab order attribution."),
              npi: zod.string(),
              email: zod.union([zod.string(), zod.null()]),
              phone: zod.union([zod.string(), zod.null()]),
            })
            .describe(
              "Clinician information required for lab orders.\n\nThis information is extracted from DoseSpot clinician records\nand validated before allowing clinicians to submit lab orders\nor create lab tests.",
            ),
          zod.null(),
        ])
        .optional(),
    }),
  })
  .describe("Response after creating a lab test.");

/**
 * Search ICD-10-CM codes by keyword (BM25) or semantic similarity (embedding).

Set `mode` to "bm25" for exact keyword matching (default) or "embedding"
for natural-language / synonym search (e.g. "heart attack" finds
"acute myocardial infarction").
 * @summary Search Icd10
 */
export const searchIcd10Body = zod
  .object({
    query: zod.string(),
    mode: zod
      .enum(["fulltextsearch", "embedding"])
      .describe("Which ranking strategy to use when searching ICD-10 codes."),
    topK: zod.number(),
  })
  .describe("Request to search ICD-10 codes.");

export const searchIcd10Response = zod
  .object({
    codes: zod.array(
      zod
        .object({
          code: zod.string(),
          description: zod.string(),
        })
        .describe("An ICD-10-CM diagnosis code with its description."),
    ),
  })
  .describe("Response containing matching ICD-10 codes.");

/**
 * Resolve specific ICD-10-CM codes by their code strings.

Given a list of ICD-10 codes (e.g. ["E11.9", "I10"]), returns
the full code objects with descriptions.  Returns 404 if any
requested code does not exist.
 * @summary Resolve Icd10
 */
export const resolveIcd10Body = zod
  .object({
    codes: zod.array(zod.string()),
  })
  .describe("Request to resolve specific ICD-10 codes.");

export const resolveIcd10Response = zod
  .object({
    codes: zod.array(
      zod
        .object({
          code: zod.string(),
          description: zod.string(),
        })
        .describe("An ICD-10-CM diagnosis code with its description."),
    ),
  })
  .describe("Response containing resolved ICD-10 codes.");

/**
 * @summary Shelf Store
 */
export const shelfStoreParams = zod.object({
  patient_id: zod.uuid(),
});

export const shelfStoreBodyKeyMax = 512;

export const shelfStoreBody = zod.object({
  key: zod.string().max(shelfStoreBodyKeyMax),
  value: zod.array(zod.record(zod.string(), zod.unknown())),
  metadata: zod.record(zod.string(), zod.unknown()).optional(),
});

export const shelfStoreResponse = zod.unknown();

/**
 * @summary Shelf Load
 */
export const shelfLoadParams = zod.object({
  patient_id: zod.uuid(),
});

export const shelfLoadQueryParams = zod.object({
  key: zod.string(),
});

export const shelfLoadResponse = zod.object({
  key: zod.string(),
  value: zod.array(zod.record(zod.string(), zod.unknown())),
  metadata: zod.record(zod.string(), zod.unknown()),
});

/**
 * @summary Shelf List
 */
export const shelfListParams = zod.object({
  patient_id: zod.uuid(),
});

export const shelfListResponse = zod.object({
  entries: zod.array(
    zod.object({
      key: zod.string(),
      metadata: zod.record(zod.string(), zod.unknown()),
    }),
  ),
});

/**
 * Fetch all active viewers for a patient, excluding the requesting clinician.
 * @summary Fetch Viewers For Patient
 */
export const fetchViewersForPatientParams = zod.object({
  user_id: zod.uuid(),
});

export const fetchViewersForPatientResponse = zod.object({
  viewers: zod.array(
    zod.object({
      full_name: zod.string(),
      display_name: zod.string(),
    }),
  ),
});

/**
 * Check which clinical workflows are available for a patient.

Returns availability of lab ordering (requires insurance info) and
prescription writing (requires an existing DoseSpot patient record).
 * @summary Fetch Workflows Available
 */
export const fetchWorkflowsAvailableParams = zod.object({
  user_id: zod.string(),
});

export const fetchWorkflowsAvailableResponse = zod
  .object({
    canOrderLabs: zod.boolean(),
    canWritePrescription: zod.boolean(),
  })
  .describe(
    "Indicates which clinical workflows are currently available for a patient.",
  );

/**
 * Apply an ordered list of modifications to a patient's proposed actions.

Modifications can add, update, or remove (archive) actions. They are
applied sequentially so earlier mutations are visible to later ones.
 * @summary Apply Plan Modifications
 */
export const applyPlanModificationsParams = zod.object({
  user_id: zod.uuid(),
});

export const applyPlanModificationsBodyModificationsItemTypeDefault = "add";
export const applyPlanModificationsBodyModificationsItemLinkTypeDefault =
  "patient";
export const applyPlanModificationsBodyModificationsItemLinkTypeDefaultOne =
  "problem";
export const applyPlanModificationsBodyModificationsItemLinkTypeDefaultTwo =
  "request";
export const applyPlanModificationsBodyModificationsItemLinkTypeDefaultThree =
  "orphan";
export const applyPlanModificationsBodyModificationsItemAlternativesDefault =
  [];
export const applyPlanModificationsBodyModificationsItemDependsOnActionExternalIdsDefault =
  [];
export const applyPlanModificationsBodyModificationsItemTypeDefaultOne =
  "update";
export const applyPlanModificationsBodyModificationsItemFieldsLinkTypeDefault =
  "patient";
export const applyPlanModificationsBodyModificationsItemFieldsLinkTypeDefaultOne =
  "problem";
export const applyPlanModificationsBodyModificationsItemFieldsLinkTypeDefaultTwo =
  "request";
export const applyPlanModificationsBodyModificationsItemFieldsLinkTypeDefaultThree =
  "orphan";
export const applyPlanModificationsBodyModificationsItemTypeDefaultTwo =
  "remove";

export const applyPlanModificationsBody = zod.object({
  modifications: zod.array(
    zod.union([
      zod
        .object({
          type: zod
            .literal("add")
            .default(applyPlanModificationsBodyModificationsItemTypeDefault),
          external_id: zod.string(),
          link: zod.union([
            zod.object({
              type: zod
                .literal("patient")
                .default(
                  applyPlanModificationsBodyModificationsItemLinkTypeDefault,
                ),
            }),
            zod.object({
              type: zod
                .literal("problem")
                .default(
                  applyPlanModificationsBodyModificationsItemLinkTypeDefaultOne,
                ),
              id: zod.uuid(),
            }),
            zod.object({
              type: zod
                .literal("request")
                .default(
                  applyPlanModificationsBodyModificationsItemLinkTypeDefaultTwo,
                ),
              id: zod.uuid(),
            }),
            zod.object({
              type: zod
                .literal("orphan")
                .default(
                  applyPlanModificationsBodyModificationsItemLinkTypeDefaultThree,
                ),
            }),
          ]),
          title: zod.string(),
          payload: zod
            .object({
              payload_id: zod.string(),
              tool_name: zod.string(),
              tool_input: zod.record(zod.string(), zod.unknown()),
              justification: zod.string(),
            })
            .describe(
              "A frozen tool call: the exact invocation to execute when the action is run.\n\nThis type is shared between CareState rows and REST API modification\nrecords. It deliberately does NOT use ``APIVIEW_MODEL_CONFIG`` because\nCareState serialisation (``model_dump()``) must produce snake_case keys\nand the SDK type must match that runtime shape. The REST API input layer\nconverts camelCase payload fields to snake_case before Pydantic sees them.\n\nThe opaque ``tool_input`` dict keys are never converted — they preserve\nwhatever casing the LLM originally used (typically camelCase).",
            ),
          alternatives: zod
            .array(
              zod
                .object({
                  payload_id: zod.string(),
                  tool_name: zod.string(),
                  tool_input: zod.record(zod.string(), zod.unknown()),
                  justification: zod.string(),
                })
                .describe(
                  "A frozen tool call: the exact invocation to execute when the action is run.\n\nThis type is shared between CareState rows and REST API modification\nrecords. It deliberately does NOT use ``APIVIEW_MODEL_CONFIG`` because\nCareState serialisation (``model_dump()``) must produce snake_case keys\nand the SDK type must match that runtime shape. The REST API input layer\nconverts camelCase payload fields to snake_case before Pydantic sees them.\n\nThe opaque ``tool_input`` dict keys are never converted — they preserve\nwhatever casing the LLM originally used (typically camelCase).",
                ),
            )
            .default(
              applyPlanModificationsBodyModificationsItemAlternativesDefault,
            ),
          justification: zod.string(),
          depends_on_action_external_ids: zod
            .array(zod.string())
            .default(
              applyPlanModificationsBodyModificationsItemDependsOnActionExternalIdsDefault,
            ),
          todo_status: zod.enum(["Open", "Done", "Archived"]).optional(),
          decision: zod
            .enum(["Pending", "Approved", "AutoApproved", "Rejected"])
            .optional(),
        })
        .describe(
          "Add a new proposed action to the plan.\n\nThe system generates the internal ``id``; callers only provide\n``external_id`` (and use it for dependency references).",
        ),
      zod
        .object({
          type: zod
            .literal("update")
            .default(applyPlanModificationsBodyModificationsItemTypeDefaultOne),
          external_id: zod.string(),
          fields: zod
            .object({
              title: zod.union([zod.string(), zod.null()]).optional(),
              link: zod
                .union([
                  zod.union([
                    zod.object({
                      type: zod
                        .literal("patient")
                        .default(
                          applyPlanModificationsBodyModificationsItemFieldsLinkTypeDefault,
                        ),
                    }),
                    zod.object({
                      type: zod
                        .literal("problem")
                        .default(
                          applyPlanModificationsBodyModificationsItemFieldsLinkTypeDefaultOne,
                        ),
                      id: zod.uuid(),
                    }),
                    zod.object({
                      type: zod
                        .literal("request")
                        .default(
                          applyPlanModificationsBodyModificationsItemFieldsLinkTypeDefaultTwo,
                        ),
                      id: zod.uuid(),
                    }),
                    zod.object({
                      type: zod
                        .literal("orphan")
                        .default(
                          applyPlanModificationsBodyModificationsItemFieldsLinkTypeDefaultThree,
                        ),
                    }),
                  ]),
                  zod.null(),
                ])
                .optional(),
              decision: zod
                .union([
                  zod.enum(["Pending", "Approved", "AutoApproved", "Rejected"]),
                  zod.null(),
                ])
                .optional(),
              payload: zod
                .union([
                  zod
                    .object({
                      payload_id: zod.string(),
                      tool_name: zod.string(),
                      tool_input: zod.record(zod.string(), zod.unknown()),
                      justification: zod.string(),
                    })
                    .describe(
                      "A frozen tool call: the exact invocation to execute when the action is run.\n\nThis type is shared between CareState rows and REST API modification\nrecords. It deliberately does NOT use ``APIVIEW_MODEL_CONFIG`` because\nCareState serialisation (``model_dump()``) must produce snake_case keys\nand the SDK type must match that runtime shape. The REST API input layer\nconverts camelCase payload fields to snake_case before Pydantic sees them.\n\nThe opaque ``tool_input`` dict keys are never converted — they preserve\nwhatever casing the LLM originally used (typically camelCase).",
                    ),
                  zod.null(),
                ])
                .optional(),
              alternatives: zod
                .union([
                  zod.array(
                    zod
                      .object({
                        payload_id: zod.string(),
                        tool_name: zod.string(),
                        tool_input: zod.record(zod.string(), zod.unknown()),
                        justification: zod.string(),
                      })
                      .describe(
                        "A frozen tool call: the exact invocation to execute when the action is run.\n\nThis type is shared between CareState rows and REST API modification\nrecords. It deliberately does NOT use ``APIVIEW_MODEL_CONFIG`` because\nCareState serialisation (``model_dump()``) must produce snake_case keys\nand the SDK type must match that runtime shape. The REST API input layer\nconverts camelCase payload fields to snake_case before Pydantic sees them.\n\nThe opaque ``tool_input`` dict keys are never converted — they preserve\nwhatever casing the LLM originally used (typically camelCase).",
                      ),
                  ),
                  zod.null(),
                ])
                .optional(),
              justification: zod.union([zod.string(), zod.null()]).optional(),
              depends_on_action_external_ids: zod
                .union([zod.array(zod.string()), zod.null()])
                .optional(),
            })
            .describe(
              "Partial update payload: only non-None fields are applied.\n\nCallers supply only the fields they want to change.",
            ),
        })
        .describe(
          "Update an existing proposed action (looked up by external_id).",
        ),
      zod
        .object({
          type: zod
            .literal("remove")
            .default(applyPlanModificationsBodyModificationsItemTypeDefaultTwo),
          external_id: zod.string(),
        })
        .describe(
          "Remove a proposed action (soft-delete: marks it as archived).",
        ),
    ]),
  ),
});

export const applyPlanModificationsResponse = zod.object({
  result: zod.object({
    applied_external_ids: zod.array(zod.string()),
    errors: zod.array(
      zod
        .object({
          index: zod.number(),
          message: zod.string(),
        })
        .describe("Error for a single modification that could not be applied."),
    ),
  }),
});

/**
 * Swap the current payload of a proposed action with one of its alternatives.

The previous payload is moved into the alternatives list.
 * @summary Switch To Alternative
 */
export const switchToAlternativeParams = zod.object({
  user_id: zod.uuid(),
});

export const switchToAlternativeBody = zod.object({
  externalId: zod.string(),
  alternativePayloadId: zod.string(),
});

export const switchToAlternativeResponse = zod.object({
  result: zod.object({
    success: zod.boolean(),
    error: zod.union([zod.string(), zod.null()]).optional(),
  }),
});

/**
 * Mark an approved proposed action as successfully executed.

Checks that all dependency actions have succeeded before allowing
execution. Creates a run record and sets todo_status to done.
 * @summary Mark Executed
 */
export const markExecutedParams = zod.object({
  user_id: zod.uuid(),
});

export const markExecutedBody = zod.object({
  externalId: zod.string(),
  toolOutput: zod
    .union([zod.record(zod.string(), zod.unknown()), zod.null()])
    .optional(),
});

export const markExecutedResponse = zod.object({
  result: zod.object({
    success: zod.boolean(),
    error: zod.union([zod.string(), zod.null()]).optional(),
    unmet_dependency_external_ids: zod
      .union([zod.array(zod.string()), zod.null()])
      .optional(),
    tool_output: zod
      .union([zod.record(zod.string(), zod.unknown()), zod.null()])
      .optional(),
  }),
});

/**
 * Reject the original proposed action but record that the clinician
executed a revised version (e.g. changed the prescription or lab order
before confirming).
 * @summary Reject With Revision
 */
export const rejectWithRevisionParams = zod.object({
  user_id: zod.uuid(),
});

export const rejectWithRevisionBody = zod.object({
  externalId: zod.string(),
  toolOutput: zod
    .union([zod.record(zod.string(), zod.unknown()), zod.null()])
    .optional(),
});

export const rejectWithRevisionResponse = zod.object({
  result: zod.object({
    success: zod.boolean(),
    error: zod.union([zod.string(), zod.null()]).optional(),
    unmet_dependency_external_ids: zod
      .union([zod.array(zod.string()), zod.null()])
      .optional(),
    tool_output: zod
      .union([zod.record(zod.string(), zod.unknown()), zod.null()])
      .optional(),
  }),
});

/**
 * Return karma points earned by the logged-in clinician.

If ``days`` is provided, only events within the last N days are counted.
Otherwise returns the all-time total.
 * @summary Get Karma Total
 */
export const getKarmaTotalQueryDaysMaxOne = 365;

export const getKarmaTotalQueryParams = zod.object({
  days: zod
    .union([zod.number().min(1).max(getKarmaTotalQueryDaysMaxOne), zod.null()])
    .optional(),
});

export const getKarmaTotalResponse = zod.object({
  totalKarma: zod.number(),
});

/**
 * Return karma points grouped into time buckets for charting.
 * @summary Get Karma Chart
 */
export const getKarmaChartQueryDaysDefault = 30;
export const getKarmaChartQueryDaysMax = 365;

export const getKarmaChartQueryParams = zod.object({
  days: zod
    .number()
    .min(1)
    .max(getKarmaChartQueryDaysMax)
    .default(getKarmaChartQueryDaysDefault),
  granularity: zod.enum(["day", "week", "month"]).optional(),
});

export const getKarmaChartResponse = zod.object({
  buckets: zod.array(
    zod.object({
      periodStart: zod.iso.datetime({}),
      karma: zod.number(),
    }),
  ),
});

/**
 * Return recent clinician activity events (transactions) for the logged-in clinician.
 * @summary Get Clinician Activity Events
 */
export const getClinicianActivityEventsQueryLimitDefault = 100;
export const getClinicianActivityEventsQueryLimitMax = 500;

export const getClinicianActivityEventsQueryParams = zod.object({
  limit: zod
    .number()
    .min(1)
    .max(getClinicianActivityEventsQueryLimitMax)
    .default(getClinicianActivityEventsQueryLimitDefault),
});

export const getClinicianActivityEventsResponseEventsItemEventTypeDefault =
  "request_closed";
export const getClinicianActivityEventsResponseEventsItemEventTypeDefaultOne =
  "prescription_written";
export const getClinicianActivityEventsResponseEventsItemEventTypeDefaultTwo =
  "lab_ordered";
export const getClinicianActivityEventsResponseEventsItemEventTypeDefaultThree =
  "karma_payout";

export const getClinicianActivityEventsResponse = zod.object({
  events: zod.array(
    zod.object({
      id: zod.uuid(),
      clinicianId: zod.uuid(),
      patientId: zod.uuid(),
      event: zod.union([
        zod.object({
          type: zod
            .literal("request_closed")
            .default(
              getClinicianActivityEventsResponseEventsItemEventTypeDefault,
            ),
          request_id: zod.string(),
          from_status: zod.union([zod.string(), zod.null()]).optional(),
          to_status: zod.string(),
          cpt_code: zod
            .union([
              zod
                .enum(["99212", "99213", "99214", "99215"])
                .describe(
                  "E/M office visit CPT codes used to classify request complexity by MDM level.",
                ),
              zod.null(),
            ])
            .optional(),
        }),
        zod.object({
          type: zod
            .literal("prescription_written")
            .default(
              getClinicianActivityEventsResponseEventsItemEventTypeDefaultOne,
            ),
          prescription_record_id: zod.string(),
          dosespot_prescription_id: zod.string(),
        }),
        zod.object({
          type: zod
            .literal("lab_ordered")
            .default(
              getClinicianActivityEventsResponseEventsItemEventTypeDefaultTwo,
            ),
          remote_id: zod.string(),
        }),
        zod.object({
          type: zod
            .literal("karma_payout")
            .default(
              getClinicianActivityEventsResponseEventsItemEventTypeDefaultThree,
            ),
          pay_period: zod.string(),
          karma_points_paid: zod.number(),
          dollar_amount: zod.number(),
          mercury_request_id: zod.string(),
          idempotency_key: zod.string(),
        }),
      ]),
      karmaPoints: zod.number(),
      displayDescription: zod.string(),
      occurredAt: zod.iso.datetime({}),
    }),
  ),
});

/**
 * Return karma offers for every open request on a patient.
 * @summary Get Patient Karma Offers
 */
export const getPatientKarmaOffersParams = zod.object({
  user_id: zod.uuid(),
});

export const getPatientKarmaOffersResponse = zod.object({
  offers: zod.array(
    zod.object({
      requestId: zod.uuid(),
      title: zod.string(),
      cptCode: zod.union([
        zod
          .enum(["99212", "99213", "99214", "99215"])
          .describe(
            "E/M office visit CPT codes used to classify request complexity by MDM level.",
          ),
        zod.null(),
      ]),
      karmaOffer: zod.number(),
    }),
  ),
  totalKarma: zod.number(),
});

/**
 * Return the current bank link status for the logged-in clinician.
 * @summary Get Bank Link
 */
export const getBankLinkResponse = zod.object({
  recipient_name: zod.string(),
  status: zod.enum(["active", "inactive", "broken"]),
});

/**
 * Register the clinician's bank account with Mercury and store the link.
 * @summary Link Bank Account
 */
export const linkBankAccountBody = zod.object({
  accountNumber: zod.string(),
  routingNumber: zod.string(),
  accountType: zod.enum([
    "businessChecking",
    "businessSavings",
    "personalChecking",
    "personalSavings",
  ]),
  accountHolderName: zod.string(),
  email: zod.string(),
});

export const linkBankAccountResponse = zod.object({
  recipient_name: zod.string(),
  status: zod.enum(["active", "inactive", "broken"]),
});

/**
 * Return all clinician bank links (admin view).
 * @summary List All Bank Links
 */
export const listAllBankLinksResponse = zod.object({
  links: zod.array(
    zod.object({
      clinicianId: zod.string(),
      mercuryRecipientId: zod.string(),
      recipientName: zod.string(),
      status: zod.enum(["active", "inactive", "broken"]),
    }),
  ),
});

/**
 * Assign or update a Mercury recipient ID for a clinician (admin).
 * @summary Assign Recipient Id
 */
export const assignRecipientIdParams = zod.object({
  clinician_id: zod.uuid(),
});

export const assignRecipientIdBody = zod.object({
  mercuryRecipientId: zod.string(),
  recipientName: zod.string(),
});

export const assignRecipientIdResponse = zod.object({
  clinicianId: zod.string(),
  mercuryRecipientId: zod.string(),
  recipientName: zod.string(),
  status: zod.enum(["active", "inactive", "broken"]),
});

/**
 * Return proposed and confirmed banking details for a clinician.
 * @summary Fetch Banking Details
 */
export const fetchBankingDetailsParams = zod.object({
  user_id: zod.uuid(),
});

export const fetchBankingDetailsResponse = zod.object({
  proposed: zod
    .union([
      zod.object({
        accountNumber: zod.string(),
        routingNumber: zod.string(),
        accountHolderName: zod.string(),
        accountType: zod.string(),
        certainty: zod.string(),
      }),
      zod.null(),
    ])
    .optional(),
  confirmed: zod
    .union([
      zod.object({
        accountNumber: zod.string(),
        routingNumber: zod.string(),
        accountHolderName: zod.string(),
        accountType: zod.string(),
        certainty: zod.string(),
      }),
      zod.null(),
    ])
    .optional(),
});

/**
 * Update the authenticated clinician's self-reported banking details.
 * @summary Update Banking Details
 */
export const updateBankingDetailsBody = zod.object({
  accountNumber: zod.string(),
  routingNumber: zod.string(),
  accountHolderName: zod.string(),
  accountType: zod.string(),
});

export const updateBankingDetailsResponse = zod.object({
  proposed: zod
    .union([
      zod.object({
        accountNumber: zod.string(),
        routingNumber: zod.string(),
        accountHolderName: zod.string(),
        accountType: zod.string(),
        certainty: zod.string(),
      }),
      zod.null(),
    ])
    .optional(),
  confirmed: zod
    .union([
      zod.object({
        accountNumber: zod.string(),
        routingNumber: zod.string(),
        accountHolderName: zod.string(),
        accountType: zod.string(),
        certainty: zod.string(),
      }),
      zod.null(),
    ])
    .optional(),
});

/**
 * Return one row per clinician for the admin payout dashboard.
 * @summary List Clinician Payout Dashboard
 */
export const listClinicianPayoutDashboardResponse = zod.object({
  rows: zod.array(
    zod
      .object({
        clinicianId: zod.uuid(),
        displayName: zod.union([zod.string(), zod.null()]),
        email: zod.union([zod.string(), zod.null()]),
        phoneNumber: zod.union([zod.string(), zod.null()]),
        npiNumber: zod.union([zod.string(), zod.null()]),
        licensedStates: zod.union([zod.array(zod.string()), zod.null()]),
        mercuryRecipientId: zod.union([zod.string(), zod.null()]),
        recipientName: zod.union([zod.string(), zod.null()]),
        bankLinkStatus: zod.union([
          zod.enum(["active", "inactive", "broken"]),
          zod.null(),
        ]),
        totalPaidOutDollars: zod.number(),
        totalPaidOutKarma: zod.number(),
        pendingKarma: zod.number(),
        pendingDollars: zod.number(),
        lastPayoutAt: zod.union([zod.string(), zod.null()]),
      })
      .describe(
        "A single row of the admin payout dashboard table.\n\nMerges the identity info collected during Cortex onboarding\n(``employee_records``) with the bank-link state and the payout totals\nderived from the karma activity log.",
      ),
  ),
});

/**
 * Return the full karma payout ledger for a single clinician.

Used by the "previous transactions" modal on the admin dashboard.
 * @summary List Clinician Payout History
 */
export const listClinicianPayoutHistoryParams = zod.object({
  clinician_id: zod.uuid(),
});

export const listClinicianPayoutHistoryResponse = zod.object({
  payouts: zod.array(
    zod
      .object({
        id: zod.uuid(),
        clinicianId: zod.uuid(),
        payPeriodStart: zod.iso.datetime({}),
        payPeriodEnd: zod.iso.datetime({}),
        karmaPoints: zod.number(),
        dollarAmount: zod.number(),
        status: zod.enum(["pending", "queued", "failed"]),
        mercuryRequestId: zod.union([zod.string(), zod.null()]),
        idempotencyKey: zod.string(),
        failureReason: zod.union([zod.string(), zod.null()]),
        createdAt: zod.iso.datetime({}),
      })
      .describe("Single row of the karma payouts ledger, returned to admins."),
  ),
});

/**
 * Return dossier-backed banking details for one clinician.

Resolves the best ``BankingDetailsDetailT`` the dossier has deduced
for the clinician -- preferring Mercury-confirmed clues over
self-reported proposals. The routing number, account type, holder
name and a masked last-4 of the account number are always returned.
The full account number is only returned when the caller passes
``?reveal=true`` so reveals are distinguishable in the audit log.
 * @summary Get Clinician Bank Details
 */
export const getClinicianBankDetailsParams = zod.object({
  clinician_id: zod.uuid(),
});

export const getClinicianBankDetailsQueryRevealDefault = false;

export const getClinicianBankDetailsQueryParams = zod.object({
  reveal: zod.boolean().optional(),
});

export const getClinicianBankDetailsResponse = zod
  .object({
    clinicianId: zod.uuid(),
    certainty: zod.string(),
    accountHolderName: zod.union([zod.string(), zod.null()]),
    accountType: zod.union([zod.string(), zod.null()]),
    routingNumber: zod.union([zod.string(), zod.null()]),
    accountNumberLast4: zod.union([zod.string(), zod.null()]),
    accountNumber: zod.union([zod.string(), zod.null()]),
  })
  .describe(
    "Banking details for one clinician, sourced from the dossier.\n\nReads :class:`~lotushealth.user_info.dossier.detail_types.banking.BankingDetailsDetailT`\n-- the canonical, high-security store for clinician ACH details --\nso all callers see the same confirmed-over-proposed view that the\ndossier system builds from self-reported + Mercury-verified clues.\n\n``account_number`` is populated only when the caller passed\n``reveal=true``; ``account_number_last4`` is always safe to show as a\nmasked display value.",
  );

/**
 * Trigger the monthly karma payout sweep immediately.

Idempotent per ``(clinician, month)``: if the sweep has already run for the
current period, Mercury rejects the duplicate idempotency key and nothing
is double-paid. Safe for admins to retry.
 * @summary Run Payout Sweep
 */
export const runPayoutSweepResponseResultCliniciansSkippedDefault = 0;
export const runPayoutSweepResponseResultFailuresDefault = [];

export const runPayoutSweepResponse = zod.object({
  result: zod.object({
    cliniciansPaid: zod.number(),
    totalAmount: zod.number(),
    requestsQueued: zod.number(),
    payPeriodStart: zod.iso.datetime({}),
    payPeriodEnd: zod.iso.datetime({}),
    cliniciansSkipped: zod.number().optional(),
    failures: zod
      .array(
        zod.object({
          clinicianId: zod.uuid(),
          recipientName: zod.string(),
          dollarAmount: zod.number(),
          reason: zod.string(),
        }),
      )
      .default(runPayoutSweepResponseResultFailuresDefault),
  }),
});

/**
 * Search for stock insurance payers whose names match *filter*.

Pass an empty *filter* with a ``null`` *limit* to retrieve all known
payers.  Pass a non-empty *filter* for real-time typeahead search.

Backed by a TurboPuffer store that is populated by the payer indexer
pipeline (Stedi → Junction resolution → BM25 index).
 * @summary Search Stock Payers
 */
export const searchStockPayersBody = zod.object({
  filter: zod.union([zod.string(), zod.null()]).optional(),
  limit: zod.union([zod.number(), zod.null()]).optional(),
});

export const searchStockPayersResponse = zod.object({
  payers: zod.array(
    zod.object({
      type: zod.literal("stock"),
      code: zod
        .object({
          origin: zod.string(),
          code: zod.string(),
          name: zod.string(),
        })
        .describe(
          "A payer identifier: origin system, code, and human-readable name.",
        ),
      displayName: zod.string(),
      imageUrl: zod.union([zod.string(), zod.null()]).optional(),
    }),
  ),
});

/**
 * @summary List Surveys
 */
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefault =
  "string";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultOne =
  "int";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultTwo =
  "simple_address";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultThree =
  "list";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefault =
  "string";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultOne =
  "int";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultTwo =
  "simple_address";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefault =
  "string";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultOne =
  "int";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultTwo =
  "simple_address";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultThree =
  "list";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefault =
  "string";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultOne =
  "int";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultTwo =
  "simple_address";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefault =
  "non_empty_string";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultOne =
  "date";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultTwo =
  "coded_choice";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultThree =
  "phone_number";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultFour =
  "email";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultFive =
  "city_state_zip";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultSix =
  "optional";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefault =
  "non_empty_string";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOne =
  "date";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultTwo =
  "coded_choice";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultThree =
  "phone_number";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFour =
  "email";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFive =
  "city_state_zip";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSix =
  "list";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefault =
  "non_empty_string";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOne =
  "date";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultTwo =
  "coded_choice";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultThree =
  "phone_number";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFour =
  "email";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFive =
  "city_state_zip";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultSeven =
  "list";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSeven =
  "non_empty_string";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultEight =
  "date";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultNine =
  "coded_choice";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnezero =
  "phone_number";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOneone =
  "email";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnetwo =
  "city_state_zip";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnethree =
  "optional";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSix =
  "non_empty_string";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSeven =
  "date";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultEight =
  "coded_choice";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultNine =
  "phone_number";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOnezero =
  "email";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOneone =
  "city_state_zip";
export const listSurveysResponseSurveysItemInstrumentSessionSubmissionsSubmissionsTypeDefault =
  "string";
export const listSurveysResponseSurveysItemInstrumentSessionSubmissionsSubmissionsTypeDefaultOne =
  "int";
export const listSurveysResponseSurveysItemInstrumentSessionSubmissionsSubmissionsTypeDefaultTwo =
  "simple_address";
export const listSurveysResponseSurveysItemInstrumentSessionSubmissionsSubmissionsTypeDefaultThree =
  "list";
export const listSurveysResponseSurveysItemInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefault =
  "string";
export const listSurveysResponseSurveysItemInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefaultOne =
  "int";
export const listSurveysResponseSurveysItemInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefaultTwo =
  "simple_address";

export const listSurveysResponse = zod.object({
  surveys: zod.array(
    zod
      .object({
        survey_id: zod.uuid(),
        user_id: zod.uuid(),
        instrument_id: zod.string(),
        status: zod.enum(["open", "completed", "archived"]),
        instrument_params: zod.union([
          zod.record(zod.string(), zod.unknown()),
          zod.null(),
        ]),
        instrument_session: zod
          .object({
            instrument_id: zod.string(),
            form_definition: zod.object({
              fields: zod.array(
                zod.object({
                  id: zod.string(),
                  profile: zod.object({
                    name: zod.string(),
                    description: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                  }),
                  suggested_submission: zod
                    .union([
                      zod.union([
                        zod.object({
                          type: zod
                            .literal("string")
                            .default(
                              listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefault,
                            ),
                          value: zod.string(),
                        }),
                        zod.object({
                          type: zod
                            .literal("int")
                            .default(
                              listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultOne,
                            ),
                          value: zod.number(),
                        }),
                        zod.object({
                          type: zod
                            .literal("simple_address")
                            .default(
                              listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultTwo,
                            ),
                          street_address: zod.string(),
                          city_state_zip: zod.string(),
                        }),
                        zod.object({
                          type: zod
                            .literal("list")
                            .default(
                              listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultThree,
                            ),
                          values: zod.array(
                            zod.union([
                              zod.object({
                                type: zod
                                  .literal("string")
                                  .default(
                                    listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefault,
                                  ),
                                value: zod.string(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("int")
                                  .default(
                                    listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultOne,
                                  ),
                                value: zod.number(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("simple_address")
                                  .default(
                                    listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultTwo,
                                  ),
                                street_address: zod.string(),
                                city_state_zip: zod.string(),
                              }),
                              zod.unknown(),
                            ]),
                          ),
                        }),
                      ]),
                      zod.null(),
                    ])
                    .optional(),
                  default_submission: zod
                    .union([
                      zod.union([
                        zod.object({
                          type: zod
                            .literal("string")
                            .default(
                              listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefault,
                            ),
                          value: zod.string(),
                        }),
                        zod.object({
                          type: zod
                            .literal("int")
                            .default(
                              listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultOne,
                            ),
                          value: zod.number(),
                        }),
                        zod.object({
                          type: zod
                            .literal("simple_address")
                            .default(
                              listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultTwo,
                            ),
                          street_address: zod.string(),
                          city_state_zip: zod.string(),
                        }),
                        zod.object({
                          type: zod
                            .literal("list")
                            .default(
                              listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultThree,
                            ),
                          values: zod.array(
                            zod.union([
                              zod.object({
                                type: zod
                                  .literal("string")
                                  .default(
                                    listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefault,
                                  ),
                                value: zod.string(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("int")
                                  .default(
                                    listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultOne,
                                  ),
                                value: zod.number(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("simple_address")
                                  .default(
                                    listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultTwo,
                                  ),
                                street_address: zod.string(),
                                city_state_zip: zod.string(),
                              }),
                              zod.unknown(),
                            ]),
                          ),
                        }),
                      ]),
                      zod.null(),
                    ])
                    .optional(),
                  validator: zod.union([
                    zod
                      .object({
                        type: zod
                          .literal("non_empty_string")
                          .default(
                            listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefault,
                          ),
                      })
                      .describe(
                        "Validator that accepts arbitrary non-empty strings.",
                      ),
                    zod
                      .object({
                        type: zod
                          .literal("date")
                          .default(
                            listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultOne,
                          ),
                      })
                      .describe("Validator that accepts arbitrary dates."),
                    zod
                      .object({
                        type: zod
                          .literal("coded_choice")
                          .default(
                            listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultTwo,
                          ),
                        options: zod.array(
                          zod
                            .object({
                              code: zod.string(),
                              display: zod.string(),
                            })
                            .describe("An option from a list of choices."),
                        ),
                      })
                      .describe(
                        "Validator that accepts any option from a list of choices.",
                      ),
                    zod
                      .object({
                        type: zod
                          .literal("phone_number")
                          .default(
                            listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultThree,
                          ),
                      })
                      .describe(
                        "Validator that accepts arbitrary phone numbers.",
                      ),
                    zod
                      .object({
                        type: zod
                          .literal("email")
                          .default(
                            listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultFour,
                          ),
                      })
                      .describe("Validator that accepts arbitrary emails."),
                    zod
                      .object({
                        type: zod
                          .literal("city_state_zip")
                          .default(
                            listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultFive,
                          ),
                      })
                      .describe(
                        "Validator that accepts city, state, and ZIP code combinations.",
                      ),
                    zod
                      .object({
                        type: zod
                          .literal("optional")
                          .default(
                            listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultSix,
                          ),
                        raw_validator: zod.union([
                          zod
                            .object({
                              type: zod
                                .literal("non_empty_string")
                                .default(
                                  listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefault,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary non-empty strings.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("date")
                                .default(
                                  listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOne,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary dates.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("coded_choice")
                                .default(
                                  listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultTwo,
                                ),
                              options: zod.array(
                                zod
                                  .object({
                                    code: zod.string(),
                                    display: zod.string(),
                                  })
                                  .describe(
                                    "An option from a list of choices.",
                                  ),
                              ),
                            })
                            .describe(
                              "Validator that accepts any option from a list of choices.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("phone_number")
                                .default(
                                  listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultThree,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary phone numbers.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("email")
                                .default(
                                  listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFour,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary emails.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("city_state_zip")
                                .default(
                                  listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFive,
                                ),
                            })
                            .describe(
                              "Validator that accepts city, state, and ZIP code combinations.",
                            ),
                          zod.unknown(),
                          zod
                            .object({
                              type: zod
                                .literal("list")
                                .default(
                                  listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSix,
                                ),
                              raw_validator: zod.union([
                                zod
                                  .object({
                                    type: zod
                                      .literal("non_empty_string")
                                      .default(
                                        listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefault,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary non-empty strings.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("date")
                                      .default(
                                        listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOne,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary dates.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("coded_choice")
                                      .default(
                                        listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultTwo,
                                      ),
                                    options: zod.array(
                                      zod
                                        .object({
                                          code: zod.string(),
                                          display: zod.string(),
                                        })
                                        .describe(
                                          "An option from a list of choices.",
                                        ),
                                    ),
                                  })
                                  .describe(
                                    "Validator that accepts any option from a list of choices.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("phone_number")
                                      .default(
                                        listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultThree,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary phone numbers.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("email")
                                      .default(
                                        listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFour,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary emails.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("city_state_zip")
                                      .default(
                                        listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFive,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts city, state, and ZIP code combinations.",
                                  ),
                                zod.unknown(),
                                zod.unknown(),
                              ]),
                            })
                            .describe("Validator that accepts lists of items."),
                        ]),
                      })
                      .describe("Validator that accepts optional fields."),
                    zod
                      .object({
                        type: zod
                          .literal("list")
                          .default(
                            listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultSeven,
                          ),
                        raw_validator: zod.union([
                          zod
                            .object({
                              type: zod
                                .literal("non_empty_string")
                                .default(
                                  listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSeven,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary non-empty strings.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("date")
                                .default(
                                  listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultEight,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary dates.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("coded_choice")
                                .default(
                                  listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultNine,
                                ),
                              options: zod.array(
                                zod
                                  .object({
                                    code: zod.string(),
                                    display: zod.string(),
                                  })
                                  .describe(
                                    "An option from a list of choices.",
                                  ),
                              ),
                            })
                            .describe(
                              "Validator that accepts any option from a list of choices.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("phone_number")
                                .default(
                                  listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnezero,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary phone numbers.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("email")
                                .default(
                                  listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOneone,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary emails.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("city_state_zip")
                                .default(
                                  listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnetwo,
                                ),
                            })
                            .describe(
                              "Validator that accepts city, state, and ZIP code combinations.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("optional")
                                .default(
                                  listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnethree,
                                ),
                              raw_validator: zod.union([
                                zod
                                  .object({
                                    type: zod
                                      .literal("non_empty_string")
                                      .default(
                                        listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSix,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary non-empty strings.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("date")
                                      .default(
                                        listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSeven,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary dates.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("coded_choice")
                                      .default(
                                        listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultEight,
                                      ),
                                    options: zod.array(
                                      zod
                                        .object({
                                          code: zod.string(),
                                          display: zod.string(),
                                        })
                                        .describe(
                                          "An option from a list of choices.",
                                        ),
                                    ),
                                  })
                                  .describe(
                                    "Validator that accepts any option from a list of choices.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("phone_number")
                                      .default(
                                        listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultNine,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary phone numbers.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("email")
                                      .default(
                                        listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOnezero,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary emails.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("city_state_zip")
                                      .default(
                                        listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOneone,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts city, state, and ZIP code combinations.",
                                  ),
                                zod.unknown(),
                                zod.unknown(),
                              ]),
                            })
                            .describe(
                              "Validator that accepts optional fields.",
                            ),
                          zod.unknown(),
                        ]),
                      })
                      .describe("Validator that accepts lists of items."),
                  ]),
                }),
              ),
            }),
            submissions: zod.object({
              submissions: zod.record(
                zod.string(),
                zod.union([
                  zod.object({
                    type: zod
                      .literal("string")
                      .default(
                        listSurveysResponseSurveysItemInstrumentSessionSubmissionsSubmissionsTypeDefault,
                      ),
                    value: zod.string(),
                  }),
                  zod.object({
                    type: zod
                      .literal("int")
                      .default(
                        listSurveysResponseSurveysItemInstrumentSessionSubmissionsSubmissionsTypeDefaultOne,
                      ),
                    value: zod.number(),
                  }),
                  zod.object({
                    type: zod
                      .literal("simple_address")
                      .default(
                        listSurveysResponseSurveysItemInstrumentSessionSubmissionsSubmissionsTypeDefaultTwo,
                      ),
                    street_address: zod.string(),
                    city_state_zip: zod.string(),
                  }),
                  zod.object({
                    type: zod
                      .literal("list")
                      .default(
                        listSurveysResponseSurveysItemInstrumentSessionSubmissionsSubmissionsTypeDefaultThree,
                      ),
                    values: zod.array(
                      zod.union([
                        zod.object({
                          type: zod
                            .literal("string")
                            .default(
                              listSurveysResponseSurveysItemInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefault,
                            ),
                          value: zod.string(),
                        }),
                        zod.object({
                          type: zod
                            .literal("int")
                            .default(
                              listSurveysResponseSurveysItemInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefaultOne,
                            ),
                          value: zod.number(),
                        }),
                        zod.object({
                          type: zod
                            .literal("simple_address")
                            .default(
                              listSurveysResponseSurveysItemInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefaultTwo,
                            ),
                          street_address: zod.string(),
                          city_state_zip: zod.string(),
                        }),
                        zod.unknown(),
                      ]),
                    ),
                  }),
                ]),
              ),
            }),
            problems: zod.record(zod.string(), zod.string()),
            interpretation: zod.union([
              zod.object({
                type: zod.enum(["complete", "incomplete", "error"]),
                text: zod.string(),
              }),
              zod.null(),
            ]),
          })
          .describe(
            'An \"instrument session\" links the immediate state of a form with an instrumnet,\nwhich\n\nThis captures the instrument type, its form definition, and the user\'s\ncurrent submissions so that follow-ups can be processed without needing\nto look up the instrument again.',
          ),
        created_at: zod.iso.datetime({}),
        updated_at: zod.iso.datetime({}),
        completed_at: zod.union([zod.iso.datetime({}), zod.null()]),
      })
      .describe(
        "Persisted instrument survey record.\n\nEach row represents one survey instance for one patient. The embedded\n``instrument_session`` carries the form definition, submissions, and\ninterpretation. Instrument-specific construction data (e.g. review\nrows for PHR data quality) lives in ``instrument_params`` so the\ninstrument can be reconstructed without the global registry.",
      ),
  ),
});

/**
 * @summary Get Survey
 */
export const getSurveyParams = zod.object({
  survey_id: zod.uuid(),
});

export const getSurveyResponseTypeDefault = "success";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefault =
  "string";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultOne =
  "int";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultTwo =
  "simple_address";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultThree =
  "list";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefault =
  "string";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultOne =
  "int";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultTwo =
  "simple_address";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefault =
  "string";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultOne =
  "int";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultTwo =
  "simple_address";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultThree =
  "list";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefault =
  "string";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultOne =
  "int";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultTwo =
  "simple_address";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefault =
  "non_empty_string";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultOne =
  "date";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultTwo =
  "coded_choice";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultThree =
  "phone_number";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultFour =
  "email";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultFive =
  "city_state_zip";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultSix =
  "optional";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefault =
  "non_empty_string";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOne =
  "date";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultTwo =
  "coded_choice";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultThree =
  "phone_number";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFour =
  "email";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFive =
  "city_state_zip";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSix =
  "list";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefault =
  "non_empty_string";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOne =
  "date";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultTwo =
  "coded_choice";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultThree =
  "phone_number";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFour =
  "email";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFive =
  "city_state_zip";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultSeven =
  "list";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSeven =
  "non_empty_string";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultEight =
  "date";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultNine =
  "coded_choice";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnezero =
  "phone_number";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOneone =
  "email";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnetwo =
  "city_state_zip";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnethree =
  "optional";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSix =
  "non_empty_string";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSeven =
  "date";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultEight =
  "coded_choice";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultNine =
  "phone_number";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOnezero =
  "email";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOneone =
  "city_state_zip";
export const getSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefault =
  "string";
export const getSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefaultOne =
  "int";
export const getSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefaultTwo =
  "simple_address";
export const getSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefaultThree =
  "list";
export const getSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefault =
  "string";
export const getSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefaultOne =
  "int";
export const getSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefaultTwo =
  "simple_address";
export const getSurveyResponseTypeDefaultOne = "not_found";

export const getSurveyResponse = zod.union([
  zod.object({
    type: zod.literal("success").default(getSurveyResponseTypeDefault),
    survey: zod
      .object({
        survey_id: zod.uuid(),
        user_id: zod.uuid(),
        instrument_id: zod.string(),
        status: zod.enum(["open", "completed", "archived"]),
        instrument_params: zod.union([
          zod.record(zod.string(), zod.unknown()),
          zod.null(),
        ]),
        instrument_session: zod
          .object({
            instrument_id: zod.string(),
            form_definition: zod.object({
              fields: zod.array(
                zod.object({
                  id: zod.string(),
                  profile: zod.object({
                    name: zod.string(),
                    description: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                  }),
                  suggested_submission: zod
                    .union([
                      zod.union([
                        zod.object({
                          type: zod
                            .literal("string")
                            .default(
                              getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefault,
                            ),
                          value: zod.string(),
                        }),
                        zod.object({
                          type: zod
                            .literal("int")
                            .default(
                              getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultOne,
                            ),
                          value: zod.number(),
                        }),
                        zod.object({
                          type: zod
                            .literal("simple_address")
                            .default(
                              getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultTwo,
                            ),
                          street_address: zod.string(),
                          city_state_zip: zod.string(),
                        }),
                        zod.object({
                          type: zod
                            .literal("list")
                            .default(
                              getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultThree,
                            ),
                          values: zod.array(
                            zod.union([
                              zod.object({
                                type: zod
                                  .literal("string")
                                  .default(
                                    getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefault,
                                  ),
                                value: zod.string(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("int")
                                  .default(
                                    getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultOne,
                                  ),
                                value: zod.number(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("simple_address")
                                  .default(
                                    getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultTwo,
                                  ),
                                street_address: zod.string(),
                                city_state_zip: zod.string(),
                              }),
                              zod.unknown(),
                            ]),
                          ),
                        }),
                      ]),
                      zod.null(),
                    ])
                    .optional(),
                  default_submission: zod
                    .union([
                      zod.union([
                        zod.object({
                          type: zod
                            .literal("string")
                            .default(
                              getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefault,
                            ),
                          value: zod.string(),
                        }),
                        zod.object({
                          type: zod
                            .literal("int")
                            .default(
                              getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultOne,
                            ),
                          value: zod.number(),
                        }),
                        zod.object({
                          type: zod
                            .literal("simple_address")
                            .default(
                              getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultTwo,
                            ),
                          street_address: zod.string(),
                          city_state_zip: zod.string(),
                        }),
                        zod.object({
                          type: zod
                            .literal("list")
                            .default(
                              getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultThree,
                            ),
                          values: zod.array(
                            zod.union([
                              zod.object({
                                type: zod
                                  .literal("string")
                                  .default(
                                    getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefault,
                                  ),
                                value: zod.string(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("int")
                                  .default(
                                    getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultOne,
                                  ),
                                value: zod.number(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("simple_address")
                                  .default(
                                    getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultTwo,
                                  ),
                                street_address: zod.string(),
                                city_state_zip: zod.string(),
                              }),
                              zod.unknown(),
                            ]),
                          ),
                        }),
                      ]),
                      zod.null(),
                    ])
                    .optional(),
                  validator: zod.union([
                    zod
                      .object({
                        type: zod
                          .literal("non_empty_string")
                          .default(
                            getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefault,
                          ),
                      })
                      .describe(
                        "Validator that accepts arbitrary non-empty strings.",
                      ),
                    zod
                      .object({
                        type: zod
                          .literal("date")
                          .default(
                            getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultOne,
                          ),
                      })
                      .describe("Validator that accepts arbitrary dates."),
                    zod
                      .object({
                        type: zod
                          .literal("coded_choice")
                          .default(
                            getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultTwo,
                          ),
                        options: zod.array(
                          zod
                            .object({
                              code: zod.string(),
                              display: zod.string(),
                            })
                            .describe("An option from a list of choices."),
                        ),
                      })
                      .describe(
                        "Validator that accepts any option from a list of choices.",
                      ),
                    zod
                      .object({
                        type: zod
                          .literal("phone_number")
                          .default(
                            getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultThree,
                          ),
                      })
                      .describe(
                        "Validator that accepts arbitrary phone numbers.",
                      ),
                    zod
                      .object({
                        type: zod
                          .literal("email")
                          .default(
                            getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultFour,
                          ),
                      })
                      .describe("Validator that accepts arbitrary emails."),
                    zod
                      .object({
                        type: zod
                          .literal("city_state_zip")
                          .default(
                            getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultFive,
                          ),
                      })
                      .describe(
                        "Validator that accepts city, state, and ZIP code combinations.",
                      ),
                    zod
                      .object({
                        type: zod
                          .literal("optional")
                          .default(
                            getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultSix,
                          ),
                        raw_validator: zod.union([
                          zod
                            .object({
                              type: zod
                                .literal("non_empty_string")
                                .default(
                                  getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefault,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary non-empty strings.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("date")
                                .default(
                                  getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOne,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary dates.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("coded_choice")
                                .default(
                                  getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultTwo,
                                ),
                              options: zod.array(
                                zod
                                  .object({
                                    code: zod.string(),
                                    display: zod.string(),
                                  })
                                  .describe(
                                    "An option from a list of choices.",
                                  ),
                              ),
                            })
                            .describe(
                              "Validator that accepts any option from a list of choices.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("phone_number")
                                .default(
                                  getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultThree,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary phone numbers.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("email")
                                .default(
                                  getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFour,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary emails.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("city_state_zip")
                                .default(
                                  getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFive,
                                ),
                            })
                            .describe(
                              "Validator that accepts city, state, and ZIP code combinations.",
                            ),
                          zod.unknown(),
                          zod
                            .object({
                              type: zod
                                .literal("list")
                                .default(
                                  getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSix,
                                ),
                              raw_validator: zod.union([
                                zod
                                  .object({
                                    type: zod
                                      .literal("non_empty_string")
                                      .default(
                                        getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefault,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary non-empty strings.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("date")
                                      .default(
                                        getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOne,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary dates.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("coded_choice")
                                      .default(
                                        getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultTwo,
                                      ),
                                    options: zod.array(
                                      zod
                                        .object({
                                          code: zod.string(),
                                          display: zod.string(),
                                        })
                                        .describe(
                                          "An option from a list of choices.",
                                        ),
                                    ),
                                  })
                                  .describe(
                                    "Validator that accepts any option from a list of choices.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("phone_number")
                                      .default(
                                        getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultThree,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary phone numbers.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("email")
                                      .default(
                                        getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFour,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary emails.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("city_state_zip")
                                      .default(
                                        getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFive,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts city, state, and ZIP code combinations.",
                                  ),
                                zod.unknown(),
                                zod.unknown(),
                              ]),
                            })
                            .describe("Validator that accepts lists of items."),
                        ]),
                      })
                      .describe("Validator that accepts optional fields."),
                    zod
                      .object({
                        type: zod
                          .literal("list")
                          .default(
                            getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultSeven,
                          ),
                        raw_validator: zod.union([
                          zod
                            .object({
                              type: zod
                                .literal("non_empty_string")
                                .default(
                                  getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSeven,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary non-empty strings.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("date")
                                .default(
                                  getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultEight,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary dates.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("coded_choice")
                                .default(
                                  getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultNine,
                                ),
                              options: zod.array(
                                zod
                                  .object({
                                    code: zod.string(),
                                    display: zod.string(),
                                  })
                                  .describe(
                                    "An option from a list of choices.",
                                  ),
                              ),
                            })
                            .describe(
                              "Validator that accepts any option from a list of choices.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("phone_number")
                                .default(
                                  getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnezero,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary phone numbers.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("email")
                                .default(
                                  getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOneone,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary emails.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("city_state_zip")
                                .default(
                                  getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnetwo,
                                ),
                            })
                            .describe(
                              "Validator that accepts city, state, and ZIP code combinations.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("optional")
                                .default(
                                  getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnethree,
                                ),
                              raw_validator: zod.union([
                                zod
                                  .object({
                                    type: zod
                                      .literal("non_empty_string")
                                      .default(
                                        getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSix,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary non-empty strings.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("date")
                                      .default(
                                        getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSeven,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary dates.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("coded_choice")
                                      .default(
                                        getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultEight,
                                      ),
                                    options: zod.array(
                                      zod
                                        .object({
                                          code: zod.string(),
                                          display: zod.string(),
                                        })
                                        .describe(
                                          "An option from a list of choices.",
                                        ),
                                    ),
                                  })
                                  .describe(
                                    "Validator that accepts any option from a list of choices.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("phone_number")
                                      .default(
                                        getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultNine,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary phone numbers.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("email")
                                      .default(
                                        getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOnezero,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary emails.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("city_state_zip")
                                      .default(
                                        getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOneone,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts city, state, and ZIP code combinations.",
                                  ),
                                zod.unknown(),
                                zod.unknown(),
                              ]),
                            })
                            .describe(
                              "Validator that accepts optional fields.",
                            ),
                          zod.unknown(),
                        ]),
                      })
                      .describe("Validator that accepts lists of items."),
                  ]),
                }),
              ),
            }),
            submissions: zod.object({
              submissions: zod.record(
                zod.string(),
                zod.union([
                  zod.object({
                    type: zod
                      .literal("string")
                      .default(
                        getSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefault,
                      ),
                    value: zod.string(),
                  }),
                  zod.object({
                    type: zod
                      .literal("int")
                      .default(
                        getSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefaultOne,
                      ),
                    value: zod.number(),
                  }),
                  zod.object({
                    type: zod
                      .literal("simple_address")
                      .default(
                        getSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefaultTwo,
                      ),
                    street_address: zod.string(),
                    city_state_zip: zod.string(),
                  }),
                  zod.object({
                    type: zod
                      .literal("list")
                      .default(
                        getSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefaultThree,
                      ),
                    values: zod.array(
                      zod.union([
                        zod.object({
                          type: zod
                            .literal("string")
                            .default(
                              getSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefault,
                            ),
                          value: zod.string(),
                        }),
                        zod.object({
                          type: zod
                            .literal("int")
                            .default(
                              getSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefaultOne,
                            ),
                          value: zod.number(),
                        }),
                        zod.object({
                          type: zod
                            .literal("simple_address")
                            .default(
                              getSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefaultTwo,
                            ),
                          street_address: zod.string(),
                          city_state_zip: zod.string(),
                        }),
                        zod.unknown(),
                      ]),
                    ),
                  }),
                ]),
              ),
            }),
            problems: zod.record(zod.string(), zod.string()),
            interpretation: zod.union([
              zod.object({
                type: zod.enum(["complete", "incomplete", "error"]),
                text: zod.string(),
              }),
              zod.null(),
            ]),
          })
          .describe(
            'An \"instrument session\" links the immediate state of a form with an instrumnet,\nwhich\n\nThis captures the instrument type, its form definition, and the user\'s\ncurrent submissions so that follow-ups can be processed without needing\nto look up the instrument again.',
          ),
        created_at: zod.iso.datetime({}),
        updated_at: zod.iso.datetime({}),
        completed_at: zod.union([zod.iso.datetime({}), zod.null()]),
      })
      .describe(
        "Persisted instrument survey record.\n\nEach row represents one survey instance for one patient. The embedded\n``instrument_session`` carries the form definition, submissions, and\ninterpretation. Instrument-specific construction data (e.g. review\nrows for PHR data quality) lives in ``instrument_params`` so the\ninstrument can be reconstructed without the global registry.",
      ),
  }),
  zod.object({
    type: zod.literal("not_found").default(getSurveyResponseTypeDefaultOne),
  }),
]);

/**
 * @summary Submit Answers
 */
export const submitAnswersParams = zod.object({
  survey_id: zod.uuid(),
});

export const submitAnswersBodySubmissionsSubmissionsTypeDefault = "string";
export const submitAnswersBodySubmissionsSubmissionsTypeDefaultOne = "int";
export const submitAnswersBodySubmissionsSubmissionsTypeDefaultTwo =
  "simple_address";
export const submitAnswersBodySubmissionsSubmissionsTypeDefaultThree = "list";
export const submitAnswersBodySubmissionsSubmissionsValuesItemTypeDefault =
  "string";
export const submitAnswersBodySubmissionsSubmissionsValuesItemTypeDefaultOne =
  "int";
export const submitAnswersBodySubmissionsSubmissionsValuesItemTypeDefaultTwo =
  "simple_address";

export const submitAnswersBody = zod.object({
  submissions: zod.object({
    submissions: zod.record(
      zod.string(),
      zod.union([
        zod.object({
          type: zod
            .literal("string")
            .default(submitAnswersBodySubmissionsSubmissionsTypeDefault),
          value: zod.string(),
        }),
        zod.object({
          type: zod
            .literal("int")
            .default(submitAnswersBodySubmissionsSubmissionsTypeDefaultOne),
          value: zod.number(),
        }),
        zod.object({
          type: zod
            .literal("simple_address")
            .default(submitAnswersBodySubmissionsSubmissionsTypeDefaultTwo),
          street_address: zod.string(),
          city_state_zip: zod.string(),
        }),
        zod.object({
          type: zod
            .literal("list")
            .default(submitAnswersBodySubmissionsSubmissionsTypeDefaultThree),
          values: zod.array(
            zod.union([
              zod.object({
                type: zod
                  .literal("string")
                  .default(
                    submitAnswersBodySubmissionsSubmissionsValuesItemTypeDefault,
                  ),
                value: zod.string(),
              }),
              zod.object({
                type: zod
                  .literal("int")
                  .default(
                    submitAnswersBodySubmissionsSubmissionsValuesItemTypeDefaultOne,
                  ),
                value: zod.number(),
              }),
              zod.object({
                type: zod
                  .literal("simple_address")
                  .default(
                    submitAnswersBodySubmissionsSubmissionsValuesItemTypeDefaultTwo,
                  ),
                street_address: zod.string(),
                city_state_zip: zod.string(),
              }),
              zod.unknown(),
            ]),
          ),
        }),
      ]),
    ),
  }),
});

export const submitAnswersResponseTypeDefault = "success";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefault =
  "string";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultOne =
  "int";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultTwo =
  "simple_address";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultThree =
  "list";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefault =
  "string";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultOne =
  "int";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultTwo =
  "simple_address";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefault =
  "string";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultOne =
  "int";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultTwo =
  "simple_address";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultThree =
  "list";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefault =
  "string";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultOne =
  "int";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultTwo =
  "simple_address";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefault =
  "non_empty_string";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultOne =
  "date";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultTwo =
  "coded_choice";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultThree =
  "phone_number";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultFour =
  "email";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultFive =
  "city_state_zip";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultSix =
  "optional";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefault =
  "non_empty_string";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOne =
  "date";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultTwo =
  "coded_choice";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultThree =
  "phone_number";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFour =
  "email";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFive =
  "city_state_zip";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSix =
  "list";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefault =
  "non_empty_string";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOne =
  "date";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultTwo =
  "coded_choice";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultThree =
  "phone_number";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFour =
  "email";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFive =
  "city_state_zip";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultSeven =
  "list";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSeven =
  "non_empty_string";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultEight =
  "date";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultNine =
  "coded_choice";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnezero =
  "phone_number";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOneone =
  "email";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnetwo =
  "city_state_zip";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnethree =
  "optional";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSix =
  "non_empty_string";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSeven =
  "date";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultEight =
  "coded_choice";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultNine =
  "phone_number";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOnezero =
  "email";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOneone =
  "city_state_zip";
export const submitAnswersResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefault =
  "string";
export const submitAnswersResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefaultOne =
  "int";
export const submitAnswersResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefaultTwo =
  "simple_address";
export const submitAnswersResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefaultThree =
  "list";
export const submitAnswersResponseSurveyInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefault =
  "string";
export const submitAnswersResponseSurveyInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefaultOne =
  "int";
export const submitAnswersResponseSurveyInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefaultTwo =
  "simple_address";
export const submitAnswersResponseTypeDefaultOne = "not_found";
export const submitAnswersResponseTypeDefaultTwo = "bad_status";

export const submitAnswersResponse = zod.union([
  zod.object({
    type: zod.literal("success").default(submitAnswersResponseTypeDefault),
    survey: zod
      .object({
        survey_id: zod.uuid(),
        user_id: zod.uuid(),
        instrument_id: zod.string(),
        status: zod.enum(["open", "completed", "archived"]),
        instrument_params: zod.union([
          zod.record(zod.string(), zod.unknown()),
          zod.null(),
        ]),
        instrument_session: zod
          .object({
            instrument_id: zod.string(),
            form_definition: zod.object({
              fields: zod.array(
                zod.object({
                  id: zod.string(),
                  profile: zod.object({
                    name: zod.string(),
                    description: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                  }),
                  suggested_submission: zod
                    .union([
                      zod.union([
                        zod.object({
                          type: zod
                            .literal("string")
                            .default(
                              submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefault,
                            ),
                          value: zod.string(),
                        }),
                        zod.object({
                          type: zod
                            .literal("int")
                            .default(
                              submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultOne,
                            ),
                          value: zod.number(),
                        }),
                        zod.object({
                          type: zod
                            .literal("simple_address")
                            .default(
                              submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultTwo,
                            ),
                          street_address: zod.string(),
                          city_state_zip: zod.string(),
                        }),
                        zod.object({
                          type: zod
                            .literal("list")
                            .default(
                              submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultThree,
                            ),
                          values: zod.array(
                            zod.union([
                              zod.object({
                                type: zod
                                  .literal("string")
                                  .default(
                                    submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefault,
                                  ),
                                value: zod.string(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("int")
                                  .default(
                                    submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultOne,
                                  ),
                                value: zod.number(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("simple_address")
                                  .default(
                                    submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultTwo,
                                  ),
                                street_address: zod.string(),
                                city_state_zip: zod.string(),
                              }),
                              zod.unknown(),
                            ]),
                          ),
                        }),
                      ]),
                      zod.null(),
                    ])
                    .optional(),
                  default_submission: zod
                    .union([
                      zod.union([
                        zod.object({
                          type: zod
                            .literal("string")
                            .default(
                              submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefault,
                            ),
                          value: zod.string(),
                        }),
                        zod.object({
                          type: zod
                            .literal("int")
                            .default(
                              submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultOne,
                            ),
                          value: zod.number(),
                        }),
                        zod.object({
                          type: zod
                            .literal("simple_address")
                            .default(
                              submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultTwo,
                            ),
                          street_address: zod.string(),
                          city_state_zip: zod.string(),
                        }),
                        zod.object({
                          type: zod
                            .literal("list")
                            .default(
                              submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultThree,
                            ),
                          values: zod.array(
                            zod.union([
                              zod.object({
                                type: zod
                                  .literal("string")
                                  .default(
                                    submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefault,
                                  ),
                                value: zod.string(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("int")
                                  .default(
                                    submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultOne,
                                  ),
                                value: zod.number(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("simple_address")
                                  .default(
                                    submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultTwo,
                                  ),
                                street_address: zod.string(),
                                city_state_zip: zod.string(),
                              }),
                              zod.unknown(),
                            ]),
                          ),
                        }),
                      ]),
                      zod.null(),
                    ])
                    .optional(),
                  validator: zod.union([
                    zod
                      .object({
                        type: zod
                          .literal("non_empty_string")
                          .default(
                            submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefault,
                          ),
                      })
                      .describe(
                        "Validator that accepts arbitrary non-empty strings.",
                      ),
                    zod
                      .object({
                        type: zod
                          .literal("date")
                          .default(
                            submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultOne,
                          ),
                      })
                      .describe("Validator that accepts arbitrary dates."),
                    zod
                      .object({
                        type: zod
                          .literal("coded_choice")
                          .default(
                            submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultTwo,
                          ),
                        options: zod.array(
                          zod
                            .object({
                              code: zod.string(),
                              display: zod.string(),
                            })
                            .describe("An option from a list of choices."),
                        ),
                      })
                      .describe(
                        "Validator that accepts any option from a list of choices.",
                      ),
                    zod
                      .object({
                        type: zod
                          .literal("phone_number")
                          .default(
                            submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultThree,
                          ),
                      })
                      .describe(
                        "Validator that accepts arbitrary phone numbers.",
                      ),
                    zod
                      .object({
                        type: zod
                          .literal("email")
                          .default(
                            submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultFour,
                          ),
                      })
                      .describe("Validator that accepts arbitrary emails."),
                    zod
                      .object({
                        type: zod
                          .literal("city_state_zip")
                          .default(
                            submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultFive,
                          ),
                      })
                      .describe(
                        "Validator that accepts city, state, and ZIP code combinations.",
                      ),
                    zod
                      .object({
                        type: zod
                          .literal("optional")
                          .default(
                            submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultSix,
                          ),
                        raw_validator: zod.union([
                          zod
                            .object({
                              type: zod
                                .literal("non_empty_string")
                                .default(
                                  submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefault,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary non-empty strings.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("date")
                                .default(
                                  submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOne,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary dates.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("coded_choice")
                                .default(
                                  submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultTwo,
                                ),
                              options: zod.array(
                                zod
                                  .object({
                                    code: zod.string(),
                                    display: zod.string(),
                                  })
                                  .describe(
                                    "An option from a list of choices.",
                                  ),
                              ),
                            })
                            .describe(
                              "Validator that accepts any option from a list of choices.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("phone_number")
                                .default(
                                  submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultThree,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary phone numbers.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("email")
                                .default(
                                  submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFour,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary emails.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("city_state_zip")
                                .default(
                                  submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFive,
                                ),
                            })
                            .describe(
                              "Validator that accepts city, state, and ZIP code combinations.",
                            ),
                          zod.unknown(),
                          zod
                            .object({
                              type: zod
                                .literal("list")
                                .default(
                                  submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSix,
                                ),
                              raw_validator: zod.union([
                                zod
                                  .object({
                                    type: zod
                                      .literal("non_empty_string")
                                      .default(
                                        submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefault,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary non-empty strings.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("date")
                                      .default(
                                        submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOne,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary dates.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("coded_choice")
                                      .default(
                                        submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultTwo,
                                      ),
                                    options: zod.array(
                                      zod
                                        .object({
                                          code: zod.string(),
                                          display: zod.string(),
                                        })
                                        .describe(
                                          "An option from a list of choices.",
                                        ),
                                    ),
                                  })
                                  .describe(
                                    "Validator that accepts any option from a list of choices.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("phone_number")
                                      .default(
                                        submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultThree,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary phone numbers.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("email")
                                      .default(
                                        submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFour,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary emails.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("city_state_zip")
                                      .default(
                                        submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFive,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts city, state, and ZIP code combinations.",
                                  ),
                                zod.unknown(),
                                zod.unknown(),
                              ]),
                            })
                            .describe("Validator that accepts lists of items."),
                        ]),
                      })
                      .describe("Validator that accepts optional fields."),
                    zod
                      .object({
                        type: zod
                          .literal("list")
                          .default(
                            submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultSeven,
                          ),
                        raw_validator: zod.union([
                          zod
                            .object({
                              type: zod
                                .literal("non_empty_string")
                                .default(
                                  submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSeven,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary non-empty strings.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("date")
                                .default(
                                  submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultEight,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary dates.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("coded_choice")
                                .default(
                                  submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultNine,
                                ),
                              options: zod.array(
                                zod
                                  .object({
                                    code: zod.string(),
                                    display: zod.string(),
                                  })
                                  .describe(
                                    "An option from a list of choices.",
                                  ),
                              ),
                            })
                            .describe(
                              "Validator that accepts any option from a list of choices.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("phone_number")
                                .default(
                                  submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnezero,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary phone numbers.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("email")
                                .default(
                                  submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOneone,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary emails.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("city_state_zip")
                                .default(
                                  submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnetwo,
                                ),
                            })
                            .describe(
                              "Validator that accepts city, state, and ZIP code combinations.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("optional")
                                .default(
                                  submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnethree,
                                ),
                              raw_validator: zod.union([
                                zod
                                  .object({
                                    type: zod
                                      .literal("non_empty_string")
                                      .default(
                                        submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSix,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary non-empty strings.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("date")
                                      .default(
                                        submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSeven,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary dates.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("coded_choice")
                                      .default(
                                        submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultEight,
                                      ),
                                    options: zod.array(
                                      zod
                                        .object({
                                          code: zod.string(),
                                          display: zod.string(),
                                        })
                                        .describe(
                                          "An option from a list of choices.",
                                        ),
                                    ),
                                  })
                                  .describe(
                                    "Validator that accepts any option from a list of choices.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("phone_number")
                                      .default(
                                        submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultNine,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary phone numbers.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("email")
                                      .default(
                                        submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOnezero,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary emails.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("city_state_zip")
                                      .default(
                                        submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOneone,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts city, state, and ZIP code combinations.",
                                  ),
                                zod.unknown(),
                                zod.unknown(),
                              ]),
                            })
                            .describe(
                              "Validator that accepts optional fields.",
                            ),
                          zod.unknown(),
                        ]),
                      })
                      .describe("Validator that accepts lists of items."),
                  ]),
                }),
              ),
            }),
            submissions: zod.object({
              submissions: zod.record(
                zod.string(),
                zod.union([
                  zod.object({
                    type: zod
                      .literal("string")
                      .default(
                        submitAnswersResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefault,
                      ),
                    value: zod.string(),
                  }),
                  zod.object({
                    type: zod
                      .literal("int")
                      .default(
                        submitAnswersResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefaultOne,
                      ),
                    value: zod.number(),
                  }),
                  zod.object({
                    type: zod
                      .literal("simple_address")
                      .default(
                        submitAnswersResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefaultTwo,
                      ),
                    street_address: zod.string(),
                    city_state_zip: zod.string(),
                  }),
                  zod.object({
                    type: zod
                      .literal("list")
                      .default(
                        submitAnswersResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefaultThree,
                      ),
                    values: zod.array(
                      zod.union([
                        zod.object({
                          type: zod
                            .literal("string")
                            .default(
                              submitAnswersResponseSurveyInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefault,
                            ),
                          value: zod.string(),
                        }),
                        zod.object({
                          type: zod
                            .literal("int")
                            .default(
                              submitAnswersResponseSurveyInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefaultOne,
                            ),
                          value: zod.number(),
                        }),
                        zod.object({
                          type: zod
                            .literal("simple_address")
                            .default(
                              submitAnswersResponseSurveyInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefaultTwo,
                            ),
                          street_address: zod.string(),
                          city_state_zip: zod.string(),
                        }),
                        zod.unknown(),
                      ]),
                    ),
                  }),
                ]),
              ),
            }),
            problems: zod.record(zod.string(), zod.string()),
            interpretation: zod.union([
              zod.object({
                type: zod.enum(["complete", "incomplete", "error"]),
                text: zod.string(),
              }),
              zod.null(),
            ]),
          })
          .describe(
            'An \"instrument session\" links the immediate state of a form with an instrumnet,\nwhich\n\nThis captures the instrument type, its form definition, and the user\'s\ncurrent submissions so that follow-ups can be processed without needing\nto look up the instrument again.',
          ),
        created_at: zod.iso.datetime({}),
        updated_at: zod.iso.datetime({}),
        completed_at: zod.union([zod.iso.datetime({}), zod.null()]),
      })
      .describe(
        "Persisted instrument survey record.\n\nEach row represents one survey instance for one patient. The embedded\n``instrument_session`` carries the form definition, submissions, and\ninterpretation. Instrument-specific construction data (e.g. review\nrows for PHR data quality) lives in ``instrument_params`` so the\ninstrument can be reconstructed without the global registry.",
      ),
  }),
  zod.object({
    type: zod.literal("not_found").default(submitAnswersResponseTypeDefaultOne),
  }),
  zod.object({
    type: zod
      .literal("bad_status")
      .default(submitAnswersResponseTypeDefaultTwo),
    current_status: zod.enum(["open", "completed", "archived"]),
    details: zod.string(),
  }),
]);

/**
 * @summary Archive Survey
 */
export const archiveSurveyParams = zod.object({
  survey_id: zod.uuid(),
});

export const archiveSurveyResponseTypeDefault = "success";
export const archiveSurveyResponseTypeDefaultOne = "not_found";
export const archiveSurveyResponseTypeDefaultTwo = "bad_status";

export const archiveSurveyResponse = zod.union([
  zod.object({
    type: zod.literal("success").default(archiveSurveyResponseTypeDefault),
  }),
  zod.object({
    type: zod.literal("not_found").default(archiveSurveyResponseTypeDefaultOne),
  }),
  zod.object({
    type: zod
      .literal("bad_status")
      .default(archiveSurveyResponseTypeDefaultTwo),
    current_status: zod.enum(["open", "completed", "archived"]),
    details: zod.string(),
  }),
]);

/**
 * @summary Create Own Phr Survey
 */
export const createOwnPhrSurveyResponseTypeDefault = "success";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefault =
  "string";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultOne =
  "int";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultTwo =
  "simple_address";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultThree =
  "list";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefault =
  "string";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultOne =
  "int";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultTwo =
  "simple_address";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefault =
  "string";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultOne =
  "int";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultTwo =
  "simple_address";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultThree =
  "list";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefault =
  "string";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultOne =
  "int";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultTwo =
  "simple_address";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefault =
  "non_empty_string";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultOne =
  "date";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultTwo =
  "coded_choice";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultThree =
  "phone_number";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultFour =
  "email";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultFive =
  "city_state_zip";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultSix =
  "optional";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefault =
  "non_empty_string";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOne =
  "date";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultTwo =
  "coded_choice";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultThree =
  "phone_number";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFour =
  "email";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFive =
  "city_state_zip";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSix =
  "list";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefault =
  "non_empty_string";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOne =
  "date";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultTwo =
  "coded_choice";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultThree =
  "phone_number";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFour =
  "email";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFive =
  "city_state_zip";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultSeven =
  "list";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSeven =
  "non_empty_string";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultEight =
  "date";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultNine =
  "coded_choice";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnezero =
  "phone_number";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOneone =
  "email";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnetwo =
  "city_state_zip";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnethree =
  "optional";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSix =
  "non_empty_string";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSeven =
  "date";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultEight =
  "coded_choice";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultNine =
  "phone_number";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOnezero =
  "email";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOneone =
  "city_state_zip";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefault =
  "string";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefaultOne =
  "int";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefaultTwo =
  "simple_address";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefaultThree =
  "list";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefault =
  "string";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefaultOne =
  "int";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefaultTwo =
  "simple_address";
export const createOwnPhrSurveyResponseTypeDefaultOne = "bad_instrument";
export const createOwnPhrSurveyResponseTypeDefaultTwo = "no_data";

export const createOwnPhrSurveyResponse = zod.union([
  zod.object({
    type: zod.literal("success").default(createOwnPhrSurveyResponseTypeDefault),
    survey: zod
      .object({
        survey_id: zod.uuid(),
        user_id: zod.uuid(),
        instrument_id: zod.string(),
        status: zod.enum(["open", "completed", "archived"]),
        instrument_params: zod.union([
          zod.record(zod.string(), zod.unknown()),
          zod.null(),
        ]),
        instrument_session: zod
          .object({
            instrument_id: zod.string(),
            form_definition: zod.object({
              fields: zod.array(
                zod.object({
                  id: zod.string(),
                  profile: zod.object({
                    name: zod.string(),
                    description: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                  }),
                  suggested_submission: zod
                    .union([
                      zod.union([
                        zod.object({
                          type: zod
                            .literal("string")
                            .default(
                              createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefault,
                            ),
                          value: zod.string(),
                        }),
                        zod.object({
                          type: zod
                            .literal("int")
                            .default(
                              createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultOne,
                            ),
                          value: zod.number(),
                        }),
                        zod.object({
                          type: zod
                            .literal("simple_address")
                            .default(
                              createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultTwo,
                            ),
                          street_address: zod.string(),
                          city_state_zip: zod.string(),
                        }),
                        zod.object({
                          type: zod
                            .literal("list")
                            .default(
                              createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultThree,
                            ),
                          values: zod.array(
                            zod.union([
                              zod.object({
                                type: zod
                                  .literal("string")
                                  .default(
                                    createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefault,
                                  ),
                                value: zod.string(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("int")
                                  .default(
                                    createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultOne,
                                  ),
                                value: zod.number(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("simple_address")
                                  .default(
                                    createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultTwo,
                                  ),
                                street_address: zod.string(),
                                city_state_zip: zod.string(),
                              }),
                              zod.unknown(),
                            ]),
                          ),
                        }),
                      ]),
                      zod.null(),
                    ])
                    .optional(),
                  default_submission: zod
                    .union([
                      zod.union([
                        zod.object({
                          type: zod
                            .literal("string")
                            .default(
                              createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefault,
                            ),
                          value: zod.string(),
                        }),
                        zod.object({
                          type: zod
                            .literal("int")
                            .default(
                              createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultOne,
                            ),
                          value: zod.number(),
                        }),
                        zod.object({
                          type: zod
                            .literal("simple_address")
                            .default(
                              createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultTwo,
                            ),
                          street_address: zod.string(),
                          city_state_zip: zod.string(),
                        }),
                        zod.object({
                          type: zod
                            .literal("list")
                            .default(
                              createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultThree,
                            ),
                          values: zod.array(
                            zod.union([
                              zod.object({
                                type: zod
                                  .literal("string")
                                  .default(
                                    createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefault,
                                  ),
                                value: zod.string(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("int")
                                  .default(
                                    createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultOne,
                                  ),
                                value: zod.number(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("simple_address")
                                  .default(
                                    createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultTwo,
                                  ),
                                street_address: zod.string(),
                                city_state_zip: zod.string(),
                              }),
                              zod.unknown(),
                            ]),
                          ),
                        }),
                      ]),
                      zod.null(),
                    ])
                    .optional(),
                  validator: zod.union([
                    zod
                      .object({
                        type: zod
                          .literal("non_empty_string")
                          .default(
                            createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefault,
                          ),
                      })
                      .describe(
                        "Validator that accepts arbitrary non-empty strings.",
                      ),
                    zod
                      .object({
                        type: zod
                          .literal("date")
                          .default(
                            createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultOne,
                          ),
                      })
                      .describe("Validator that accepts arbitrary dates."),
                    zod
                      .object({
                        type: zod
                          .literal("coded_choice")
                          .default(
                            createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultTwo,
                          ),
                        options: zod.array(
                          zod
                            .object({
                              code: zod.string(),
                              display: zod.string(),
                            })
                            .describe("An option from a list of choices."),
                        ),
                      })
                      .describe(
                        "Validator that accepts any option from a list of choices.",
                      ),
                    zod
                      .object({
                        type: zod
                          .literal("phone_number")
                          .default(
                            createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultThree,
                          ),
                      })
                      .describe(
                        "Validator that accepts arbitrary phone numbers.",
                      ),
                    zod
                      .object({
                        type: zod
                          .literal("email")
                          .default(
                            createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultFour,
                          ),
                      })
                      .describe("Validator that accepts arbitrary emails."),
                    zod
                      .object({
                        type: zod
                          .literal("city_state_zip")
                          .default(
                            createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultFive,
                          ),
                      })
                      .describe(
                        "Validator that accepts city, state, and ZIP code combinations.",
                      ),
                    zod
                      .object({
                        type: zod
                          .literal("optional")
                          .default(
                            createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultSix,
                          ),
                        raw_validator: zod.union([
                          zod
                            .object({
                              type: zod
                                .literal("non_empty_string")
                                .default(
                                  createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefault,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary non-empty strings.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("date")
                                .default(
                                  createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOne,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary dates.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("coded_choice")
                                .default(
                                  createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultTwo,
                                ),
                              options: zod.array(
                                zod
                                  .object({
                                    code: zod.string(),
                                    display: zod.string(),
                                  })
                                  .describe(
                                    "An option from a list of choices.",
                                  ),
                              ),
                            })
                            .describe(
                              "Validator that accepts any option from a list of choices.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("phone_number")
                                .default(
                                  createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultThree,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary phone numbers.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("email")
                                .default(
                                  createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFour,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary emails.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("city_state_zip")
                                .default(
                                  createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFive,
                                ),
                            })
                            .describe(
                              "Validator that accepts city, state, and ZIP code combinations.",
                            ),
                          zod.unknown(),
                          zod
                            .object({
                              type: zod
                                .literal("list")
                                .default(
                                  createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSix,
                                ),
                              raw_validator: zod.union([
                                zod
                                  .object({
                                    type: zod
                                      .literal("non_empty_string")
                                      .default(
                                        createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefault,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary non-empty strings.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("date")
                                      .default(
                                        createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOne,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary dates.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("coded_choice")
                                      .default(
                                        createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultTwo,
                                      ),
                                    options: zod.array(
                                      zod
                                        .object({
                                          code: zod.string(),
                                          display: zod.string(),
                                        })
                                        .describe(
                                          "An option from a list of choices.",
                                        ),
                                    ),
                                  })
                                  .describe(
                                    "Validator that accepts any option from a list of choices.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("phone_number")
                                      .default(
                                        createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultThree,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary phone numbers.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("email")
                                      .default(
                                        createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFour,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary emails.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("city_state_zip")
                                      .default(
                                        createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFive,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts city, state, and ZIP code combinations.",
                                  ),
                                zod.unknown(),
                                zod.unknown(),
                              ]),
                            })
                            .describe("Validator that accepts lists of items."),
                        ]),
                      })
                      .describe("Validator that accepts optional fields."),
                    zod
                      .object({
                        type: zod
                          .literal("list")
                          .default(
                            createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultSeven,
                          ),
                        raw_validator: zod.union([
                          zod
                            .object({
                              type: zod
                                .literal("non_empty_string")
                                .default(
                                  createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSeven,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary non-empty strings.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("date")
                                .default(
                                  createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultEight,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary dates.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("coded_choice")
                                .default(
                                  createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultNine,
                                ),
                              options: zod.array(
                                zod
                                  .object({
                                    code: zod.string(),
                                    display: zod.string(),
                                  })
                                  .describe(
                                    "An option from a list of choices.",
                                  ),
                              ),
                            })
                            .describe(
                              "Validator that accepts any option from a list of choices.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("phone_number")
                                .default(
                                  createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnezero,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary phone numbers.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("email")
                                .default(
                                  createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOneone,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary emails.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("city_state_zip")
                                .default(
                                  createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnetwo,
                                ),
                            })
                            .describe(
                              "Validator that accepts city, state, and ZIP code combinations.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("optional")
                                .default(
                                  createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnethree,
                                ),
                              raw_validator: zod.union([
                                zod
                                  .object({
                                    type: zod
                                      .literal("non_empty_string")
                                      .default(
                                        createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSix,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary non-empty strings.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("date")
                                      .default(
                                        createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSeven,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary dates.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("coded_choice")
                                      .default(
                                        createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultEight,
                                      ),
                                    options: zod.array(
                                      zod
                                        .object({
                                          code: zod.string(),
                                          display: zod.string(),
                                        })
                                        .describe(
                                          "An option from a list of choices.",
                                        ),
                                    ),
                                  })
                                  .describe(
                                    "Validator that accepts any option from a list of choices.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("phone_number")
                                      .default(
                                        createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultNine,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary phone numbers.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("email")
                                      .default(
                                        createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOnezero,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary emails.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("city_state_zip")
                                      .default(
                                        createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOneone,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts city, state, and ZIP code combinations.",
                                  ),
                                zod.unknown(),
                                zod.unknown(),
                              ]),
                            })
                            .describe(
                              "Validator that accepts optional fields.",
                            ),
                          zod.unknown(),
                        ]),
                      })
                      .describe("Validator that accepts lists of items."),
                  ]),
                }),
              ),
            }),
            submissions: zod.object({
              submissions: zod.record(
                zod.string(),
                zod.union([
                  zod.object({
                    type: zod
                      .literal("string")
                      .default(
                        createOwnPhrSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefault,
                      ),
                    value: zod.string(),
                  }),
                  zod.object({
                    type: zod
                      .literal("int")
                      .default(
                        createOwnPhrSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefaultOne,
                      ),
                    value: zod.number(),
                  }),
                  zod.object({
                    type: zod
                      .literal("simple_address")
                      .default(
                        createOwnPhrSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefaultTwo,
                      ),
                    street_address: zod.string(),
                    city_state_zip: zod.string(),
                  }),
                  zod.object({
                    type: zod
                      .literal("list")
                      .default(
                        createOwnPhrSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefaultThree,
                      ),
                    values: zod.array(
                      zod.union([
                        zod.object({
                          type: zod
                            .literal("string")
                            .default(
                              createOwnPhrSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefault,
                            ),
                          value: zod.string(),
                        }),
                        zod.object({
                          type: zod
                            .literal("int")
                            .default(
                              createOwnPhrSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefaultOne,
                            ),
                          value: zod.number(),
                        }),
                        zod.object({
                          type: zod
                            .literal("simple_address")
                            .default(
                              createOwnPhrSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefaultTwo,
                            ),
                          street_address: zod.string(),
                          city_state_zip: zod.string(),
                        }),
                        zod.unknown(),
                      ]),
                    ),
                  }),
                ]),
              ),
            }),
            problems: zod.record(zod.string(), zod.string()),
            interpretation: zod.union([
              zod.object({
                type: zod.enum(["complete", "incomplete", "error"]),
                text: zod.string(),
              }),
              zod.null(),
            ]),
          })
          .describe(
            'An \"instrument session\" links the immediate state of a form with an instrumnet,\nwhich\n\nThis captures the instrument type, its form definition, and the user\'s\ncurrent submissions so that follow-ups can be processed without needing\nto look up the instrument again.',
          ),
        created_at: zod.iso.datetime({}),
        updated_at: zod.iso.datetime({}),
        completed_at: zod.union([zod.iso.datetime({}), zod.null()]),
      })
      .describe(
        "Persisted instrument survey record.\n\nEach row represents one survey instance for one patient. The embedded\n``instrument_session`` carries the form definition, submissions, and\ninterpretation. Instrument-specific construction data (e.g. review\nrows for PHR data quality) lives in ``instrument_params`` so the\ninstrument can be reconstructed without the global registry.",
      ),
    replaced_survey_id: zod.union([zod.uuid(), zod.null()]),
  }),
  zod.object({
    type: zod
      .literal("bad_instrument")
      .default(createOwnPhrSurveyResponseTypeDefaultOne),
    instrument_id: zod.string(),
  }),
  zod.object({
    type: zod
      .literal("no_data")
      .default(createOwnPhrSurveyResponseTypeDefaultTwo),
  }),
]);

/**
 * Fetch all available search sources for testing.
 * @summary Fetch Available Sources
 */
export const fetchAvailableSourcesResponse = zod
  .object({
    sources: zod.array(
      zod
        .object({
          id: zod.string(),
          name: zod.string(),
          description: zod.string(),
        })
        .describe("Information about an available search source."),
    ),
  })
  .describe("Response containing available search sources.");

/**
 * Perform a search across selected sources.
 * @summary Perform Search
 */
export const performSearchBody = zod
  .object({
    query: zod.string(),
    sources: zod.array(zod.string()),
    topK: zod.number(),
  })
  .describe("Request to perform a unified search.");

export const performSearchResponse = zod
  .object({
    query: zod.string(),
    items: zod.array(
      zod
        .object({
          source: zod.string(),
          title: zod.string(),
          subtitle: zod.union([zod.string(), zod.null()]),
          content: zod.string(),
          url: zod.string(),
          lastUpdatedAt: zod.union([zod.iso.datetime({}), zod.null()]),
        })
        .describe("A single search result item."),
    ),
    sourcesSearched: zod.array(zod.string()),
    totalResults: zod.number(),
  })
  .describe("Response from a unified search.");
